// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customized tailwind directives omitting base layer */
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
@media (min-width: 560px) {
    .\\!container {
        max-width: 560px !important;
    }
    .container {
        max-width: 560px;
    }
}
@media (min-width: 1080px) {
    .\\!container {
        max-width: 1080px !important;
    }
    .container {
        max-width: 1080px;
    }
}
@media (min-width: 1280px) {
    .\\!container {
        max-width: 1280px !important;
    }
    .container {
        max-width: 1280px;
    }
}
@media (min-width: 1464px) {
    .\\!container {
        max-width: 1464px !important;
    }
    .container {
        max-width: 1464px;
    }
}
@media (min-width: 1536px) {
    .\\!container {
        max-width: 1536px !important;
    }
    .container {
        max-width: 1536px;
    }
}
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
.carina-advanced-transition--loop-indefinitely {
    animation-iteration-count: infinite;
}
.carina-advanced-transition--linear {
    animation-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-advanced-transition--productive-ease-in-out {
    animation-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
}
.carina-advanced-transition--productive-ease-in {
    animation-timing-function: var(
    --carina-transition-timing-function-productive-ease-in
  );
}
.carina-advanced-transition--productive-ease-out {
    animation-timing-function: var(
    --carina-transition-timing-function-productive-ease-out
  );
}
.carina-advanced-transition--expressive-ease-in-out {
    animation-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
}
.carina-advanced-transition--expressive-ease-in {
    animation-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in
  );
}
.carina-advanced-transition--expressive-ease-out {
    animation-timing-function: var(
    --carina-transition-timing-function-expressive-ease-out
  );
}
.carina-advanced-transition--50 {
    animation-duration: var(--carina-transition-duration-50);
}
.carina-advanced-transition--100 {
    animation-duration: var(--carina-transition-duration-100);
}
.carina-advanced-transition--200 {
    animation-duration: var(--carina-transition-duration-200);
}
.carina-advanced-transition--300 {
    animation-duration: var(--carina-transition-duration-300);
}
.carina-advanced-transition--400 {
    animation-duration: var(--carina-transition-duration-400);
}
.carina-advanced-transition--550 {
    animation-duration: var(--carina-transition-duration-550);
}
.carina-advanced-transition--700 {
    animation-duration: var(--carina-transition-duration-700);
}
.carina-advanced-transition--800 {
    animation-duration: var(--carina-transition-duration-800);
}
.carina-advanced-transition--1200 {
    animation-duration: var(--carina-transition-duration-1200);
}
.carina-transition--appear-start,
.carina-transition--enter-start,
.carina-transition--exit-start {
    transition-property: none;
}
.carina-transition--linear {
    transition-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-transition--productive-ease-in-out {
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
}
.carina-transition--productive-ease-in {
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in
  );
}
.carina-transition--productive-ease-out {
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-out
  );
}
.carina-transition--expressive-ease-in-out {
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
}
.carina-transition--expressive-ease-in {
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in
  );
}
.carina-transition--expressive-ease-out {
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-out
  );
}
.carina-transition--appear-50,
.carina-transition--enter-50,
.carina-transition--exit-50 {
    transition-duration: var(--carina-transition-duration-50);
}
.carina-transition--appear-100,
.carina-transition--enter-100,
.carina-transition--exit-100 {
    transition-duration: var(--carina-transition-duration-100);
}
.carina-transition--appear-200,
.carina-transition--enter-200,
.carina-transition--exit-200 {
    transition-duration: var(--carina-transition-duration-200);
}
.carina-transition--appear-300,
.carina-transition--enter-300,
.carina-transition--exit-300 {
    transition-duration: var(--carina-transition-duration-300);
}
.carina-transition--appear-400,
.carina-transition--enter-400,
.carina-transition--exit-400 {
    transition-duration: var(--carina-transition-duration-400);
}
.carina-transition--appear-550,
.carina-transition--enter-550,
.carina-transition--exit-550 {
    transition-duration: var(--carina-transition-duration-550);
}
.carina-transition--appear-700,
.carina-transition--enter-700,
.carina-transition--exit-700 {
    transition-duration: var(--carina-transition-duration-700);
}
.carina-transition--appear-800,
.carina-transition--enter-800,
.carina-transition--exit-800 {
    transition-duration: var(--carina-transition-duration-800);
}
.carina-transition--appear-1200,
.carina-transition--enter-1200,
.carina-transition--exit-1200 {
    transition-duration: var(--carina-transition-duration-1200);
}
.carina-transition {
    --carina-transition-opacity: 1;
    --carina-transition-scale: 1;
    --carina-transition-scale-x: var(--carina-transition-scale);
    --carina-transition-scale-y: var(--carina-transition-scale);
    --carina-transition-translate-x: 0;
    --carina-transition-translate-y: 0;
    --carina-transition-rotate: 0;
    --carina-transition-skew-x: 0;
    --carina-transition-skew-y: 0;
    transform: translate(
      var(--carina-transition-translate-x),
      var(--carina-transition-translate-y)
    )
    rotate(var(--carina-transition-rotate))
    skewX(var(--carina-transition-skew-x))
    skewY(var(--carina-transition-skew-y))
    scaleX(var(--carina-transition-scale-x))
    scaleY(var(--carina-transition-scale-y));
    opacity: var(--carina-transition-opacity);
}
.carina-transition--fade-in {
    --carina-transition-opacity: 1;
}
.carina-transition--fade-out {
    --carina-transition-opacity: 0;
}
.carina-accordion > * {
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-bottom: var(--carina-border-width-0);
}
.carina-accordion > *:last-of-type {
    border-bottom: var(--carina-border-width-1) solid
      var(--carina-border-color-soft);
}
.carina-accordion--inside-only > * {
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-bottom: var(--carina-border-width-0);
}
.carina-accordion--inside-only > *:first-of-type {
    border-top: var(--carina-border-width-0);
}
.carina-accordion-header {
    display: flex;
    align-items: baseline;
    padding-top: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
    cursor: pointer;
    opacity: var(--carina-opacity-100);
    padding-inline-end: var(--carina-spacing-4);
    padding-inline-start: var(--carina-spacing-2);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
}
.carina-accordion-header:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-accordion-header:hover:not(.carina-accordion-header--disabled) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-accordion-header__header {
    display: flex;
    flex: 1 0 0;
    overflow: hidden;
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    white-space: nowrap;
}
.carina-accordion-header__header--open {
    overflow: auto;
    white-space: normal;
    text-overflow: clip;
}
.carina-accordion-header__header--chevron-start {
    margin-inline-start: var(--carina-spacing-2);
}
.carina-accordion-header--disabled {
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-accordion-header--padding-mode-roomy {
    padding-top: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-4);
}
.carina-accordion-header__chevron {
    display: flex;
    flex: initial;
    align-items: flex-start;
    align-self: flex-start;
    color: var(--carina-text-color-soft);
}
.carina-accordion-header__chevron svg {
    transition-delay: var(--carina-transition-duration-100);
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in
    );
    transition-duration: var(--carina-transition-duration-200);
    transition-property: transform;
}
.carina-accordion-header__chevron--open--chevron-placement-end > svg {
    transform: rotate(-180deg);
    transition-delay: 0ms;
}
.carina-accordion-header__chevron--not-open--chevron-placement-start > svg {
    transform: rotate(-90deg);
    transition-delay: 0ms;
}
[dir='rtl'] .carina-accordion-header__chevron--not-open--chevron-placement-start > svg {
    transform: rotate(90deg);
    transition-delay: 0ms;
}
.carina-accordion-header__chevron--reduce-motion > svg {
    transition-property: none;
}
.carina-accordion-icon {
    flex: initial;
    overflow: hidden;
    color: var(--carina-text-color-soft);
}
.carina-accordion-section {
    padding-right: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
    padding-left: var(--carina-spacing-2);
    overflow: hidden;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    visibility: hidden;
}
.carina-accordion-section--open,
.carina-accordion-section__collapse.carina-transition--exit-active .carina-accordion-section,
.carina-accordion-section__collapse.carina-transition--exit-start .carina-accordion-section {
    visibility: visible;
}
.carina-accordion-section__collapse {
    transition-duration: var(--carina-transition-duration-100);
}
.carina-accordion-section__collapse.carina-transition--exit-done {
    max-height: 0;
    overflow: hidden;
}
.carina-accordion-section__collapse.carina-transition--enter-done,
.carina-accordion-section__collapse.carina-transition--appear-done {
    transform: none;
}
.carina-detailed-accordion-header {
    display: flex;
    flex: 1 0 0;
    align-items: flex-start;
    overflow: hidden;
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    text-overflow: ellipsis;
}
.carina-detailed-accordion-header--open {
    overflow: auto;
    white-space: normal;
    text-overflow: clip;
}
.carina-detailed-accordion-header__label-and-description {
    display: flex;
    flex-basis: 0%;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-inline-end: var(--carina-spacing-2);
    padding-inline-start: var(--carina-spacing-0);
}
.carina-detailed-accordion-header__label-and-description--icon-at-start {
    margin-inline-start: var(--carina-spacing-2);
    margin-inline-end: var(--carina-spacing-0);
}
.carina-detailed-accordion-header__label-and-description--open {
    overflow: auto;
    white-space: normal;
    text-overflow: clip;
}
.carina-detailed-accordion-header__label-text {
    overflow: hidden;
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    white-space: nowrap;
    text-overflow: ellipsis;
}
.carina-detailed-accordion-header__description-text {
    overflow: hidden;
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    white-space: nowrap;
    text-overflow: ellipsis;
}
.carina-detailed-accordion-header__description-text--open {
    overflow: auto;
    white-space: normal;
    text-overflow: clip;
}
.carina-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-right: 0;
    margin-left: 0;
    padding-top: 0;
    padding-right: var(--carina-spacing-1);
    padding-bottom: 0;
    padding-left: var(--carina-spacing-1);
    border: var(--carina-border-width-1) solid transparent;
    border-radius: var(--carina-border-radius-xl);
    text-decoration: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    font-family: inherit;
    line-height: inherit;
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-out
  );
    transition-property: background-color, color, border-color, outline-color;
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-button:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-button--ghost {
    outline-offset: var(--carina-border-width-0);
}
.carina-button:active:not(.carina-button--disabled) {
    transform: scale(var(--carina-scale-shrink));
}
.carina-button--disabled {
    transform: none;
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-button--disabled .carina-button__icon-start,
.carina-button--disabled .carina-button__icon-end {
    transform: none;
}
.carina-button--brand.carina-button--filled,
.carina-button--primary.carina-button--filled {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
}
.carina-button--brand.carina-button--filled:hover:not(.carina-button--disabled), .carina-button--primary.carina-button--filled:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-hover);
}
.carina-button--brand.carina-button--filled:active:not(.carina-button--disabled),
  .carina-button--brand.carina-button--filled.carina-button--active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--filled:active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--filled.carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-active);
}
.carina-button--brand.carina-button--lined,
.carina-button--primary.carina-button--lined {
    border-color: var(--carina-border-color-primary);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-primary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--brand.carina-button--lined:hover:not(.carina-button--disabled), .carina-button--primary.carina-button--lined:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary-hover);
}
.carina-button--brand.carina-button--lined:active:not(.carina-button--disabled),
  .carina-button--brand.carina-button--lined.carina-button--active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--lined:active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--lined.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary-active);
}
.carina-button--brand.carina-button--ghost,
.carina-button--primary.carina-button--ghost {
    color: var(--carina-text-color-primary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--brand.carina-button--ghost:hover:not(.carina-button--disabled), .carina-button--primary.carina-button--ghost:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-button--brand.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--brand.carina-button--ghost.carina-button--active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--primary.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
    outline: none;
}
.carina-button--secondary.carina-button--filled {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary);
}
.carina-button--secondary.carina-button--filled:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-secondary-hover);
}
.carina-button--secondary.carina-button--filled:active:not(.carina-button--disabled),
  .carina-button--secondary.carina-button--filled.carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-secondary-active);
}
.carina-button--secondary.carina-button--lined {
    border-color: var(--carina-border-color-secondary);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-secondary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--secondary.carina-button--lined:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary-hover);
}
.carina-button--secondary.carina-button--lined:active:not(.carina-button--disabled),
  .carina-button--secondary.carina-button--lined.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary-active);
}
.carina-button--secondary.carina-button--ghost {
    color: var(--carina-text-color-secondary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--secondary.carina-button--ghost:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-button--secondary.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--secondary.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
    outline: none;
}
.carina-button--tertiary.carina-button--filled {
    color: var(--carina-text-color-on-tertiary);
    background-color: var(--carina-background-color-tertiary);
}
.carina-button--tertiary.carina-button--filled:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-tertiary-hover);
}
.carina-button--tertiary.carina-button--filled:active:not(.carina-button--disabled),
  .carina-button--tertiary.carina-button--filled.carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-tertiary-active);
}
.carina-button--tertiary.carina-button--lined {
    border-color: var(--carina-border-color-tertiary);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-tertiary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--tertiary.carina-button--lined:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-tertiary);
    background-color: var(--carina-background-color-tertiary-hover);
}
.carina-button--tertiary.carina-button--lined:active:not(.carina-button--disabled),
  .carina-button--tertiary.carina-button--lined.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-tertiary);
    background-color: var(--carina-background-color-tertiary-active);
}
.carina-button--tertiary.carina-button--ghost {
    color: var(--carina-text-color-tertiary);
    background-color: var(--carina-colors-transparent);
}
.carina-button--tertiary.carina-button--ghost:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-button--tertiary.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--tertiary.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
    outline: none;
}
.carina-button--neutral-inverse:focus-visible {
    outline-color: var(
      --carina-border-color-inverse-focus,
      var(--carina-border-color-inverse)
    );
}
.carina-button--neutral-inverse.carina-button--filled:not(.carina-button--elevated) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-neutral-inverse);
}
.carina-button--neutral-inverse.carina-button--filled:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-neutral-inverse-hover);
}
.carina-button--neutral-inverse.carina-button--filled:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--neutral-inverse.carina-button--filled:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-neutral-inverse-active);
}
.carina-button--neutral-inverse.carina-button--lined:not(.carina-button--elevated) {
    border-color: var(--carina-border-color-inverse);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-base-inverse);
    background-color: var(--carina-colors-transparent);
}
.carina-button--neutral-inverse.carina-button--lined:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-neutral-inverse-hover);
}
.carina-button--neutral-inverse.carina-button--lined:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--neutral-inverse.carina-button--lined:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-neutral-inverse-active);
}
.carina-button--neutral-inverse.carina-button--ghost {
    color: var(--carina-text-color-base-inverse);
    background-color: var(--carina-colors-transparent);
}
.carina-button--neutral-inverse.carina-button--ghost:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-neutral-hover);
}
.carina-button--neutral-inverse.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--neutral-inverse.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-neutral-active);
}
.carina-button--neutral:focus-visible {
    outline-color: var(--carina-border-color-hard);
}
.carina-button--neutral.carina-button--filled:not(.carina-button--elevated) {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral);
}
.carina-button--neutral.carina-button--filled:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-neutral-hover);
}
.carina-button--neutral.carina-button--filled:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--neutral.carina-button--filled:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral-active);
}
.carina-button--neutral.carina-button--lined:not(.carina-button--elevated) {
    border-color: var(--carina-border-color-hard);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-transparent);
}
.carina-button--neutral.carina-button--lined:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral-hover);
}
.carina-button--neutral.carina-button--lined:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--neutral.carina-button--lined:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral-active);
}
.carina-button--neutral.carina-button--ghost {
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-transparent);
}
.carina-button--neutral.carina-button--ghost:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-button--neutral.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--neutral.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral);
}
.carina-button--menu {
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-soft);
    background-color: var(--carina-colors-transparent);
}
.carina-button--menu:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-button--menu:active:not(.carina-button--disabled),
  .carina-button--menu.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-button--danger:focus-visible {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-button--danger.carina-button--filled:not(.carina-button--elevated) {
    border-color: var(--carina-border-color-danger);
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-danger);
}
.carina-button--danger.carina-button--filled:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    border-color: var(--carina-background-color-danger-hover);
    background-color: var(--carina-background-color-danger-hover);
}
.carina-button--danger.carina-button--filled:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--danger.carina-button--filled:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    border-color: var(--carina-background-color-danger-active);
    background-color: var(--carina-background-color-danger-active);
}
.carina-button--danger.carina-button--filled.carina-button--disabled {
    border-color: transparent;
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-neutral);
}
.carina-button--danger.carina-button--lined:not(.carina-button--elevated) {
    border-color: var(--carina-border-color-danger);
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-danger);
    background-color: var(--carina-colors-transparent);
}
.carina-button--danger.carina-button--lined:not(.carina-button--elevated):hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-danger-hover);
}
.carina-button--danger.carina-button--lined:not(.carina-button--elevated):active:not(.carina-button--disabled),
  .carina-button--danger.carina-button--lined:not(.carina-button--elevated).carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-danger-active);
}
.carina-button--danger.carina-button--lined.carina-button--disabled {
    border-color: var(--carina-border-color-base);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-transparent);
}
.carina-button--danger.carina-button--ghost {
    color: var(--carina-text-color-danger);
    background-color: var(--carina-colors-transparent);
    outline: none;
}
.carina-button--danger.carina-button--ghost:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale);
}
.carina-button--danger.carina-button--ghost:active:not(.carina-button--disabled),
  .carina-button--danger.carina-button--ghost.carina-button--active:not(.carina-button--disabled) {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-hover);
}
.carina-button--danger.carina-button--ghost.carina-button--disabled {
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-transparent);
}
.carina-button--sm {
    min-width: 80px;
    min-height: 36px;
    padding-right: var(--carina-spacing-4);
    padding-left: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-sm);
}
.carina-button--md {
    min-width: 96px;
    min-height: 40px;
    padding-right: var(--carina-spacing-6);
    padding-left: var(--carina-spacing-6);
    font-size: var(--carina-font-size-body-md);
}
.carina-button--lg {
    min-width: 112px;
    min-height: 44px;
    padding-right: var(--carina-spacing-6);
    padding-left: var(--carina-spacing-6);
    font-size: var(--carina-font-size-body-md);
}
.carina-button--pill {
    border-radius: var(--carina-border-radius-full);
}
.carina-button--block {
    width: 100%;
}
.carina-button.carina-button--elevated {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
}
.carina-button.carina-button--elevated:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-hover);
    box-shadow: var(--carina-box-shadow-2xl);
    transform: scale(var(--carina-scale-grow));
}
.carina-button.carina-button--elevated:active:not(.carina-button--disabled),
  .carina-button.carina-button--elevated.carina-button--active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-active);
    transform: none;
}
.carina-button--icon-only,
.carina-button--icons-only {
    min-width: 0;
    margin: 0;
    padding: var(--carina-spacing-1);
}
.carina-button--icons-only {
    justify-content: space-evenly;
}
.carina-button--icon-only.carina-button--sm {
    width: var(--carina-spacing-9);
    height: var(--carina-spacing-9);
}
.carina-button--icon-only.carina-button--md {
    width: var(--carina-spacing-10);
    height: var(--carina-spacing-10);
}
.carina-button--icon-only.carina-button--lg {
    width: var(--carina-spacing-11);
    height: var(--carina-spacing-11);
}
.carina-button--icons-only.carina-button--sm {
    width: var(--carina-spacing-15);
    height: var(--carina-spacing-9);
}
.carina-button--icons-only.carina-button--md {
    width: var(--carina-spacing-16);
    height: var(--carina-spacing-10);
}
.carina-button--icons-only.carina-button--lg {
    width: var(--carina-spacing-17);
    height: var(--carina-spacing-11);
}
.carina-button--icons-only.carina-button--fab {
    width: var(--carina-spacing-20);
    height: var(--carina-spacing-16);
}
.carina-button--icon-only.carina-button--fab,
.carina-button--icons-only.carina-button--fab {
    padding: var(--carina-spacing-3);
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
    box-shadow: var(--carina-box-shadow-2xl);
}
.carina-button--icon-only.carina-button--fab:hover:not(.carina-button--disabled), .carina-button--icons-only.carina-button--fab:hover:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-hover);
}
.carina-button--icon-only.carina-button--fab:active:not(.carina-button--disabled), .carina-button--icons-only.carina-button--fab:active:not(.carina-button--disabled) {
    background-color: var(--carina-background-color-primary-active);
}
.carina-button--icon-only.carina-button--fab svg, .carina-button--icons-only.carina-button--fab svg {
    width: var(--carina-spacing-7);
    height: var(--carina-spacing-7);
}
.carina-button__icon-start,
.carina-button__icon-end {
    display: flex;
    align-items: center;
    margin: 0;
    padding-inline-end: 0;
    padding-inline-start: 0;
}
.carina-button__icon-start {
    margin-inline-end: var(--carina-spacing-2);
    margin-inline-start: 0;
}
.carina-button__icon-end {
    margin-inline-end: 0;
    margin-inline-start: var(--carina-spacing-2);
}
.carina-button--icon-only .carina-button__icon-start,
.carina-button--icons-only .carina-button__icon-start,
.carina-button--icon-only .carina-button__icon-end,
.carina-button--icons-only .carina-button__icon-end {
    margin: 0;
    margin-inline: 0;
}
.carina-alerts {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.carina-alerts--fixed {
    position: fixed;
    top: var(--carina-spacing-6);
    right: var(--carina-spacing-6);
    left: var(--carina-spacing-6);
    z-index: var(--carina-z-index-alert);
    align-items: center;
    width: calc(100% - var(--carina-spacing-12));
    pointer-events: none;
}
.carina-alerts__container {
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
}
.carina-alerts__collapse {
    width: 100%;
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-out
  );
}
.carina-alerts__collapse-container {
    padding-bottom: var(--carina-spacing-3);
}
.carina-alerts__collapse-container--last {
    padding-bottom: var(--carina-spacing-0);
}
.carina-alerts--page .carina-alerts__collapse {
    transition-duration: var(--carina-transition-duration-200);
}
.carina-alerts--user .carina-alerts__collapse {
    transition-duration: var(--carina-transition-duration-400);
}
.carina-alerts__collapse.carina-transition--out {
    --carina-transition-opacity: var(--carina-opacity-0);
}
.carina-alerts__collapse.carina-transition--appear-active {
    height: auto;
    overflow: visible;
}
.carina-app-alert {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 50px;
    padding-right: var(--carina-spacing-3);
    padding-left: var(--carina-spacing-3);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    line-height: var(--carina-line-height-tight);
    box-shadow: none;
    pointer-events: auto;
}
.carina-app-alert--info {
    color: var(--carina-text-color-on-info);
    border-color: var(--carina-background-color-info);
    background-color: var(--carina-background-color-info);
}
.carina-app-alert--warning {
    color: var(--carina-text-color-on-warning);
    border-color: var(--carina-background-color-warning);
    background-color: var(--carina-background-color-warning);
}
.carina-app-alert--danger {
    color: var(--carina-text-color-on-danger);
    border-color: var(--carina-background-color-danger);
    background-color: var(--carina-background-color-danger);
}
.carina-app-alert--success {
    color: var(--carina-text-color-on-success);
    border-color: var(--carina-background-color-success);
    background-color: var(--carina-background-color-success);
}
.carina-app-alert__action-container {
    display: flex;
    flex-grow: 2;
    align-items: center;
    justify-content: center;
}
.carina-app-alert__action-container .carina-app-alert__action {
    margin-top: var(--carina-spacing-2);
    margin-bottom: var(--carina-spacing-2);
    font-weight: var(--carina-font-weight-body);
    background-color: transparent;
}
.carina-app-alert__action-container .carina-app-alert__action a {
    border-color: transparent;
    border-style: solid;
    border-width: var(--carina-border-width-4);
    text-decoration: underline;
    background-color: transparent;
    border-radius: var(--carina-border-radius-md);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
        --carina-transition-timing-function-expressive-ease-in-out
      );
    transition-duration: calc(
        var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
      );
    transition-property: outline-color;
}
.carina-app-alert__action-container .carina-app-alert__action a:focus-visible {
    transition-duration: var(--carina-transition-duration-100);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--info a {
    color: var(--carina-text-color-on-info);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--info a:focus-visible {
    outline-color: var(--carina-text-color-on-info);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--success a {
    color: var(--carina-text-color-on-success);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--success a:focus-visible {
    outline-color: var(--carina-text-color-on-success);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--danger a {
    color: var(--carina-text-color-on-danger);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--danger a:focus-visible {
    outline-color: var(--carina-text-color-on-danger);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--warning a {
    color: var(--carina-text-color-on-warning);
}
.carina-app-alert__action-container .carina-app-alert__action.carina-app-alert__action--warning a:focus-visible {
    outline-color: var(--carina-text-color-on-warning);
}
.carina-app-alert__action--dismissible {
    margin-inline-end: 0;
}
.carina-app-alert__content-container {
    display: flex;
    flex-wrap: nowrap;
}
.carina-app-alert__content {
    margin-top: var(--carina-spacing-4);
    margin-inline-start: var(--carina-spacing-3);
    margin-bottom: var(--carina-spacing-4);
    margin-inline-end: var(--carina-spacing-4);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-app-alert .carina-app-alert__dismiss-container {
    display: flex;
    align-items: center;
    align-self: flex-start;
    height: 36px;
    margin: auto;
    cursor: pointer;
}
[dir='rtl'] .carina-app-alert .carina-app-alert__dismiss-container {
    margin-right: var(--carina-spacing-4);
    margin-left: 0;
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button span {
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: var(--carina-border-radius-full);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button {
    width: 36px;
    height: 36px;
    min-height: 0;
    margin: 0;
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 0;
    border-color: transparent;
    border-style: solid;
    border-width: var(--carina-border-width-2);
    border-radius: var(--carina-border-radius-full);
    outline-offset: var(--carina-border-width-0);
    background-color: transparent;
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--info {
    color: var(--carina-text-color-on-info);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--info:hover {
    background-color: var(--carina-background-color-info-hover);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--info:active {
    background-color: var(--carina-background-color-info-active);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--info:focus-visible {
    outline-color: var(--carina-text-color-on-info);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--danger {
    color: var(--carina-text-color-on-danger);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--danger:hover {
    background-color: var(--carina-background-color-danger-hover);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--danger:active {
    background-color: var(--carina-background-color-danger-active);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--danger:focus-visible {
    outline-color: var(--carina-text-color-on-danger);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--success {
    color: var(--carina-text-color-on-success);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--success:hover {
    background-color: var(--carina-background-color-success-hover);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--success:active {
    background-color: var(--carina-background-color-success-active);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--success:focus-visible {
    outline-color: var(--carina-text-color-on-info);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--warning {
    color: var(--carina-text-color-on-warning);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--warning:hover {
    background-color: var(--carina-background-color-warning-hover);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--warning:active {
    background-color: var(--carina-background-color-warning-active);
}
.carina-app-alert .carina-app-alert__dismiss-container .carina-app-alert__dismiss-button--warning:focus-visible {
    outline-color: var(--carina-text-color-on-warning);
}
.carina-app-alert__icon {
    align-self: flex-start;
    height: 24px;
    margin-top: var(--carina-spacing-3);
    margin-bottom: var(--carina-spacing-3);
    background-color: transparent;
}
.carina-app-alert__icon--info {
    color: var(--carina-text-color-on-info);
}
.carina-app-alert__icon--warning {
    color: var(--carina-text-color-on-warning);
}
.carina-app-alert__icon--danger {
    color: var(--carina-text-color-on-danger);
}
.carina-app-alert__icon--success {
    color: var(--carina-text-color-on-success);
}
.carina-page-alert {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-height: 50px;
    padding-right: var(--carina-spacing-3);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: 10px;
    line-height: var(--carina-line-height-tight);
    box-shadow: none;
    pointer-events: auto;
}
[dir='rtl'] .carina-page-alert {
    padding-left: var(--carina-spacing-4);
}
.carina-page-alert--info {
    border-color: var(--carina-border-color-info);
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale);
}
.carina-page-alert--warning {
    border-color: var(--carina-border-color-warning);
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale);
}
.carina-page-alert--danger {
    border-color: var(--carina-border-color-danger);
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale);
}
.carina-page-alert--success {
    border-color: var(--carina-border-color-success);
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale);
}
.carina-page-alert__title {
    margin-bottom: var(--carina-spacing-2);
    font-weight: var(--carina-font-weight-display);
}
.carina-page-alert__action-container {
    display: flex;
    align-items: flex-start;
    width: 100%;
}
.carina-page-alert__action-container--bottom {
    flex-wrap: wrap;
}
.carina-page-alert__action {
    margin-top: var(--carina-spacing-4);
    margin-inline-end: var(--carina-spacing-4);
    margin-bottom: var(--carina-spacing-4);
    margin-inline-start: auto;
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-sm);
}
.carina-page-alert__action a {
    padding: var(--carina-spacing-0-5);
    text-decoration: underline;
    border-radius: var(--carina-border-radius-md);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-property: outline-color;
}
.carina-page-alert__action a:focus-visible {
    transition-duration: var(--carina-transition-duration-100);
}
.carina-page-alert__action--bottom {
    flex: 0 0 100%;
    margin-top: 0;
    margin-bottom: var(--carina-spacing-4);
}
.carina-page-alert__action.carina-page-alert__action--info a {
    color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert__action.carina-page-alert__action--info a:hover {
    color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert__action.carina-page-alert__action--info a:active {
    color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert__action.carina-page-alert__action--info a:focus-visible {
    outline-color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert__action.carina-page-alert__action--success a {
    color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert__action.carina-page-alert__action--success a:hover {
    color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert__action.carina-page-alert__action--success a:active {
    color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert__action.carina-page-alert__action--success a:focus-visible {
    outline-color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert__action.carina-page-alert__action--danger a {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert__action.carina-page-alert__action--danger a:hover {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert__action.carina-page-alert__action--danger a:active {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert__action.carina-page-alert__action--danger a:focus-visible {
    outline-color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert__action.carina-page-alert__action--warning a {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert__action.carina-page-alert__action--warning a:hover {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert__action.carina-page-alert__action--warning a:active {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert__action.carina-page-alert__action--warning a:focus-visible {
    outline-color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert__action--dismissible {
    margin-inline-end: 0;
}
.carina-page-alert__action--dismissible a,
  .carina-page-alert__action--dismissible button {
    border-color: transparent;
}
.carina-page-alert__content-container {
    margin-top: var(--carina-spacing-4);
    margin-inline-end: var(--carina-spacing-6);
    margin-bottom: var(--carina-spacing-4);
    margin-inline-start: 0;
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-page-alert__content-container--bottom {
    margin-bottom: var(--carina-spacing-3);
}
.carina-page-alert .carina-page-alert__dismiss-container {
    align-self: flex-start;
    height: 36px;
    margin-top: var(--carina-spacing-1-5);
    margin-right: 0;
    margin-left: var(--carina-spacing-0-5);
    cursor: pointer;
}
[dir='rtl'] .carina-page-alert .carina-page-alert__dismiss-container {
    margin-right: var(--carina-spacing-2);
    margin-left: 0;
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-height: 0;
    padding: 0;
    border-radius: var(--carina-border-radius-full);
    outline-offset: var(--carina-border-width-0);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button span {
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: var(--carina-border-radius-full);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--info {
    color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--info:hover {
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale-hover);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--info:active {
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale-active);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--info:focus-visible {
    outline-color: var(--carina-text-color-on-info-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--danger {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--danger:hover {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-hover);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--danger:active {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-active);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--danger:focus-visible {
    outline-color: var(--carina-text-color-on-danger-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--success {
    color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--success:hover {
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale-hover);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--success:active {
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale-active);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--success:focus-visible {
    outline-color: var(--carina-text-color-on-success-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--warning {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--warning:hover {
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale-hover);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--warning:active {
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale-active);
}
.carina-page-alert .carina-page-alert__dismiss-container .carina-page-alert__dismiss-button--warning:focus-visible {
    outline-color: var(--carina-text-color-on-warning-pale);
}
.carina-page-alert__icon {
    display: flex;
    align-items: center;
    align-self: flex-start;
    padding-top: var(--carina-spacing-3);
    padding-inline-start: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-3);
    padding-inline-end: var(--carina-spacing-3);
    border-radius: 10px;
}
.carina-page-alert__icon--info {
    color: var(--carina-text-color-on-info-pale-soft);
}
.carina-page-alert__icon--warning {
    color: var(--carina-text-color-on-warning-pale-soft);
}
.carina-page-alert__icon--danger {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-page-alert__icon--success {
    color: var(--carina-text-color-on-success-pale-soft);
}
.carina-user-alert {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 560px;
    min-height: 50px;
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: 10px;
    line-height: var(--carina-line-height-body-sm);
    box-shadow: var(--carina-box-shadow-lg);
    pointer-events: auto;
}
.carina-user-alert--info {
    border-color: var(--carina-border-color-info);
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale);
}
.carina-user-alert--warning {
    border-color: var(--carina-border-color-warning);
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale);
}
.carina-user-alert--danger {
    border-color: var(--carina-border-color-danger);
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale);
}
.carina-user-alert--success {
    border-color: var(--carina-border-color-success);
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale);
}
.carina-user-alert--fixed {
    position: fixed;
    top: 20px;
    left: 50%;
    z-index: var(--carina-z-index-alert);
    width: calc(100% - 40px);
    transform: translateX(-50%);
}
.carina-user-alert__title {
    margin-bottom: var(--carina-spacing-2);
    font-weight: var(--carina-font-weight-display);
}
.carina-user-alert__action-container {
    display: flex;
    align-items: flex-start;
    width: 100%;
}
.carina-user-alert__action {
    margin-top: var(--carina-spacing-5);
    margin-inline-end: var(--carina-spacing-5);
    margin-bottom: var(--carina-spacing-5);
    margin-inline-start: auto;
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-sm);
    max-height: 20px;
}
.carina-user-alert__action a {
    padding: var(--carina-spacing-0-5);
    text-decoration: underline;
    border-radius: var(--carina-border-radius-md);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-property: outline-color;
}
.carina-user-alert__action a:focus-visible {
    transition-duration: var(--carina-transition-duration-100);
}
.carina-user-alert__action button {
    margin-top: calc(-1 * var(--carina-spacing-2));
    margin-bottom: calc(-1 * var(--carina-spacing-2));
    font-weight: var(--carina-font-weight-body);
}
.carina-user-alert__action.carina-user-alert__action--info a {
    color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert__action.carina-user-alert__action--info a:hover {
    color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert__action.carina-user-alert__action--info a:active {
    color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert__action.carina-user-alert__action--info a:focus-visible {
    outline-color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert__action.carina-user-alert__action--success a {
    color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert__action.carina-user-alert__action--success a:hover {
    color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert__action.carina-user-alert__action--success a:active {
    color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert__action.carina-user-alert__action--success a:focus-visible {
    outline-color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert__action.carina-user-alert__action--danger a {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert__action.carina-user-alert__action--danger a:hover {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert__action.carina-user-alert__action--danger a:active {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert__action.carina-user-alert__action--danger a:focus-visible {
    outline-color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert__action.carina-user-alert__action--warning a {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert__action.carina-user-alert__action--warning a:hover {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert__action.carina-user-alert__action--warning a:active {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert__action.carina-user-alert__action--warning a:focus-visible {
    outline-color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert__action--dismissible {
    margin-inline-end: 0;
}
.carina-user-alert__action--dismissible a,
  .carina-user-alert__action--dismissible button {
    border-color: transparent;
    border-style: solid;
    border-width: var(--carina-border-width-4);
}
.carina-user-alert__content-container {
    margin-top: var(--carina-spacing-5);
    margin-inline-end: var(--carina-spacing-2);
    margin-bottom: var(--carina-spacing-5);
    margin-inline-start: 0;
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-user-alert .carina-user-alert__dismiss-container {
    align-self: flex-start;
    height: 36px;
    margin-top: var(--carina-spacing-3);
    margin-bottom: var(--carina-spacing-3);
    margin-right: var(--carina-spacing-3);
    margin-left: var(--carina-spacing-2);
    cursor: pointer;
}
[dir='rtl'] .carina-user-alert .carina-user-alert__dismiss-container {
    margin-right: var(--carina-spacing-2);
    margin-left: 0;
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-height: 0;
    margin: 0;
    padding: 0;
    border-radius: var(--carina-border-radius-full);
    outline-offset: var(--carina-border-width-0);
    cursor: pointer;
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button span {
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: var(--carina-border-radius-full);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--info {
    color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--info:hover {
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale-hover);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--info:active {
    color: var(--carina-text-color-on-info-pale);
    background-color: var(--carina-background-color-info-pale-active);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--info:focus-visible {
    outline-color: var(--carina-text-color-on-info-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--danger {
    color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--danger:hover {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-hover);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--danger:active {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-active);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--danger:focus-visible {
    outline-color: var(--carina-text-color-on-danger-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--success {
    color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--success:hover {
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale-hover);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--success:active {
    color: var(--carina-text-color-on-success-pale);
    background-color: var(--carina-background-color-success-pale-active);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--success:focus-visible {
    outline-color: var(--carina-text-color-on-success-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--warning {
    color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--warning:hover {
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale-hover);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--warning:active {
    color: var(--carina-text-color-on-warning-pale);
    background-color: var(--carina-background-color-warning-pale-active);
}
.carina-user-alert .carina-user-alert__dismiss-container .carina-user-alert__dismiss-button--warning:focus-visible {
    outline-color: var(--carina-text-color-on-warning-pale);
}
.carina-user-alert__icon {
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    padding-top: calc(var(--carina-spacing-4) + var(--carina-spacing-0-5));
    padding-inline-end: var(--carina-spacing-4);
    padding-bottom: calc(var(--carina-spacing-4) + var(--carina-spacing-0-5));
    padding-inline-start: var(--carina-spacing-3);
}
.carina-user-alert__icon--info {
    color: var(--carina-text-color-on-info-pale-soft);
}
.carina-user-alert__icon--warning {
    color: var(--carina-text-color-on-warning-pale-soft);
}
.carina-user-alert__icon--danger {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-user-alert__icon--success {
    color: var(--carina-text-color-on-success-pale-soft);
}
.carina-avatar {
    --indicator-height: 25%;
    --indicator-offset: -3.125%;
    --indicator-vertical-offset: 12.5%;
    --indicator-horizontal-offset: 12.5%;
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: var(--carina-border-radius-full);
    cursor: default;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-avatar:focus-within {
    transition-duration: var(--carina-transition-duration-100);
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-avatar__main {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: var(--carina-avatar-bg);
    border-color: var(--carina-border-color-soft);
    border-style: none;
    color: var(--carina-avatar-fg);
    border-radius: var(--carina-border-radius-full);
    overflow: hidden;
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-md);
    font-family: var(--carina-font-family-primary);
}
.carina-avatar__main--background-0 {
    --carina-avatar-fg: var(--carina-text-color-base-inverse);
    --carina-avatar-bg: var(--carina-colors-accessory-1-50);
}
.carina-avatar__main--background-1 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-2-30);
}
.carina-avatar__main--background-2 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-3-30);
}
.carina-avatar__main--background-3 {
    --carina-avatar-fg: var(--carina-text-color-base-inverse);
    --carina-avatar-bg: var(--carina-colors-accessory-4-50);
}
.carina-avatar__main--background-4 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-0-40);
}
.carina-avatar__main--background-5 {
    --carina-avatar-fg: var(--carina-text-color-base-inverse);
    --carina-avatar-bg: var(--carina-colors-accessory-2-50);
}
.carina-avatar__main--background-6 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-1-20);
}
.carina-avatar__main--background-7 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-3-10);
}
.carina-avatar__main--background-8 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-4-30);
}
.carina-avatar__main--background-9 {
    --carina-avatar-fg: var(--carina-text-color-base);
    --carina-avatar-bg: var(--carina-colors-accessory-0-10);
}
.carina-avatar__main--border {
    border-style: solid;
}
.carina-avatar__main--square {
    border-radius: var(--carina-border-radius-2xl);
}
.carina-avatar__main--edit-scrim {
    cursor: pointer;
}
.carina-avatar__main--hover-scrim.carina-avatar__main--hover-shadow:hover {
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-avatar__main--hover-scrim.carina-avatar__main--hover-shadow:hover div {
    opacity: var(--carina-opacity-50);
}
.carina-avatar__main--hover-scrim.carina-avatar__main--hover-shadow:hover span {
    opacity: var(--carina-opacity-100);
}
.carina-avatar__main--hover-scrim:hover {
    box-shadow: none;
}
.carina-avatar__main--hover-scrim:hover div {
    opacity: var(--carina-opacity-50);
}
.carina-avatar__main--hover-scrim:hover span {
    opacity: var(--carina-opacity-100);
}
.carina-avatar__main--hover-scrim div,
  .carina-avatar__main--hover-scrim span {
    opacity: var(--carina-opacity-0);
}
.carina-avatar__main--hover-shadow:hover {
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-avatar__main--image {
    background-color: transparent;
}
.carina-avatar__main--interactive {
    cursor: pointer;
}
.carina-avatar__image {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    margin: 0;
    -o-object-fit: cover;
    object-fit: cover;
    transform: translate(-50%, -50%);
}
.carina-avatar__loading-image {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(-50%, -50%);
    visibility: hidden;
}
.carina-avatar__action,
.carina-avatar__action-icon {
    position: absolute;
    bottom: 0;
    inset-inline-start: 0;
    width: 100%;
    height: calc(100% * 42 / 128);
}
.carina-avatar__action {
    background-color: var(--carina-background-color-surface);
    opacity: var(--carina-opacity-50);
}
.carina-avatar__action-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: var(--carina-opacity-100);
    fill: var(--carina-text-color-base);
}
.carina-avatar__action--border,
.carina-avatar__action-icon--border {
    height: calc(100% * 48 / 128);
}
.carina-avatar__indicator {
    position: absolute;
    bottom: var(--indicator-offset);
    box-sizing: border-box;
    width: var(--indicator-height);
    height: var(--indicator-height);
    border-color: var(--carina-background-color-surface);
    border-style: solid;
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral);
    inset-inline-end: var(--indicator-offset);
}
.carina-avatar__indicator--accent {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary);
}
.carina-avatar__indicator--brand,
.carina-avatar__indicator--primary {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
}
.carina-avatar__indicator--secondary {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary);
}
.carina-avatar__indicator--danger {
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-danger);
}
.carina-avatar__indicator--interactive {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
}
.carina-avatar__indicator--neutral {
    color: var(--carina-text-color-on-neutral);
    background-color: var(--carina-background-color-neutral);
}
.carina-avatar__indicator--success {
    color: var(--carina-text-color-on-success);
    background-color: var(--carina-background-color-success);
}
.carina-avatar__indicator--tertiary {
    color: var(--carina-text-color-on-tertiary);
    background-color: var(--carina-background-color-tertiary);
}
.carina-avatar__indicator--warning {
    color: var(--carina-text-color-on-warning);
    background-color: var(--carina-background-color-warning);
}
.carina-avatar__indicator--square {
    --indicator-offset: -6.25%;
}
.carina-avatar__indicator--top-end {
    top: var(--indicator-offset);
    inset-inline-end: var(--indicator-offset);
}
.carina-avatar__indicator--top-start {
    top: var(--indicator-offset);
    inset-inline-start: var(--indicator-offset);
}
.carina-avatar__indicator--bottom-end {
    bottom: var(--indicator-offset);
    inset-inline-end: var(--indicator-offset);
}
.carina-avatar__indicator--bottom-start {
    bottom: var(--indicator-offset);
    inset-inline-start: var(--indicator-offset);
}
.carina-avatar__indicator-top-end,
.carina-avatar__indicator-top-start,
.carina-avatar__indicator-bottom-end,
.carina-avatar__indicator-bottom-start {
    position: absolute;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.carina-avatar__indicator-top-end {
    top: var(--indicator-vertical-offset);
    inset-inline-end: var(--indicator-horizontal-offset);
    transform: translate(50%, -50%);
}
[dir='rtl'] .carina-avatar__indicator-top-end {
    transform: translate(-50%, -50%);
}
.carina-avatar__indicator-top-start {
    top: var(--indicator-vertical-offset);
    inset-inline-start: var(--indicator-horizontal-offset);
    transform: translate(-50%, -50%);
}
[dir='rtl'] .carina-avatar__indicator-top-start {
    transform: translate(50%, -50%);
}
.carina-avatar__indicator-bottom-end {
    bottom: var(--indicator-vertical-offset);
    inset-inline-end: var(--indicator-horizontal-offset);
    transform: translate(50%, 50%);
}
[dir='rtl'] .carina-avatar__indicator-bottom-end {
    transform: translate(-50%, 50%);
}
.carina-avatar__indicator-bottom-start {
    bottom: var(--indicator-vertical-offset);
    inset-inline-start: var(--indicator-horizontal-offset);
    transform: translate(-50%, 50%);
}
[dir='rtl'] .carina-avatar__indicator-bottom-start {
    transform: translate(50%, 50%);
}
.carina-avatar-group {
    position: relative;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-avatar-group--grid {
    display: flex;
    flex-wrap: wrap;
}
.carina-avatar-group--stacked {
    display: flex;
    width: auto;
}
.carina-avatar-group__avatar-container {
    padding: var(--carina-spacing-0);
}
.carina-avatar-group__avatar-container--grid {
    margin: var(--carina-spacing-0-5);
}
.carina-avatar-group__front-avatar {
    position: absolute;
    bottom: 0;
    left: 0;
}
.carina-avatar-group__back-avatar {
    position: absolute;
    top: 0;
    right: 0;
}
.carina-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: var(--carina-spacing-5);
    height: var(--carina-spacing-5);
    padding: 0 var(--carina-spacing-1-5);
    border-radius: var(--carina-border-radius-full);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
}
.carina-badge__indicator {
    display: inline-block;
    width: var(--carina-spacing-2-5);
    height: var(--carina-spacing-2-5);
    border-radius: var(--carina-border-radius-full);
    transform: translateY(-4px);
}
.carina-badge--danger {
    color: var(--carina-text-color-on-danger);
    background-color: var(--carina-background-color-danger);
}
.carina-badge--tertiary {
    color: var(--carina-text-color-on-tertiary);
    background-color: var(--carina-background-color-tertiary);
}
@keyframes carina-bounce {
    0%,
  50%,
  100% {
        transform: translateY(0);
    }
    25%,
  75% {
        transform: translateY(var(--carina-bounce-distance));
    }
}
.carina-text-link {
    box-sizing: border-box;
    width: auto;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    overflow: visible;
    color: var(--carina-text-color-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: inherit;
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-decoration: underline;
    text-indent: 0;
    text-shadow: none;
    background: none;
    outline: 0;
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-text-link svg {
    position: relative;
    top: -1px;
    display: inline-block;
    margin-inline-end: var(--carina-spacing-1);
    vertical-align: middle;
}
.carina-text-link:hover {
    color: var(--carina-text-color-primary-hover);
}
.carina-text-link:focus {
    outline-color: var(--carina-border-color-primary-focus);
    border-radius: var(--carina-border-radius-md);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-text-link:active {
    color: var(--carina-text-color-primary-active);
}
.carina-text-link--block {
    top: 0;
    display: inline-flex;
}
.carina-text-link--bold {
    font-weight: var(--carina-font-weight-display);
}
.carina-text-link--sm {
    font-size: var(--carina-font-size-body-2xs);
}
.carina-text-link--md {
    font-size: var(--carina-font-size-body-sm);
}
.carina-text-link--lg {
    font-size: var(--carina-font-size-body-md);
}
.carina-text-link--neutral {
    color: var(--carina-text-color-base);
}
.carina-text-link--neutral:hover {
    color: var(--carina-text-color-base);
}
.carina-text-link--neutral:active {
    color: var(--carina-text-color-base);
}
.carina-text-link--neutral:visited {
    color: var(--carina-text-color-primary-visited);
}
.carina-text-link--brand,
.carina-text-link--interactive {
    color: var(--carina-text-color-primary);
}
.carina-text-link--brand:hover, .carina-text-link--interactive:hover {
    color: var(--carina-text-color-primary-hover);
}
.carina-text-link--brand:active, .carina-text-link--interactive:active {
    color: var(--carina-text-color-primary-active);
}
.carina-text-link--brand:visited, .carina-text-link--interactive:visited {
    color: var(--carina-text-color-primary-visited);
}
.carina-text-link--warning {
    color: var(--carina-text-color-warning);
}
.carina-text-link--warning:hover {
    color: var(--carina-text-color-warning-hover);
}
.carina-text-link--warning:active {
    color: var(--carina-text-color-warning-active);
}
.carina-text-link--warning:visited {
    color: var(--carina-text-color-warning-visited);
}
.carina-text-link--danger {
    color: var(--carina-text-color-danger);
}
.carina-text-link--danger:hover {
    color: var(--carina-text-color-danger-hover);
}
.carina-text-link--danger:active {
    color: var(--carina-text-color-danger-active);
}
.carina-text-link--danger:visited {
    color: var(--carina-text-color-danger-visited);
}
.carina-text-link--accent {
    color: var(--carina-text-color-secondary);
}
.carina-text-link--accent:hover {
    color: var(--carina-text-color-secondary-hover);
}
.carina-text-link--accent:active {
    color: var(--carina-text-color-secondary-active);
}
.carina-text-link--accent:visited {
    color: var(--carina-text-color-secondary-visited);
}
.carina-text-link--tertiary {
    color: var(--carina-text-color-tertiary);
}
.carina-text-link--tertiary:hover {
    color: var(--carina-text-color-tertiary-hover);
}
.carina-text-link--tertiary:active {
    color: var(--carina-text-color-tertiary-active);
}
.carina-text-link--tertiary:visited {
    color: var(--carina-text-color-tertiary-visited);
}
.carina-text-link--success {
    color: var(--carina-text-color-success);
}
.carina-text-link--success:hover {
    color: var(--carina-text-color-success-hover);
}
.carina-text-link--success:active {
    color: var(--carina-text-color-success-active);
}
.carina-text-link--success:visited {
    color: var(--carina-text-color-success-visited);
}
.carina-text-link--icon-sm svg {
    width: var(--carina-icon-xs);
    height: var(--carina-icon-xs);
}
.carina-text-link--icon-md svg {
    width: var(--carina-icon-md);
    height: var(--carina-icon-md);
}
.carina-text-link--icon-lg svg {
    width: var(--carina-icon-lg);
    height: var(--carina-icon-lg);
}
.carina-text-link.carina-text-link--icon-end {
    text-align: right;
}
.carina-text-link.carina-text-link--icon-end svg {
    margin-inline-end: 0;
    margin-inline-start: var(--carina-spacing-1);
}
.carina-text-link--disabled {
    color: var(--carina-text-color-disabled);
    text-decoration: none;
    cursor: default;
}
.carina-text-link--disabled[aria-disabled]:focus {
    outline-color: var(--carina-text-color-disabled);
}
.carina-text-link--disabled:hover,
  .carina-text-link--disabled:focus,
  .carina-text-link--disabled:active {
    color: var(--carina-text-color-disabled);
    text-decoration: none;
    cursor: default;
}
.carina-truncating-list {
    display: flex;
}
.carina-truncating-list__item--truncated {
    position: absolute;
    visibility: hidden;
}
.carina-breadcrumbs__breadcrumb,
.carina-breadcrumbs__breadcrumb-list-item {
    display: none;
    align-items: center;
    box-sizing: border-box;
    height: var(--carina-spacing-5);
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0-5) var(--carina-spacing-0);
    font-family: var(--carina-font-family-body);
}
.carina-breadcrumbs__breadcrumb--expanded,
.carina-breadcrumbs__breadcrumb-list-item--expanded {
    display: inline-flex;
}
.carina-breadcrumbs__breadcrumb--mobile,
.carina-breadcrumbs__breadcrumb-list-item--mobile {
    display: inline-flex;
}
.carina-breadcrumbs__breadcrumb--hidden-mobile,
.carina-breadcrumbs__breadcrumb-list-item--hidden-mobile {
    display: none;
}
.carina-breadcrumbs__breadcrumb-content {
    display: flex;
    box-sizing: border-box;
    max-width: 200px;
    margin: var(--carina-spacing-0);
    margin-inline-end: var(--carina-spacing-1);
    border: var(--carina-border-width-2) solid transparent;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: default;
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: text-decoration, outline-color;
    transition-property: text-decoration, outline-color, -webkit-text-decoration;
}
.carina-breadcrumbs__breadcrumb-content:focus-within {
    text-decoration: underline;
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-breadcrumbs__breadcrumb-content a:focus {
    outline: 0;
}
.carina-breadcrumbs__breadcrumb-content > * {
    vertical-align: baseline;
}
.carina-breadcrumbs__breadcrumb-content .carina-breadcrumbs__breadcrumb {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.carina-breadcrumbs__breadcrumb-icon {
    width: 16px;
    height: 16px;
    margin-top: 0;
    margin-right: var(--carina-spacing-0-5);
    margin-bottom: 0;
    margin-left: var(--carina-spacing-0-5);
    color: var(--carina-text-color-soft);
}
[dir='rtl'] .carina-breadcrumbs__breadcrumb-icon {
    transform: rotate(var(--carina-rotate-180));
}
.carina-breadcrumbs__breadcrumb--current,
.carina-breadcrumbs__breadcrumb-list-item--current {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
    text-decoration: none;
}
.carina-breadcrumbs__breadcrumb--current .carina-breadcrumbs__breadcrumb-content, .carina-breadcrumbs__breadcrumb-list-item--current .carina-breadcrumbs__breadcrumb-content {
    margin-inline-end: var(--carina-spacing-0);
}
.carina-breadcrumbs__breadcrumb--collapsed,
.carina-breadcrumbs__breadcrumb-list-item--collapsed {
    margin: 0;
    transform: translateY(4px);
}
.carina-breadcrumbs__breadcrumb-content--collapsed {
    width: 16px;
    height: 16px;
    margin-top: 0;
    margin-right: var(--carina-spacing-0-5);
    margin-bottom: 0;
    margin-left: var(--carina-spacing-0-5);
    border: none;
    color: var(--carina-text-color-primary);
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: text-decoration, outline-color;
    transition-property: text-decoration, outline-color, -webkit-text-decoration;
    border-radius: var(--carina-border-radius-md);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
}
.carina-breadcrumbs__breadcrumb-content--collapsed:active {
    color: var(--carina-text-color-primary-active);
}
.carina-breadcrumbs__breadcrumb-content--collapsed:focus {
    color: var(--carina-text-color-primary);
    text-decoration: underline;
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-breadcrumbs__breadcrumb-content--collapsed:hover {
    color: var(--carina-text-color-primary-hover);
}
.carina-breadcrumbs {
    text-wrap: nowrap;
    margin-top: var(--carina-spacing-1);
    margin-bottom: var(--carina-spacing-1);
    padding: 0;
    line-height: var(--carina-line-height-body-2xs);
    font-size: var(--carina-font-size-body-2xs);
    list-style-type: none;
    background: transparent;
}
.carina-breadcrumbs--user_expanded {
    width: 100%;
    text-wrap: wrap;
}
.carina-popper {
    border-radius: var(--carina-border-radius-md);
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background-color: var(--carina-background-color-surface);
}
.carina-popper__container {
    z-index: var(--carina-z-index-scope, var(--carina-z-index-popper));
}
.carina-popper--shadow {
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-popper__arrow::after,
.carina-popper__arrow::before {
    position: absolute;
    top: 1px;
    left: 0;
    border-style: solid;
    border-color: var(--carina-border-color-soft) var(--carina-border-color-soft)
    transparent transparent;
    transform: rotate(var(--carina-rotate-negative-45)) translate(-50%, -50%);
    transform-origin: 0 0;
    content: '';
}
.carina-popper__arrow::after {
    border-width: calc(
    var(--carina-border-width-4) + var(--carina-border-width-1)
  );
}
.carina-popper__arrow::before {
    border-color: var(--carina-background-color-popper)
    var(--carina-background-color-popper) transparent transparent;
    border-width: var(--carina-border-width-4);
    z-index: 1;
}
.carina-popper__arrow--top {
    bottom: 0;
}
.carina-popper__arrow--top::before,
  .carina-popper__arrow--top::after {
    top: -1px;
}
.carina-popper__arrow--top::before {
    border-color: transparent transparent var(--carina-background-color-popper)
      var(--carina-background-color-popper);
}
.carina-popper__arrow--top::after {
    border-color: transparent transparent var(--carina-border-color-soft)
      var(--carina-border-color-soft);
}
.carina-popper__arrow--end {
    left: 0;
}
.carina-popper__arrow--end::before,
  .carina-popper__arrow--end::after {
    left: 1px;
}
.carina-popper__arrow--end::before {
    border-color: var(--carina-background-color-popper) transparent transparent
      var(--carina-background-color-popper);
}
.carina-popper__arrow--end::after {
    border-color: var(--carina-border-color-soft) transparent transparent
      var(--carina-border-color-soft);
}
.carina-popper__arrow--bottom {
    top: 0;
}
.carina-popper__arrow--bottom::before {
    border-color: var(--carina-background-color-popper)
      var(--carina-background-color-popper) transparent transparent;
}
.carina-popper__arrow--bottom::after {
    border-color: var(--carina-border-color-soft)
      var(--carina-border-color-soft) transparent transparent;
}
.carina-popper__arrow--start {
    right: 0;
}
.carina-popper__arrow--start::before,
  .carina-popper__arrow--start::after {
    left: -1px;
}
.carina-popper__arrow--start::before {
    border-color: transparent var(--carina-background-color-popper)
      var(--carina-background-color-popper) transparent;
}
.carina-popper__arrow--start::after {
    border-color: transparent var(--carina-border-color-soft)
      var(--carina-border-color-soft) transparent;
}
.carina-popper__arrow--top.carina-popper__arrow--shadow::before {
    box-shadow: -6px 6px 6px 0 rgb(0 0 0 / 4%);
}
.carina-popper__arrow--end.carina-popper__arrow--shadow::before {
    box-shadow: -6px -6px 6px 0 rgb(0 0 0 / 4%);
}
.carina-popper__arrow--bottom.carina-popper__arrow--shadow::before {
    box-shadow: 6px -6px 6px 0 rgb(0 0 0 / 4%);
}
.carina-popper__arrow--start.carina-popper__arrow--shadow::before {
    box-shadow: 6px 6px 6px 0 rgb(0 0 0 / 4%);
}
.carina-popper__arrow--medium::before {
    border-width: 7px;
}
.carina-popper__arrow--medium::after {
    border-width: 8px;
}
.carina-popper__arrow--large::before {
    border-width: 11px;
}
.carina-popper__arrow--large::after {
    border-width: 12px;
}
.carina-popper__backup-arrow {
    position: absolute;
    visibility: hidden;
}
.carina-popper__transition {
    transform: translate(
    var(--carina-transition-translate-x),
    var(--carina-transition-translate-y)
  );
    transition-delay: var(--carina-transition-delay-50);
}
.carina-popper__transition.carina-transition--out {
    --carina-transition-opacity: 0;
}
.carina-popper__transition--disabled {
    --carina-transition-opacity: 0;
    transition-property: none;
}
.carina-visually-hidden-element {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-visually-hidden-element--focus:focus,
    .carina-visually-hidden-element--focus:active {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
}
.carina-tooltip__popper {
    max-width: 282px;
    padding: var(--carina-spacing-2);
    color: var(--carina-text-color-base-inverse);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-body-3xs);
    box-shadow: var(--carina-box-shadow-lg);
    pointer-events: none;
    word-break: break-word;
    background-color: var(--carina-background-color-surface-inverse);
    border: none;
}
.carina-tooltip__arrow::before {
    border-color: var(--carina-background-color-surface-inverse);
}
.carina-tooltip__arrow::after {
    border-color: transparent;
}
.carina-magazine {
    position: absolute;
    z-index: calc(
    var(--carina-z-index-current) + var(--carina-z-index-popper-diff)
  );
    display: block;
    box-sizing: border-box;
    width: -moz-max-content;
    width: max-content;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-md);
    overflow: auto;
    text-align: left;
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-popper);
    outline: none;
    box-shadow: var(--carina-box-shadow-lg);
}
[dir='rtl'] .carina-magazine {
    text-align: right;
}
.carina-magazine-option__label-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.carina-magazine-option__label-row svg {
    margin: auto;
}
.carina-magazine-option__label-container {
    display: flex;
    align-items: flex-start;
}
.carina-magazine-option__label-check {
    display: flex;
    align-items: center;
}
.carina-magazine-option__label-check-icon {
    color: var(--carina-text-color-base);
}
.carina-magazine-option__list-item {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.carina-magazine-option__line-break {
    width: 100%;
    margin-top: var(--carina-spacing-2);
    margin-bottom: var(--carina-spacing-2);
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
}
.carina-magazine-option {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    box-sizing: border-box;
    margin: var(--carina-spacing-0) var(--carina-spacing-2);
    padding: var(--carina-spacing-2);
    border: var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-align: left;
    text-transform: none;
    text-indent: var(--carina-spacing-0);
    text-shadow: none;
    outline: var(--carina-spacing-0);
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    word-break: break-word;
}
[dir='rtl'] .carina-magazine-option {
    text-align: right;
}
.carina-magazine-option:-moz-focus-inner {
    border: var(--carina-border-width-0);
}
.carina-magazine-option:focus-visible.carina-magazine-option--focused:not(.carina-magazine-option--selected):not(
      .carina-magazine-option--disabled
    ):not(.carina-magazine-option--heading):not(.carina-magazine-option--destructive):not(
      .carina-magazine-option__secondary-label-container
    ) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
    box-shadow: var(--carina-ring-black) inset;
}
.carina-magazine-option:focus-visible.carina-magazine-option--focused:not(.carina-magazine-option--selected):not(
      .carina-magazine-option--disabled
    ):not(.carina-magazine-option--heading):not(.carina-magazine-option--destructive):not(
      .carina-magazine-option__secondary-label-container
    ) li {
    color: var(--carina-text-color-base);
}
.carina-magazine-option li {
    color: var(--carina-text-color-base);
}
.carina-magazine-option div span {
    color: var(--carina-text-color-base);
}
.carina-magazine-option:hover:not(.carina-magazine-option--selected):not(.carina-magazine-option--disabled):not(
      .carina-magazine-option--destructive
    ):not(.carina-magazine-option--heading):not(.carina-magazine-option__secondary-label-container) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-magazine-option:hover:not(.carina-magazine-option--selected):not(.carina-magazine-option--disabled):not(
      .carina-magazine-option--destructive
    ):not(.carina-magazine-option--heading):not(.carina-magazine-option__secondary-label-container) li {
    color: var(--carina-text-color-base);
    outline: none;
}
.carina-magazine-option:hover:not(.carina-magazine-option--selected):not(.carina-magazine-option--disabled):not(
      .carina-magazine-option--destructive
    ):not(.carina-magazine-option--heading):not(.carina-magazine-option__secondary-label-container) div span {
    color: var(--carina-text-color-base);
}
.carina-magazine-option:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-magazine-option.carina-magazine-option--heading {
    min-height: 20px;
    margin-top: var(--carina-spacing-2-5);
    margin-bottom: var(--carina-spacing-1-5);
    padding-top: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-radius: var(--carina-border-radius-none);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-2xs);
    text-transform: uppercase;
    cursor: default;
}
.carina-magazine-option.carina-magazine-option--heading[role='separator']:not(:first-of-type) {
    width: 100%;
    height: 100%;
    margin-top: var(--carina-spacing-3);
    margin-inline: var(--carina-spacing-0);
    padding: var(--carina-spacing-2-5) var(--carina-spacing-4)
      var(--carina-spacing-0);
}
.carina-magazine-option--heading:hover,
  .carina-magazine-option--heading:focus,
  .carina-magazine-option--heading:active,
  .carina-magazine-option--disabled:hover,
  .carina-magazine-option--disabled:focus,
  .carina-magazine-option--disabled:active {
    background-color: unset;
}
.carina-magazine-option__secondary-label-container {
    padding-inline-start: var(--carina-spacing-0);
}
.carina-magazine-option__secondary-label-container li {
    float: left;
    margin-top: var(--carina-spacing-2);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    list-style: none;
    list-style-type: disc;
    margin-inline-start: var(--carina-spacing-2);
}
.carina-magazine-option__secondary-label-container li::before {
    margin-inline-end: var(--carina-spacing-2);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    vertical-align: middle;
    content: '\\00b7';
}
.carina-magazine-option__secondary-label-container li:first-of-type {
    margin-inline-start: var(--carina-spacing-0);
}
.carina-magazine-option__secondary-label-container li:first-of-type::before {
    content: none;
}
[dir='rtl'] .carina-magazine-option__secondary-label-container li {
    float: right;
}
.carina-magazine-option.carina-magazine-option--selected {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-selected);
}
.carina-magazine-option.carina-magazine-option--selected:focus-visible {
    box-shadow: var(--carina-ring-black) inset;
}
.carina-magazine-option.carina-magazine-option--focused:not(.carina-magazine-option--heading):not(.carina-magazine-option--disabled):not(
    .carina-magazine-option--destructive
  ):not(.carina-magazine-option--selected) li {
    color: var(--carina-text-color-base);
    outline: none;
}
.carina-magazine-option.carina-magazine-option--focused:not(.carina-magazine-option--heading):not(.carina-magazine-option--disabled):not(
    .carina-magazine-option--destructive
  ):not(.carina-magazine-option--selected) div span {
    color: var(--carina-text-color-base);
}
.carina-magazine-option.carina-magazine-option--focused:not(.carina-magazine-option--heading):not(.carina-magazine-option--disabled):not(
    .carina-magazine-option--destructive
  ):not(.carina-magazine-option--selected):focus-visible {
    box-shadow: var(--carina-ring-black) inset;
}
.carina-magazine-option--destructive {
    color: var(--carina-text-color-danger);
}
.carina-magazine-option--destructive:focus-visible.carina-magazine-option--focused {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale);
}
.carina-magazine-option--destructive:focus-visible {
    box-shadow: var(--carina-ring-danger) inset;
}
.carina-magazine-option--destructive:focus:not(.carina-magazine-option--disabled),
  .carina-magazine-option--destructive:hover:not(.carina-magazine-option--disabled) {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale);
}
.carina-magazine-option--destructive:active {
    color: var(--carina-text-color-on-danger-pale);
    background-color: var(--carina-background-color-danger-pale-hover);
}
.carina-magazine-option--disabled {
    color: var(--carina-text-color-disabled);
    cursor: default;
    opacity: var(--carina-opacity-50);
}
.carina-magazine-option--disabled:hover,
  .carina-magazine-option--disabled:focus {
    background-color: var(--carina-background-color-surface);
}
.carina-magazine-option--disabled.carina-magazine-option--destructive {
    color: var(--carina-text-color-danger);
}
.carina-magazine-option.carina-magazine-option--first-option {
    border-top: var(--carina-border-width-0);
}
.carina-magazine-option--selected:not(.carina-magazine-option--focused) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-menu__magazine {
    position: relative;
    width: -moz-max-content;
    width: max-content;
    min-width: 176px;
    max-width: 18rem;
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
}
.carina-bulk-action-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 56px;
    border-radius: var(--carina-border-radius-xl);
    container-type: inline-size;
    color: var(--carina-text-color-base-inverse);
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-surface-inverse);
    box-shadow: var(--carina-box-shadow-none);
}
.carina-bulk-action-bar__label {
    box-sizing: border-box;
    width: -moz-fit-content;
    width: fit-content;
    padding: var(--carina-spacing-4) var(--carina-spacing-3)
    var(--carina-spacing-4) var(--carina-spacing-6);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
[dir='rtl'] .carina-bulk-action-bar__label {
    padding-right: var(--carina-spacing-6);
    padding-left: var(--carina-spacing-3);
}
.carina-bulk-action-bar__dismiss {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 56px;
    height: 100%;
    border-inline-start: var(--carina-spacing-px) solid
    var(--carina-border-color-inverse);
}
.carina-bulk-action-bar__dismiss :hover {
    cursor: pointer;
}
.carina-bulk-action-bar__actions {
    display: none;
    flex-grow: 1;
    flex-shrink: 100;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    height: 100%;
    margin: 0 var(--carina-spacing-2);
    padding: var(--carina-spacing-2) 0;
}
.carina-bulk-action-bar__actions--small {
    display: flex;
}
.carina-bulk-action-bar__menu {
    position: absolute;
    padding: 0 var(--carina-spacing-1);
    visibility: hidden;
}
.carina-bulk-action-bar__menu--visible {
    position: static;
    visibility: visible;
}
.carina-bulk-action-bar__menu-action {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.carina-bulk-action-bar__action-value {
    margin-inline-start: var(--carina-spacing-4);
}
.carina-button-group {
    display: flex;
}
.carina-button-group__item {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 40px;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-4);
    border: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-surface);
    cursor: pointer;
    margin-inline-start: calc(-1 * var(--carina-spacing-px));
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
}
.carina-button-group__item:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    z-index: calc(var(--carina-z-index-current) + 2);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-button-group__item--small {
    min-width: 96px;
    height: 32px;
    font-size: var(--carina-font-size-body-sm);
}
.carina-button-group__item--large {
    min-width: 128px;
    height: 44px;
}
.carina-button-group__item--disabled {
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-button-group__item:not(.carina-button-group__item--disabled):not(.carina-button-group__item--selected):not(
    .carina-button-group__item:active
  ):hover {
    color: var(--carina-text-color-base);
    background: var(--carina-background-color-surface-hover);
}
.carina-button-group__item:active:not(.carina-button-group__item--disabled),
.carina-button-group__item--selected,
.carina-button-group__item--selected:focus,
.carina-button-group__item--selected:hover {
    color: var(--carina-text-color-on-primary);
    background: var(--carina-background-color-primary);
    cursor: default;
}
.carina-button-group__item--selected {
    border: var(--carina-border-width-1) solid
    var(--carina-border-color-primary-focus);
    z-index: calc(var(--carina-z-index-current) + 1);
}
.carina-button-group__item--first {
    margin-inline-start: var(--carina-spacing-0);
    border-start-start-radius: var(--carina-spacing-2-5);
    border-end-start-radius: var(--carina-spacing-2-5);
}
.carina-button-group__item--last {
    border-start-end-radius: var(--carina-spacing-2-5);
    border-end-end-radius: var(--carina-spacing-2-5);
}
.carina-button-group__item--auto-width,
.carina-button-group__item--icon-only {
    min-width: unset;
}
.carina-button-group__item--icon-only {
    padding: var(--carina-spacing-2);
}
.carina-button-group__item-icon {
    display: flex;
    align-content: center;
    justify-content: center;
}
.carina-button-group__item-icon--start {
    padding-inline-end: var(--carina-spacing-2);
}
.carina-button-group__item-icon--end {
    padding-inline-start: var(--carina-spacing-2);
}
.carina-button-group__item-icon--icon-only {
    padding: var(--carina-spacing-0);
}
.carina-card__body {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-width: 0;
}
.carina-card__body--horizontal {
    flex: 1 0 50%;
}
.carina-card__body--vertical {
    flex: 1 0 40%;
    min-height: calc(var(--card-height, 500px) * 0.4);
}
.carina-card__container {
    display: flex;
    width: var(--card-width, 500px);
    max-height: var(--card-height, 500px);
    border-radius: var(--carina-border-radius-xl);
    overflow: hidden;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-family: var(--carina-font-family-primary);
    direction: ltr;
    background-color: var(--carina-background-color-surface);
}
[dir='rtl'] .carina-card__container {
    direction: rtl;
}
.carina-card__container--border {
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
}
.carina-card__container--horizontal {
    flex-direction: row;
}
[dir='rtl'] .carina-card__container--horizontal {
    direction: rtl;
}
.carina-card__container--horizontal.carina-card__container--responsive {
    width: 100%;
}
.carina-card__container--vertical {
    flex-wrap: wrap;
}
.carina-card__container--vertical.carina-card__container--responsive {
    width: 100%;
    height: 100%;
}
.carina-card__container--vertical.carina-card__container--fixed-width {
    height: 100%;
}
.carina-card__container--shadow-none {
    box-shadow: var(--carina-box-shadow-none);
}
.carina-card__container--shadow-md {
    box-shadow: var(--carina-box-shadow-md);
}
.carina-card__container--shadow-lg {
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-card__container--shadow-xl {
    box-shadow: var(--carina-box-shadow-xl);
}
.carina-card__container--shadow-2xl {
    box-shadow: var(--carina-box-shadow-2xl);
}
.carina-card__endcap {
    display: flex;
}
.carina-card__endcap--header {
    align-items: center;
    justify-content: center;
}
.carina-card__endcap--header.carina-card__endcap--horizontal {
    flex: 0 0 20%;
}
.carina-card__endcap--header.carina-card__endcap--vertical {
    width: 100%;
    min-height: calc(var(--card-height, 500px) * 0.4);
}
.carina-card__endcap--footer.carina-card__endcap--horizontal {
    align-items: flex-start;
    justify-content: center;
}
.carina-card__endcap--footer.carina-card__endcap--vertical {
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-height: 10%;
}
.carina-card__image {
    position: relative;
    padding: 0;
    overflow: hidden;
}
.carina-card__image--full {
    width: 100%;
    height: 100%;
}
.carina-card__image--padded {
    width: 80%;
    height: 80%;
}
.carina-card__image-canvas {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
}
.carina-carousel {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
}
.carina-carousel--show-overhang {
    padding: var(--carina-spacing-0)
    calc(var(--carina-spacing-4) + (0.5 * var(--carina-spacing-1)));
}
.carina-carousel__container {
    position: relative;
    padding: var(--carina-spacing-0) 0.4rem;
}
.carina-carousel__container--inset-controls {
    padding: var(--carina-spacing-0);
}
.carina-carousel--lg-dots {
    --carina-carousel-dot-size: 16px;
    --carina-carousel-dot-padding: 24px;
}
.carina-carousel--md-dots {
    --carina-carousel-dot-size: 12px;
    --carina-carousel-dot-padding: 20px;
}
.carina-carousel__control {
    position: absolute;
    top: calc(50% - 24px);
    z-index: var(--carina-z-index-10);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    padding: var(--carina-spacing-0-5);
    border: 0;
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-soft);
    line-height: 36px;
    text-align: center;
    background: var(--carina-background-color-surface);
    box-shadow: color-mix(
  in srgb,
  #000 calc(var(--carina-opacity-25) * 100%),
  transparent
) 0 var(--carina-spacing-1)
  var(--carina-spacing-2) calc(-1 * var(--carina-spacing-1));
    transform: translateY(-50%);
    transform-origin: 50% 50%;
    cursor: pointer;
    opacity: var(--carina-opacity-0);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-property: transform, box-shadow, outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: calc(-1 * var(--carina-border-width-4));
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
}
.carina-carousel__control:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
    transition-property: transform, box-shadow, outline-color;
}
.carina-carousel__control:active {
    transform: translateY(-50%) scale(1.03);
}
.carina-carousel__control--previous {
    inset-inline-start: 0;
}
[dir='rtl'] .carina-carousel__control--previous {
    box-shadow: color-mix(
  in srgb,
  #000 calc(var(--carina-opacity-25) * 100%),
  transparent
) 0 calc(-1 * var(--carina-spacing-1))
  var(--carina-spacing-2) calc(-1 * var(--carina-spacing-1));
    transform: rotate(180deg) translateY(50%);
    transform-origin: 50% 50%;
}
.carina-carousel__control--next {
    inset-inline-end: 0;
}
[dir='rtl'] .carina-carousel__control--next {
    box-shadow: color-mix(
  in srgb,
  #000 calc(var(--carina-opacity-25) * 100%),
  transparent
) 0 calc(-1 * var(--carina-spacing-1))
  var(--carina-spacing-2) calc(-1 * var(--carina-spacing-1));
    transform: rotate(180deg) translateY(50%);
    transform-origin: 50% 50%;
}
.carina-carousel__control--inset {
    width: 24px;
    height: 24px;
}
.carina-carousel__control--previous.carina-carousel__control--inset {
    inset-inline-start: calc(var(--carina-spacing-1));
}
.carina-carousel__control--next.carina-carousel__control--inset {
    inset-inline-end: calc(var(--carina-spacing-1));
}
.carina-carousel__dot {
    position: absolute;
    width: var(--carina-carousel-dot-size);
    height: var(--carina-carousel-dot-size);
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    border: 0;
    border-radius: var(--carina-border-radius-full);
    text-decoration: none;
    background: var(--carina-background-color-neutral);
    transform-origin: 50% 50%;
    cursor: pointer;
    transition: transform var(--carina-transition-duration-400)
      var(--carina-transition-timing-function-productive-ease-in-out),
    opacity var(--carina-transition-duration-400)
      var(--carina-transition-timing-function-productive-ease-in-out),
    box-shadow var(--carina-transition-duration-100)
      var(--carina-transition-timing-function-productive-ease-in-out);
}
.carina-carousel__dot--active {
    background: var(--carina-background-color-surface-inverse);
    cursor: default;
}
.carina-carousel__dot--hidden {
    opacity: var(--carina-opacity-0);
}
.carina-carousel__dots {
    position: relative;
    margin: var(--carina-spacing-4) auto 0;
    background: var(--carina-background-color-surface);
    padding: var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-2xl);
    width: calc(
    var(--carina-carousel-dot-padding) * var(--carina-carousel-visible-dots) +
      16px
  );
    height: calc(var(--carina-carousel-dot-size) + 2 * var(--carina-spacing-2));
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
}
.carina-carousel__dots:focus-visible {
    transition-duration: var(--carina-transition-duration-100);
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-carousel__dots--hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    white-space: nowrap;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
}
.carina-carousel__dots--1 {
    --carina-carousel-visible-dots: 1;
}
.carina-carousel__dots--2 {
    --carina-carousel-visible-dots: 2;
}
.carina-carousel__dots--3 {
    --carina-carousel-visible-dots: 3;
}
.carina-carousel__dots--4 {
    --carina-carousel-visible-dots: 4;
}
.carina-carousel__dots--5 {
    --carina-carousel-visible-dots: 5;
}
.carina-carousel__numbers {
    position: absolute;
    top: var(--carina-spacing-4);
    inset-inline-start: var(--carina-spacing-8);
    padding: calc(2 * var(--carina-spacing-px)) var(--carina-spacing-2);
    border-radius: calc(
    var(--carina-border-radius-sm) + var(--carina-border-radius-lg)
  );
    color: var(--carina-text-color-base-inverse);
    background: color-mix(
    in srgb,
    var(--carina-background-color-surface-inverse)
      calc(var(--carina-opacity-80) * 100%),
    transparent
  );
    pointer-events: none;
}
.carina-carousel__numbers--inset {
    top: var(--carina-spacing-2);
    inset-inline-start: var(--carina-spacing-2);
}
.carina-carousel__slide {
    flex: 0 0 100%;
    box-sizing: border-box;
    padding: var(--carina-spacing-0) calc(6 * var(--carina-spacing-px));
    overflow: hidden;
}
.carina-carousel__slide > * {
    border-radius: var(--carina-border-radius-xl);
}
.carina-carousel__slide > * > img {
    border-radius: var(--carina-border-radius-xl);
}
.carina-carousel__slide--inset {
    padding: var(--carina-spacing-0);
}
.carina-carousel__slide--hidden {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    pointer-events: none;
}
.carina-carousel__slide--1-cols {
    flex-basis: calc(100% / 1);
    width: calc(100% / 1);
    max-width: calc(100% / 1);
}
.carina-carousel__slide--2-cols {
    flex-basis: calc(100% / 2);
    width: calc(100% / 2);
    max-width: calc(100% / 2);
}
.carina-carousel__slide--3-cols {
    flex-basis: calc(100% / 3);
    width: calc(100% / 3);
    max-width: calc(100% / 3);
}
.carina-carousel__slide--4-cols {
    flex-basis: calc(100% / 4);
    width: calc(100% / 4);
    max-width: calc(100% / 4);
}
.carina-carousel__slide--5-cols {
    flex-basis: calc(100% / 5);
    width: calc(100% / 5);
    max-width: calc(100% / 5);
}
.carina-carousel__slide--6-cols {
    flex-basis: calc(100% / 6);
    width: calc(100% / 6);
    max-width: calc(100% / 6);
}
.carina-carousel__slide--7-cols {
    flex-basis: calc(100% / 7);
    width: calc(100% / 7);
    max-width: calc(100% / 7);
}
.carina-carousel__slide--8-cols {
    flex-basis: calc(100% / 8);
    width: calc(100% / 8);
    max-width: calc(100% / 8);
}
.carina-carousel__slide--9-cols {
    flex-basis: calc(100% / 9);
    width: calc(100% / 9);
    max-width: calc(100% / 9);
}
.carina-carousel__slide--10-cols {
    flex-basis: calc(100% / 10);
    width: calc(100% / 10);
    max-width: calc(100% / 10);
}
.carina-carousel__slide--11-cols {
    flex-basis: calc(100% / 11);
    width: calc(100% / 11);
    max-width: calc(100% / 11);
}
.carina-carousel__slide--12-cols {
    flex-basis: calc(100% / 12);
    width: calc(100% / 12);
    max-width: calc(100% / 12);
}
.carina-carousel__slider-wrapper {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
}
.carina-carousel__slider-wrapper--show-overhang {
    padding: var(--carina-spacing-0) calc(50 * var(--carina-spacing-px));
}
.carina-carousel__slider {
    display: flex;
    align-items: stretch;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    list-style: none;
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-400);
    transition-property: transform;
}
.carina-carousel__slider--touching {
    transition-duration: calc(0 * var(--carina-transition-duration-50));
}
.carina-checkbox {
    position: absolute;
    margin: var(--carina-spacing-0);
    cursor: pointer;
    opacity: var(--carina-opacity-0);
}
.carina-checkbox + div {
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-property: outline-color;
}
.carina-checkbox:focus-visible + div {
    transition-duration: var(--carina-transition-duration-100);
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-checkbox--error:focus-visible + div {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-checkbox__box {
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    align-self: flex-start;
    justify-content: center;
    width: var(--carina-spacing-4);
    height: var(--carina-spacing-4);
    box-sizing: border-box;
    margin-right: var(--carina-spacing-2);
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-sm);
    background-color: var(--carina-colors-transparent);
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: border-color, box-shadow;
}
[dir='rtl'] .carina-checkbox__box {
    margin-right: var(--carina-spacing-0);
    margin-left: var(--carina-spacing-2);
}
.carina-checkbox__box--read-only {
    color: var(--carina-text-color-base);
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-checkbox__box--read-only:focus {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-checkbox__box--read-only:hover {
    cursor: default;
}
.carina-checkbox__box--checked {
    border-color: var(--carina-border-color-primary);
    background-color: var(--carina-background-color-primary);
}
.carina-checkbox__box--error {
    border-color: var(--carina-border-color-danger);
}
.carina-checkbox__box--checked.carina-checkbox__box--error {
    background-color: var(--carina-background-color-danger);
}
.carina-checkbox__box--disabled,
.carina-checkbox__box--disabled.carina-checkbox__box--error {
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-neutral-inactive);
    cursor: default;
}
.carina-checkbox__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: var(--carina-spacing-4);
    height: var(--carina-spacing-4);
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    pointer-events: none;
    fill: var(--carina-text-color-on-primary);
}
.carina-checkbox__box--error.carina-checkbox__icon {
    fill: var(--carina-text-color-on-danger);
}
.carina-checkbox__icon--disabled {
    fill: var(--carina-text-color-disabled);
}
.carina-checkbox__indeterminate-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: var(--carina-spacing-4);
    height: var(--carina-spacing-4);
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    fill: var(--carina-text-color-on-primary);
}
.carina-checkbox__indeterminate-icon--disabled {
    fill: var(--carina-text-color-disabled);
}
.carina-checkbox__label {
    display: flex;
    align-items: center;
    min-height: var(--carina-spacing-4);
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    padding-right: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-tight);
    text-indent: 0;
    text-shadow: none;
    cursor: pointer;
}
[dir='rtl'] .carina-checkbox__label {
    padding-right: var(--carina-spacing-0);
    padding-left: var(--carina-spacing-4);
}
.carina-checkbox__label--disabled {
    color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-label {
    position: relative;
    display: block;
    margin: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-spacing-1);
    padding: var(--carina-spacing-0);
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    vertical-align: top;
}
.carina-label,
.carina-label__abbr {
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-label--hidden {
    position: absolute;
    width: var(--carina-spacing-px);
    height: var(--carina-spacing-px);
    overflow: hidden;
    white-space: nowrap;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
}
.carina-label--underline,
.carina-label--outline {
    overflow: hidden;
    left: var(--carina-spacing-0);
}
.carina-label--underline,
.carina-label--outline,
.carina-label--grid {
    position: absolute;
    max-width: calc(100% - var(--carina-spacing-8));
    font-size: var(--carina-font-size-body-md);
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: top var(--carina-transition-duration-100) ease
      calc(0 * var(--carina-transition-duration-100)),
    font-size var(--carina-transition-duration-100) ease
      calc(0 * var(--carina-transition-duration-100)),
    padding-left var(--carina-transition-duration-100) ease
      calc(0 * var(--carina-transition-duration-100));
    padding-inline-start: var(--carina-spacing-4);
}
[dir='rtl'] .carina-label--underline, [dir='rtl'] .carina-label--outline, [dir='rtl'] .carina-label--grid {
    right: var(--carina-spacing-0);
    left: unset;
    transition: top var(--carina-transition-duration-100) ease
        calc(0 * var(--carina-transition-duration-100)),
      font-size var(--carina-transition-duration-100) ease
        calc(0 * var(--carina-transition-duration-100)),
      padding-right var(--carina-transition-duration-100) ease
        calc(0 * var(--carina-transition-duration-100));
}
.carina-label--grid {
    top: var(--carina-spacing-0-5);
    padding-inline-start: var(--carina-spacing-2);
}
.carina-label--outline,
.carina-label--underline {
    top: calc(var(--carina-spacing-2-5) - var(--carina-spacing-px));
}
.carina-label--animated {
    font-size: var(--carina-font-size-body-sm);
}
.carina-label--animated.carina-label--underline,
.carina-label--animated.carina-label--outline {
    top: calc(-1 * var(--carina-spacing-2-5));
}
.carina-label--icon.carina-label--underline,
.carina-label--icon.carina-label--outline {
    padding-inline-start: var(--carina-spacing-11);
}
.carina-label--icon.carina-label--required.carina-label--underline,
.carina-label--icon.carina-label--required.carina-label--outline {
    padding-inline-start: calc(
    var(--carina-spacing-12) + var(--carina-spacing-1)
  );
}
.carina-label--end-icon.carina-label--underline,
.carina-label--end-icon.carina-label--outline {
    max-width: calc(100% - var(--carina-spacing-8) - var(--carina-spacing-5));
}
.carina-label--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-label__abbr {
    position: absolute;
    inset-inline-start: calc(-1 * var(--carina-spacing-2-5));
    color: var(--carina-text-color-danger);
    font-size: var(--carina-font-size-body-xl);
    text-decoration: none;
    top: calc(-1 * var(--carina-spacing-0-5));
    transition: left var(--carina-transition-duration-100) ease
    calc(0 * var(--carina-transition-duration-100));
}
[dir='rtl'] .carina-label__abbr {
    transition: right var(--carina-transition-duration-100) ease
      calc(0 * var(--carina-transition-duration-100));
}
.carina-label__abbr--grid {
    line-height: var(--carina-line-height-none);
    left: calc(-1 * var(--carina-spacing-2));
}
.carina-label__abbr--underline,
.carina-label__abbr--outline {
    inset-inline-start: var(--carina-spacing-2);
    font-size: var(--carina-font-size-body-sm);
}
.carina-label__abbr--icon.carina-label__abbr--underline,
.carina-label__abbr--icon.carina-label__abbr--outline {
    inset-inline-start: var(--carina-spacing-11);
}
.carina-helper-text {
    display: block;
    margin: var(--carina-spacing-1) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xs);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    vertical-align: top;
}
.carina-helper-text > svg {
    position: relative;
    top: -1px;
    display: inline;
    vertical-align: middle;
    margin-inline-end: var(--carina-spacing-1);
}
.carina-helper-text--error {
    color: var(--carina-text-color-danger);
}
.carina-helper-text--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-helper-text--grid {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-checkbox-group {
    clear: both;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0;
    color: var(--carina-text-color-base);
    text-align: left;
    list-style-type: none;
    outline: 0;
}
[dir='rtl'] .carina-checkbox-group {
    text-align: right;
}
.carina-checkbox-group--horizontal > label {
    display: inline-flex;
    padding-right: var(--carina-spacing-6);
}
[dir='rtl'] .carina-checkbox-group--horizontal > label {
    padding-right: var(--carina-spacing-0);
    padding-left: var(--carina-spacing-6);
}
.carina-checkbox-group__container {
    display: inline-block;
}
.carina-input-fieldset {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-md);
    overflow: hidden;
    background: transparent;
    pointer-events: none;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: border-color, outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-input-fieldset--default.carina-input-fieldset--label {
    bottom: 0;
}
.carina-input-fieldset--grid {
    top: 0;
    inset-inline-start: 0;
    border-style: dashed;
    border-width: var(--carina-border-width-0) var(--carina-border-width-0)
    var(--carina-border-width-1) var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-none);
}
.carina-input-fieldset--outline {
    top: calc(-1 * var(--carina-spacing-2-5));
}
.carina-input-fieldset--underline {
    top: calc(-1 * var(--carina-spacing-2-5));
    border-width: var(--carina-border-width-0) var(--carina-border-width-0)
    var(--carina-border-width-1) var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-none);
}
.carina-input-fieldset--error:not(.carina-input-fieldset--disabled, .carina-input-fieldset-outer) {
    border-color: var(--carina-border-color-danger);
}
.carina-input-fieldset--disabled:not(.carina-input-fieldset-outer),
.carina-input-fieldset--read-only:not(.carina-input-fieldset-outer, .carina-input-fieldset--error) {
    border-color: var(--carina-border-color-soft);
}
.carina-input-fieldset--disabled.carina-input-fieldset-outer {
    border-color: var(--carina-colors-transparent);
}
.carina-input-fieldset__legend {
    display: block;
    width: 0;
    height: 19.5px;
    padding: 0;
    margin: var(--carina-spacing-0) var(--carina-spacing-3);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: 19.5px;
    letter-spacing: normal;
    visibility: hidden;
    transition-duration: var(--carina-animation-duration-100);
    transition-property: width;
}
.carina-input-fieldset--default .carina-input-fieldset__legend {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-input-fieldset__legend--animated {
    width: unset;
    padding: var(--carina-spacing-0) var(--carina-spacing-1);
}
.carina-input-fieldset__legend--animated:empty {
    padding: var(--carina-spacing-0);
}
.carina-input-fieldset__legend--animated.carina-input-fieldset__legend--hiddenlabel {
    width: 0;
    padding: var(--carina-spacing-0);
}
.carina-input-fieldset__legend--required {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-input-fieldset__legend--animated.carina-input-fieldset__legend--required.carina-input-fieldset__legend--label {
    margin: var(--carina-spacing-0) var(--carina-spacing-1);
    padding: var(--carina-spacing-0) var(--carina-spacing-1)
    var(--carina-spacing-0) var(--carina-spacing-3);
}
[dir='rtl'] .carina-input-fieldset__legend--animated.carina-input-fieldset__legend--required.carina-input-fieldset__legend--label {
    padding: var(--carina-spacing-0) var(--carina-spacing-3)
      var(--carina-spacing-0) var(--carina-spacing-1);
}
.carina-input-fieldset-outer {
    top: -13px;
    position: absolute;
    pointer-events: none;
    border-color: transparent;
    border-style: solid;
}
.carina-input-fieldset-outer--outline {
    left: -3px;
    width: calc(100% + 6px);
    border-radius: calc(var(--carina-border-radius-md) + 3px);
    border-width: var(--carina-border-width-2);
}
.carina-input-fieldset-outer--underline,
.carina-input-fieldset-outer--grid {
    border-bottom-width: var(--carina-border-width-2);
}
.carina-input-fieldset-outer__legend {
    background: transparent;
    border-color: transparent;
    color: transparent;
    margin-inline-start: calc(var(--carina-spacing-3) + 2px);
}
.carina-input-group {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    border: 0;
    margin-inline: var(--carina-spacing-0);
    padding-block: var(--carina-spacing-0);
    padding-inline: var(--carina-spacing-0);
    min-inline-size: var(--carina-spacing-0);
}
.carina-input-group.carina-input-group--outline {
    margin-top: 19px;
}
.carina-input-group.carina-input-group--outline legend {
    top: -19px;
}
.carina-input-group.carina-input-group--underline {
    margin-top: 29px;
}
.carina-input-group.carina-input-group--underline legend {
    top: -29px;
}
.carina-input-group__group .carina-input-group__item .carina-helper-text {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-input-group__group .carina-input-group__item .carina-textbox__input,
.carina-input-group__group .carina-input-group__item .carina-dropdown__button,
.carina-input-group__group .carina-input-group__item .carina-input-fieldset,
.carina-input-group__group .carina-input-group__item .carina-input-fieldset-outer {
    border-radius: 0;
}
.carina-input-group__group
  > .carina-input-group__item:first-child
  :is(
    .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  ):first-child
  .carina-input-fieldset--default,
.carina-input-group__group
  > .carina-input-group__item:first-child
  :is(
    .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  ):first-child
  .carina-input-fieldset--outline {
    border-start-start-radius: var(--carina-border-radius-md);
    border-end-start-radius: var(--carina-border-radius-md);
}
.carina-input-group__group
  > .carina-input-group__item:first-child
  :is(
    .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  ):first-child
  .carina-input-fieldset--outline.carina-input-fieldset-outer {
    border-start-start-radius: calc(var(--carina-border-radius-md) + 3px);
    border-end-start-radius: calc(var(--carina-border-radius-md) + 3px);
}
.carina-input-group__group
  > .carina-input-group__item:last-child
  :nth-last-child(
    1 of .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  )
  .carina-input-fieldset--default,
.carina-input-group__group
  > .carina-input-group__item:last-child
  :nth-last-child(
    1 of .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  )
  .carina-input-fieldset--outline {
    border-start-end-radius: var(--carina-border-radius-md);
    border-end-end-radius: var(--carina-border-radius-md);
}
.carina-input-group__group
  > .carina-input-group__item:last-child
  :nth-last-child(
    1 of .carina-textbox__container,
    .carina-dropdown,
    .carina-combobox:has(> .carina-combobox)
  )
  .carina-input-fieldset--outline.carina-input-fieldset-outer {
    border-start-end-radius: calc(var(--carina-border-radius-md) + 3px);
    border-end-end-radius: calc(var(--carina-border-radius-md) + 3px);
}
.carina-input-group__group
  > .carina-input-group__item:not(:first-child)
  .carina-input-fieldset:not(.carina-input-fieldset-outer) {
    border-inline-start-width: var(--carina-border-width-0);
}
.carina-input-group__group > .carina-input-group__item {
    width: 100%;
}
.carina-input-group__group > .carina-input-group__item:has(.carina-date-range-picker),
  .carina-input-group__group > .carina-input-group__item:has(.carina-time-range-picker) {
    width: 200%;
}
.carina-input-group__group > .carina-input-group__item:focus-within {
    position: relative;
    z-index: 1;
}
.carina-input-group__group
  > .carina-input-group__item:focus-within
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ) {
    border-inline-start-width: var(--carina-border-width-1);
}
.carina-input-group__group
  > .carina-input-group__item:has(+ .carina-input-group__item:focus-within)
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-input-group__group
  > .carina-input-group__item:has(
    .carina-date-range-picker__textbox-wrapper
      > .carina-textbox__container:first-child:focus-within
  )
  + .carina-input-group__item
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ),
.carina-input-group__group
  > .carina-input-group__item:has(
    .carina-time-range-picker__inner-container
      > .carina-combobox:first-child:focus-within
  )
  + .carina-input-group__item
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ) {
    border-inline-start-width: var(--carina-border-width-0);
}
.carina-input-group__item
  .carina-date-range-picker__textbox-wrapper
  > .carina-textbox__container:first-child:has(
    + .carina-textbox__container:focus-within
  )
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-input-group__item
  .carina-time-range-picker__inner-container
  > .carina-combobox:first-child:has(+ .carina-combobox:focus-within)
  :is(
    .carina-combobox__fieldset--default,
    .carina-combobox__fieldset--outline,
    .carina-input-fieldset--default,
    .carina-input-fieldset--outline
  ):not(.carina-combobox__fieldset--outer, .carina-input-fieldset-outer) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-input-group__item:has(
    .carina-date-range-picker__textbox-wrapper
      > .carina-textbox__container:first-child:focus-within
  )
  .carina-date-range-picker__textbox-wrapper
  > .carina-textbox__container:nth-child(2)
  :is(.carina-input-fieldset--default, .carina-input-fieldset--outline):not(
    .carina-input-fieldset-outer
  ) {
    border-inline-start-width: var(--carina-border-width-0);
}
.carina-input-group__item:has(
    .carina-time-range-picker__inner-container
      > .carina-combobox:first-child:focus-within
  )
  .carina-time-range-picker__inner-container
  > .carina-combobox:nth-child(2)
  :is(
    .carina-combobox__fieldset--default,
    .carina-combobox__fieldset--outline,
    .carina-input-fieldset--default,
    .carina-input-fieldset--outline
  ):not(.carina-combobox__fieldset--outer, .carina-input-fieldset-outer) {
    border-inline-start-width: var(--carina-border-width-0);
}
.carina-input-group__item .carina-time-range-picker__inner-container .carina-combobox--focus,
.carina-input-group__item
  .carina-date-range-picker__textbox-wrapper
  .carina-textbox__container:focus-within {
    z-index: 1;
}
.carina-textbox-icon {
    position: absolute;
    bottom: 8.5px;
    display: block;
    width: var(--carina-icon-md);
    height: var(--carina-icon-md);
    color: var(--carina-text-color-soft);
}
.carina-textbox-icon svg {
    display: block;
    vertical-align: middle;
}
.carina-textbox-icon--readonly:hover {
    cursor: default;
}
.carina-textbox-icon--small {
    bottom: var(--carina-spacing-1-5);
}
.carina-textbox-icon--grid {
    bottom: var(--carina-spacing-1);
    width: var(--carina-icon-xs);
    height: var(--carina-icon-xs);
}
.carina-textbox-icon--start {
    inset-inline-start: var(--carina-spacing-4);
}
.carina-textbox-icon--start.carina-textbox-icon--grid {
    inset-inline-start: var(--carina-spacing-1);
}
.carina-textbox-icon--end {
    inset-inline-end: var(--carina-spacing-4);
}
.carina-textbox-icon--end.carina-textbox-icon--grid {
    inset-inline-end: var(--carina-spacing-1);
}
.carina-textbox__container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
}
.carina-textbox__container > fieldset {
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: border-color;
}
.carina-textbox__container--default:focus-within > fieldset {
    outline-color: var(--carina-border-color-primary-focus);
    transition-property: border-color, outline-color;
}
.carina-textbox__container--default.carina-textbox__container--error:focus-within > fieldset {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-textbox__container--underline {
    border-radius: var(--carina-border-radius-md) var(--carina-border-radius-md) 0
    0;
    background-color: transparent;
}
.carina-textbox__container--underline:focus-within > .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textbox__container--underline.carina-textbox__container--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textbox__container--grid {
    border-radius: var(--carina-border-radius-md) var(--carina-border-radius-md) 0
    0;
    background-color: transparent;
}
.carina-textbox__container--grid:focus-within > .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textbox__container--grid.carina-textbox__container--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textbox__container--outline {
    margin-top: var(--carina-spacing-2-5);
    background-color: transparent;
}
.carina-textbox__container--outline:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textbox__container--outline.carina-textbox__container--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textbox__container--error {
    border-color: var(--carina-border-color-danger);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: border-color;
}
.carina-textbox__input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 36px;
    padding: 0 var(--carina-spacing-4);
    border: 0;
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-align: start;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    vertical-align: middle;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-textbox__input::-moz-placeholder {
    color: var(--carina-text-color-soft);
}
.carina-textbox__input::placeholder {
    color: var(--carina-text-color-soft);
}
.carina-textbox__input:focus {
    outline: 0;
}
.carina-textbox__input:-ms-clear {
    display: none;
}
.carina-textbox__input:disabled {
    border-color: var(--carina-border-color-soft);
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-textbox__input:disabled::-moz-placeholder {
    color: color-mix(
        in srgb,
        var(--carina-text-color-disabled) calc(var(--carina-opacity-40) * 100%),
        transparent
      );
    opacity: var(--carina-opacity-40);
}
.carina-textbox__input:disabled::placeholder {
    color: color-mix(
        in srgb,
        var(--carina-text-color-disabled) calc(var(--carina-opacity-40) * 100%),
        transparent
      );
    opacity: var(--carina-opacity-40);
}
.carina-textbox__input--grid {
    height: 24px;
    padding-inline-start: var(--carina-spacing-1);
    padding-inline-end: var(--carina-spacing-1);
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-textbox__input--underline,
.carina-textbox__input--outline {
    height: 42px;
}
.carina-textbox__input--default {
    height: 40px;
    margin: 0;
    background-color: transparent;
}
.carina-textbox__input--default.carina-textbox__input--small {
    height: 36px;
    padding: 0 var(--carina-spacing-3);
    font-size: var(--carina-font-size-xs);
}
.carina-textbox__input--underline {
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-textbox__input--outline {
    margin: var(--carina-spacing-2-5) 0 0;
    background-color: transparent;
}
.carina-textbox__input--default.carina-textbox__input--icon-end {
    padding-inline-end: calc(var(--carina-spacing-10) + var(--carina-spacing-1));
}
.carina-textbox__input--default.carina-textbox__input--icon-start {
    padding-inline-start: calc(
    var(--carina-spacing-10) + var(--carina-spacing-1)
  );
}
.carina-textbox__input--underline.carina-textbox__input--icon-end {
    padding-inline-end: calc(var(--carina-spacing-10) + var(--carina-spacing-1));
}
.carina-textbox__input--underline.carina-textbox__input--icon-end:required {
    padding-inline-end: calc(var(--carina-spacing-9) + var(--carina-spacing-2));
}
.carina-textbox__input--underline.carina-textbox__input--icon-start {
    padding-inline-start: calc(
    var(--carina-spacing-12) + var(--carina-spacing-1)
  );
}
.carina-textbox__input--grid.carina-textbox__input--icon-end {
    padding-inline-end: var(--carina-spacing-6);
}
.carina-textbox__input--grid.carina-textbox__input--icon-start {
    padding-inline-start: var(--carina-spacing-6);
}
.carina-textbox__input--outline.carina-textbox__input--icon-end {
    padding-inline-end: calc(var(--carina-spacing-10) + var(--carina-spacing-1));
}
.carina-textbox__input--outline.carina-textbox__input--icon-start {
    padding-inline-start: calc(
    var(--carina-spacing-10) + var(--carina-spacing-2)
  );
}
.carina-textbox__input.carina-textbox__input--read-only {
    color: var(--carina-text-color-base);
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-textbox__input.carina-textbox__input--read-only:focus {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textbox__input.carina-textbox__input--read-only:hover {
    cursor: default;
}
.carina-textbox__container--default > .carina-input-fieldset {
    height: 40px;
    bottom: 0px;
}
.carina-textbox__container--default > .carina-input-fieldset-outer {
    bottom: -3px;
    height: 46px;
}
.carina-textbox__container--grid > .carina-input-fieldset {
    height: 100%;
}
.carina-textbox__container--grid > .carina-input-fieldset-outer {
    height: calc(100% + 6px);
    top: unset;
    bottom: -3px;
}
.carina-textbox__container--outline > .carina-input-fieldset,
.carina-textbox__container--underline > .carina-input-fieldset {
    height: calc(100% + var(--carina-spacing-2-5));
}
.carina-textbox__container--outline > .carina-input-fieldset-outer,
.carina-textbox__container--underline > .carina-input-fieldset-outer {
    height: calc(100% + calc(var(--carina-spacing-2-5) + 6px));
}
.carina-color-picker__picker {
    box-sizing: initial;
    width: 200px;
    padding: var(--carina-spacing-2-5) var(--carina-spacing-2-5) 0;
    border-radius: var(--carina-border-radius-sm);
    font-family: var(--carina-font-family-primary);
    background: var(--carina-background-color-popper);
    box-shadow: var(--carina-box-shadow-xl);
}
.carina-color-picker__picker-controls {
    display: flex;
}
.carina-color-picker__picker-sliders {
    flex: 1;
    padding: var(--carina-spacing-1) 0;
}
.carina-color-picker__picker-color {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    margin: var(--carina-spacing-1) 0 0 var(--carina-spacing-1);
    border-radius: calc(1.5 * var(--carina-border-radius-xs));
}
.carina-color-picker__picker-active-color {
    position: absolute;
    border-radius: var(--carina-border-radius-xs);
    background: rgb(
    var(--carina-color-picker-picker-rgb-r)
      var(--carina-color-picker-picker-rgb-g)
      var(--carina-color-picker-picker-rgb-b) /
      var(--carina-color-picker-picker-rgb-a)
  );
    box-shadow: inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-0) var(--carina-spacing-px)
      rgb(0 0 0 / calc(var(--carina-opacity-5) + var(--carina-opacity-10))),
    inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-1) rgb(0 0 0 / var(--carina-opacity-25));
    inset: var(--carina-spacing-0);
}
.carina-color-picker__picker-hue {
    position: relative;
    box-sizing: content-box;
    height: 0.625rem;
    border-radius: var(--carina-border-radius-xs);
    overflow: hidden;
    box-shadow: inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-0) var(--carina-spacing-px)
      rgb(0 0 0 / calc(var(--carina-opacity-5) + var(--carina-opacity-10))),
    inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-1) rgb(0 0 0 / var(--carina-opacity-25));
}
.carina-color-picker__picker--disable-alpha.carina-color-picker__picker-hue {
    height: 1.5rem;
}
.carina-color-picker__picker-alpha {
    position: relative;
    box-sizing: content-box;
    height: 0.625rem;
    margin-top: var(--carina-spacing-1);
    border-radius: var(--carina-border-radius-xs);
    overflow: hidden;
    box-shadow: inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-0) var(--carina-spacing-px)
      rgb(0 0 0 / calc(var(--carina-opacity-5) + var(--carina-opacity-10))),
    inset var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-1) rgb(0 0 0 / var(--carina-opacity-25));
}
.carina-color-picker__picker-saturation {
    position: relative;
    box-sizing: content-box;
    width: 100%;
    margin: calc(-1 * var(--carina-spacing-px));
    padding-bottom: 75%;
    border: 1px solid rgb(0 0 0 / var(--carina-opacity-25));
    border-radius: var(--carina-border-radius-xs);
    overflow: hidden;
}
.carina-color-picker__picker--sketch-field-container input {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-popper);
}
.carina-color-picker__picker--sketch-field-container label {
    color: var(--carina-text-color-base) !important;
}
.carina-color-picker__pointer {
    width: var(--carina-border-width-4);
    height: var(--carina-spacing-2);
    margin-top: var(--carina-spacing-px);
    border-radius: var(--carina-border-width-1);
    background: var(--carina-colors-grayscale-5);
    box-shadow: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-spacing-0-5) rgb(0 0 0 / var(--carina-opacity-60));
    transform: translateX(-2px);
}
.carina-color-picker__pointer--disable-alpha {
    height: 22px;
}
.carina-color-picker__presets-container {
    margin: var(--carina-spacing-0) calc(-1 * var(--carina-spacing-2-5));
    padding: calc(var(--carina-spacing-2-5) / 2) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-2-5);
    border-top: var(--carina-spacing-px) solid var(--carina-border-color-soft);
}
.carina-color-picker__presets-label {
    margin: var(--carina-spacing-0);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-normal);
}
.carina-color-picker__presets-colors {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding-top: calc(var(--carina-spacing-2-5) / 2);
}
.carina-color-picker__presets-swatch {
    width: 16px;
    height: 16px;
    margin: var(--carina-spacing-0) var(--carina-spacing-2-5)
    var(--carina-spacing-2-5) var(--carina-spacing-0);
    border-radius: 3px;
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    outline-color: var(--carina-colors-transparent);
}
.carina-color-picker__presets-swatch:focus-within {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-color-picker__presets-swatch.carina-color-picker__presets-swatch--selected {
    outline-color: #0099e0;
}
.carina-color-picker__presets-swatch.carina-color-picker__presets-swatch--selected:focus-within {
    outline-color: var(--carina-border-color-hard);
}
.carina-scrim {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--carina-z-index-scrim);
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: var(--carina-background-color-scrim);
    backdrop-filter: blur(4px);
}
.carina-modal {
    --carina-z-index-current: var(--carina-z-index-modal);
    --carina-z-index-popper: calc(
    var(--carina-z-index-modal) + var(--carina-z-index-popper-diff)
  );
    --carina-z-index-scrim: calc(
    var(--carina-z-index-modal) + var(--carina-z-index-scrim-diff)
  );
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--carina-z-index-modal);
    display: flex;
    align-items: center;
    justify-content: center;
}
.carina-modal--fullscreen {
    --carina-z-index-current: var(--carina-z-index-fullscreen-modal);
    --carina-z-index-popper: calc(
      var(--carina-z-index-fullscreen-modal) + var(--carina-z-index-popper-diff)
    );
    --carina-z-index-scrim: calc(
      var(--carina-z-index-fullscreen-modal) + var(--carina-z-index-scrim-diff)
    );
}
.carina-modal--fluid {
    --carina-z-index-current: var(--carina-z-index-fullscreen-modal);
    --carina-z-index-popper: calc(
      var(--carina-z-index-fullscreen-modal) + var(--carina-z-index-popper-diff)
    );
    --carina-z-index-scrim: calc(
      var(--carina-z-index-fullscreen-modal) + var(--carina-z-index-scrim-diff)
    );
}
.carina-modal__dialog {
    z-index: var(--carina-z-index-modal);
    box-sizing: border-box;
    max-width: 100%;
    max-height: 100%;
    border: 0;
    overflow: hidden;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background-color: var(--carina-background-color-surface);
    outline: none;
    box-shadow: var(--carina-box-shadow-2xl);
}
.carina-modal__dialog--center {
    max-width: calc(100% - 16px);
    max-height: 100%;
    border-radius: var(--carina-border-radius-xl);
}
.carina-modal__dialog--sm {
    width: 420px;
}
.carina-modal__dialog--md {
    width: 560px;
}
.carina-modal__dialog--lg {
    width: 800px;
}
.carina-modal__dialog--xl {
    width: 1240px;
}
.carina-modal__dialog--fluid {
    z-index: var(--carina-z-index-modal);
    width: 100%;
    height: 100%;
}
.carina-modal__dialog--fullscreen {
    z-index: var(--carina-z-index-fullscreen-modal);
    width: 100%;
    height: 100%;
}
.carina-modal__dialog--side {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 480px;
    max-width: 100%;
}
.carina-modal__dialog--start {
    left: 0;
}
[dir='rtl'] .carina-modal__dialog--start {
    right: 0;
    left: auto;
}
.carina-modal__dialog--end {
    right: 0;
}
[dir='rtl'] .carina-modal__dialog--end {
    right: auto;
    left: 0;
}
.carina-modal__dialog--bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    max-height: 100%;
    border-top-left-radius: var(--carina-border-radius-xl);
    border-top-right-radius: var(--carina-border-radius-xl);
}
.carina-modal__scrim {
    width: 100%;
    height: 100%;
    transition-property: opacity;
}
.carina-modal__content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow: hidden;
}
.carina-modal__dialog--productive,
.carina-modal__scrim--productive,
.carina-modal__content--productive {
    transition-duration: var(--carina-transition-duration-200);
}
.carina-modal__dialog--expressive,
.carina-modal__scrim--expressive,
.carina-modal__content--expressive {
    transition-duration: var(--carina-transition-duration-400);
}
.carina-modal__dialog.carina-transition--out {
    --carina-transition-opacity: 0;
}
.carina-modal__content.carina-transition--enter-done,
.carina-modal__content.carina-transition--appear-done,
.carina-modal__dialog.carina-transition--enter-done,
.carina-modal__dialog.carina-transition--appear-done {
    transform: none;
}
.carina-modal__scrim.carina-transition--out {
    --carina-transition-opacity: 0;
}
.carina-modal__content--productive {
    transition-delay: var(--carina-transition-delay-200);
}
.carina-modal__content--expressive {
    transition-delay: var(--carina-transition-delay-400);
}
.carina-modal__content.carina-transition--out {
    --carina-transition-opacity: 0;
}
.carina-dropdown {
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-align: start;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-dropdown--error
  > .carina-input-fieldset:not(
    .carina-input-fieldset-outer,
    .carina-input-fieldset--disabled
  ) {
    border-color: var(--carina-border-color-danger);
}
.carina-dropdown--default,
.carina-dropdown--default.carina-dropdown--open {
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-100);
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: border-color;
    transition-property: outline-color, border-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-dropdown--default:focus-within > .carina-input-fieldset,
  .carina-dropdown--default.focus-in-portal > .carina-input-fieldset,
  .carina-dropdown--default.carina-dropdown--open:focus-within > .carina-input-fieldset,
  .carina-dropdown--default.carina-dropdown--open.focus-in-portal > .carina-input-fieldset {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-dropdown--default.carina-dropdown--error:focus-within > .carina-input-fieldset,
    .carina-dropdown--default.carina-dropdown--error.focus-in-portal > .carina-input-fieldset,
    .carina-dropdown--default.carina-dropdown--open.carina-dropdown--error:focus-within > .carina-input-fieldset,
    .carina-dropdown--default.carina-dropdown--open.carina-dropdown--error.focus-in-portal > .carina-input-fieldset {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-dropdown--grid {
    height: 24px;
}
.carina-dropdown--grid:focus-within > .carina-input-fieldset-outer,
  .carina-dropdown--grid.focus-in-portal > .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-dropdown--grid.carina-dropdown--error:focus-within > .carina-input-fieldset-outer,
    .carina-dropdown--grid.carina-dropdown--error.focus-in-portal > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-dropdown--outline:focus-within > .carina-input-fieldset-outer,
  .carina-dropdown--outline.focus-in-portal > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-dropdown--outline.carina-dropdown--error:focus-within > .carina-input-fieldset-outer,
    .carina-dropdown--outline.carina-dropdown--error.focus-in-portal > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-dropdown--underline:focus-within > .carina-input-fieldset-outer,
  .carina-dropdown--underline.focus-in-portal > .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-dropdown--underline.carina-dropdown--error:focus-within > .carina-input-fieldset-outer,
    .carina-dropdown--underline.carina-dropdown--error.focus-in-portal > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-dropdown__button {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-4);
    border: 0;
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-align: start;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    outline: 0;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-dropdown__button:focus,
  .carina-dropdown__button:active {
    outline: 0;
}
.carina-dropdown__button:focus-visible {
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
}
.carina-dropdown__button ::-moz-focus-inner {
    border: 0;
}
.carina-dropdown__button.carina-dropdown__button--read-only {
    color: var(--carina-text-color-base);
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-dropdown__button.carina-dropdown__button--read-only:focus {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-dropdown__button.carina-dropdown__button--read-only:hover {
    cursor: default;
}
.carina-dropdown--underline .carina-dropdown__button {
    height: 42px;
}
.carina-dropdown__button--default {
    height: 40px;
    background-color: transparent;
}
.carina-dropdown__button--grid {
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-dropdown__button--outline {
    margin-top: var(--carina-spacing-2-5);
    background-color: transparent;
    height: 42px;
}
.carina-dropdown__button--underline {
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-dropdown__button--disabled {
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-dropdown__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--carina-spacing-6);
    height: var(--carina-spacing-6);
    color: var(--carina-text-color-base);
    pointer-events: none;
}
.carina-dropdown__icon--disabled,
.carina-dropdown__icon--read-only {
    color: var(--carina-text-color-disabled);
}
.carina-dropdown__placeholder {
    overflow: hidden;
    color: var(--carina-text-color-soft);
    white-space: nowrap;
    text-align: start;
    text-overflow: ellipsis;
}
.carina-dropdown__placeholder--disabled {
    color: color-mix(
    in srgb,
    var(--carina-text-color-soft) calc(var(--carina-opacity-40) * 100%),
    transparent
  );
    pointer-events: none;
}
.carina-dropdown__text--grid {
    padding-inline-start: var(--carina-spacing-1);
}
.carina-dropdown__text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.carina-dropdown__text--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-dropdown--default > .carina-input-fieldset {
    height: 40px;
    bottom: 0px;
}
.carina-dropdown--default > .carina-input-fieldset-outer {
    height: 46px;
    bottom: -3px;
}
.carina-dropdown--default .carina-dropdown__label {
    height: 21px;
}
.carina-dropdown--outline > .carina-input-fieldset, .carina-dropdown--underline > .carina-input-fieldset {
    height: calc(100% + var(--carina-spacing-2-5));
}
.carina-dropdown--outline > .carina-input-fieldset-outer, .carina-dropdown--underline > .carina-input-fieldset-outer {
    height: calc(100% + var(--carina-spacing-2-5) + 6px);
}
.carina-dropdown--grid > .carina-input-fieldset {
    height: 100%;
}
.carina-dropdown--grid > .carina-input-fieldset-outer {
    top: -3px;
    height: calc(100% + 6px);
}
.carina-dropdown__magazine {
    position: static;
    width: 100%;
    max-height: 192px;
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    box-shadow: none;
}
@keyframes carina-loading-icon--circle {
    0% {
        transform: rotateZ(var(--carina-rotate-0));
    }
    66% {
        transform: rotateZ(220deg);
    }
    100% {
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-icon--tail-chase-xs {
    0% {
        stroke-dashoffset: 26;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 6;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 26;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-icon--tail-chase-sm {
    0% {
        stroke-dashoffset: 32;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 5;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 32;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-icon--tail-chase-md {
    0% {
        stroke-dashoffset: 40;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 3;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 40;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-icon--tail-chase-lg {
    0% {
        stroke-dashoffset: 48;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 2;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 48;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
.carina-loading-icon {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    overflow: visible;
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xl);
    font-family: var(--carina-font-family-primary);
    transform-origin: 50% 50%;
}
.carina-loading-icon__circle {
    margin-bottom: var(--carina-spacing-0-5);
    overflow: visible;
    transform-origin: 50% 50%;
    animation: carina-loading-icon--circle 3770ms linear infinite;
    fill: transparent;
    stroke: var(--carina-background-color-neutral-inactive);
    stroke-dasharray: 400;
    stroke-linecap: round;
    stroke-width: 2px;
}
.carina-loading-icon__circle--xs {
    width: var(--carina-icon-xs);
    height: var(--carina-icon-xs);
}
.carina-loading-icon__circle--sm {
    width: var(--carina-icon-sm);
    height: var(--carina-icon-sm);
}
.carina-loading-icon__circle--md {
    width: var(--carina-icon-md);
    height: var(--carina-icon-md);
}
.carina-loading-icon__circle--lg {
    width: var(--carina-icon-lg);
    height: var(--carina-icon-lg);
}
.carina-loading-icon__tail-chaser {
    transform-origin: 50% 50%;
    fill: transparent;
    stroke-linecap: round;
    stroke-width: 2px;
}
.carina-loading-icon__tail-chaser--xs {
    animation: carina-loading-icon--tail-chase-xs 2450ms linear infinite;
    stroke-dasharray: 33;
}
.carina-loading-icon__tail-chaser--sm {
    animation: carina-loading-icon--tail-chase-sm 2450ms linear infinite;
    stroke-dasharray: 40;
}
.carina-loading-icon__tail-chaser--md {
    animation: carina-loading-icon--tail-chase-md 2450ms linear infinite;
    stroke-dasharray: 50;
}
.carina-loading-icon__tail-chaser--lg {
    animation: carina-loading-icon--tail-chase-lg 2450ms linear infinite;
    stroke-dasharray: 66;
}
.carina-loading-icon__gradient-color-1 {
    stop-color: var(--carina-background-color-tertiary);
}
.carina-loading-icon__gradient-color-2 {
    stop-color: var(--carina-background-color-primary);
}
.carina-loading-icon__gradient-color-3 {
    stop-color: var(--carina-background-color-secondary);
}
.carina-loading-icon__rail {
    stroke: var(--carina-background-color-neutral-inactive);
}
.carina-combobox {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    font-size: var(--carina-font-size-body-md);
    line-height: var(--carina-line-height-normal);
    cursor: text;
}
.carina-combobox__input {
    display: flex;
    align-items: flex-start;
    min-height: 40px;
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    background-color: transparent;
}
.carina-combobox__input--outline {
    margin: var(--carina-spacing-2-5) 0 0;
}
.carina-combobox__input--outline,
.carina-combobox__input--underline {
    min-height: 42px;
}
.carina-combobox__input--grid,
.carina-combobox__input--outline,
.carina-combobox__input--underline {
    background-color: transparent;
}
.carina-combobox__input__element {
    flex: 1 0 auto;
    width: 80px;
    height: 24px;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    border: var(--carina-border-width-0) none;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    background: var(--carina-colors-transparent);
    outline: none;
}
.carina-combobox__input__element::-moz-placeholder {
    color: var(--carina-text-color-soft);
}
.carina-combobox__input__element::placeholder {
    color: var(--carina-text-color-soft);
}
.carina-combobox__input__multiselect {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - var(--carina-spacing-12));
    padding-top: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-px);
    -moz-column-gap: var(--carina-spacing-2);
    column-gap: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
    padding-inline-start: var(--carina-spacing-4);
}
.carina-combobox__input__multiselect__option {
    height: 24px;
}
.carina-combobox__input__multiselect__option__tag {
    display: flex;
    align-items: center;
}
.carina-combobox__input__multiselect__option__input {
    display: flex;
    flex: 1 0 auto;
    width: 80px;
    padding-inline-end: var(--carina-spacing-3);
    padding-inline-start: var(--carina-spacing-0);
}
.carina-combobox__input__multiselect__option__placeholder {
    position: relative;
    top: 1px;
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    width: 80px;
    padding-inline-end: var(--carina-spacing-3);
    overflow: hidden;
    color: var(--carina-text-color-soft);
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;
}
.carina-combobox__input__button-group {
    position: absolute;
    inset-inline-end: var(--carina-spacing-1);
    display: flex;
    align-items: center;
    padding-top: var(--carina-spacing-0-5);
    padding-inline-start: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-2);
}
.carina-combobox__input__button-group--grid {
    transform: translateY(var(--carina-spacing-1-5));
}
.carina-combobox__input__button-group--outline,
.carina-combobox__input__button-group--underline {
    padding-top: calc(var(--carina-spacing-0-5) + var(--carina-spacing-px));
}
.carina-combobox--grid .carina-combobox__input__button-group__item > .carina-button--icon-only {
    padding: var(--carina-spacing-0);
    min-height: unset;
    width: 24px;
    height: 24px;
    margin-inline-end: var(--carina-spacing-2);
}
.carina-combobox__input--read-only {
    color: var(--carina-text-color-base);
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-combobox__input--read-only:focus {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-combobox__input--read-only:hover {
    cursor: default;
}
.carina-combobox__input--read-only .carina-button {
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-combobox__input--read-only .carina-button:hover {
    cursor: default;
    background-color: var(--carina-colors-transparent);
}
.carina-combobox__input--read-only .carina-combobox__input__element {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.carina-combobox__input--read-only .carina-combobox__input__element:hover {
    cursor: default;
}
.carina-combobox--grid > .carina-combobox__input--read-only,
.carina-combobox--underline > .carina-combobox__input--read-only {
    border-radius: var(--carina-border-radius-none);
}
.carina-combobox__input__loader {
    position: relative;
    top: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
    margin-inline-end: var(--carina-spacing-0-5);
    margin-inline-start: var(--carina-spacing-0-5);
}
.carina-combobox__virtualized__list__option {
    margin-inline-start: var(--carina-spacing-2);
    margin-inline-end: var(--carina-spacing-2);
    width: calc(100% - 16px);
}
.carina-combobox--focus .carina-combobox__input__element,
  .carina-combobox--focus .carina-combobox__input__multiselect__option__input {
    flex: 1 0 auto;
    width: 80px;
}
.carina-combobox--empty .carina-combobox__input__element,
  .carina-combobox--empty .carina-combobox__input__multiselect__option__input {
    flex: 0 0 auto;
    width: var(--carina-spacing-px);
}
.carina-combobox--error {}
.carina-combobox--disabled {
    border-color: var(--carina-border-color-soft);
    color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-combobox--disabled .carina-combobox__input__element {
    color: var(--carina-text-color-disabled);
    -webkit-text-fill-color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-combobox--disabled .carina-combobox__input__button-group__item button {
    cursor: default;
}
.carina-combobox--disabled .carina-combobox__input__button {
    color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-combobox--disabled .carina-combobox__input__button svg,
  .carina-combobox--disabled .carina-combobox__input__button svg path,
  .carina-combobox--disabled .carina-combobox__input__button svg group {
    fill: currentcolor;
}
.carina-combobox--disabled .carina-combobox__input__multiselect__option__placeholder {
    color: color-mix(
      in srgb,
      var(--carina-text-color-disabled) calc(var(--carina-opacity-40) * 100%),
      transparent
    );
}
.carina-combobox__input__multiselect__option:not(
    .carina-combobox__input__multiselect__option__input
  ):not(.carina-combobox__input__multiselect__option__placeholder)
  + .carina-combobox__input__multiselect__option__input,
.carina-combobox__input__multiselect__option:not(
    .carina-combobox__input__multiselect__option__input
  ):not(.carina-combobox__input__multiselect__option__placeholder)
  + .carina-combobox__input__multiselect__option__placeholder {
    padding-inline-start: var(--carina-spacing-0-5);
    padding-inline-end: var(--carina-spacing-0-5);
}
.carina-combobox--default.carina-combobox--focus .carina-input-fieldset {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-combobox--default.carina-combobox--focus.carina-combobox--error .carina-input-fieldset {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-combobox--grid.carina-combobox--focus .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-combobox--grid.carina-combobox--focus.carina-combobox--error .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-combobox--grid .carina-combobox__input__multiselect {
    padding-top: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
    padding-inline-start: var(--carina-spacing-1);
}
.carina-combobox--grid .carina-combobox__input__multiselect__option {
    padding-top: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
}
.carina-combobox--grid .carina-combobox__input {
    min-height: 24px;
    align-items: flex-end;
}
.carina-combobox--grid .carina-combobox__input__button-group {
    padding-top: var(--carina-spacing-0);
    padding-inline-end: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
}
.carina-combobox--outline.carina-combobox--focus .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-combobox--outline.carina-combobox--focus.carina-combobox--error .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-combobox--underline.carina-combobox--focus .carina-input-fieldset-outer {
    bottom: -3px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-combobox--underline.carina-combobox--focus.carina-combobox--error .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-combobox__popover {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
}
.carina-combobox__popover * {
    box-sizing: border-box;
}
.carina-combobox__popover .carina-combobox__scrollview {
    padding: var(--carina-spacing-2);
    overflow-y: auto;
}
.carina-combobox__popover .carina-combobox__list__option__text {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.carina-combobox__popover .carina-combobox__list__option__check-container {
    display: flex;
    align-items: center;
    visibility: hidden;
}
.carina-combobox__popover .carina-combobox__list__option__check-icon {
    color: var(--carina-text-color-base);
}
.carina-combobox__popover .carina-combobox__list {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    line-height: var(--carina-line-height-tight);
    list-style-type: none;
}
.carina-combobox__popover .carina-combobox__list__subtext {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
}
.carina-combobox__popover .carina-combobox__list__option {
    margin-top: var(--carina-spacing-0);
    margin-bottom: var(--carina-spacing-0);
    line-height: var(--carina-line-height-normal);
    padding: var(--carina-spacing-2);
    font-size: var(--carina-font-size-body-sm);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    transition-timing-function: var(
        --carina-transition-timing-function-expressive-ease-in-out
      );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
}
.carina-combobox__popover .carina-combobox__list__option:hover {
    background-color: var(--carina-background-color-surface-hover);
    cursor: pointer;
}
.carina-combobox__popover .carina-combobox__list__option:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-combobox__popover .carina-combobox__list__option--selected,
      .carina-combobox__popover .carina-combobox__list__option--selected:hover,
      .carina-combobox__popover .carina-combobox__list__option--selected --focus {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-selected);
}
.carina-combobox__popover .carina-combobox__list__option--selected .carina-combobox__list__subtext, .carina-combobox__popover .carina-combobox__list__option--selected:hover .carina-combobox__list__subtext, .carina-combobox__popover .carina-combobox__list__option--selected --focus .carina-combobox__list__subtext {
    color: var(--carina-text-color-base);
}
.carina-combobox__popover .carina-combobox__list__option--selected .carina-combobox__list__option__check-icon, .carina-combobox__popover .carina-combobox__list__option--selected:hover .carina-combobox__list__option__check-icon, .carina-combobox__popover .carina-combobox__list__option--selected --focus .carina-combobox__list__option__check-icon {
    visibility: visible;
}
.carina-combobox__popover .carina-combobox__list__option--focus:not(.carina-combobox__popover .carina-combobox__list__option--selected) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-combobox__popover .carina-combobox__list__option--disabled {
    color: var(--carina-text-color-disabled);
    background-color: var(--carina-background-color-surface);
}
.carina-combobox__popover .carina-combobox__list__option--disabled.carina-combobox__popover .carina-combobox__list__option:hover {
    background-color: var(--carina-background-color-surface);
}
.carina-combobox__popover .carina-combobox__list__option--disabled > .carina-combobox__list__subtext {
    color: var(--carina-text-color-disabled);
}
.carina-combobox__popover .carina-combobox__list__option--disabled:hover {
    cursor: default;
}
.carina-combobox__popover .carina-combobox__list__option__create {
    color: var(--carina-text-color-primary);
}
.carina-combobox__popover .carina-combobox__list__heading {
    margin-top: var(--carina-spacing-1);
    margin-bottom: var(--carina-spacing-0-5);
    padding-top: var(--carina-spacing-1);
    padding-inline-start: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-1);
    padding-inline-end: var(--carina-spacing-2);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-tight);
    text-transform: uppercase;
}
.carina-combobox__popover .carina-combobox__list__divider {
    margin-top: var(--carina-spacing-1);
    margin-bottom: var(--carina-spacing-1);
    border: var(--carina-border-width-0) none;
    border-top: var(--carina-border-width-1) solid;
    border-top-color: var(--carina-border-color-soft);
}
.carina-combobox__popover .carina-combobox__list--empty {
    padding-top: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-2);
    padding-inline-start: var(--carina-spacing-4);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
    font-style: italic;
}
.carina-combobox > .carina-comboboxinput-input-fieldset {
    height: calc(var(--carina-combobox-fieldset-height) + 10px);
}
.carina-combobox > .carina-input-fieldset-outer {
    height: calc(var(--carina-combobox-fieldset-height) + 16px);
}
.carina-comboboxinput-input-fieldset.carina-comboboxinput-input-fieldset--default {
    height: var(--carina-combobox-fieldset-height);
    bottom: 0px;
}
.carina-comboboxinput-input-fieldset.carina-comboboxinput-input-fieldset--grid {
    height: 24px;
    top: unset;
    bottom: 0;
}
.carina-comboboxinput-input-fieldset--default.carina-comboboxinput-input-fieldset--label {
    top: 15px;
}
.carina-date-picker-modal__buttons {
    display: inline-flex;
    justify-content: flex-end;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: var(--carina-spacing-4);
    padding-inline-end: var(--carina-spacing-4);
}
.carina-date-picker-modal__buttons button:first-of-type {
    margin-inline-end: var(--carina-spacing-4);
}
.carina-date-picker-popper {
    background-color: var(--carina-background-color-popper);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-date-picker-toggle-button {
    position: absolute;
    inset-inline-end: var(--carina-spacing-0);
    top: 50%;
    transform: translate(var(--carina-spacing-1-5), -50%);
}
.carina-date-picker-toggle-button .carina-button--disabled {
    color: var(--carina-text-color-disabled);
    opacity: unset;
}
.carina-date-picker-toggle-button.carina-date-picker-toggle-button--outline,
.carina-date-picker-toggle-button.carina-date-picker-toggle-button--underline {
    transform: translate(
    var(--carina-spacing-1-5),
    calc(-50% - var(--carina-spacing-px))
  );
}
.carina-textbox-icon--grid > .carina-date-picker-toggle-button {
    transform: translateY(-50%);
}
.carina-day-picker__nav-button-left {
    position: absolute;
    left: 0;
}
.carina-day-picker__nav-button-right {
    position: absolute;
    right: 0;
}
.carina-day-picker__caption-dropdowns ~ .carina-day-picker__nav-button-left,
.carina-day-picker__caption:has(.carina-day-picker__caption-dropdowns) .carina-day-picker__nav-button-left,
.carina-day-picker__caption-dropdowns ~ .carina-day-picker__nav-button-right,
.carina-day-picker__caption:has(.carina-day-picker__caption-dropdowns) .carina-day-picker__nav-button-right {
    position: relative;
}
.carina-day-picker {
    --rdp-cell-size: 40px;
    --rdp-accent-color: var(--carina-background-color-primary);
    --rdp-background-color: transparent;
    --rdp-accent-color-dark: var(--carina-background-color-primary);
    --rdp-background-color-dark: transparent;
    --rdp-outline: none;
    --rdp-outline-selected: none;
    padding: var(--carina-spacing-4);
    color: var(--carina-text-color-base);
    font-family: var(--carina-font-family-primary);
}
.carina-day-picker__vhidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-day-picker__button-reset {
    position: relative;
    margin: 0;
    padding: 0;
    color: inherit;
    font: inherit;
    background: none;
    outline: none;
    cursor: default;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-day-picker__button {
    border: 2px solid transparent;
}
.carina-day-picker__button[aria-disabled='true'] {
    opacity: 0.25;
    pointer-events: none;
}
.carina-day-picker__button:not([aria-disabled='true'], .carina-day-picker__day--disabled) {
    cursor: pointer;
}
.carina-day-picker__button:hover:not([aria-disabled='true'], .carina-day-picker__day--disabled) {
    border: var(--carina-border-width-2) solid
    var(--carina-border-color-primary-focus);
    border-radius: var(--carina-border-radius-xl);
}
.carina-day-picker__months {
    display: flex;
}
.carina-day-picker__month {
    margin: 0 1rem;
}
.carina-day-picker__month .carina-day-picker__caption-start {
    margin-left: 0;
}
.carina-day-picker__month .carina-day-picker__caption-end {
    margin-right: 0;
}
.carina-day-picker__table {
    max-width: calc(var(--rdp-cell-size) * 7);
    margin: 0;
    border-collapse: collapse;
}
.carina-day-picker__with-week-number .carina-day-picker__table {
    max-width: calc(var(--rdp-cell-size) * 8);
    border-collapse: collapse;
}
.carina-day-picker__caption {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    text-align: left;
}
.carina-day-picker__multiple-months .carina-day-picker__caption {
    position: relative;
    display: flex;
    min-height: 40px;
    text-align: center;
}
.carina-day-picker__caption-dropdowns {
    position: relative;
    display: inline-flex;
    gap: var(--carina-spacing-2);
    width: 100%;
    padding: 0 0.25rem;
}
.carina-day-picker__caption-label {
    position: relative;
    z-index: calc(var(--carina-z-index-current, 1) + 10);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: 0 0.25rem;
    border: 0;
    border: 2px solid transparent;
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-lg);
    line-height: var(--carina-line-height-display-sm);
    font-family: inherit;
    white-space: nowrap;
}
.carina-day-picker__nav {
    white-space: nowrap;
}
.carina-day-picker__multiple-months .carina-day-picker__caption-start .carina-day-picker__nav {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}
.carina-day-picker__multiple-months .carina-day-picker__caption-end .carina-day-picker__nav {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
}
.carina-day-picker__nav-button {
    display: none;
}
.carina-day-picker__dropdown-year,
.carina-day-picker__dropdown-month {
    position: relative;
    display: inline-flex;
    align-items: center;
}
.carina-day-picker__dropdown-month {
    flex-grow: 1;
}
.carina-day-picker__dropdown-year__popper {
    min-width: 84px;
}
.carina-day-picker__dropdown {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: calc(var(--carina-z-index-current, 1) + 20);
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    background-color: transparent;
    cursor: inherit;
    opacity: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-day-picker__dropdown:focus-visible:not([disabled]) + .carina-day-picker__caption-label {
    outline-color: var(--carina-border-color-primary-focus);
    outline-offset: var(--carina-border-width-0);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-day-picker__dropdown[disabled] {
    color: unset;
    opacity: unset;
}
.carina-day-picker__dropdown:focus:not([disabled]) + .carina-day-picker__caption-label,
.carina-day-picker__dropdown:active:not([disabled]) + .carina-day-picker__caption-label {
    border-radius: 6px;
    background-color: var(--rdp-background-color);
}
.carina-day-picker__dropdown-icon {
    margin: 0 0 0 5px;
}
.carina-day-picker__head {
    border: 0;
}
.carina-day-picker__head-row,
.carina-day-picker__row {
    height: 100%;
}
tbody tr.carina-day-picker__row {
    border-bottom: 0;
}
.carina-day-picker__head-cell {
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    text-align: center;
    text-transform: none;
    vertical-align: middle;
}
.carina-day-picker__tbody {
    border: 0;
}
.carina-day-picker__tfoot {
    margin: 0.5rem;
}
.carina-day-picker__cell {
    width: var(--rdp-cell-size);
    height: 100%;
    height: var(--rdp-cell-size);
    padding: 0;
    position: relative;
    text-align: center;
}
.carina-day-picker__week-number {
    font-size: var(--carina-font-size-body-2xs);
}
.carina-day-picker__week-number,
.carina-day-picker__day {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--rdp-cell-size);
    max-width: var(--rdp-cell-size);
    height: var(--rdp-cell-size);
    margin: 0;
    padding: 1px;
    border: 2px solid transparent;
    border-radius: var(--carina-border-radius-xl);
    overflow: hidden;
}
.carina-day-picker__week-number:focus-visible, .carina-day-picker__day:focus-visible {
    outline-width: 3px;
    outline-style: solid;
    outline-color: var(--carina-text-color-on-primary);
    outline-offset: -6px;
}
.carina-day-picker__week-number:not(.carina-day-picker__week-number--selected):focus-visible, .carina-day-picker__day:not(.carina-day-picker__day--selected):focus-visible {
    outline-width: 0px;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-day-picker__week-number--selected:focus-visible, .carina-day-picker__day--selected:focus-visible {
    outline-color: var(--carina-text-color-on-primary);
}
.carina-day-picker__day--today {
    position: relative;
}
.carina-day-picker__day--today:not(.carina-day-picker__day--outside) {
    font-weight: var(--carina-font-weight-display);
}
.carina-day-picker__cell:has(.carina-day-picker__day--today)::after {
    position: absolute;
    top: 75%;
    left: 30%;
    width: 40%;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: var(--carina-border-color-secondary-focus);
    border-radius: var(--carina-border-radius-full);
    content: '';
    pointer-events: none;
}
.carina-day-picker__cell:has(.carina-day-picker__day--selected.carina-day-picker__day--today)::after {
    border-bottom-color: var(--carina-text-color-on-primary);
}
.carina-day-picker__cell:has(
    .carina-day-picker__day--range-middle.carina-day-picker__day--selected.carina-day-picker__day--today
  )::after {
    border-bottom-color: var(--carina-text-color-on-primary-pale-soft);
}
.carina-day-picker__day--selected {
    border-radius: var(--carina-border-radius-xl);
    border-width: var(--carina-border-width-1);
    border-style: solid;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-day-picker__day--selected,
.carina-day-picker__day--selected:focus,
.carina-day-picker__day--selected:active,
.carina-day-picker__day--selected:hover:not(.carina-day-picker__day--range-middle) {
    border: 1px solid var(--carina-border-color-primary-focus);
    color: var(--carina-text-color-on-primary);
    background-color: var(--rdp-accent-color);
}
.carina-day-picker__day--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-day-picker__day--selected.carina-day-picker__day--disabled {
    color: var(--carina-text-color-on-primary);
    opacity: var(--carina-opacity-40);
}
.carina-day-picker__day--range-start:not(.carina-day-picker__day--range-end) {
    border-start-end-radius: var(--carina-border-radius-none);
    border-end-end-radius: var(--carina-border-radius-none);
}
.carina-day-picker__day--range-start:not(.carina-day-picker__day--range-end):hover {
    border-start-end-radius: var(--carina-border-radius-none);
    border-end-end-radius: var(--carina-border-radius-none);
}
.carina-day-picker__day--range-end:not(.carina-day-picker__day--range-start) {
    border-start-start-radius: var(--carina-border-radius-none);
    border-end-start-radius: var(--carina-border-radius-none);
}
.carina-day-picker__day--range-end:not(.carina-day-picker__day--range-start):hover {
    border-start-start-radius: var(--carina-border-radius-none);
    border-end-start-radius: var(--carina-border-radius-none);
}
.carina-day-picker__day--range-middle.carina-day-picker__day--selected {
    border-radius: var(--carina-border-radius-none);
    color: var(--carina-text-color-on-primary-pale);
    background-color: var(--carina-background-color-primary-pale);
    border-color: var(--carina-colors-transparent);
}
.carina-day-picker__day--range-middle.carina-day-picker__day--selected:hover {
    border-radius: var(--carina-border-radius-none);
    border-color: var(--carina-border-color-primary-focus);
}
.carina-day-picker__day--range-middle.carina-day-picker__day--selected:focus-visible {
    outline-width: var(--carina-border-width-2);
    outline-color: var(--carina-border-color-hard);
    outline-offset: calc(-1 * var(--carina-border-width-2));
}
.carina-day-picker__day--range-middle.carina-day-picker__day--selected.carina-day-picker__day--disabled {
    opacity: var(--carina-opacity-40);
}
.carina-date-range-picker {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    border: 0;
    margin-inline: var(--carina-spacing-0);
    padding-block: var(--carina-spacing-0);
    padding-inline: var(--carina-spacing-0);
    min-inline-size: var(--carina-spacing-0);
}
.carina-date-range-picker--outline input {
    margin-top: var(--carina-spacing-0);
}
.carina-date-range-picker--all-labels.carina-date-range-picker--outline {
    margin-top: 29.5px;
}
.carina-date-range-picker--all-labels.carina-date-range-picker--outline legend {
    top: -29.5px;
}
.carina-date-range-picker--all-labels.carina-date-range-picker--underline {
    margin-top: 29.5px;
}
.carina-date-range-picker--all-labels.carina-date-range-picker--underline legend {
    top: -29.5px;
}
.carina-date-range-picker--only-top-label.carina-date-range-picker--outline {
    margin-top: 10px;
}
.carina-date-range-picker__textbox-wrapper {
    display: flex;
    align-items: flex-end;
}
.carina-date-range-picker__separator {
    display: flex;
    color: var(--carina-text-color-base);
    align-items: center;
    align-self: flex-end;
    padding-right: var(--carina-spacing-2);
    padding-left: var(--carina-spacing-2);
}
.carina-date-range-picker__separator--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-date-range-picker__separator--default {
    height: 40px;
}
.carina-date-range-picker__separator--outline {
    height: 42px;
    margin-top: 10px;
}
.carina-date-range-picker__separator--underline {
    height: 42px;
}
.carina-date-range-picker__separator--grid {
    height: 24px;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.\\!flex {
    display: flex !important;
}
.flex {
    display: flex;
}
.grid {
    display: grid;
}
.hidden {
    display: none;
}
.carina-file-upload__dropzone {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--carina-spacing-2);
    border-color: var(--carina-border-color-base);
    border-style: dashed;
    border-width: var(--carina-border-width-2);
    border-radius: var(--carina-border-radius-xl);
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, border-color;
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    outline-color: var(--carina-colors-transparent);
}
.carina-file-upload__dropzone:focus,
  .carina-file-upload__dropzone:focus-within {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload__dropzone--disabled {
    cursor: default;
    border-color: var(--carina-border-color-soft);
}
.carina-file-upload__dropzone--list-first {
    margin-top: var(--carina-spacing-6);
}
.carina-file-upload {
    position: relative;
    width: 100%;
    max-width: 400px;
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
}
.carina-file-upload--large {
    max-width: 992px;
}
.carina-file-upload--block {
    max-width: none;
}
.carina-file-upload__drop-area {
    padding: var(--carina-spacing-0) var(--carina-spacing-4);
}
.carina-file-upload__drop-area--large {
    padding-bottom: var(--carina-spacing-8);
    text-align: center;
}
.carina-file-upload__header {
    margin: var(--carina-spacing-6) var(--carina-spacing-0);
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-size: var(--carina-font-size-display-xs);
}
.carina-file-upload__header--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-file-upload__upload {
    margin: 31px 0;
    color: var(--carina-text-color-primary);
    font-size: var(--carina-font-size-body-sm);
}
.carina-file-upload__upload > * {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-file-upload__upload > svg {
    position: relative;
    top: var(--carina-spacing-0-5);
    display: inline;
    color: var(--carina-text-color-base);
    vertical-align: unset;
}
.carina-file-upload__upload--large {
    margin-bottom: var(--carina-spacing-2);
    color: var(--carina-text-color-base);
}
.carina-file-upload__upload--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-file-upload__upload--disabled > svg {
    color: var(--carina-text-color-soft);
}
.carina-file-upload__upload--large.carina-file-upload__upload--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-file-upload__drop-area-labels-container {
    margin: var(--carina-spacing-2) var(--carina-spacing-0)
    var(--carina-spacing-4);
}
.carina-file-upload__accepted-files {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
    padding-bottom: var(--carina-spacing-1);
}
.carina-file-upload__file-limit {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
}
.carina-file-upload__button-container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: var(--carina-spacing-4);
}
.carina-file-upload__action-bar {
    display: flex;
    justify-content: space-between;
    max-width: 400px;
    margin-top: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-sm);
}
.carina-file-upload__action-bar--list-first {
    margin-top: var(--carina-spacing-0);
}
.carina-file-upload__remove-all {
    box-sizing: border-box;
    padding: 0;
    border: 0;
    color: var(--carina-text-color-primary);
    font-family: inherit;
    font-size: var(--carina-font-size-body-2xs);
    line-height: inherit;
    background-color: var(--carina-colors-transparent);
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: text-decoration, outline-color;
    transition-property: text-decoration, outline-color, -webkit-text-decoration;
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    outline-color: var(--carina-colors-transparent);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-file-upload__remove-all:hover {
    text-decoration: underline;
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload__remove-all:focus,
  .carina-file-upload__remove-all:focus-visible {
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload__file-list {
    max-width: 400px;
    max-height: calc(
    42px * 10 + 8px
  );
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    padding-top: var(--carina-spacing-2);
    overflow-y: auto;
    list-style: none;
}
.carina-file-upload__file {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 296px;
    height: 42px;
    box-sizing: border-box;
    border-color: var(--carina-border-color-soft);
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-xl);
    border-style: solid;
    color: var(--carina-text-color-primary);
    font-size: var(--carina-font-size-body-sm);
    line-height: 32px;
    padding-inline-start: var(--carina-spacing-3);
    padding-inline-end: var(--carina-spacing-2);
}
.carina-file-upload__file:not(:last-of-type) {
    margin-bottom: var(--carina-spacing-2);
}
.carina-file-upload__name {
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    max-width: 100%;
    overflow: hidden;
    color: var(--carina-text-color-primary);
    font-weight: var(--carina-font-weight-body);
    direction: ltr;
    text-align: start;
    text-decoration: none;
}
.carina-file-upload__name-start {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
}
.carina-file-upload__name-end {
    white-space: pre;
}
.carina-file-upload-read-only {
    width: 100%;
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    text-align: start;
}
.carina-file-upload-read-only__content {
    position: relative;
    display: flex;
    flex-direction: column;
    font-weight: 300;
}
.carina-file-upload-read-only__content--1-cols {
    max-width: calc(400px * 1);
}
.carina-file-upload-read-only__content--2-cols {
    max-width: calc(400px * 2);
}
.carina-file-upload-read-only__content--3-cols {
    max-width: calc(400px * 3);
}
.carina-file-upload-read-only__content--4-cols {
    max-width: calc(400px * 4);
}
.carina-file-upload-read-only__content--5-cols {
    max-width: calc(400px * 5);
}
.carina-file-upload-read-only__content--6-cols {
    max-width: calc(400px * 6);
}
.carina-file-upload-read-only__content--7-cols {
    max-width: calc(400px * 7);
}
.carina-file-upload-read-only__content--8-cols {
    max-width: calc(400px * 8);
}
.carina-file-upload-read-only__content--9-cols {
    max-width: calc(400px * 9);
}
.carina-file-upload-read-only__content--10-cols {
    max-width: calc(400px * 10);
}
.carina-file-upload-read-only__attachment-count {
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-size: var(--carina-font-size-body-md);
}
.carina-file-upload-read-only__download-all {
    align-self: flex-end;
    box-sizing: border-box;
    padding: var(--carina-spacing-0);
    border: 0;
    color: var(--carina-text-color-primary);
    font-family: inherit;
    font-weight: revert;
    font-size: var(--carina-font-size-body-2xs);
    line-height: revert;
    background-color: transparent;
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: outline-color, text-decoration;
    transition-property: outline-color, text-decoration, -webkit-text-decoration;
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    outline-color: var(--carina-colors-transparent);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-file-upload-read-only__download-all:hover {
    text-decoration: underline;
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload-read-only__download-all:focus,
  .carina-file-upload-read-only__download-all:focus-visible {
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload-read-only__header {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: var(--carina-spacing-4);
    padding-inline-end: var(--carina-spacing-3);
}
.carina-file-upload-read-only__show-all {
    align-self: flex-end;
    box-sizing: border-box;
    border: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    color: var(--carina-text-color-primary);
    font-family: inherit;
    font-weight: revert;
    font-size: var(--carina-font-size-body-2xs);
    line-height: revert;
    background-color: transparent;
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: outline-color, text-decoration;
    transition-property: outline-color, text-decoration, -webkit-text-decoration;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-inline: var(--carina-spacing-2-5);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-file-upload-read-only__show-all:hover {
    text-decoration: underline;
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload-read-only__show-all:focus,
  .carina-file-upload-read-only__show-all:focus-visible {
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload-read-only__wrapper {
    max-height: calc(6 * (56px + 12px));
}
.carina-file-upload-read-only__file-list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 100%;
    max-height: calc(6 * (56px + 12px));
}
.carina-file-upload-read-only__wrapper-remaining {
    max-height: none;
}
.carina-file-upload-read-only__file-list-remaining {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    height: 100%;
    max-height: none;
}
.carina-file-upload-read-only__file-item {
    box-sizing: border-box;
    min-width: 266px;
    max-width: 400px;
    padding-top: var(--carina-spacing-2-5);
    padding-inline-end: var(--carina-spacing-3);
    padding-bottom: 12px;
    padding-inline-start: var(--carina-spacing-0);
    font-family: var(--carina-font-family-primary);
}
.carina-file-upload-read-only__file-item--1-cols {
    width: calc(100% / 1);
}
.carina-file-upload-read-only__file-item--2-cols {
    width: calc(100% / 2);
}
.carina-file-upload-read-only__file-item--3-cols {
    width: calc(100% / 3);
}
.carina-file-upload-read-only__file-item--4-cols {
    width: calc(100% / 4);
}
.carina-file-upload-read-only__file-item--5-cols {
    width: calc(100% / 5);
}
.carina-file-upload-read-only__file-item--6-cols {
    width: calc(100% / 6);
}
.carina-file-upload-read-only__file-item--7-cols {
    width: calc(100% / 7);
}
.carina-file-upload-read-only__file-item--8-cols {
    width: calc(100% / 8);
}
.carina-file-upload-read-only__file-item--9-cols {
    width: calc(100% / 9);
}
.carina-file-upload-read-only__file-item--10-cols {
    width: calc(100% / 10);
}
.carina-file-upload-read-only__paper-container {
    position: relative;
    box-sizing: border-box;
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background-color: var(--carina-background-color-surface);
}
.carina-file-upload-read-only__file-content {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 56px;
    padding: var(--carina-spacing-2);
}
.carina-file-upload-read-only__thumbnail {
    flex-shrink: 0;
    width: calc(56px - 1rem);
    height: calc(56px - 1rem);
}
.carina-file-upload-read-only__details {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: flex-start;
    margin-top: calc(-1 * var(--carina-spacing-4));
    padding: var(--carina-spacing-4) var(--carina-spacing-2)
    var(--carina-spacing-0);
    overflow-x: hidden;
}
.carina-file-upload-read-only__name {
    display: flex;
    justify-content: flex-start;
    max-width: 100%;
    margin-bottom: var(--carina-spacing-1);
    overflow-x: hidden;
    color: var(--carina-text-color-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    direction: ltr;
    text-decoration: none;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
}
.carina-file-upload-read-only__name:focus,
  .carina-file-upload-read-only__name:focus-visible {
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-file-upload-read-only__name-start {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
}
.carina-file-upload-read-only__name-end {
    white-space: pre;
}
.carina-file-upload-read-only__date-and-size {
    display: flex;
    flex-direction: row;
    margin: var(--carina-spacing-0) calc(-1 * var(--carina-spacing-2));
}
.carina-file-upload-read-only__date-and-size div:not(:first-of-type) {
    border-style: solid;
    border-inline-start-width: var(--carina-border-width-1);
    border-inline-start-color: var(--carina-border-color-soft);
    font-weight: var(--carina-font-weight-body);
}
.carina-file-upload-read-only__date {
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
}
.carina-file-upload-read-only__size {
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
}
.carina-file-upload-read-only__menu:hover {
    background-color: var(--carina-background-color-surface);
}
.carina-tag {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    padding: var(--carina-spacing-1);
    border-color: var(--carina-tag-border-color, var(--carina-border-color-soft));
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    background-color: var(
    --carina-tag-background-color,
    var(--carina-background-color-surface-alt)
  );
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: background-color, border-color, color, outline-color;
}
.carina-tag--clickable {
    border-color: var(--carina-tag-border-color, var(--carina-border-color-base));
    cursor: pointer;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-tag--clickable:hover {
    background-color: var(
      --carina-tag-background-hover,
      var(--carina-background-color-surface-hover)
    );
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag--clickable:active {
    background-color: var(
      --carina-tag-background-active,
      var(--carina-background-color-surface-active)
    );
    color: var(--carina-text-color-base);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag--clickable:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag--dismissible {
    border-color: var(--carina-tag-border-color, var(--carina-border-color-base));
}
.carina-tag--dismissible.carina-tag--small {
    padding-inline-start: var(--carina-spacing-1);
    padding-inline-end: var(--carina-spacing-0);
}
.carina-tag--small {
    height: 20px;
}
.carina-tag--medium {
    height: 28px;
}
.carina-tag--large {
    height: 32px;
}
.carina-tag--disabled {
    opacity: var(--carina-opacity-40);
    pointer-events: none;
}
.carina-tag--outline.carina-tag--clickable,
.carina-tag--outline.carina-tag--dismissible {
    border-color: var(
    --carina-tag-border-color,
    var(--carina-border-color-primary)
  );
    color: var(--carina-tag-text-inverse, var(--carina-text-color-primary));
    background-color: transparent;
}
.carina-tag--clickable.carina-tag--outline:hover {
    color: var(--carina-tag-text-hover, var(--carina-text-color-on-primary));
    background-color: var(
      --carina-tag-background-hover,
      var(--carina-background-color-primary-hover)
    );
}
.carina-tag--clickable.carina-tag--outline:active {
    color: var(--carina-tag-text-active, var(--carina-text-color-on-primary));
    background-color: var(
      --carina-tag-background-active,
      var(--carina-background-color-primary-active)
    );
}
.carina-tag__dismiss-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--carina-spacing-0);
    border-width: 0;
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-transparent);
    cursor: pointer;
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in
  );
    transition-property: background-color, border-color, color, outline-color;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-tag__dismiss-button:hover {
    background-color: var(
      --carina-tag-background-hover,
      var(--carina-background-color-surface-hover)
    );
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag__dismiss-button:active {
    background-color: var(
      --carina-tag-background-active,
      var(--carina-background-color-surface-active)
    );
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag__dismiss-button:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tag__dismiss-button--disabled {
    pointer-events: none;
}
.carina-tag__dismiss-button--small {
    width: 18px;
    height: 18px;
    margin-inline-start: -1px;
}
.carina-tag__dismiss-button--medium {
    width: 20px;
    height: 20px;
}
.carina-tag__dismiss-button--large {
    width: 24px;
    height: 24px;
}
.carina-tag__dismiss-button--outline {
    color: var(--carina-tag-text-inverse, var(--carina-text-color-primary));
}
.carina-tag__dismiss-button--outline:hover {
    color: var(--carina-tag-text-hover, var(--carina-text-color-on-primary));
    background-color: var(
      --carina-tag-background-hover,
      var(--carina-background-color-primary-hover)
    );
}
.carina-tag__dismiss-button--outline:active {
    color: var(--carina-tag-text-active, var(--carina-text-color-on-primary));
    background-color: var(
      --carina-tag-background-active,
      var(--carina-background-color-primary-active)
    );
}
.carina-tag__indicator {
    width: 10px;
    height: 10px;
    border-radius: var(--carina-border-radius-full);
}
.carina-tag__indicator--brand,
.carina-tag__indicator--primary {
    background-color: var(--carina-background-color-primary);
}
.carina-tag__indicator--accent,
.carina-tag__indicator--secondary {
    background-color: var(--carina-background-color-secondary);
}
.carina-tag__indicator--danger {
    background-color: var(--carina-background-color-danger);
}
.carina-tag__indicator--interactive {
    background-color: var(--carina-background-color-primary);
}
.carina-tag__indicator--success {
    background-color: var(--carina-background-color-success);
}
.carina-tag__indicator--tertiary {
    background-color: var(--carina-background-color-tertiary);
}
.carina-tag__indicator--warning {
    background-color: var(--carina-background-color-warning);
}
.carina-tag__label {
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.carina-tag__offset {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: var(--carina-spacing-2);
}
.carina-tag--clickable.carina-tag--outline.carina-tag--color-1,
  .carina-tag--dismissible.carina-tag--outline.carina-tag--color-1 {
    background-color: var(--carina-colors-transparent);
}
.carina-tag--clickable.carina-tag--color-1,
  .carina-tag--dismissible.carina-tag--color-1 {
    border-color: var(--carina-colors-accessory-0-20);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-0-20);
}
.carina-tag--clickable.carina-tag--color-1,
  .carina-tag--color-1 .carina-tag__dismiss-button {
    color: var(--carina-text-color-base);
}
.carina-tag--clickable.carina-tag--color-1:hover,
    .carina-tag--clickable.carina-tag--color-1:active,
    .carina-tag--color-1 .carina-tag__dismiss-button:hover,
    .carina-tag--color-1 .carina-tag__dismiss-button:active {
    border-color: var(--carina-colors-accessory-0-30);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-0-30);
}
.carina-tag--clickable.carina-tag--outline.carina-tag--color-2,
  .carina-tag--dismissible.carina-tag--outline.carina-tag--color-2 {
    background-color: var(--carina-colors-transparent);
}
.carina-tag--clickable.carina-tag--color-2,
  .carina-tag--dismissible.carina-tag--color-2 {
    border-color: var(--carina-colors-accessory-1-20);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-1-20);
}
.carina-tag--clickable.carina-tag--color-2,
  .carina-tag--color-2 .carina-tag__dismiss-button {
    color: var(--carina-text-color-base);
}
.carina-tag--clickable.carina-tag--color-2:hover,
    .carina-tag--clickable.carina-tag--color-2:active,
    .carina-tag--color-2 .carina-tag__dismiss-button:hover,
    .carina-tag--color-2 .carina-tag__dismiss-button:active {
    border-color: var(--carina-colors-accessory-1-30);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-1-30);
}
.carina-tag--clickable.carina-tag--outline.carina-tag--color-3,
  .carina-tag--dismissible.carina-tag--outline.carina-tag--color-3 {
    background-color: var(--carina-colors-transparent);
}
.carina-tag--clickable.carina-tag--color-3,
  .carina-tag--dismissible.carina-tag--color-3 {
    border-color: var(--carina-colors-accessory-2-20);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-2-20);
}
.carina-tag--clickable.carina-tag--color-3,
  .carina-tag--color-3 .carina-tag__dismiss-button {
    color: var(--carina-text-color-base);
}
.carina-tag--clickable.carina-tag--color-3:hover,
    .carina-tag--clickable.carina-tag--color-3:active,
    .carina-tag--color-3 .carina-tag__dismiss-button:hover,
    .carina-tag--color-3 .carina-tag__dismiss-button:active {
    border-color: var(--carina-colors-accessory-2-30);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-2-30);
}
.carina-tag--clickable.carina-tag--outline.carina-tag--color-4,
  .carina-tag--dismissible.carina-tag--outline.carina-tag--color-4 {
    background-color: var(--carina-colors-transparent);
}
.carina-tag--clickable.carina-tag--color-4,
  .carina-tag--dismissible.carina-tag--color-4 {
    border-color: var(--carina-colors-accessory-3-20);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-3-20);
}
.carina-tag--clickable.carina-tag--color-4,
  .carina-tag--color-4 .carina-tag__dismiss-button {
    color: var(--carina-text-color-base);
}
.carina-tag--clickable.carina-tag--color-4:hover,
    .carina-tag--clickable.carina-tag--color-4:active,
    .carina-tag--color-4 .carina-tag__dismiss-button:hover,
    .carina-tag--color-4 .carina-tag__dismiss-button:active {
    border-color: var(--carina-colors-accessory-3-30);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-3-30);
}
.carina-tag--clickable.carina-tag--outline.carina-tag--color-5,
  .carina-tag--dismissible.carina-tag--outline.carina-tag--color-5 {
    background-color: var(--carina-colors-transparent);
}
.carina-tag--clickable.carina-tag--color-5,
  .carina-tag--dismissible.carina-tag--color-5 {
    border-color: var(--carina-colors-accessory-4-20);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-4-20);
}
.carina-tag--clickable.carina-tag--color-5,
  .carina-tag--color-5 .carina-tag__dismiss-button {
    color: var(--carina-text-color-base);
}
.carina-tag--clickable.carina-tag--color-5:hover,
    .carina-tag--clickable.carina-tag--color-5:active,
    .carina-tag--color-5 .carina-tag__dismiss-button:hover,
    .carina-tag--color-5 .carina-tag__dismiss-button:active {
    border-color: var(--carina-colors-accessory-4-30);
    color: var(--carina-text-color-base);
    background-color: var(--carina-colors-accessory-4-30);
}
.carina-multi-select__filter-area {
    padding: var(--carina-spacing-4);
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
}
.carina-multi-select__filter-area :where(.carina-textbox-icon) {
    cursor: text;
    pointer-events: none;
}
.carina-multi-select__filter-area-button {
    box-sizing: border-box;
    border: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    color: var(--carina-text-color-primary);
    font-size: var(--carina-font-size-body-xs);
    font-family: var(--carina-font-family-primary);
    line-height: inherit;
    background-color: var(--carina-colors-transparent);
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-inline-start: var(--carina-spacing-2-5);
    padding-inline-end: var(--carina-spacing-2-5);
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, -webkit-text-decoration;
    transition-property: outline-color, text-decoration;
    transition-property: outline-color, text-decoration, -webkit-text-decoration;
}
.carina-multi-select__filter-area-button:hover {
    text-decoration: underline;
    transition-duration: var(--carina-transition-duration-100);
}
.carina-multi-select__filter-area-button:focus,
  .carina-multi-select__filter-area-button:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    border-radius: var(--carina-border-radius-md);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-multi-select__filter-area-button-container {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding-top: var(--carina-spacing-4);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-xs);
    font-family: var(--carina-font-family-primary);
    margin-inline-start: calc(-1 * var(--carina-spacing-2-5));
    margin-inline-end: calc(-1 * var(--carina-spacing-2-5));
}
.carina-multi-select__item-renderer {
    position: relative;
    left: var(--carina-spacing-2);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: var(--carina-spacing-0-5) var(--carina-spacing-2);
    border: 0;
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    line-height: inherit;
    background-color: var(--carina-background-color-popper);
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-multi-select__item-renderer:hover {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-multi-select__item-renderer:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-selected);
}
.carina-multi-select__item-renderer--selected {
    border: 0;
    color: var(--carina-text-color-base);
}
.carina-multi-select__item-renderer--selected:hover {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-multi-select__item-renderer--heading {
    padding: var(--carina-spacing-2);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-2xs);
    text-transform: uppercase;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    pointer-events: none;
}
.carina-multi-select__item-renderer--focus {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-multi-select__item-renderer--keyboard-focus {
    box-shadow: inset 0 0 0 var(--carina-border-width-2)
    var(--carina-border-color-base);
}
.carina-multi-select__item-renderer--disabled {
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-multi-select__item-renderer-icon-space {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    height: 16px;
    pointer-events: none;
}
.carina-multi-select__item-renderer-highlight-label {
    flex-grow: 0;
    flex-shrink: 0;
    color: var(--carina-background-color-primary);
    font-weight: var(--carina-font-weight-display);
    letter-spacing: -0.3px;
}
.carina-multi-select__item-renderer-highlight-label--focus {
    color: var(--carina-background-color-primary);
}
.carina-multi-select__item-renderer-label-container {
    width: 100%;
    overflow: hidden;
    font-size: var(--carina-font-size-body-sm);
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    background-color: var(--carina-colors-transparent);
    pointer-events: none;
    padding-inline-start: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-2);
}
[dir='rtl'] .carina-multi-select__item-renderer-label-container {
    text-align: right;
}
.carina-multi-select__item-renderer-label-container--no-match-message {
    text-overflow: unset;
    white-space: normal;
}
.carina-multi-select__item-renderer--no-match-message {
    display: flex;
    align-items: flex-start;
}
.carina-multi-select__selected-indicator {
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-sm);
}
.carina-multi-select__selected-indicator--disabled {
    border-color: var(--carina-border-color-soft);
}
.carina-multi-select__selected-indicator--selected {
    border-color: var(--carina-colors-transparent);
    background-color: var(--carina-background-color-primary);
}
.carina-multi-select__selected-indicator--selected--disabled {
    background-color: var(--carina-background-color-primary);
}
.carina-multi-select__selected-indicator-check {
    fill: var(--carina-text-color-base-inverse);
}
.carina-multi-select .carina-popper {
    border-radius: var(--carina-border-radius-xl);
}
.carina-pseudo-focus {
    display: flex;
    flex-direction: column;
    width: 300px;
    min-width: 296px;
    max-width: 100vw;
    height: 400px;
    max-height: calc(100vh - 10px);
    border-radius: var(--carina-border-radius-xl);
    overflow: hidden;
    background-color: var(--carina-background-color-popper);
    outline: none;
}
.carina-pseudo-focus__auto-sizer-inner-element {
    padding-top: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
}
.carina-pseudo-focus__auto-sizer-container {
    height: 100%;
}
.carina-container {
    box-sizing: border-box;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
}
.carina-container--normal {
    container-type: normal;
}
.carina-container--size {
    container-type: size;
}
.carina-container--inline-size {
    container-type: inline-size;
}
.carina-container--sm {
    max-width: var(--carina-breakpoint-sm);
}
.carina-container--md {
    max-width: var(--carina-breakpoint-md);
}
.carina-container--lg {
    max-width: var(--carina-breakpoint-lg);
}
.carina-container--xl {
    max-width: var(--carina-breakpoint-xl);
}
.carina-container--2xl {
    max-width: var(--carina-breakpoint-2xl);
}
.carina-row {
    --carina-row-gutter-x: var(--carina-spacing-4);
    --carina-row-gutter-y: var(--carina-spacing-0);
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--carina-row-gutter-y) * -1);
    margin-inline-start: calc(var(--carina-row-gutter-x) * -0.5);
    margin-inline-end: calc(var(--carina-row-gutter-x) * -0.5);
}
.carina-row > * {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    margin-top: var(--carina-row-gutter-y);
    padding-right: calc(var(--carina-row-gutter-x) * 0.5);
    padding-left: calc(var(--carina-row-gutter-x) * 0.5);
}
.carina-column {
    flex: 1 0 0%;
}
.carina-row--cols-auto > * {
    flex: 0 0 auto;
    width: auto;
}
.carina-row--cols-1 > * {
    flex: 0 0 auto;
    width: calc(100% / 1);
}
.carina-row--cols-2 > * {
    flex: 0 0 auto;
    width: calc(100% / 2);
}
.carina-row--cols-3 > * {
    flex: 0 0 auto;
    width: calc(100% / 3);
}
.carina-row--cols-4 > * {
    flex: 0 0 auto;
    width: calc(100% / 4);
}
.carina-row--cols-5 > * {
    flex: 0 0 auto;
    width: calc(100% / 5);
}
.carina-row--cols-6 > * {
    flex: 0 0 auto;
    width: calc(100% / 6);
}
.carina-row--gutter-x-compact {
    --carina-row-gutter-x: var(--carina-spacing-4);
}
.carina-row--gutter-y-compact {
    --carina-row-gutter-y: var(--carina-spacing-4);
}
.carina-row--gutter-x-default {
    --carina-row-gutter-x: var(--carina-spacing-6);
}
.carina-row--gutter-y-default {
    --carina-row-gutter-y: var(--carina-spacing-6);
}
.carina-row--gutter-x-roomy {
    --carina-row-gutter-x: var(--carina-spacing-8);
}
.carina-row--gutter-y-roomy {
    --carina-row-gutter-y: var(--carina-spacing-8);
}
.carina-row--gutter-x-0 {
    --carina-row-gutter-x: var(--carina-spacing-0);
}
.carina-row--gutter-y-0 {
    --carina-row-gutter-y: var(--carina-spacing-0);
}
.carina-row--gutter-x-2 {
    --carina-row-gutter-x: var(--carina-spacing-2);
}
.carina-row--gutter-y-2 {
    --carina-row-gutter-y: var(--carina-spacing-2);
}
.carina-row--gutter-x-4 {
    --carina-row-gutter-x: var(--carina-spacing-4);
}
.carina-row--gutter-y-4 {
    --carina-row-gutter-y: var(--carina-spacing-4);
}
.carina-row--gutter-x-6 {
    --carina-row-gutter-x: var(--carina-spacing-6);
}
.carina-row--gutter-y-6 {
    --carina-row-gutter-y: var(--carina-spacing-6);
}
.carina-row--gutter-x-8 {
    --carina-row-gutter-x: var(--carina-spacing-8);
}
.carina-row--gutter-y-8 {
    --carina-row-gutter-y: var(--carina-spacing-8);
}
.carina-row--gutter-x-10 {
    --carina-row-gutter-x: var(--carina-spacing-10);
}
.carina-row--gutter-y-10 {
    --carina-row-gutter-y: var(--carina-spacing-10);
}
.carina-column--fill {
    flex: 1 0 0%;
    width: 0;
}
.carina-column--auto {
    flex: 0 0 auto;
    width: auto;
}
.carina-column--span-1 {
    flex: 0 0 auto;
    width: calc(100% * 1 / 12);
}
.carina-column--span-2 {
    flex: 0 0 auto;
    width: calc(100% * 2 / 12);
}
.carina-column--span-3 {
    flex: 0 0 auto;
    width: calc(100% * 3 / 12);
}
.carina-column--span-4 {
    flex: 0 0 auto;
    width: calc(100% * 4 / 12);
}
.carina-column--span-5 {
    flex: 0 0 auto;
    width: calc(100% * 5 / 12);
}
.carina-column--span-6 {
    flex: 0 0 auto;
    width: calc(100% * 6 / 12);
}
.carina-column--span-7 {
    flex: 0 0 auto;
    width: calc(100% * 7 / 12);
}
.carina-column--span-8 {
    flex: 0 0 auto;
    width: calc(100% * 8 / 12);
}
.carina-column--span-9 {
    flex: 0 0 auto;
    width: calc(100% * 9 / 12);
}
.carina-column--span-10 {
    flex: 0 0 auto;
    width: calc(100% * 10 / 12);
}
.carina-column--span-11 {
    flex: 0 0 auto;
    width: calc(100% * 11 / 12);
}
.carina-column--span-12 {
    flex: 0 0 auto;
    width: calc(100% * 12 / 12);
}
.carina-column--offset-1 {
    margin-right: 0;
    margin-left: calc(100% * 1 / 12);
}
[dir='rtl'] .carina-column--offset-1 {
    margin-right: calc(100% * 1 / 12);
    margin-left: 0;
}
.carina-column--offset-2 {
    margin-right: 0;
    margin-left: calc(100% * 2 / 12);
}
[dir='rtl'] .carina-column--offset-2 {
    margin-right: calc(100% * 2 / 12);
    margin-left: 0;
}
.carina-column--offset-3 {
    margin-right: 0;
    margin-left: calc(100% * 3 / 12);
}
[dir='rtl'] .carina-column--offset-3 {
    margin-right: calc(100% * 3 / 12);
    margin-left: 0;
}
.carina-column--offset-4 {
    margin-right: 0;
    margin-left: calc(100% * 4 / 12);
}
[dir='rtl'] .carina-column--offset-4 {
    margin-right: calc(100% * 4 / 12);
    margin-left: 0;
}
.carina-column--offset-5 {
    margin-right: 0;
    margin-left: calc(100% * 5 / 12);
}
[dir='rtl'] .carina-column--offset-5 {
    margin-right: calc(100% * 5 / 12);
    margin-left: 0;
}
.carina-column--offset-6 {
    margin-right: 0;
    margin-left: calc(100% * 6 / 12);
}
[dir='rtl'] .carina-column--offset-6 {
    margin-right: calc(100% * 6 / 12);
    margin-left: 0;
}
.carina-column--offset-7 {
    margin-right: 0;
    margin-left: calc(100% * 7 / 12);
}
[dir='rtl'] .carina-column--offset-7 {
    margin-right: calc(100% * 7 / 12);
    margin-left: 0;
}
.carina-column--offset-8 {
    margin-right: 0;
    margin-left: calc(100% * 8 / 12);
}
[dir='rtl'] .carina-column--offset-8 {
    margin-right: calc(100% * 8 / 12);
    margin-left: 0;
}
.carina-column--offset-9 {
    margin-right: 0;
    margin-left: calc(100% * 9 / 12);
}
[dir='rtl'] .carina-column--offset-9 {
    margin-right: calc(100% * 9 / 12);
    margin-left: 0;
}
.carina-column--offset-10 {
    margin-right: 0;
    margin-left: calc(100% * 10 / 12);
}
[dir='rtl'] .carina-column--offset-10 {
    margin-right: calc(100% * 10 / 12);
    margin-left: 0;
}
.carina-column--offset-11 {
    margin-right: 0;
    margin-left: calc(100% * 11 / 12);
}
[dir='rtl'] .carina-column--offset-11 {
    margin-right: calc(100% * 11 / 12);
    margin-left: 0;
}
.carina-filter-control-bar__tag-list {
    display: none;
    gap: var(--carina-spacing-2);
    margin-top: var(--carina-spacing-2);
    margin-bottom: var(--carina-spacing-2);
}
.carina-filter-button {
    padding: var(--carina-spacing-2) 0;
    white-space: nowrap;
}
.carina-filter-control-bar {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.carina-filter-control-bar__button {
    margin-left: var(--carina-spacing-2);
    margin-top: var(--carina-spacing-2);
}
.carina-filter-control-bar__empty-container {
    padding: var(--carina-spacing-4);
    padding-top: 0;
}
.carina-filter-control-bar__filters-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: var(--carina-spacing-3);
    align-items: center;
    max-width: 100%;
}
.carina-filter-control-bar__tags-list-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
}
.carina-filter-control-bar__visually-hidden-message {
    height: 0;
    overflow: hidden;
    width: 0;
}
.carina-filter-select {
    flex-grow: 1;
    box-sizing: border-box;
    height: 56px;
    overflow: hidden;
    -ms-overflow-style: none;
}
.carina-filter-select__inner {
    display: none;
    gap: var(--carina-spacing-2);
}
.carina-search-bar.carina-textbox__container .carina-input-fieldset {
    border-radius: var(--carina-border-radius-full);
}
.carina-search-bar .carina-textbox-icon {
    bottom: 14px;
    inset-inline-end: var(--carina-spacing-2);
}
.carina-search-bar > .carina-textbox__input {
    border-radius: var(--carina-border-radius-full);
    padding-inline-end: 84px;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
}
.carina-search-bar > .carina-textbox__input:disabled {
    color: color-mix(
      in srgb,
      var(--carina-text-color-soft) calc(var(--carina-opacity-40) * 100%),
      transparent
    );
}
.carina-search-bar .carina-button {
    display: flex;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    text-decoration: none;
}
.carina-search-bar .carina-button:hover:not(.carina-button--disabled, :active) {
    color: var(--carina-text-color-base);
}
.carina-search-bar .carina-button:focus-visible {
    outline: none;
    box-shadow: 0 0 0 var(--carina-border-width-2)
      var(--carina-border-color-base);
}
.carina-search-bar__button-icons {
    position: absolute;
    display: flex;
    inset-inline-end: 0;
}
.carina-single-dimension-filters {
    position: relative;
    box-sizing: border-box;
    max-width: 100%;
    height: 56px;
}
.carina-single-dimension-filters:has(.carina-single-dimension-filters__inner-container--scroll) {
    overflow: hidden;
    -ms-overflow-y: hidden;
}
.carina-single-dimension-filters__inner-container {
    display: flex;
    gap: var(--carina-spacing-2);
    -ms-overflow-y: auto;
    margin-inline: var(--carina-spacing-0);
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.carina-single-dimension-filters__inner-container::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    background-color: var(--carina-colors-transparent);
}
.carina-single-dimension-filters__inner-container--scroll {
    margin-inline: 36px;
    overflow: auto;
    padding-inline: var(--carina-spacing-1);
    scroll-behavior: smooth;
}
.carina-single-dimension-filters__inner-container--scroll:focus-visible {
    outline: none;
    box-shadow: var(--carina-ring-base) inset;
}
.carina-single-dimension-filters__scroll-arrow {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 56px;
    border-radius: 0;
    background-color: var(--carina-background-color-surface);
    box-shadow: var(--carina-box-shadow-md);
    cursor: pointer;
    inset-inline-end: auto;
    inset-inline-start: 0;
}
.carina-single-dimension-filters__scroll-arrow:hover {
    color: var(--carina-text-color-soft);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-single-dimension-filters__scroll-arrow:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-single-dimension-filters__end-scroll-arrow {
    inset-inline-end: 0;
    inset-inline-start: unset;
}
.carina-single-dimension-filters__scroll-arrow > .carina-button.carina-button--icon-only {
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    border: 0;
    color: var(--carina-text-color-soft);
}
.carina-single-dimension-filters__scroll-arrow > .carina-button.carina-button--icon-only:focus {
    border-radius: var(--carina-border-radius-sm);
    box-shadow: var(--carina-ring-base);
}
.carina-single-dimension-filters__scroll-arrow > .carina-button.carina-button--icon-only:hover:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-single-dimension-filters__scroll-arrow > .carina-button.carina-button--icon-only:active:not(.carina-button--disabled) {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-flyout__container {
    display: inline-block;
}
.carina-flyout__trigger {
    cursor: pointer;
}
.carina-flyout__popper {
    padding: var(--carina-spacing-4);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-2xs);
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-popper);
}
.carina-flyout-icon__button {
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    color: inherit;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-0);
}
.carina-flyout-icon__button:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    border-radius: var(--carina-border-radius-full);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-flyout-icon__button--disabled {
    color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-flyout-icon--xs {
    width: var(--carina-icon-xs);
    height: var(--carina-icon-xs);
}
.carina-flyout-icon--sm {
    width: var(--carina-icon-sm);
    height: var(--carina-icon-sm);
}
.carina-flyout-icon--md {
    width: var(--carina-icon-md);
    height: var(--carina-icon-md);
}
.carina-flyout-icon--lg {
    width: var(--carina-icon-lg);
    height: var(--carina-icon-lg);
}
.carina-form-element {
    display: block;
    box-sizing: border-box;
    width: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-spacing-4) var(--carina-spacing-0);
    vertical-align: top;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-form-element__form-label {
    position: relative;
}
.carina-form-element__form-label--visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-form-element__form-label-container {
    display: block;
    margin-bottom: var(--carina-spacing-1);
    padding: var(--carina-spacing-0);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    vertical-align: top;
}
.carina-form-element__form-label-required-indicator-container {
    position: absolute;
    inset-inline-start: -11px;
    top: -2px;
    color: var(--carina-text-color-danger);
    font-size: var(--carina-font-size-body-xl);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-form-element__form-message {
    display: block;
    margin: var(--carina-spacing-1) var(--carina-spacing-0)
    var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xs);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: normal;
    text-transform: none;
    text-indent: var(--carina-spacing-0);
    text-shadow: none;
    vertical-align: top;
}
.carina-form-element__form-message-error-icon-container {
    position: relative;
    vertical-align: middle;
    padding-inline: 0 calc(var(--carina-spacing-px) * 5);
}
.carina-form-element__form-message-error-icon-container svg {
    display: inline-block;
    vertical-align: text-bottom;
}
.carina-form-element__form-message.carina-form-element__form-message--info {
    color: var(--carina-text-color-soft);
}
.carina-form-element__form-message.carina-form-element__form-message--error {
    color: var(--carina-text-color-danger);
}
.carina-form-element__form-message.carina-form-element__form-message--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-formlayout {
    position: relative;
    width: 100%;
}
.carina-formsection {
    display: flex;
    flex-direction: column;
}
.carina-formsection__content {
    flex: 1 0 0%;
    padding-top: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-4);
}
.carina-formsection__content--stack {
    flex: 1 0 auto;
}
.carina-formsection__header {
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    direction: ltr;
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
[dir='rtl'] .carina-formsection__header {
    direction: rtl;
}
.carina-formsection__header h3 {
    margin: calc(var(--carina-spacing-5) + var(--carina-spacing-px)) 0;
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-display-2xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-tight);
}
.carina-formsection__header--stack {
    color: var(--carina-text-color-heading, var(--carina-text-color-base));
    direction: ltr;
}
[dir='rtl'] .carina-formsection__header--stack {
    direction: rtl;
}
.carina-numeric-selector {
    display: flex;
    flex-direction: row;
}
.carina-numeric-selector input {
    text-align: center;
}
[dir='rtl'] .carina-numeric-selector input {
    text-align: center;
}
.carina-numeric-selector__textbox {
    padding: 0 var(--carina-spacing-1);
    width: 56px;
    box-sizing: border-box;
    border: 0;
    font-size: 100%;
    font-family: inherit;
}
.carina-numeric-selector__textbox input {
    padding: 0;
}
.carina-numeric-selector .carina-input-fieldset--default {
    top: 0px;
    bottom: unset;
}
.carina-numeric-selector--grid input {
    --moz-appearance: textfield;
    padding: 0;
    text-align: center;
}
.carina-numeric-selector--grid button {
    width: var(--carina-spacing-6);
    height: var(--carina-spacing-6);
}
.carina-numeric-selector--underline input {
    --moz-appearance: textfield;
    text-align: center;
}
.carina-numeric-selector--outline {
    height: calc(40px + 2 * var(--carina-border-width-1));
}
.carina-numeric-selector--outline input {
    --moz-appearance: textfield;
    text-align: center;
}
.carina-numeric-selector__buttons {
    width: 40px;
    height: 40px;
}
.carina-numeric-selector__buttons > button {
    color: var(--carina-text-color-soft);
}
.carina-numeric-selector__buttons .carina-button {
    color: var(--carina-text-color-soft);
    outline-offset: var(--carina-border-width-0);
}
.carina-numeric-selector__buttons.carina-numeric-selector__buttons--grid {
    width: var(--carina-spacing-6);
    height: var(--carina-spacing-6);
}
.carina-numeric-selector__buttons.carina-numeric-selector__buttons--grid button {
    width: var(--carina-spacing-6);
    height: var(--carina-spacing-6);
}
.carina-numeric-selector__buttons.carina-numeric-selector__buttons--grid .carina-button {
    min-height: unset;
}
.carina-numeric-selector__textbox.carina-numeric-selector__textbox--underline,
.carina-numeric-selector__textbox.carina-numeric-selector__textbox--outline {
    position: relative;
    top: calc(-1 * var(--carina-spacing-2-5));
    height: calc(40px + 2 * var(--carina-border-width-1));
}
.carina-numeric-selector__buttons.carina-numeric-selector__buttons--underline,
.carina-numeric-selector__buttons.carina-numeric-selector__buttons--outline {
    margin: var(--carina-border-width-1);
}
.carina-numeric-selector__text {
    align-self: center;
    margin: var(--carina-border-width-1) 0;
    padding: 0 var(--carina-spacing-1);
}
.carina-radiogroup__button {
    position: relative;
    display: inherit;
    padding: var(--carina-spacing-2) 0;
    outline: none;
}
.carina-radiogroup__button--inline {
    display: inline-block;
}
.carina-radiogroup__button-input {
    position: absolute;
    left: -9999px;
}
[dir='rtl'] .carina-radiogroup__button-input {
    right: -9999px;
    left: unset;
}
.carina-radiogroup__button-label {
    position: relative;
    display: inline-block;
    margin-inline-start: var(--carina-spacing-4);
    padding-inline-start: var(--carina-spacing-2);
    font-size: var(--carina-font-size-body-sm);
}
.carina-radiogroup__button-label::before {
    position: absolute;
    top: 0;
    left: calc(-1 * var(--carina-spacing-4));
    display: block;
    box-sizing: border-box;
    width: var(--carina-spacing-4);
    height: var(--carina-spacing-4);
    padding-inline-start: var(--carina-spacing-2);
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-md);
    background-color: transparent;
    cursor: pointer;
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-property: border-color, background-color, outline-color;
    outline-width: var(--carina-border-width-2);
    outline-style: solid;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    content: '';
}
[dir='rtl'] .carina-radiogroup__button-label::before {
    right: calc(-1 * var(--carina-spacing-4));
    left: auto;
}
.carina-radiogroup__button-label.carina-radiogroup__button-label--read-only:not(.carina-radiogroup__button-label--checked):not(
    .carina-radiogroup__button-label--disabled
  )::before {
    color: var(--carina-text-color-base);
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
    cursor: default;
}
.carina-radiogroup__button-label.carina-radiogroup__button-label--read-only:not(.carina-radiogroup__button-label--checked):not(
    .carina-radiogroup__button-label--disabled
  )::before:focus {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-radiogroup__button-label--error::before {
    border-color: var(--carina-border-color-danger);
    border-style: solid;
    border-width: var(--carina-border-width-1);
}
.carina-radiogroup__button-label--inline {
    padding-inline-end: var(--carina-spacing-4);
}
.carina-radiogroup__button-label--checked::before {
    border-color: var(--carina-border-color-primary);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    background: var(--carina-background-color-primary);
}
.carina-radiogroup__button-label--checked::after {
    position: absolute;
    top: 0.3125rem;
    left: -0.6875rem;
    display: block;
    box-sizing: border-box;
    width: 0.375rem;
    height: 0.375rem;
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-spacing-4);
    background: var(--carina-text-color-on-primary);
    cursor: pointer;
    content: '';
}
[dir='rtl'] .carina-radiogroup__button-label--checked::after {
    right: -0.6875rem;
    left: auto;
}
.carina-radiogroup__button-label--checked.carina-radiogroup__button-label--error::before {
    border-color: var(--carina-border-color-danger);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    background-color: var(--carina-background-color-danger);
}
.carina-radiogroup__button-label--focused::before {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-radiogroup__button-label--focused.carina-radiogroup__button-label--checked::before {
    border-color: var(--carina-border-color-primary);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    background: var(--carina-background-color-primary);
}
.carina-radiogroup__button-label--focused.carina-radiogroup__button-label--checked::after {
    position: absolute;
    top: 0.3125rem;
    left: -0.6875rem;
    display: block;
    box-sizing: border-box;
    width: 0.375rem;
    height: 0.375rem;
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-spacing-4);
    background: var(--carina-text-color-on-primary);
    cursor: pointer;
    content: '';
}
[dir='rtl'] .carina-radiogroup__button-label--focused.carina-radiogroup__button-label--checked::after {
    right: -0.6875rem;
    left: auto;
}
.carina-radiogroup__button-label--focused.carina-radiogroup__button-label--checked.carina-radiogroup__button-label--error::before {
    border-color: var(--carina-border-color-danger);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    background: var(--carina-background-color-danger);
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-radiogroup__button-label--focused.carina-radiogroup__button-label--error::before {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-radiogroup__button-label--disabled {
    color: var(--carina-text-color-disabled);
    cursor: default;
}
.carina-radiogroup__button-label--disabled::before {
    border-width: 0;
    color: var(--carina-text-color-disabled);
    background-color: var(--carina-background-color-neutral-inactive);
    cursor: default;
}
.carina-radiogroup__button-label--disabled.carina-radiogroup__button-label--checked::before {
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-radiogroup {
    display: block;
    clear: both;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-tight);
    direction: ltr;
    letter-spacing: normal;
    text-align: left;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    list-style-type: none;
    outline: 0;
}
[dir='rtl'] .carina-radiogroup {
    direction: rtl;
    text-align: right;
}
.carina-switch {
    display: inline-block;
}
.carina-switch__track {
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 40px;
    height: 24px;
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-2);
    border-radius: var(--carina-border-radius-full);
    background-color: transparent;
    outline: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition: background-color var(--carina-transition-duration-400),
    outline-color
      var(--carina-transition-timing-function-expressive-ease-in-out)
      calc(var(--carina-page-loaded, 0) * var(--carina-transition-duration-100));
}
.carina-switch__track:focus {
    outline-color: var(--carina-border-color-primary-focus);
}
.carina-switch__thumb {
    position: absolute;
    top: 3px;
    inset-inline-start: 3px;
    width: 14px;
    height: 14px;
    border-radius: var(--carina-border-radius-xl);
    background-color: var(--carina-background-color-neutral);
    transform: translateX(0);
    transition: transform var(--carina-transition-duration-200)
    var(--carina-transition-timing-function-productive-ease-in);
}
.carina-switch__track.carina-switch__track--read-only {
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.carina-switch__track.carina-switch__track--read-only:hover {
    cursor: default;
}
.carina-switch__thumb.carina-switch__thumb--read-only {
    background-color: var(--carina-border-color-soft);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.carina-switch__thumb.carina-switch__thumb--read-only:hover {
    cursor: default;
}
.carina-switch--on .carina-switch__track {
    border: 0;
    background-color: var(--carina-text-color-primary);
}
.carina-switch--on .carina-switch__thumb {
    top: 2px;
    inset-inline-start: -2px;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    padding: var(--carina-spacing-0-5);
    color: var(--carina-text-color-primary);
    background-color: var(--carina-background-color-surface);
    transform: translateX(100%);
}
[dir='rtl'] .carina-switch--on .carina-switch__thumb {
    transform: translateX(-100%);
}
.carina-switch--disabled .carina-switch__track {
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-switch--disabled .carina-switch--on .carina-switch__track {
    background-color: var(--carina-text-color-primary);
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-textarea-icon {
    position: absolute;
    bottom: var(--carina-spacing-4);
    padding: var(--carina-spacing-0-5);
}
.carina-textarea-icon svg {
    display: block;
    vertical-align: middle;
}
.carina-textarea-icon--start {
    inset-inline-start: var(--carina-spacing-4);
}
.carina-textarea-icon--start.carina-textarea-icon--grid {
    inset-inline-start: var(--carina-spacing-1);
}
.carina-textarea-icon--end {
    inset-inline-end: var(--carina-spacing-4);
}
.carina-textarea {
    position: relative;
    box-sizing: border-box;
    width: 100%;
}
.carina-textarea > fieldset {
    transition-timing-function: var(
      --carina-transition-timing-function-productive-ease-in-out
    );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: border-color;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-textarea.carina-textarea--default:focus-within > fieldset {
    outline-color: var(--carina-border-color-primary-focus);
    transition-property: border-color, outline-color;
}
.carina-textarea.carina-textarea--default.carina-textarea--error:focus-within > fieldset {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-textarea.carina-textarea--default .carina-input-fieldset:not(.carina-input-fieldset--hiddenlabel) {
    bottom: 3px;
}
@supports (height: -moz-available) {
    .carina-textarea.carina-textarea--default .carina-input-fieldset:not(.carina-input-fieldset--hiddenlabel) {
        bottom: unset;
        top: calc(var(--carina-textarea-label-height) + 4px);
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) {
        height: 100%;
    }
}
.carina-textarea.carina-textarea--default .carina-input-fieldset--hiddenlabel {
    top: 0px;
}
.carina-textarea--grid {
    margin-top: var(--carina-spacing-0);
}
.carina-textarea--grid:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textarea--grid.carina-textarea--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textarea--grid > .carina-input-fieldset-outer {
    top: -3px;
}
.carina-textarea--outline {
    margin-top: 10px;
}
.carina-textarea--outline:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textarea--outline.carina-textarea--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textarea--underline {
    margin-top: 10px;
}
.carina-textarea--underline .carina-input-fieldset-outer {
    bottom: 0;
    top: unset;
}
.carina-textarea--underline:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-textarea--underline.carina-textarea--error:focus-within > .carina-input-fieldset-outer {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-textarea--error {
    border-color: var(--carina-border-color-danger);
}
.carina-textarea__textarea {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: var(--carina-spacing-0) var(--carina-spacing-0)
    calc(-1 * var(--carina-spacing-1)) var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-4)
    var(--carina-spacing-2) var(--carina-spacing-4);
    border-color: transparent;
    border-radius: var(--carina-border-radius-md);
    border-style: solid;
    border-width: var(--carina-border-width-0) var(--carina-spacing-0-5)
    var(--carina-spacing-0-5) var(--carina-spacing-0-5);
    overflow: auto;
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    line-height: var(--carina-line-height-normal);
    letter-spacing: 0;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    resize: vertical;
}
.carina-textarea__textarea::-moz-placeholder {
    color: var(--carina-text-color-soft);
}
.carina-textarea__textarea::placeholder {
    color: var(--carina-text-color-soft);
}
[dir='rtl'] .carina-textarea__textarea {
    direction: rtl;
    text-align: right;
}
.carina-textarea__textarea:focus {
    outline: 0;
}
.carina-textarea__textarea:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
}
.carina-textarea__textarea:disabled {
    border-color: transparent;
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-textarea__textarea:disabled::-moz-placeholder {
    color: color-mix(
        in srgb,
        var(--carina-text-color-soft) calc(var(--carina-opacity-40) * 100%),
        transparent
      );
}
.carina-textarea__textarea:disabled::placeholder {
    color: color-mix(
        in srgb,
        var(--carina-text-color-soft) calc(var(--carina-opacity-40) * 100%),
        transparent
      );
}
.carina-textarea__textarea svg {
    vertical-align: middle;
}
.carina-textarea__textarea.carina-textarea__textarea--read-only {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-alt);
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.carina-textarea__textarea.carina-textarea__textarea--read-only:hover {
    cursor: default;
}
.carina-textarea__textarea.carina-textarea__input--icon-end {
    padding-inline-end: calc(var(--carina-textarea-icon-width) + 16px);
}
.carina-textarea__textarea.carina-textarea__input--icon-start {
    padding-inline-start: calc(var(--carina-textarea-icon-width) + 16px);
}
.carina-textarea__textarea--fixed-size {
    resize: none;
}
.carina-textarea__textarea--s.carina-textarea__textarea--default {
    min-height: 4rem;
}
.carina-textarea__textarea--m.carina-textarea__textarea--default {
    min-height: 6rem;
}
.carina-textarea__textarea--l.carina-textarea__textarea--default {
    min-height: 8rem;
}
.carina-textarea__textarea--xl.carina-textarea__textarea--default {
    min-height: 16rem;
}
.carina-textarea__textarea--s {
    min-height: 3.5rem;
}
.carina-textarea__textarea--m {
    min-height: 5.5rem;
}
.carina-textarea__textarea--l {
    min-height: 7.5rem;
}
.carina-textarea__textarea--xl {
    min-height: 15.5rem;
}
.carina-textarea__textarea--grid {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0) var(--carina-spacing-0-5)
    var(--carina-spacing-0) var(--carina-spacing-1);
    border-width: var(--carina-border-width-0) var(--carina-border-width-0)
    var(--carina-spacing-0-5) var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-textarea__textarea--grid.carina-textarea__textarea--s {
    min-height: 0;
}
.carina-textarea__textarea--grid.carina-textarea__textarea--m {
    min-height: 0;
}
.carina-textarea__textarea--grid.carina-textarea__textarea--l {
    min-height: 0;
}
.carina-textarea__textarea--grid.carina-textarea__textarea--xl {
    min-height: 0;
}
.carina-textarea__textarea--outline {
    margin-top: var(--carina-spacing-2);
    padding: var(--carina-spacing-0-5)
    calc(var(--carina-spacing-4) - var(--carina-border-width-2))
    calc(var(--carina-spacing-2) - var(--carina-spacing-0-5))
    calc(var(--carina-spacing-4) - var(--carina-border-width-2));
    background-color: transparent;
}
.carina-textarea__textarea--underline {
    margin-top: var(--carina-spacing-2);
    padding: var(--carina-spacing-0-5) var(--carina-spacing-4)
    calc(var(--carina-spacing-2) - var(--carina-spacing-0-5))
    var(--carina-spacing-4);
    border-width: var(--carina-border-width-0) var(--carina-border-width-0)
    var(--carina-spacing-0-5) var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-none);
    background-color: transparent;
}
.carina-time-range-picker__label--hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-time-range-picker__outer-container {
    box-sizing: border-box;
    width: 100%;
    margin-inline: var(--carina-spacing-0);
    padding-block: var(--carina-spacing-0);
    padding-inline: var(--carina-spacing-0);
    min-inline-size: var(--carina-spacing-0);
    border: 0;
}
.carina-time-range-picker__outer-container input {
    margin-top: var(--carina-spacing-0);
}
.carina-time-range-picker--outline .carina-time-range-picker__outer-container.carina-time-range-picker__outer-container--all {
    margin-top: 29.5px;
}
.carina-time-range-picker--outline .carina-time-range-picker__outer-container.carina-time-range-picker__label--only-top,
.carina-time-range-picker--underline .carina-time-range-picker__outer-container.carina-time-range-picker__label--only-top {
    margin-top: 10px;
}
.carina-time-range-picker--underline .carina-time-range-picker__outer-container.carina-time-range-picker__outer-container--all {
    margin-top: 39.5px;
}
.carina-time-range-picker__inner-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
}
.carina-time-range-picker__separator {
    color: var(--carina-text-color-base);
    display: flex;
    align-items: center;
    align-self: flex-end;
    height: 40px;
    padding-right: var(--carina-spacing-2);
    padding-left: var(--carina-spacing-2);
}
.carina-time-range-picker--outline,
.carina-time-range-picker--underline {
    position: relative;
}
.carina-time-range-picker--outline .carina-time-range-picker__label.carina-time-range-picker__label--all {
    top: -29.5px;
}
.carina-time-range-picker--outline .carina-time-range-picker__separator {
    height: 42px;
    margin-top: 10px;
}
.carina-time-range-picker--underline .carina-time-range-picker__label.carina-time-range-picker__label--all {
    top: -39.5px;
}
.carina-time-range-picker--underline .carina-time-range-picker__label--only-top {
    top: -10px;
}
.carina-time-range-picker--underline .carina-time-range-picker__separator {
    height: 42px;
}
.carina-array-field__button-container {
    margin-bottom: var(--carina-spacing-6);
}
.carina-forms__read-only-text {
    width: 100%;
    padding-top: var(--carina-spacing-1);
    padding-bottom: var(--carina-spacing-0-5);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    white-space: pre-wrap;
    word-wrap: break-word;
}
.carina-forms__read-only-text__no-entry {
    color: var(--carina-text-color-soft);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.carina-link-list-item__heading {
    font-size: var(--carina-font-size-body-xl);
    line-height: var(--carina-line-height-tight);
}
.carina-link-list-item__heading--block {
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-2xs);
    text-transform: uppercase;
}
.carina-link-list-item__link {
    display: inline-block;
    border: 0;
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-normal);
    text-align: left;
    text-decoration: none;
    background: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-link-list-item__heading-subtext,
  .carina-link-list-item__subtext {
    display: block;
    margin-top: var(--carina-spacing-0-5);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
    line-height: var(--carina-line-height-normal);
}
.carina-link-list-item--interactive {
    color: var(--carina-text-color-primary);
    cursor: pointer;
}
.carina-link-list-item--interactive .carina-link-list-item__link:hover {
    color: var(--carina-text-color-primary-hover);
    text-decoration: underline;
}
.carina-link-list-item--interactive .carina-link-list-item__link:active {
    color: var(--carina-text-color-primary-active);
}
.carina-link-list-item__li {
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 0 var(--carina-spacing-2) 0;
    font-family: var(--carina-font-family-primary);
    letter-spacing: normal;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
    list-style: none;
    padding-inline: var(--carina-spacing-1-5);
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-spacing-0);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
}
.carina-link-list-item__li:focus-visible {
    border-radius: var(--carina-border-radius-md);
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-link-list {
    margin: 0 0 var(--carina-spacing-4) 0;
    padding: 0;
    font-family: var(--carina-font-family-primary);
    letter-spacing: normal;
    text-indent: 0;
    text-shadow: none;
    list-style: none;
}
.carina-link-list .carina-link-list-item__heading-subtext,
  .carina-link-list .carina-link-list-item__subtext {
    display: none;
}
.carina-link-list--block {
    display: block;
    padding: 0;
    text-decoration: none;
}
.carina-link-list--block .carina-link-list-item__heading-subtext,
    .carina-link-list--block .carina-link-list-item__subtext {
    display: block;
}
.carina-link-list--block .carina-link-list-item--interactive:hover {
    background-color: var(--carina-background-color-surface-hover);
    cursor: pointer;
}
.carina-link-list--block .carina-link-list-item--interactive:hover .carina-link-list-item__link {
    color: var(--carina-text-color-primary-hover);
    text-decoration: underline;
}
.carina-link-list--block .carina-link-list-item__li {
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: var(--carina-spacing-4);
    border-top-width: 1px;
    border-top-style: solid;
}
.carina-link-list--block .carina-link-list-item__li .carina-link-list-item__heading {
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-2xs);
    line-height: var(--carina-line-height-tight);
    text-transform: uppercase;
}
.carina-link-list--block .carina-link-list-item__li .carina-link-list-item__heading-subtext {
    line-height: var(--carina-line-height-tight);
    text-transform: uppercase;
}
.carina-link-list--block .carina-link-list-item__li:last-child {
    border-bottom-width: 1px;
    border-bottom-style: solid;
}
.carina-link-list--block .carina-link-list-item--inert,
      .carina-link-list--block .carina-link-list-item--interactive {
    border-color: var(--carina-border-color-soft);
}
.carina-link-list--block.carina-link-list--small .carina-link-list-item__li {
    padding: var(--carina-spacing-2);
}
.carina-link-list--block.carina-link-list--clean .carina-link-list-item__li {
    border: initial;
}
.carina-link-list--block.carina-link-list--clean .carina-link-list-item__li:last-child {
    border: initial;
}
@keyframes carina-loading-spinner--circle {
    0% {
        transform: rotateZ(var(--carina-rotate-0));
    }
    66% {
        transform: rotateZ(220deg);
    }
    100% {
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-spinner--tail-chase-md {
    0% {
        stroke-dashoffset: 100;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 0;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 100;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
@keyframes carina-loading-spinner--tail-chase-lg {
    0% {
        stroke-dashoffset: 240;
        transform: rotateZ(var(--carina-rotate-0));
    }
    50% {
        stroke-dashoffset: 0;
        transform: rotateZ(var(--carina-rotate-45));
    }
    100% {
        stroke-dashoffset: 240;
        transform: rotateZ(var(--carina-rotate-360));
    }
}
.carina-loading-spinner {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--carina-spacing-8);
    overflow: visible;
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-lg);
    font-family: var(--carina-font-family-primary);
    transform-origin: 50% 50%;
}
.carina-loading-spinner--textinline {
    flex-direction: row;
    margin-right: var(--carina-spacing-2);
    margin-bottom: var(--carina-spacing-8);
}
.carina-loading-spinner__circle {
    width: 78px;
    height: 78px;
    margin: 33px;
    overflow: visible;
    transform-origin: 50% 50%;
    animation: carina-loading-spinner--circle 3773ms linear infinite;
    fill: transparent;
    stroke: var(--carina-background-color-neutral-inactive);
    stroke-linecap: round;
    stroke-width: 6px;
    stroke-dasharray: 600;
}
.carina-loading-spinner__circle--lg {
    stroke-dasharray: 900;
    width: 178px;
    height: 178px;
}
.carina-loading-spinner__tail-chaser {
    transform-origin: 50% 50%;
    animation: carina-loading-spinner--tail-chase-md 2450ms linear infinite;
    stroke-dasharray: 175;
    stroke-width: 6px;
    fill: transparent;
}
.carina-loading-spinner__tail-chaser--lg {
    transform-origin: 50% 50%;
    animation: carina-loading-spinner--tail-chase-lg 2450ms linear infinite;
    stroke-dasharray: 400;
    stroke-width: 6px;
    fill: transparent;
}
.carina-loading-spinner__text {
    position: relative;
    justify-content: center;
    height: auto;
    margin: 0;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-lg);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-display-2xs);
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
}
.carina-loading-spinner__text--textinline {
    display: inline-block;
    margin-left: var(--carina-spacing-2);
}
.carina-loading-spinner__gradient-color-1 {
    stop-color: var(--carina-background-color-secondary);
}
.carina-loading-spinner__gradient-color-2 {
    stop-color: var(--carina-background-color-primary);
}
.carina-loading-spinner__gradient-color-3 {
    stop-color: var(--carina-background-color-tertiary);
}
.carina-panel {
    height: 100%;
    transform: none;
    opacity: var(--carina-opacity-100);
    --carina-z-index-current: var(--carina-z-index-panel);
    --carina-z-index-popper: calc(
    var(--carina-z-index-panel) + var(--carina-z-index-popper-diff)
  );
    --carina-z-index-scrim: calc(
    var(--carina-z-index-panel) + var(--carina-z-index-scrim-diff)
  );
    --carina-panel-width: 480px;
}
.carina-panel--inline {
    overflow: visible;
}
.carina-panel__outer-container {
    --carina-collapse-size: var(--carina-panel-width);
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-inline-start-width: var(--carina-border-width-1);
    position: fixed;
    top: var(--carina-spacing-0);
    bottom: var(--carina-spacing-0);
    z-index: var(--carina-z-index-panel);
    box-sizing: border-box;
    width: var(--carina-collapse-size);
    max-width: 100vw;
    max-height: 100vh;
    overflow: hidden;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background-color: var(--carina-background-color-surface);
    outline: none;
    box-shadow: var(--carina-box-shadow-2xl);
    transform: translateX(var(--carina-transition-translate-x));
}
.carina-panel--start .carina-panel__outer-container {
    inset-inline-start: var(--carina-spacing-0);
    border-inline-start-width: var(--carina-border-width-0);
    border-inline-end-width: var(--carina-border-width-1);
}
.carina-panel--end .carina-panel__outer-container {
    inset-inline-end: var(--carina-spacing-0);
}
.carina-panel__content-container {
    box-sizing: border-box;
    width: var(--carina-panel-width);
    max-width: 100vw;
    height: 100%;
    overflow: hidden;
    opacity: var(--carina-transition-opacity);
    transition-duration: var(--carina-transition-duration-200);
}
.carina-panel__scrim {
    opacity: var(--carina-transition-opacity);
}
.carina-panel--expressive .carina-panel__outer-container,
  .carina-panel--expressive .carina-panel__scrim {
    transition-duration: var(--carina-transition-duration-400);
}
.carina-panel--productive .carina-panel__outer-container,
  .carina-panel--productive .carina-panel__scrim,
  .carina-transition--out .carina-panel__outer-container,
  .carina-transition--out .carina-panel__scrim {
    transition-duration: var(--carina-transition-duration-200);
}
.carina-panel--productive.carina-panel--scrim.carina-transition--in .carina-panel__outer-container,
.carina-panel--productive .carina-panel__content-container,
.carina-panel--expressive.carina-transition--out .carina-panel__content-container {
    transition-delay: var(--carina-transition-delay-200);
}
.carina-panel--expressive.carina-panel--scrim.carina-transition--in .carina-panel__outer-container,
.carina-panel--expressive.carina-transition--in .carina-panel__content-container,
.carina-panel--productive.carina-panel--scrim.carina-transition--in .carina-panel__content-container {
    transition-delay: var(--carina-transition-delay-400);
}
.carina-panel--expressive.carina-panel--scrim.carina-transition--in .carina-panel__content-container {
    transition-delay: var(--carina-transition-delay-800);
}
.carina-panel.carina-transition--enter-done,
.carina-panel.carina-transition--appear-done {
    transform: none;
}
.carina-panel.carina-transition--enter-done .carina-panel__outer-container, .carina-panel.carina-transition--appear-done .carina-panel__outer-container {
    transform: none;
}
.carina-panel.carina-transition--enter-done .carina-panel__content-container, .carina-panel.carina-transition--appear-done .carina-panel__content-container {
    transform: none;
}
.carina-scroll-view-with-bars {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    box-sizing: border-box;
    width: 100%;
    max-width: inherit;
    height: 100%;
    max-height: inherit;
    overflow: hidden;
}
.carina-scroll-view-with-bars__header {
    flex-grow: 0;
    flex-shrink: 0;
    overflow: visible;
    transition: box-shadow var(--carina-transition-duration-200)
    var(--carina-transition-timing-function-productive-ease-in-out);
}
.carina-scroll-view-with-bars__header--shadow {
    z-index: calc(var(--carina-z-index-current) + 1);
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-scroll-view-with-bars__footer {
    flex-grow: 0;
    flex-shrink: 0;
    overflow: visible;
    transition: box-shadow var(--carina-transition-duration-200)
    var(--carina-transition-timing-function-productive-ease-in-out);
}
.carina-scroll-view-with-bars__footer--shadow {
    z-index: calc(var(--carina-z-index-current) + 1);
    box-shadow: var(--carina-box-shadow-reverse-lg);
}
.carina-scroll-view-with-bars__scroll-view {
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto;
}
.carina-skip-link {
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: var(--carina-z-index-modal);
    min-width: 112px;
    padding-top: var(--carina-spacing-3) var(--carina-spacing-6);
    border: 0;
    color: var(--carina-text-color-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    text-align: center;
    text-decoration: none;
    background-color: var(--carina-background-color-surface);
    cursor: pointer;
}
.carina-navigation-next__app-switcher-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 48px;
    width: 48px;
    height: 48px;
    border-radius: var(--carina-border-radius-full);
    margin-top: var(--carina-spacing-0-5);
    margin-bottom: var(--carina-spacing-3);
    margin-inline-start: var(--carina-spacing-4);
    margin-inline-end: var(--carina-spacing-4);
    background-image: linear-gradient(
    85deg,
    var(--carina-colors-primary-70) 50%,
    var(--carina-colors-secondary-50) 95%
  );
    cursor: pointer;
}
.carina-navigation-next__app-switcher-button::before {
    position: absolute;
    border-radius: var(--carina-border-radius-full);
    display: block;
    z-index: -1;
    background-image: linear-gradient(
      85deg,
      var(--carina-colors-primary-70) 0%,
      var(--carina-colors-primary-60) 60%,
      var(--carina-colors-secondary-40) 100%
    );
    opacity: 0;
    content: '';
    inset: 0;
}
.carina-navigation-next__app-switcher-button:hover::before {
    z-index: 0;
    opacity: 1;
    width: 100%;
    transition: opacity var(--carina-transition-duration-100)
        var(--carina-transition-timing-function-productive-ease-out);
}
.carina-navigation-next__app-switcher-button:focus-within {
    border-radius: var(--carina-border-radius-full);
    outline: var(--carina-border-width-2) solid var(--carina-border-color-inverse-focus);
}
.carina-navigation-next__app-switcher-button-icon-container {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: var(--carina-spacing-3);
    padding-inline-start: var(--carina-spacing-2);
}
.carina-navigation-next__app-switcher-button-text-container {
    display: none;
}
.carina-navigation-next__app-switcher-button-text {
    font-size: var(--carina-font-size-md);
}
.carina-navigation-next__app-switcher-menu {
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
    height: 100vh;
    width: 100%;
    margin-inline-end: var(--carina-spacing-0-5);
    position: relative;
    padding: var(--carina-spacing-4);
    overflow-y: auto;
}
.carina-navigation-next__app-switcher-menu-heading {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.carina-navigation-next__app-switcher-menu-heading-button {
    height: 2.75rem;
    width: 2.75rem;
}
.carina-navigation-next__app-switcher-menu-heading-text {
    font-size: var(--carina-font-size-display-xs);
    margin: var(--carina-spacing-6) var(--carina-spacing-2);
    width: calc(100% - 3.75rem);
    word-wrap: break-word;
}
.carina-navigation-next__app-switcher-menu-list {
    margin: var(--carina-spacing-4) var(--carina-spacing-2)
    var(--carina-spacing-0) var(--carina-spacing-2);
    padding: var(--carina-spacing-0);
}
.carina-navigation-next__app-switcher-menu-card {
    position: relative;
    display: flex;
    width: 17rem;
    height: 100%;
    margin: var(--carina-spacing-2) var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-4)
    var(--carina-spacing-2) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
    cursor: pointer;
}
.carina-navigation-next__app-switcher-menu-card:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__app-switcher-menu-card:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__app-switcher-menu-card-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: var(--carina-border-radius-2xl);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-0 {
    background-image: linear-gradient(#179aeb, #015fb5);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-1 {
    background-image: linear-gradient(#05a5a5, #047885);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-2 {
    background-image: linear-gradient(#00a882, #008265);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-3 {
    background-image: linear-gradient(#ed7118, #e71063);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-4 {
    background-image: linear-gradient(#ff558a, #c538b7);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-5 {
    background-image: linear-gradient(#cc3dbe, #772adb);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-6 {
    background-image: linear-gradient(#179aeb, #772adb);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-7 {
    background-image: linear-gradient(#77a11e, #009070);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-8 {
    background-image: linear-gradient(#ed7118, #c538b7);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--background-9 {
    background-image: linear-gradient(#179aeb, #00a882);
}
.carina-navigation-next__app-switcher-menu-card-icon-container--current {
    outline: var(--carina-spacing-0-5) solid var(--carina-border-color-primary);
    outline-offset: calc(1.5 * var(--carina-spacing-0-5));
}
.carina-navigation-next__app-switcher-menu-card-text-container {
    display: flex;
    flex-direction: column;
    margin-inline-start: var(--carina-spacing-4);
    width: 11.5rem;
}
.carina-navigation-next__app-switcher-menu-card-heading {
    display: flex;
    align-items: center;
    margin: var(--carina-spacing-0);
    font-size: var(--carina-font-size-body-lg);
    line-height: var(--carina-line-height-header-5);
}
.carina-navigation-next__app-switcher-menu-card-link {
    text-decoration: none;
    color: var(--carina-text-color-base);
}
.carina-navigation-next__app-switcher-menu-card-link:focus-within {
    outline: 0;
}
.carina-navigation-next__app-switcher-menu-card-link::after {
    content: '';
    inset: 0;
    position: absolute;
}
.carina-navigation-next__app-switcher-menu-card-description {
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0);
    line-height: var(--carina-line-height-normal);
    font-size: var(--carina-font-size-body-sm);
    color: var(--carina-text-color-base);
    word-wrap: break-word;
}
.carina-navigation-next__mega-menu {
    --carina-border-color-secondary-focus: #00c89b;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 400px;
    max-width: 100vw;
    overflow-x: scroll;
    padding: var(--carina-spacing-6);
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
    border-inline-start: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-navigation-next__mega-menu-list {
    height: calc(100% - 2.5rem);
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    -moz-column-fill: auto;
    column-fill: auto;
    -moz-column-width: 200px;
    column-width: 200px;
    -moz-column-gap: var(--carina-spacing-4);
    column-gap: var(--carina-spacing-4);
}
.carina-navigation-next__mega-menu-list > * {
    margin-bottom: var(--carina-spacing-2);
    margin-inline-end: var(--carina-spacing-4);
    width: 200px;
}
.carina-navigation-next__mega-menu-list > *:last-child {
    margin-bottom: var(--carina-spacing-0);
}
.carina-navigation-next__mega-menu-buttons {
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.carina-navigation-next__mega-menu-link {
    display: flex;
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    padding-inline-end: var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    cursor: pointer;
    flex-direction: row;
    align-items: center;
}
.carina-navigation-next__mega-menu-link:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__mega-menu-link:hover a {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__mega-menu-link:focus-within {
    box-shadow: var(--carina-ring-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__mega-menu-link a {
    display: flex;
    border-radius: var(--carina-border-radius-xl);
    align-items: center;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    text-decoration: none;
}
.carina-navigation-next__mega-menu-link a:hover {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__mega-menu-link a:focus-visible {
    outline: 0;
}
.carina-navigation-next__mega-menu-link--header {
    font-weight: var(--carina-font-weight-display);
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0);
}
.carina-navigation-next__mega-menu-link--header a {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-md);
    padding: var(--carina-spacing-1) var(--carina-spacing-0);
}
.carina-navigation-next__mega-menu-link--current {
    background-color: var(--carina-background-color-surface-alt);
}
.carina-navigation-next__mega-menu-link--current a {
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-semi-bold);
}
.carina-navigation-next__mega-menu-link--disabled {
    background-color: transparent;
    cursor: default;
}
.carina-navigation-next__mega-menu-link--disabled:hover {
    background-color: transparent;
}
.carina-navigation-next__mega-menu-link--disabled:hover a {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__mega-menu-link--disabled:focus-within {
    outline: 0;
    background-color: transparent;
}
.carina-navigation-next__mega-menu-link--disabled a {
    cursor: default;
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__mega-menu-link--disabled a:hover {
    color: var(--carina-text-color-disabled);
    background-color: transparent;
}
.carina-navigation-next__mega-menu-link--disabled a:focus-visible {
    outline: 0;
}
.carina-navigation-next__mega-menu-link--disabled svg {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__mega-menu-link__indicator {
    align-self: stretch;
    background-color: var(--carina-border-color-secondary-focus);
    border-radius: var(--carina-border-radius-xl);
    margin: var(--carina-spacing-0-5) var(--carina-spacing-1);
    visibility: hidden;
    width: 0.25rem;
    flex-shrink: 0;
}
.carina-navigation-next__mega-menu-link__indicator--current {
    visibility: visible;
}
.carina-navigation-next__mega-menu-link__link {
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0);
    word-break: break-word;
    width: 100%;
}
.carina-navigation-next__mega-menu-link__link--header {
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__mega-menu-link__icon {
    visibility: hidden;
    margin-inline-end: var(--carina-spacing-2);
    flex-shrink: 0;
}
.carina-navigation-next__mega-menu-link__icon--header {
    visibility: visible;
}
.carina-navigation-next__mega-menu-link__spacer {
    width: var(--carina-spacing-3);
}
.carina-navigation-next__mega-menu-link:not(.carina-navigation-next__mega-menu-link--header) .carina-navigation-next__mega-menu-link__indicator {
    margin: var(--carina-spacing-1) var(--carina-spacing-0)
      var(--carina-spacing-1) var(--carina-spacing-4);
}
.carina-navigation-next__mega-menu-link:not(.carina-navigation-next__mega-menu-link--header) .carina-navigation-next__mega-menu-link__link {
    margin-inline-start: var(--carina-spacing-2);
}
.carina-navigation-next__mega-menu-section {
    height: -moz-min-content;
    height: min-content;
    -moz-column-break-inside: avoid;
    break-inside: avoid;
}
.carina-navigation-next__mega-menu-section__list {
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0);
    padding: var(--carina-spacing-0-5) var(--carina-spacing-0);
}
.carina-navigation-next__mobile-navigation-container {
    --carina-navigation-mobile-header-height: 56px;
    --carina-navigation-mobile-z-index: 100;
    --carina-collapse-min-size: auto;
    display: flex;
    flex-direction: column;
    height: calc(100vh - var(--carina-shell-banner-current-height, 0rem));
    overflow: hidden;
    position: relative;
}
.carina-navigation-next__mobile-navigation-container__object-layer {
    --carina-background-color-surface-hover: #dedfe0;
    position: absolute;
    width: 100%;
    top: var(--carina-navigation-mobile-header-height, 56px);
    z-index: var(--carina-navigation-mobile-z-index, 100);
    height: calc(100% - var(--carina-navigation-mobile-header-height));
    overflow: hidden;
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
    display: flex;
    flex-direction: column;
}
.carina-navigation-next__mobile-navigation-container__object-layer .carina-navigation-next__object-sidebar-dropdown {
    margin-bottom: var(--carina-spacing-2);
}
.carina-navigation-next__mobile-navigation-container__solution-layer {
    width: 100%;
    top: var(--carina-navigation-mobile-header-height, 56px);
    z-index: calc(var(--carina-navigation-mobile-z-index, 100) + 1);
    height: calc(100vh - var(--carina-navigation-mobile-header-height, 56px));
    overflow: hidden;
}
.carina-navigation-next__mobile-navigation-container__solution-layer-container {
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
}
.carina-navigation-next__mobile-navigation-container__main {
    position: absolute;
    top: var(--carina-navigation-mobile-header-height);
    overflow: auto;
    height: calc(100vh - var(--carina-navigation-mobile-header-height));
}
.carina-navigation-next__mobile-navigation-container__community-panel {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--carina-background-color-surface);
}
.carina-navigation-next__mobile-navigation-container__user-profile-panel {
    display: flex;
    flex-direction: column;
    background-color: var(--carina-background-color-surface);
}
.carina-navigation-next__mobile-navigation-container__user-profile-panel-button {
    margin: var(--carina-spacing-4) var(--carina-spacing-6)
    var(--carina-spacing-0-5) var(--carina-spacing-0);
    align-self: end;
    padding: var(--carina-spacing-1);
}
.carina-navigation-next__mobile-navigation-container__skip-link {
    display: flex;
    border-radius: var(--carina-border-radius-xl);
    border-width: var(--carina-border-width-2);
    box-shadow: var(--carina-ring-base);
    justify-content: center;
    outline: 0;
}
.carina-navigation-next__mobile-navigation-container__skip-link:focus + .carina-navigation-next__mobile-navigation-container__header {
    position: absolute;
    left: -9999px;
}
.carina-navigation-next__mobile-navigation-header {
    --carina-navigation-mobile-header-height: 56px;
    display: flex;
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
    position: sticky;
    top: 0;
    width: 100%;
    height: var(--carina-navigation-mobile-header-height);
    justify-content: space-between;
    align-items: center;
}
.carina-navigation-next__mobile-navigation-header__logo-container {
    flex-shrink: 2;
    height: 100%;
}
.carina-navigation-next__mobile-navigation-header__logo-container:focus-visible {
    outline: var(--carina-border-width-2) var(--carina-border-color-hard) solid;
    outline-offset: calc(var(--carina-spacing-1) * -1);
    border-radius: var(--carina-border-radius-2xl);
}
.carina-navigation-next__mobile-navigation-header__logo-container .carina-navigation-next__solution-navigation-logo__svg {
    position: relative;
}
.carina-navigation-next__mobile-navigation-header__logo-container .carina-navigation-next__solution-navigation-logo__svg > g {
    transform: translate(0, -4px);
}
.carina-navigation-next__mobile-navigation-header__logo {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-4);
    height: 100%;
    width: auto;
    max-height: 100%;
    max-width: 100%;
}
.carina-navigation-next__mobile-navigation-header__logo:focus-within {
    border-radius: var(--carina-border-radius-lg);
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__mobile-navigation-header__logo .carina-navigation-next__solution-navigation-logo__svg-animation-group {
    transform: translate(0, var(--carina-spacing-4)) scale(2);
}
.carina-navigation-next__mobile-navigation-header__end-button {
    margin-top: var(--carina-spacing-2);
    margin-inline-end: var(--carina-spacing-4);
    margin-bottom: var(--carina-spacing-2);
    margin-inline-start: var(--carina-spacing-0);
}
.carina-navigation-next__mobile-navigation-header__end-button:focus-within {
    border-radius: var(--carina-border-radius-lg);
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-mobile-container {
    display: flex;
    flex-direction: column;
}
.carina-navigation-next__object-mobile-container__solution-bar {
    display: flex;
    margin: var(--carina-spacing-4);
    width: calc(100vw - 2 * var(--carina-spacing-4));
    align-items: center;
    cursor: pointer;
}
.carina-navigation-next__object-mobile-container__solution-bar:focus-within {
    border-radius: var(--carina-border-radius-lg);
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-mobile-container__solution-bar-icon {
    margin-inline-end: var(--carina-spacing-2);
}
[dir='rtl'] .carina-navigation-next__object-mobile-container__solution-bar-icon {
    transform: rotate(180deg);
}
.carina-navigation-next__object-mobile-container__solution-bar-text {
    display: flex;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-xl);
    font-weight: var(--carina-font-weight-display);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__object-mobile-container__object-header-container {
    border-top-left-radius: var(--carina-border-radius-lg);
    border-top-right-radius: var(--carina-border-radius-lg);
    margin: var(--carina-spacing-0) var(--carina-spacing-4);
}
.carina-navigation-next__object-mobile-container__object-layer-scroll {
    display: flex;
    margin: auto;
    flex-direction: column;
    width: calc(100% - 2 * var(--carina-spacing-4));
    background-color: var(--carina-background-color-surface-alt);
    padding: var(--carina-spacing-2) var(--carina-spacing-1-5);
}
.carina-navigation-next__object-mobile-container__object-layer-container {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-navigation-next__solution-mobile-container {
    display: flex;
    flex-direction: column;
}
.carina-navigation-next__navigation-community {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 800px;
    height: 800px;
    width: 420px;
    padding: var(--carina-spacing-6);
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
}
.carina-navigation-next__navigation-community-header {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-lg);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__navigation-community-description {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-body-sm);
    margin: var(--carina-spacing-4) var(--carina-spacing-0);
    text-align: center;
}
.carina-navigation-next__navigation-community-image {
    height: 224px;
    width: 224px;
    margin-top: var(--carina-spacing-12);
}
.carina-navigation-next__navigation-flyout__trigger-container {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    list-style: none;
}
.carina-navigation-next__navigation-flyout__popper {
    border-width: var(--carina-border-width-0);
}
.carina-navigation-next__search-box {
    display: inline-flex;
    align-items: center;
    margin-bottom: var(--carina-spacing-3);
}
.carina-navigation-next__search-box__header {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-header-4);
    font-weight: var(--carina-font-weight-display);
    margin: var(--carina-spacing-2-5);
    line-height: var(--carina-line-height-header-4);
}
.carina-navigation-next__search-item {
    display: flex;
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    align-items: center;
    height: 100%;
    cursor: pointer;
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__search-item:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__search-item:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__search-item a {
    display: flex;
    min-height: 1.5rem;
    width: 100%;
    border-radius: var(--carina-border-radius-xl);
    align-items: center;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    line-height: normal;
    text-decoration: none;
}
.carina-navigation-next__search-item a:focus-visible {
    outline: 0;
}
.carina-navigation-next__search-item__start-icon {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__search-item__link {
    margin: var(--carina-spacing-2) var(--carina-spacing-0);
    flex: 1 1 100%;
    word-break: break-word;
}
.carina-navigation-next__search-list__header {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-header-6);
    font-weight: var(--carina-font-weight-display);
    margin: var(--carina-spacing-2) var(--carina-spacing-0);
    line-height: var(--carina-line-height-header-6);
    padding-left: var(--carina-spacing-2);
}
.carina-navigation-next__search-list__list {
    padding: var(--carina-spacing-0);
    margin-bottom: var(--carina-spacing-5);
}
.carina-navigation-next__navigation-user-profile {
    width: 100%;
    min-width: 15.5rem;
    padding: var(--carina-spacing-0);
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
}
.carina-navigation-next__navigation-user-profile::before {
    content: '';
    height: 2.5rem;
    width: 2rem;
    position: absolute;
    bottom: 0.125rem;
    left: -2rem;
    z-index: 1;
}
.carina-navigation-next__navigation-user-profile__name {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-lg);
    font-weight: var(--carina-font-weight-display);
    margin: var(--carina-spacing-3) var(--carina-spacing-0);
}
.carina-navigation-next__navigation-user-profile__email,
.carina-navigation-next__navigation-user-profile__id {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-xs);
    line-height: var(--carina-line-height-3);
}
.carina-navigation-next__navigation-user-profile__scroll .carina-scroll-view-with-bars__scroll-view {
    padding-top: var(--carina-spacing-4);
    padding-inline-start: var(--carina-spacing-4);
    padding-inline-end: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-4);
    max-height: calc(100vh - 40px - var(--carina-spacing-4));
    overflow-x: hidden;
    position: static;
    scrollbar-color: var(--carina-border-color-primary)
      var(--carina-background-color-surface);
    scrollbar-width: thin;
}
.carina-navigation-next__navigation-user-profile__avatar-content {
    display: flex;
    padding-top: var(--carina-spacing-0);
    padding-inline-start: var(--carina-spacing-4);
    padding-inline-end: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-4);
    flex-direction: column;
    align-items: center;
}
.carina-navigation-next__navigation-user-profile__list {
    display: flex;
    margin: var(--carina-spacing-0);
    padding-top: var(--carina-spacing-2);
    padding-inline-start: var(--carina-spacing-0);
    padding-inline-end: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
    flex-direction: column;
    list-style-type: none;
}
.carina-navigation-next__navigation-user-profile__account-list,
.carina-navigation-next__navigation-user-profile__list-item {
    padding: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__navigation-user-profile__account-list > * {
    margin-bottom: var(--carina-spacing-1);
}
.carina-navigation-next__navigation-user-profile__account-list > *:last-child {
    margin-bottom: var(--carina-spacing-0);
}
.carina-navigation-next__navigation-user-profile__link,
.carina-navigation-next__navigation-user-profile__account-link {
    display: flex;
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2-5);
    text-decoration: none;
    align-items: center;
}
.carina-navigation-next__navigation-user-profile__link:hover, .carina-navigation-next__navigation-user-profile__account-link:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__navigation-user-profile__link:focus-within, .carina-navigation-next__navigation-user-profile__account-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__navigation-user-profile--expanded {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.carina-navigation-next__navigation-user-profile__name--expanded {
    line-height: var(--carina-line-height-header-6);
    margin: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-spacing-3) var(--carina-spacing-0);
}
.carina-navigation-next__navigation-user-profile__avatar--expanded {
    margin-inline-end: var(--carina-spacing-4);
}
.carina-navigation-next__navigation-user-profile__container--expanded {
    display: flex;
    flex-direction: row;
}
.carina-navigation-next__navigation-user-profile__list--expanded {
    padding: var(--carina-spacing-4) var(--carina-spacing-0)
    var(--carina-spacing-2) var(--carina-spacing-0);
}
.carina-navigation-next__navigation-user-profile__list-item--expanded {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.carina-navigation-next__navigation-user-profile__link--expanded {
    width: 100%;
}
.carina-navigation-next__navigation-user-profile__accounts-header {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-2xs);
    text-transform: uppercase;
}
.carina-navigation-next__navigation-user-profile__link-icon {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__navigation-user-profile__account-link {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.carina-navigation-next__navigation-user-profile__account-link:hover .carina-navigation-next__navigation-user-profile__account-link-end {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__navigation-user-profile__account-link-avatar {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__navigation-user-profile__account-link-start {
    display: flex;
    color: var(--carina-text-color-base);
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.carina-navigation-next__navigation-user-profile__account-link-end {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
}
.carina-navigation-next__object-header-container {
    --carina-navigation-object-header-full-height: 80px;
    --carina-navigation-object-header-border-height: var(--carina-spacing-px);
    display: grid;
    grid-template-areas: 'start'
    'end';
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    background-color: var(--carina-background-color-surface-alt);
    color: var(--carina-text-color-base);
    padding: var(--carina-spacing-4);
}
.carina-navigation-next__object-header-container__start {
    min-width: 320px;
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__object-header-container__end {
    height: 48px;
    margin-top: var(--carina-spacing-2);
    display: flex;
    align-items: center;
}
.carina-navigation-next__object-header-container__top {
    display: flex;
    width: 100%;
    align-items: center;
    margin: 0;
    padding-bottom: var(--carina-spacing-1);
}
.carina-navigation-next__object-header-container__top * {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-header-container__top-breadcrumbs {
    width: calc(100% - 4rem);
}
.carina-navigation-next__object-header-container__top-chevron-container {
    display: none;
}
.carina-navigation-next__object-header-container__top-icon-container {
    display: none;
}
.carina-navigation-next__object-header-container__top-breadcrumbs-root {
    font-size: var(--carina-font-size-sm);
    white-space: nowrap;
}
.carina-navigation-next__object-header-container__top-breadcrumbs-object {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: var(--carina-font-weight-bold);
    font-size: var(--carina-font-size-lg);
}
.carina-navigation-next__object-header-container__top-breadcrumbs-root,
.carina-navigation-next__object-header-container__top-chevron {
    display: none;
}
.carina-navigation-next__object-header-container__top-chevron {
    margin: var(--carina-spacing-0) var(--carina-spacing-1);
}
.carina-navigation-next__object-header-container__top-end-content > * {
    display: flex;
    font-size: var(--carina-font-size-sm);
}
.carina-navigation-next__object-header-container__lower-container {
    display: flex;
    flex-direction: column;
    font-size: var(--carina-font-size-sm);
}
.carina-navigation-next__object-header-container__lower-divider-icon {
    display: none;
}
.carina-navigation-next__object-navigation-link {
    display: flex;
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    align-items: center;
    min-height: 2rem;
    cursor: pointer;
}
.carina-navigation-next__object-navigation-link:hover,
  .carina-navigation-next__object-navigation-link:focus-within {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__object-navigation-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-navigation-link a {
    display: flex;
    min-height: 1.5rem;
    width: 100%;
    border-radius: var(--carina-border-radius-xl);
    align-items: center;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-body-sm);
    text-decoration: none;
}
.carina-navigation-next__object-navigation-link a:hover,
    .carina-navigation-next__object-navigation-link a:focus-within {
    color: var(--carina-text-color-base);
    outline: 0;
}
.carina-navigation-next__object-navigation-link--current {
    background-color: var(--carina-background-color-surface-selected);
}
.carina-navigation-next__object-navigation-link--current a {
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-bold);
}
.carina-navigation-next__object-navigation-link--disabled {
    background-color: transparent;
    cursor: default;
}
.carina-navigation-next__object-navigation-link--disabled:hover,
  .carina-navigation-next__object-navigation-link--disabled:focus-within {
    background-color: transparent;
}
.carina-navigation-next__object-navigation-link--disabled:focus-within {
    outline: 0;
}
.carina-navigation-next__object-navigation-link--disabled a {
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-navigation-next__object-navigation-link--disabled a:focus-visible {
    outline: 0;
}
.carina-navigation-next__object-navigation-link__indicator {
    align-self: stretch;
    background-color: var(--carina-border-color-secondary-focus);
    border-radius: var(--carina-border-radius-xl);
    margin: var(--carina-spacing-1-5) var(--carina-spacing-1);
    visibility: hidden;
    width: 0.25rem;
}
.carina-navigation-next__object-navigation-link__indicator--current {
    visibility: visible;
}
.carina-navigation-next__object-navigation-menu {
    --carina-background-color-surface: #eeeff0;
    --carina-background-color-surface-active: #f6f7f7;
    --carina-background-color-surface-hover: #dedfe0;
    --carina-background-color-surface-selected: #f6f7f7;
    --carina-border-color-secondary-focus: #00c89b;
    max-width: 15.5rem;
    padding: var(--carina-spacing-6);
    background-color: var(--carina-background-color-surface);
    box-shadow: var(--carina-box-shadow-lg);
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__object-navigation-menu::before {
    content: '';
    height: 2.5rem;
    width: 2rem;
    position: absolute;
    top: calc(50% - 1.25rem);
    left: -2rem;
    z-index: 1;
}
.carina-popper:has(> .carina-navigation-next__object-navigation-menu) {
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__object-navigation-menu__heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: var(--carina-spacing-2);
}
.carina-navigation-next__object-navigation-menu__heading-icon {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__object-navigation-menu__heading-text {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-lg);
    font-weight: var(--carina-font-weight-display);
    line-height: var(--carina-line-height-header-3);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__object-navigation-menu__description {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-xs);
}
.carina-navigation-next__object-navigation-menu__list {
    margin: var(--carina-spacing-2) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-navigation-next__object-sidebar-collapse {
    --carina-navigation-object-sidebar-full-width: 240px;
    --carina-navigation-object-sidebar-compact-width: 64px;
    width: 100%;
    min-width: var(--carina-navigation-object-sidebar-compact-width);
}
.carina-navigation-next__object-sidebar-container {
    --carina-background-color-surface-active: #f6f7f7;
    --carina-background-color-surface-hover: #dedfe0;
    --carina-background-color-surface-selected: #f6f7f7;
    --carina-border-color-secondary-focus: #00c89b;
    container-type: inline-size;
    container-name: object;
    height: calc(
    100vh - var(--carina-shell-banner-current-height) -
      var(--carina-shell-title-current-height)
  );
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
    position: relative;
}
.carina-navigation-object-sidebar-container-scroll .carina-navigation-next__object-sidebar-link,
  .carina-navigation-object-sidebar-container-scroll .carina-navigation-next__object-sidebar-dropdown {
    margin: var(--carina-spacing-0);
    min-height: 40px;
    padding: 0;
    padding-inline-end: var(--carina-spacing-2);
}
.carina-navigation-object-sidebar-container-scroll .carina-navigation-next__object-sidebar-dropdown {
    margin-top: var(--carina-spacing-0-5);
    margin-bottom: var(--carina-spacing-2);
}
.carina-navigation-object-sidebar-container-scroll .carina-scroll-view-with-bars__footer {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-3);
}
.carina-navigation-object-sidebar-container-scroll
    .carina-scroll-view-with-bars__footer
    .carina-navigation-next__object-sidebar-link__content {
    margin-top: 0;
}
.carina-navigation-object-sidebar-container-scroll .carina-scroll-view-with-bars__scroll-view {
    position: static;
    scrollbar-width: thin;
}
.carina-navigation-next__object-sidebar-container-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--carina-background-color-surface);
    width: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-3) var(--carina-spacing-2-5);
}
.carina-navigation-next__object-sidebar-container-container > div,
.carina-navigation-next__object-sidebar-container-container > .carina-navigation-next__object-sidebar-segment,
.carina-navigation-next__object-sidebar-container-container
  > .carina-navigation-next__navigation-flyout__trigger-container {
    width: 100%;
}
.carina-navigation-next__object-sidebar-dropdown {
    display: flex;
    width: 100%;
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    justify-content: center;
    min-height: 2rem;
    cursor: pointer;
    flex-direction: column;
}
.carina-navigation-next__object-sidebar-dropdown a {
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-md);
    text-decoration: none;
}
.carina-navigation-next__object-sidebar-dropdown:hover .carina-navigation-next__object-sidebar-dropdown__start-icon,
    .carina-navigation-next__object-sidebar-dropdown:hover .carina-navigation-next__object-sidebar-dropdown__title,
    .carina-navigation-next__object-sidebar-dropdown:hover .carina-navigation-next__object-sidebar-dropdown__chevron {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--carina-spacing-1) var(--carina-spacing-3);
}
.carina-navigation-next__object-sidebar-dropdown__row:active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__object-sidebar-dropdown__row:hover {
    background-color: var(--carina-background-color-surface);
    border-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__object-sidebar-dropdown__row:focus-within {
    border-radius: var(--carina-border-radius-xl);
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-sidebar-dropdown--disabled {
    background-color: transparent;
    pointer-events: none;
}
.carina-navigation-next__object-sidebar-dropdown--disabled a {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-dropdown--disabled a:focus-visible {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-sidebar-dropdown--disabled svg {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-dropdown__indicator--current {
    border-radius: var(--carina-border-radius-xl);
    height: 20px;
    width: 4px;
    background-color: var(--carina-border-color-secondary-focus);
    margin: 0 var(--carina-spacing-1) 0 var(--carina-spacing-0-5);
    flex-shrink: 0;
    display: none;
}
.carina-navigation-next__object-sidebar-dropdown-link__indicator {
    border-radius: var(--carina-border-radius-xl);
    height: 20px;
    width: 4px;
    background-color: var(--carina-border-color-secondary-focus);
    margin: var(--carina-spacing-0) var(--carina-spacing-3)
    var(--carina-spacing-0) var(--carina-spacing-1);
    flex-shrink: 0;
}
.carina-navigation-next__object-sidebar-dropdown__start-icon {
    color: var(--carina-text-color-base);
    min-width: 20px;
}
.carina-navigation-next__object-sidebar-dropdown__start-icon--current {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__title {
    padding-inline-start: var(--carina-spacing-2);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__title:hover {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__title:focus-within {
    outline: 0;
}
.carina-navigation-next__object-sidebar-dropdown__chevron {
    color: var(--carina-text-color-base);
    margin-inline-start: auto;
}
.carina-navigation-next__object-sidebar-dropdown__dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    list-style: none;
    border-radius: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-border-radius-xl) var(--carina-border-radius-xl);
    margin: var(--carina-spacing-1) var(--carina-spacing-0);
    padding-inline-start: var(--carina-spacing-0);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown * {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown--expanded,
.carina-navigation-next__object-sidebar-dropdown__title--expanded,
.carina-navigation-next__object-sidebar-dropdown__start-icon--expanded,
.carina-navigation-next__object-sidebar-dropdown__dropdown--expanded {
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown--force-expanded,
.carina-navigation-next__object-sidebar-dropdown--force-expanded .carina-navigation-next__object-sidebar-dropdown__title,
.carina-navigation-next__object-sidebar-dropdown--force-expanded .carina-navigation-next__object-sidebar-dropdown__start-icon,
.carina-navigation-next__object-sidebar-dropdown--force-expanded .carina-navigation-next__object-sidebar-dropdown__dropdown,
.carina-navigation-next__object-sidebar-dropdown--force-expanded .carina-navigation-next__object-sidebar-dropdown__row:hover {
    background-color: var(--carina-background-color-surface-selected);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__title--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item {
    display: flex;
    align-items: center;
    text-align: start;
    width: 100%;
    padding: var(--carina-spacing-0) var(--carina-spacing-1);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item:has(.carina-navigation-next__object-sidebar-dropdown__dropdown-link--disabled) {
    cursor: default;
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link {
    font-size: var(--carina-font-size-body-sm);
    display: flex;
    align-items: center;
    padding-inline-start: var(--carina-spacing-9);
    padding-top: var(--carina-spacing-1);
    padding-bottom: var(--carina-spacing-1);
    width: 100%;
    border-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link:hover {
    background-color: var(--carina-background-color-surface-hover);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
    width: 100%;
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link:has(.carina-navigation-next__object-sidebar-dropdown-link__indicator) {
    padding-inline-start: var(--carina-spacing-4);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link--current {
    font-weight: var(--carina-font-weight-display);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link--disabled {
    background-color: transparent;
    pointer-events: none;
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-dropdown__dropdown-list-item .carina-navigation-next__object-sidebar-dropdown__dropdown-link--disabled:focus-visible {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-sidebar-header {
    box-sizing: border-box;
    display: flex;
    gap: var(--carina-spacing-2);
    align-items: center;
    justify-content: flex-start;
    padding-inline-start: var(--carina-spacing-2-5);
    padding-inline-end: var(--carina-spacing-0);
    padding-top: var(--carina-spacing-3);
    padding-bottom: var(--carina-spacing-4);
    position: relative;
    flex-shrink: 0;
    width: 100%;
}
.carina-navigation-next__object-sidebar-header__icon {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;
    flex-shrink: 0;
}
.carina-navigation-next__object-sidebar-header__title {
    font-family: var(--carina-font-family-display);
    font-size: var(--carina-font-size-header-6);
    font-weight: var(--carina-font-weight-display);
    line-height: var(--carina-line-height-header-4);
    position: relative;
    flex-shrink: 0;
    color: var(--carina-text-color-base);
    white-space: nowrap;
}
.carina-navigation-next__object-sidebar-link {
    display: flex;
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    align-items: center;
    min-height: 2rem;
    cursor: pointer;
    width: 100%;
    min-width: 42px;
    padding-inline-start: 0;
}
.carina-navigation-next__object-sidebar-link:active .carina-navigation-next__object-sidebar-link__content {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__object-sidebar-link:focus-within .carina-navigation-next__object-sidebar-link__content {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__object-sidebar-link:hover .carina-navigation-next__object-sidebar-link__content {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__object-sidebar-link a,
  .carina-navigation-next__object-sidebar-link button {
    display: flex;
    width: 100%;
    text-decoration: none;
}
.carina-navigation-next__object-sidebar-link a:focus-visible, .carina-navigation-next__object-sidebar-link button:focus-visible {
    outline: 0;
}
.carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-link a,
  .carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-link button {
    margin-inline-start: calc(var(--carina-spacing-1) / 2);
}
.carina-navigation-next__object-sidebar-link--current .carina-navigation-next__object-sidebar-link__content {
    background-color: var(--carina-background-color-surface-selected);
    font-weight: var(--carina-font-weight-semi-bold);
}
.carina-navigation-next__object-sidebar-link--disabled,
.carina-navigation-next__object-sidebar-link--disabled-style-only {
    background-color: transparent;
}
.carina-navigation-next__object-sidebar-link--disabled:hover .carina-navigation-next__object-sidebar-link__content, .carina-navigation-next__object-sidebar-link--disabled-style-only:hover .carina-navigation-next__object-sidebar-link__content {
    background-color: transparent;
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-link--disabled:focus-within .carina-navigation-next__object-sidebar-link__content, .carina-navigation-next__object-sidebar-link--disabled-style-only:focus-within .carina-navigation-next__object-sidebar-link__content {
    outline: 0;
}
.carina-navigation-next__object-sidebar-link--disabled a:focus-visible, .carina-navigation-next__object-sidebar-link--disabled button:focus-visible, .carina-navigation-next__object-sidebar-link--disabled-style-only a:focus-visible, .carina-navigation-next__object-sidebar-link--disabled-style-only button:focus-visible {
    outline: 0;
}
.carina-navigation-next__object-sidebar-link--disabled-style-only .carina-navigation-next__object-sidebar-link__content,
.carina-navigation-next__object-sidebar-link--disabled .carina-navigation-next__object-sidebar-link__content {
    color: var(--carina-text-color-disabled);
    cursor: pointer;
}
.carina-navigation-next__object-sidebar-link--disabled-style-only .carina-navigation-next__object-sidebar-link__content svg, .carina-navigation-next__object-sidebar-link--disabled .carina-navigation-next__object-sidebar-link__content svg {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__object-sidebar-link--disabled {
    pointer-events: none;
}
.carina-navigation-next__object-sidebar-link--disabled-style-only {
    cursor: default;
}
.carina-navigation-next__object-sidebar-link--disabled-style-only a,
  .carina-navigation-next__object-sidebar-link--disabled-style-only button {
    cursor: default;
}
.carina-navigation-next__object-sidebar-link__indicator {
    align-self: stretch;
    background-color: var(--carina-border-color-secondary-focus);
    border-radius: var(--carina-border-radius-xl);
    visibility: hidden;
    width: 0.25rem;
    margin: var(--carina-spacing-0-5) var(--carina-spacing-0-5)
    var(--carina-spacing-0-5) var(--carina-spacing-1);
}
.carina-navigation-next__object-sidebar-link__indicator--current {
    visibility: visible;
}
.carina-navigation-next__object-sidebar-link__spacer {
    min-width: var(--carina-spacing-5);
    height: var(--carina-spacing-5);
    width: var(--carina-spacing-5);
}
.carina-navigation-next__object-sidebar-link__start-icon {
    min-width: 20px;
}
.carina-navigation-next__object-sidebar-link__link {
    width: 100%;
    height: 100%;
}
.carina-navigation-next__object-sidebar-link__content {
    display: inline-flex;
    width: 100%;
    min-height: 32px;
    height: auto;
    border-radius: var(--carina-border-radius-xl);
    align-items: center;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    line-height: normal;
    margin: var(--carina-spacing-1) var(--carina-spacing-0);
    padding: var(--carina-spacing-1) var(--carina-spacing-0);
    word-break: break-word;
    transition: max-height var(--carina-transition-duration-300)
    var(--carina-transition-timing-function-productive-ease-out);
}
.carina-navigation-next__object-sidebar-link__chevron {
    min-width: 20px;
    opacity: var(--carina-opacity-0);
}
.carina-navigation-next__object-sidebar-link__chevron--flyout {
    margin-inline-start: var(--carina-spacing-2-5);
}
[dir='rtl'] .carina-navigation-next__object-sidebar-link__chevron--flyout {
    transform: rotate(180deg);
}
.carina-navigation-next__object-sidebar-link__children-wrapper {
    flex-grow: 2;
    text-align: start;
    margin-inline-start: var(--carina-spacing-2);
    opacity: 0;
    clip: rect(0, 0, 0, 0);
    height: 0px;
    width: unset;
    position: absolute;
}
.carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-link__children-wrapper {
    height: unset;
    width: -moz-min-content;
    width: min-content;
    clip: unset;
    opacity: 1;
    position: static;
}
.carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-link {
    width: 100%;
}
.carina-navigation-next__object-sidebar-segment {
    padding-inline-start: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__object-sidebar-segment__header {
    text-transform: uppercase;
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-xs);
    line-height: var(--carina-line-height-body-xs);
    font-weight: var(--carina-font-weight-display);
    font-family: var(--carina-font-family-body);
    display: none;
    padding: var(--carina-spacing-3) var(--carina-spacing-0)
    var(--carina-spacing-2-5) var(--carina-spacing-3);
}
.carina-navigation-next__object-sidebar-segment__header div {
    margin-inline-end: var(--carina-spacing-2);
    max-width: calc(100% - 28px);
    word-wrap: break-word;
}
.carina-navigation-next__object-sidebar-segment__header svg {
    min-width: 20px;
}
.carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-segment__header {
    display: flex;
    justify-content: space-between;
    padding: var(--carina-spacing-3);
}
.carina-navigation-next__object-sidebar-segment > ul {
    margin: 0;
    padding: 0;
}
.carina-navigation-object-sidebar-container-scroll
  .carina-navigation-next__object-sidebar-segment
  .carina-navigation-next__object-sidebar-link {
    min-height: 40px;
}
.carina-navigation-next__object-sidebar-segment::before {
    content: '';
    display: block;
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    max-width: 24px;
    margin: 24px 0px 24px 8px;
}
.carina-navigation-next__mobile-navigation-container .carina-navigation-next__object-sidebar-segment::before {
    max-width: 100%;
    border-top: none;
    margin: 0;
    height: 0;
}
.carina-navigation-next__solution-navigation-link {
    display: flex;
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-sm);
    align-items: center;
    min-height: 2rem;
    cursor: pointer;
}
.carina-navigation-next__solution-navigation-link:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__solution-navigation-link:hover a {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-navigation-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__solution-navigation-link a {
    display: flex;
    min-height: 1.5rem;
    width: 100%;
    border-radius: var(--carina-border-radius-xl);
    align-items: center;
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
    line-height: normal;
    text-decoration: none;
}
.carina-navigation-next__solution-navigation-link a:focus-visible {
    outline: 0;
}
.carina-navigation-next__solution-navigation-link--current {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__solution-navigation-link--current a {
    color: var(--carina-text-color-base);
    font-weight: bold;
}
.carina-navigation-next__solution-navigation-link--disabled {
    background-color: transparent;
    cursor: default;
}
.carina-navigation-next__solution-navigation-link--disabled:hover {
    background-color: transparent;
}
.carina-navigation-next__solution-navigation-link--disabled:hover a {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-navigation-link--disabled:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-navigation-link--disabled a {
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-navigation-next__solution-navigation-link--disabled a:focus-visible {
    outline: 0;
}
.carina-navigation-next__solution-navigation-link__indicator {
    align-self: stretch;
    background-color: var(--carina-border-color-secondary-focus);
    border-radius: var(--carina-border-radius-xl);
    margin: var(--carina-spacing-1-5) var(--carina-spacing-1);
    visibility: hidden;
    width: 0.25rem;
}
.carina-navigation-next__solution-navigation-link__indicator--current {
    visibility: visible;
}
.carina-navigation-next__solution-navigation-logo {
    --carina-navigation-logo-height: 80px;
    --carina-navigation-logo-x-offset: var(--carina-spacing-7);
    --carina-navigation-logo-y-offset: var(--carina-spacing-6);
    --carina-navigation-logo-full-offset: var(--carina-spacing-24);
    background-color: color-mix(
    in srgb,
    var(--carina-background-color-primary) 50%,
    transparent
  );
    align-items: center;
    display: flex;
    height: calc(var(--carina-navigation-logo-height) - var(--carina-spacing-px));
    justify-content: center;
    width: 100%;
}
.carina-navigation-next__solution-navigation-logo a {
    align-items: center;
    color: var(--carina-text-color-primary);
    display: flex;
    height: 100%;
    justify-content: center;
    outline: none;
    position: relative;
    text-decoration: none;
    width: 100%;
}
.carina-navigation-next__solution-navigation-logo a:focus,
    .carina-navigation-next__solution-navigation-logo a:focus-visible {
    outline: var(--carina-border-width-2) var(--carina-border-color-hard)
        solid;
    outline-offset: calc(var(--carina-border-width-8) * -1);
    border-radius: var(--carina-border-radius-2xl);
}
.carina-navigation-next__solution-navigation-logo img {
    height: var(--carina-navigation-logo-height);
    width: auto;
    max-width: 100%;
    max-height: 100%;
}
.carina-navigation-next__solution-navigation-logo .carina-navigation-next__solution-navigation-logo__svg-animation-group {
    transform: translate(
      var(--carina-navigation-logo-x-offset),
      var(--carina-navigation-logo-y-offset)
    );
}
.carina-navigation-next__solution-navigation-logo .carina-navigation-next__solution-navigation-logo__svg {
    height: var(--carina-navigation-logo-height);
}
.carina-navigation-next__solution-navigation-logo .carina-navigation-next__solution-navigation-logo__svg-full {
    opacity: 0;
}
.carina-navigation-next__solution-navigation-logo:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-navigation-logo__svg {
    position: absolute;
    top: 0;
    left: 0;
}
.carina-navigation-next__solution-navigation-logo__svg-animation-group {
    transition-property: transform;
    transition-duration: 0ms;
    transition-delay: 0ms;
    transition-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-navigation-next__solution-navigation-logo__svg-compact,
  .carina-navigation-next__solution-navigation-logo__svg-full {
    transition-property: opacity;
    transition-duration: var(--carina-transition-duration-100);
    transition-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-navigation-next__solution-navigation-logo__compact {
    display: none;
    opacity: 0%;
    transition-property: opacity;
    transition-duration: var(--carina-transition-duration-200);
    transition-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-navigation-next__solution-navigation-logo__compact--compact:hover {
    display: block;
    opacity: 0%;
}
.carina-navigation-next__solution-navigation-logo__full {
    display: block;
    opacity: 100%;
    transform: translateX(0%);
    transition-property: transform;
    transition-duration: var(--carina-transition-duration-200);
    transition-timing-function: var(--carina-transition-timing-function-linear);
}
.carina-navigation-next__solution-navigation-logo__full--compact {
    display: flex;
    opacity: 0%;
}
.carina-navigation-next__solution-navigation-menu {
    --carina-background-color-surface-active: #003673;
    --carina-background-color-surface-alt: #183f6d;
    --carina-background-color-surface-hover: #003673;
    --carina-background-color-surface-selected: #003673;
    --carina-border-color-secondary-focus: #00c89b;
    max-width: 15.5rem;
    padding: var(--carina-spacing-6);
    background-color: var(--carina-background-color-surface);
    box-shadow: var(--carina-box-shadow-lg);
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__solution-navigation-menu::before {
    content: '';
    height: 2.5rem;
    width: 2rem;
    position: absolute;
    top: calc(50% - 1.5625rem);
    left: -2rem;
    z-index: 1;
}
.carina-popper:has(> .carina-navigation-next__solution-navigation-menu) {
    border-start-end-radius: var(--carina-border-radius-xl);
    border-end-end-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__solution-navigation-menu__heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: var(--carina-spacing-3);
}
.carina-navigation-next__solution-navigation-menu__heading-icon {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__solution-navigation-menu__heading-text {
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-lg);
    font-weight: var(--carina-font-weight-display);
    line-height: var(--carina-line-height-header-3);
    margin: var(--carina-spacing-0);
}
.carina-navigation-next__solution-navigation-menu__description {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-xs);
}
.carina-navigation-next__solution-navigation-menu__list {
    margin: var(--carina-spacing-2) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-navigation-next__solution-sidebar-collapse {
    width: 100%;
    min-width: 80px;
}
.carina-navigation-next__solution-sidebar-container {
    --carina-background-color-surface-active: #003673;
    --carina-background-color-surface-alt: #183f6d;
    --carina-background-color-surface-hover: #003673;
    --carina-background-color-surface-selected: #003673;
    --carina-border-color-secondary-focus: #00c89b;
    --carina-navigation-solution-sidebar-full-width: 320px;
    --carina-navigation-solution-sidebar-compact-width: 80px;
    --carina-navigation-solution-sidebar-mobile-width: 100%;
    container-type: inline-size;
    container-name: solution;
    height: calc(100vh - var(--carina-shell-banner-current-height, 0rem));
    background-color: var(--carina-background-color-surface);
    position: relative;
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-navigation-next__solution-navigation-logo {
    margin: var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-5) var(--carina-spacing-0);
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-navigation-next__solution-sidebar-link,
  .carina-navigation-next__solution-sidebar-container-scroll .carina-navigation-next__solution-sidebar-dropdown {
    margin: var(--carina-spacing-0-5) var(--carina-spacing-3)
      var(--carina-spacing-3-5) var(--carina-spacing-3);
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-scroll-view-with-bars__scroll-view {
    overflow-x: hidden;
    position: static;
    scrollbar-color: var(--carina-border-color-primary)
      var(--carina-background-color-surface);
    scrollbar-width: thin;
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-scroll-view-with-bars__header--shadow {
    box-shadow: var(--carina-box-shadow-xl);
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-scroll-view-with-bars__footer {
    margin-bottom: var(--carina-spacing-4);
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-scroll-view-with-bars__footer > div:first-child {
    margin-top: var(--carina-spacing-5);
}
.carina-navigation-next__solution-sidebar-container-scroll .carina-scroll-view-with-bars__footer--shadow {
    box-shadow: var(--carina-box-shadow-reverse-xl);
}
.carina-navigation-next__solution-sidebar-container-skip-link {
    display: flex;
    background-color: var(--carina-background-color-primary);
    border-radius: var(--carina-border-radius-xl);
    border-width: var(--carina-border-width-2);
    box-shadow: var(--carina-ring-base);
    justify-content: center;
    outline: 0;
}
.carina-navigation-next__solution-sidebar-container-skip-link:focus {
    position: absolute;
    width: 17.25rem;
}
.carina-navigation-next__solution-sidebar-container-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    list-style: none;
}
.carina-navigation-next__solution-sidebar-container-footer {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-navigation-next__solution-sidebar-dropdown {
    padding-top: var(--carina-spacing-0);
    padding-bottom: var(--carina-spacing-0);
    padding-inline-end: var(--carina-spacing-2);
    padding-inline-start: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-md);
    justify-content: center;
    min-height: 2.5rem;
    cursor: pointer;
    width: -moz-min-content;
    width: min-content;
    flex-direction: column;
    transition: opacity var(--carina-transition-duration-300)
    var(--carina-transition-timing-function-expressive-ease-in-out)
    var(--carina-transition-delay-100);
}
.carina-navigation-next__solution-sidebar-dropdown .carina-collapse--vertical {
    --carina-collapse-size: 0px;
    opacity: var(--carina-opacity-0);
    width: 0px;
}
.carina-navigation-next__solution-sidebar-dropdown a {
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-soft);
    text-decoration: none;
}
.carina-navigation-next__solution-sidebar-dropdown:active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__solution-sidebar-dropdown:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__solution-sidebar-dropdown:hover .carina-navigation-next__solution-sidebar-dropdown__start-icon,
    .carina-navigation-next__solution-sidebar-dropdown:hover .carina-navigation-next__solution-sidebar-dropdown__title,
    .carina-navigation-next__solution-sidebar-dropdown:hover .carina-navigation-next__solution-sidebar-dropdown__chevron {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown:focus-within {
    border-radius: var(--carina-border-radius-xl);
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__solution-sidebar-dropdown--current {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__solution-sidebar-dropdown--current svg,
  .carina-navigation-next__solution-sidebar-dropdown--current .carina-navigation-next__solution-sidebar-dropdown__chevron {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown--disabled {
    background-color: transparent;
    pointer-events: none;
}
.carina-navigation-next__solution-sidebar-dropdown--disabled a,
  .carina-navigation-next__solution-sidebar-dropdown--disabled svg {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-sidebar-dropdown--disabled a:focus-visible, .carina-navigation-next__solution-sidebar-dropdown--disabled svg:focus-visible {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__solution-sidebar-dropdown__indicator {
    border-radius: var(--carina-border-radius-xl);
    height: 24px;
    width: 4px;
    background-color: var(--carina-border-color-secondary-focus);
    flex-shrink: 0;
    visibility: hidden;
    margin: var(--carina-spacing-0) var(--carina-spacing-0-5);
}
.carina-navigation-next__solution-sidebar-dropdown__indicator--current {
    visibility: visible;
}
.carina-navigation-next__solution-sidebar-dropdown-link__indicator {
    border-radius: var(--carina-border-radius-xl);
    height: 20px;
    width: 4px;
    flex-shrink: 0;
    background-color: var(--carina-border-color-secondary-focus);
    margin: var(--carina-spacing-0) var(--carina-spacing-2);
}
.carina-navigation-next__solution-sidebar-dropdown__start-icon {
    color: var(--carina-text-color-soft);
    flex-shrink: 0;
}
.carina-navigation-next__solution-sidebar-dropdown__title {
    display: none;
    color: var(--carina-text-color-soft);
}
.carina-navigation-next__solution-sidebar-dropdown__title:hover {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown__title:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-sidebar-dropdown__start-icon--current {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown__chevron {
    display: none;
    color: var(--carina-text-color-soft);
    margin-inline-end: var(--carina-spacing-1);
}
.carina-navigation-next__solution-sidebar-dropdown__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: var(--carina-spacing-1);
}
.carina-navigation-next__solution-sidebar-dropdown__row:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown {
    display: flex;
    flex-direction: column;
    align-items: center;
    list-style: none;
    border-radius: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-border-radius-xl) var(--carina-border-radius-xl);
    margin: var(--carina-spacing-1) var(--carina-spacing-0);
    padding-inline-start: var(--carina-spacing-0);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown * {
    color: var(--carina-text-color-soft);
}
.carina-navigation-next__solution-sidebar-dropdown--expanded,
.carina-navigation-next__solution-sidebar-dropdown__title--expanded,
.carina-navigation-next__solution-sidebar-dropdown__start-icon--expanded,
.carina-navigation-next__solution-sidebar-dropdown__dropdown--expanded,
.carina-navigation-next__solution-sidebar-dropdown__chevron--expanded {
    background-color: var(--carina-background-color-surface-active);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown--expanded {
    opacity: var(--carina-opacity-0);
    transition: opacity 0ms;
}
.carina-navigation-next__solution-sidebar-dropdown__indicator--current-child {
    visibility: visible;
}
.carina-navigation-next__solution-sidebar-dropdown__title--current,
.carina-navigation-next__solution-sidebar-dropdown__title--current-child {
    font-weight: var(--carina-font-weight-display);
}
.carina-navigation-next__solution-sidebar-dropdown__title--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item {
    display: flex;
    align-items: center;
    text-align: start;
    width: 100%;
    padding: var(--carina-spacing-0) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-1);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item:has(.carina-navigation-next__solution-sidebar-dropdown__dropdown-link--disabled) {
    cursor: default;
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link {
    font-size: var(--carina-font-size-body-sm);
    display: flex;
    align-items: center;
    padding-inline-start: var(--carina-spacing-12);
    padding-top: var(--carina-spacing-2-5);
    padding-bottom: var(--carina-spacing-2-5);
    width: 100%;
    border-radius: var(--carina-border-radius-xl);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link:hover {
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
    width: 100%;
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link:has(.carina-navigation-next__solution-sidebar-dropdown-link__indicator) {
    padding-inline-start: var(--carina-spacing-7);
    font-weight: var(--carina-font-weight-display);
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link--disabled {
    background-color: transparent;
    pointer-events: none;
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link--disabled:focus-visible {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__solution-sidebar-link {
    display: flex;
    padding: var(--carina-spacing-0) var(--carina-spacing-3)
    var(--carina-spacing-0) var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    font-size: var(--carina-font-size-body-md);
    align-items: center;
    min-height: 2.5rem;
    cursor: pointer;
    width: -moz-min-content;
    width: min-content;
}
.carina-navigation-next__solution-sidebar-link:active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__solution-sidebar-link:focus-within {
    box-shadow: var(--carina-ring-base);
    outline: 0;
}
.carina-navigation-next__solution-sidebar-link:hover:not(.carina-navigation-next__solution-sidebar-link--disabled):not(.carina-navigation-next__solution-sidebar-link--disabled-style-only) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation-next__solution-sidebar-link:hover:not(.carina-navigation-next__solution-sidebar-link--disabled):not(.carina-navigation-next__solution-sidebar-link--disabled-style-only) a,
    .carina-navigation-next__solution-sidebar-link:hover:not(.carina-navigation-next__solution-sidebar-link--disabled):not(.carina-navigation-next__solution-sidebar-link--disabled-style-only) svg {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-link a,
  .carina-navigation-next__solution-sidebar-link button {
    padding-inline-start: var(--carina-spacing-1);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-md);
    text-decoration: none;
}
.carina-navigation-next__solution-sidebar-link--current {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation-next__solution-sidebar-link--current a,
  .carina-navigation-next__solution-sidebar-link--current svg {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-link--disabled,
.carina-navigation-next__solution-sidebar-link--disabled-style-only {
    background-color: transparent;
}
.carina-navigation-next__solution-sidebar-link--disabled:hover, .carina-navigation-next__solution-sidebar-link--disabled-style-only:hover {
    background-color: transparent;
}
.carina-navigation-next__solution-sidebar-link--disabled:focus-within, .carina-navigation-next__solution-sidebar-link--disabled-style-only:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-sidebar-link--disabled a,
  .carina-navigation-next__solution-sidebar-link--disabled button,
  .carina-navigation-next__solution-sidebar-link--disabled-style-only a,
  .carina-navigation-next__solution-sidebar-link--disabled-style-only button {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-sidebar-link--disabled a:focus-visible, .carina-navigation-next__solution-sidebar-link--disabled button:focus-visible, .carina-navigation-next__solution-sidebar-link--disabled-style-only a:focus-visible, .carina-navigation-next__solution-sidebar-link--disabled-style-only button:focus-visible {
    outline: 0;
}
.carina-navigation-next__solution-sidebar-link--disabled svg, .carina-navigation-next__solution-sidebar-link--disabled-style-only svg {
    color: var(--carina-text-color-disabled);
}
.carina-navigation-next__solution-sidebar-link--disabled {
    pointer-events: none;
}
.carina-navigation-next__solution-sidebar-link--disabled-style-only {
    cursor: default;
}
.carina-navigation-next__solution-sidebar-link--disabled-style-only a,
  .carina-navigation-next__solution-sidebar-link--disabled-style-only button {
    cursor: default;
}
.carina-navigation-next__solution-sidebar-link--mobile {
    background-color: var(--carina-background-color-surface-alt);
    width: calc(100% - 2 * var(--carina-spacing-3) - 2px);
}
.carina-navigation-next__solution-sidebar-link--mobile a,
  .carina-navigation-next__solution-sidebar-link--mobile svg {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-link__indicator {
    border-radius: var(--carina-border-radius-xl);
    height: 24px;
    width: 4px;
    background-color: var(--carina-border-color-secondary-focus);
    visibility: hidden;
    flex-shrink: 0;
    margin: var(--carina-spacing-0) var(--carina-spacing-0-5)
    var(--carina-spacing-0) var(--carina-spacing-0-5);
}
.carina-navigation-next__solution-sidebar-link__indicator--current {
    visibility: visible;
}
.carina-navigation-next__solution-sidebar-link__spacer {
    min-width: var(--carina-spacing-8);
    height: var(--carina-spacing-8);
    width: var(--carina-spacing-8);
}
.carina-navigation-next__solution-sidebar-link__start-icon {
    color: var(--carina-text-color-soft);
    flex-shrink: 0;
    box-sizing: content-box;
    margin-inline-end: var(--carina-spacing-2);
}
.carina-navigation-next__solution-sidebar-link__start-icon--current {
    color: var(--carina-text-color-base);
}
.carina-navigation-next__solution-sidebar-link__link {
    align-items: center;
    text-align: start;
    word-break: break-word;
    opacity: var(--carina-opacity-100);
    width: 100%;
    height: 40px;
    display: flex;
}
.carina-navigation-next__solution-sidebar-link__link:focus-within {
    outline: 0;
}
.carina-navigation-next__solution-sidebar-link__link--mobile-top {
    opacity: var(--carina-opacity-100);
}
.carina-navigation-next__solution-sidebar-link__chevron {
    display: none;
}
.carina-navigation-next__solution-sidebar-link__chevron--flyout {
    color: var(--carina-text-color-soft);
    margin-inline-end: var(--carina-spacing-2);
}
[dir='rtl'] .carina-navigation-next__solution-sidebar-link__chevron--flyout {
    transform: rotate(180deg);
}
.carina-navigation__app-switcher {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: content-box;
    width: 45px;
    height: 56px;
    padding: var(--carina-spacing-0) var(--carina-spacing-1-5);
    background: var(--carina-background-color-primary);
    margin-inline-start: var(--carina-spacing-3-5);
}
.carina-navigation__app-switcher .carina-button--brand {
    background-color: var(--carina-background-color-primary);
}
.carina-navigation__app-switcher .carina-button--brand:focus-visible {
    outline: var(--carina-border-color-soft) var(--carina-border-width-1);
    box-shadow: var(--carina-ring-white);
}
.carina-navigation__app-switcher-container .carina-tooltip__container {
    z-index: calc(var(--carina-z-index-popper) + 1);
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container) {
    z-index: var(--carina-z-index-popper);
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container) .carina-popper {
    border-width: var(--carina-border-width-0);
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container) .carina-popper .carina-navigation__app-switcher-menu {
    border-radius: var(--carina-border-radius-md);
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container):where([data-placement='bottom-end']) .carina-popper .carina-navigation__app-switcher-menu {
    border-top-right-radius: 0;
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container):where([data-placement='bottom-start']) .carina-popper .carina-navigation__app-switcher-menu {
    border-top-left-radius: 0;
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container):where([data-placement='top-end']) .carina-popper .carina-navigation__app-switcher-menu {
    border-bottom-right-radius: 0;
}
.carina-navigation__app-switcher-container > .carina-popper__container:not(.carina-tooltip__container):where([data-placement='top-start']) .carina-popper .carina-navigation__app-switcher-menu {
    border-bottom-left-radius: 0;
}
.carina-navigation__app-switcher-menu {
    box-sizing: border-box;
    width: 360px;
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    overflow: auto;
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-primary);
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-navigation__app-switcher-menu ul {
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    list-style: none;
}
.carina-navigation__app-switcher-menu .carina-button--brand:focus-visible {
    box-shadow: var(--carina-ring-white);
    outline-color: var(--carina-border-color-inverse);
    outline-width: var(--carina-border-width-1);
}
.carina-navigation__app-switcher-menu-item {
    margin: var(--carina-spacing-0) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-xl);
}
.carina-navigation__app-switcher-menu-item:hover {
    background-color: var(--carina-background-color-primary-hover);
}
.carina-navigation__app-switcher-menu-item:active {
    background-color: var(--carina-background-color-primary-active);
}
.carina-navigation__app-switcher-menu-item a {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    min-height: 40px;
    padding: var(--carina-spacing-1) var(--carina-spacing-4);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-on-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    text-decoration: none;
    cursor: pointer;
}
.carina-navigation__app-switcher-menu-item a:focus-visible {
    outline: var(--carina-border-width-2) solid
        var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-white);
}
.carina-navigation__app-switcher-menu-item a span {
    margin-inline-end: var(--carina-spacing-4);
    display: flex;
    align-items: center;
    color: var(--carina-text-color-on-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
}
.carina-navigation__app-switcher-menu-item a span div {
    min-width: 75%;
    overflow-wrap: break-word;
}
.carina-navigation__app-switcher-menu-item a span > span {
    display: flex;
    align-items: center;
    width: 1.25rem;
    height: 1.5rem;
    margin-inline-end: var(--carina-spacing-4);
}
.carina-navigation__app-switcher-menu-item a span > span svg {
    width: 1.25rem;
    height: 1.25rem;
}
.carina-navigation__divider {
    width: 1px;
    height: 32px;
    background-color: var(--carina-background-color-neutral);
}
.carina-navigation__flyout-menu {
    box-sizing: border-box;
    width: 360px;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    overflow: hidden;
    font-family: var(--carina-font-family-primary);
    list-style: none;
    background-color: var(--carina-background-color-surface);
}
.carina-navigation__flyout-menu-popper {
    padding: var(--carina-spacing-0);
}
.carina-navigation__flyout-menu-item {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    min-height: 36px;
}
.carina-navigation__flyout-menu-item a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 36px;
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: 300;
    font-size: var(--carina-font-size-body-sm);
    text-decoration: none;
    margin-inline: var(--carina-spacing-2);
    padding-inline: var(--carina-spacing-4);
}
.carina-navigation__flyout-menu-item a span {
    margin-inline-end: var(--carina-spacing-4);
    display: flex;
    align-items: center;
}
.carina-navigation__flyout-menu-item a div {
    min-width: 75%;
    overflow-wrap: break-word;
}
.carina-navigation__flyout-menu-item a:focus-visible {
    outline: none;
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__flyout-menu-item:hover a {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__flyout-menu-item:active a {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__global-navigation-link {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    text-decoration: none;
    cursor: pointer;
}
.carina-navigation__global-navigation-link a,
  .carina-navigation__global-navigation-link div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100% - 0.5rem);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    white-space: nowrap;
    text-decoration: none;
    cursor: pointer;
    transition-timing-function: var(
      --carina-transition-timing-function-productive-ease-in-out
    );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
    margin-inline-end: var(--carina-spacing-1-5);
}
.carina-navigation__global-navigation-link a {
    padding-inline: var(--carina-spacing-5);
}
.carina-navigation__global-navigation-link div {
    padding-inline: var(--carina-spacing-4);
    margin-inline-start: var(--carina-spacing-0);
    margin-top: var(--carina-spacing-1);
    margin-bottom: var(--carina-spacing-1);
}
.carina-navigation__global-navigation-link div svg {
    padding-inline-start: var(--carina-spacing-2);
    box-sizing: border-box;
}
.carina-navigation__global-navigation-link:hover a,
    .carina-navigation__global-navigation-link:hover div {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__global-navigation-link:active a,
    .carina-navigation__global-navigation-link:active div {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__global-navigation-link:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__global-navigation-link--selected:hover a,
    .carina-navigation__global-navigation-link--selected:hover div,
    .carina-navigation__global-navigation-link--selected:active a,
    .carina-navigation__global-navigation-link--selected:active div {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-selected);
}
.carina-navigation__global-navigation-link--selected span,
  .carina-navigation__global-navigation-link--selected svg {
    color: var(--carina-text-color-primary);
}
.carina-navigation__global-navigation-menu {
    position: relative;
    display: inline-block;
    height: 100%;
}
.carina-navigation__global-navigation-menu-container {
    position: absolute;
    bottom: var(--carina-spacing-0);
    z-index: var(--carina-z-index-panel);
    display: none;
    width: 220px;
    height: auto;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-base);
    background: var(--carina-background-color-popper);
    box-shadow: var(--carina-box-shadow-lg);
    transform: translateY(100%);
    inset-inline-start: var(--carina-spacing-0);
}
.carina-navigation__global-navigation-menu-container--selected {
    display: block;
}
.carina-navigation__global-navigation-menu-item {
    display: inline-block;
    width: 100%;
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    white-space: nowrap;
    padding-inline: var(--carina-spacing-2);
}
.carina-navigation__global-navigation-menu-item a {
    display: block;
    box-sizing: border-box;
    padding: var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    white-space: normal;
    text-align: start;
    text-decoration: none;
    transition-timing-function: var(
      --carina-transition-timing-function-productive-ease-in-out
    );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
}
.carina-navigation__global-navigation-menu-item a:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__global-navigation-menu-item a:active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__global-navigation-menu-item a:focus-visible {
    outline: var(--carina-border-width-2) solid
        var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__logo {
    display: flex;
    align-items: center;
    height: 18px;
    padding: var(--carina-spacing-0) var(--carina-spacing-6);
}
.carina-navigation__logo a {
    text-decoration: none;
}
.carina-navigation__logo-image {
    display: inline;
    width: 93px;
    height: 18px;
    -o-object-fit: contain;
    object-fit: contain;
    vertical-align: initial;
}
.carina-navigation__page-title {
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xl);
    line-height: var(--carina-line-height-display-2xs);
    margin-inline-start: var(--carina-spacing-2);
    margin-block-end: 1rem;
    margin-block-start: 1rem;
    font-family: var(--carina-font-family-primary);
}
.carina-navigation__product-title {
    overflow: hidden;
    color: var(--carina-text-color-primary);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xl);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-tight);
    letter-spacing: 1;
    white-space: nowrap;
    text-transform: uppercase;
    text-overflow: ellipsis;
    padding-inline-start: var(--carina-spacing-4);
}
.carina-navigation__search {
    display: flex;
    align-items: center;
    width: 40px;
    height: 40px;
    margin-inline: var(--carina-spacing-1);
}
.carina-navigation__search-collapse {
    position: absolute;
    z-index: calc(var(--carina-z-index-current, 0) + 1);
    display: flex;
    align-items: center;
    height: 100%;
    inset-inline-end: var(--carina-spacing-0);
}
.carina-navigation__search-collapse-wrapper {
    display: flex;
    align-items: center;
}
.carina-navigation__search-button {
    margin-inline: var(--carina-spacing-0);
}
.carina-navigation__search-button,
.carina-navigation__search-small-screen-button {
    display: flex;
    align-items: center;
    padding-inline: var(--carina-spacing-2);
    inset-inline-end: var(--carina-spacing-4);
}
.carina-navigation__search-filters-container {
    position: absolute;
    top: 38px;
    box-sizing: border-box;
    width: 100%;
    padding: var(--carina-spacing-4);
    border-radius: var(--carina-border-radius-sm);
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
    box-shadow: var(--carina-box-shadow-lg);
}
.carina-navigation__search-sub-container {
    position: relative;
    z-index: var(--carina-z-index-panel);
    display: flex;
    width: 560px;
    height: 100%;
    opacity: var(--carina-opacity-100);
}
.carina-navigation__search-button-wrapper {
    min-width: 24px;
    margin-inline-start: var(--carina-spacing-1);
}
.carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m {
    position: relative;
    z-index: 0;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    min-height: 0;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    background-color: transparent;
}
.carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:active {
    background-color: var(--carina-background-color-surface-active);
    transform: var(scale(var(--carina-scale-shrink)));
}
.carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-black);
}
.carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:disabled,
  .carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:disabled:hover,
  .carina-navigation__search-button-wrapper .carina-button--icon-only.carina-button--m:disabled:active {
    cursor: default;
    opacity: var(--carina-opacity-40);
}
.carina-navigation__search-container {
    position: relative;
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    align-items: center;
}
.carina-navigation__search-container .carina-textbox-icon {
    position: absolute;
    top: 50%;
    inset-inline-start: var(--carina-spacing-2-5);
    transform: translateY(-50%);
}
.carina-navigation__search-container .carina-textbox__container .carina-input-fieldset {
    height: 36px;
}
.carina-navigation__search-container .carina-textbox__input {
    height: 36px;
    border-radius: var(--carina-border-radius-sm);
    font-size: var(--carina-font-size-sm);
    padding-inline-end: var(--carina-spacing-16);
}
.carina-navigation__search-container .carina-button__icon,
.carina-navigation__search-container .carina-textbox-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--carina-text-color-base);
}
.carina-navigation__search-container-icons {
    position: absolute;
    top: 50%;
    inset-inline-end: var(--carina-spacing-2-5);
    display: flex;
    transform: translateY(-50%);
}
@keyframes carina-navigation__side-navigation--outer-container-in {
    from {
        width: 0;
        opacity: var(--carina-opacity-0);
    }
    to {
        width: 320px;
        opacity: var(--carina-opacity-100);
    }
}
@keyframes carina-navigation__side-navigation--outer-container-out {
    from {
        width: 320px;
        opacity: var(--carina-opacity-100);
    }
    to {
        width: 0;
        opacity: var(--carina-opacity-0);
    }
}
@keyframes carina-navigation__side-navigation--outer-container-in-small {
    from {
        width: 0;
        opacity: var(--carina-opacity-0);
    }
    to {
        width: 100vw;
        opacity: var(--carina-opacity-100);
    }
}
@keyframes carina-navigation__side-navigation--outer-container-out-small {
    from {
        width: 100vw;
        opacity: var(--carina-opacity-100);
    }
    to {
        width: 0;
        opacity: var(--carina-opacity-0);
    }
}
@keyframes carina-navigation__side-navigation--outer-container-in-fade {
    from {
        opacity: var(--carina-opacity-0);
    }
    to {
        opacity: var(--carina-opacity-100);
    }
}
@keyframes carina-navigation__side-navigation--outer-container-out-fade {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
.carina-navigation__side-navigation {
    flex-grow: 0;
    flex-shrink: 0;
    width: 0;
    height: 100%;
    overflow: auto;
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface);
    opacity: 0;
}
.carina-navigation__side-navigation--open {
    border-inline-end: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    width: 320px;
    opacity: 1;
}
.carina-navigation__side-navigation--animate {
    animation: carina-navigation__side-navigation--outer-container-in
    var(--carina-transition-duration-400)
    var(--carina-transition-timing-function-expressive-ease-out);
    animation-fill-mode: forwards;
}
.carina-navigation__side-navigation--animate:not(.carina-navigation__side-navigation--open) {
    animation: carina-navigation__side-navigation--outer-container-out
    var(--carina-transition-duration-200)
    var(--carina-transition-timing-function-expressive-ease-out);
    animation-fill-mode: both;
}
.carina-navigation__side-navigation-list {
    margin: var(--carina-spacing-2) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
    list-style: none;
}
.carina-navigation__side-navigation-header {
    display: flex;
    padding: var(--carina-spacing-3) var(--carina-spacing-6);
    overflow: hidden;
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    white-space: nowrap;
    text-transform: uppercase;
    text-overflow: ellipsis;
}
.carina-navigation__side-navigation-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - var(--carina-spacing-4));
    margin: var(--carina-spacing-0) auto;
    padding: var(--carina-spacing-0);
    border-radius: var(--carina-border-radius-md);
    cursor: pointer;
}
.carina-navigation__side-navigation-link:hover:not(.carina-navigation__side-navigation-link--disabled) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__side-navigation-link:hover:not(.carina-navigation__side-navigation-link--disabled) a {
    color: var(--carina-text-color-base);
}
.carina-navigation__side-navigation-link:active:not(.carina-navigation__side-navigation-link--disabled) {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__side-navigation-link:active:not(.carina-navigation__side-navigation-link--disabled) a {
    color: var(--carina-text-color-base);
}
.carina-navigation__side-navigation-link:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__side-navigation-link a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    min-height: 24px;
    padding: var(--carina-spacing-2) var(--carina-spacing-4);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    font-family: var(--carina-font-family-primary);
    text-align: start;
    text-decoration: none;
    transition-timing-function: var(
      --carina-transition-timing-function-productive-ease-in-out
    );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
}
.carina-navigation__side-navigation-link a:focus-visible {
    outline: var(--carina-border-width-2) solid
        var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__side-navigation-link--current {
    position: relative;
    background-color: var(--carina-background-color-surface-selected);
    cursor: default;
}
.carina-navigation__side-navigation-link--current::before {
    position: absolute;
    top: 0;
    width: var(--carina-spacing-1);
    height: 100%;
    background-color: var(--carina-border-color-secondary-focus);
    content: '';
    inset-inline-start: 0;
    border-start-start-radius: var(--carina-border-radius-md);
    border-end-start-radius: var(--carina-border-radius-md);
}
.carina-navigation__side-navigation-link--current a {
    color: var(--carina-text-color-base);
}
.carina-navigation__side-navigation-link--disabled > div > a > svg {
    flex-shrink: 0;
    padding-inline-end: var(--carina-spacing-1);
}
.carina-navigation__side-navigation-link--disabled {
    position: relative;
    justify-content: flex-start;
    box-sizing: border-box;
    min-height: 40px;
    cursor: default;
}
.carina-navigation__side-navigation-link--disabled a {
    cursor: default;
}
.carina-navigation__side-navigation-menu {
    list-style: none;
}
.carina-navigation__side-navigation-menu:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__side-navigation-menu-list {
    padding-inline-start: var(--carina-spacing-6);
    margin-block: var(--carina-spacing-4);
}
.carina-navigation__side-navigation-menu-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: calc(100% - var(--carina-spacing-4));
    min-height: 40px;
    margin: var(--carina-spacing-0) auto var(--carina-spacing-0-5);
    padding: var(--carina-spacing-2) var(--carina-spacing-4);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-soft);
    font-family: var(--carina-font-family-primary);
    white-space: nowrap;
    cursor: pointer;
    transition-timing-function: var(
    --carina-transition-timing-function-productive-ease-in-out
  );
    transition-duration: var(--carina-transition-duration-100);
    transition-property: box-shadow;
}
.carina-navigation__side-navigation-menu-trigger span {
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-md);
    white-space: normal;
}
.carina-navigation__side-navigation-menu-trigger svg {
    min-width: 24px;
    min-height: 24px;
}
.carina-navigation__side-navigation-menu-trigger:hover {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__side-navigation-menu-trigger:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__side-navigation-menu-trigger:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-base);
}
.carina-navigation__title-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    background: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-navigation__top-navigation {
    position: relative;
    width: 100%;
}
.carina-navigation__top-navigation-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    background: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-navigation__top-navigation-border {
    width: 100%;
    height: 0.25rem;
    background: linear-gradient(
    90deg,
    var(--carina-background-color-primary) 0%,
    var(--carina-background-color-secondary) 95%
  );
}
@keyframes carina-navigation__top-navigation--outer-container-in {
    from {
        opacity: 0;
    }
    to {
        opacity: var(--carina-opacity-80);
    }
}
.carina-navigation__top-navigation-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 56px;
    background: var(--carina-background-color-surface);
    opacity: var(--carina-opacity-80);
    animation: carina-navigation__top-navigation--outer-container-in
    var(--carina-transition-duration-200)
    var(--carina-transition-timing-function-productive-ease-in-out);
}
.carina-navigation__user-profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: var(--carina-spacing-2);
    padding: var(--carina-spacing-3) var(--carina-spacing-6)
    var(--carina-spacing-6);
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    font-family: var(--carina-font-family-primary);
}
.carina-navigation__user-profile a {
    display: block;
    box-sizing: border-box;
    min-width: 112px;
    margin: var(--carina-spacing-4) auto;
    padding: var(--carina-spacing-2);
    border: var(--carina-border-width-1) solid var(--carina-border-color-hard);
    border-radius: var(--carina-border-radius-sm);
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-md);
    text-align: center;
    text-decoration: none;
}
.carina-navigation__user-profile a:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-navigation__user-profile a:active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-navigation__user-profile a:focus-visible {
    outline: none;
    box-shadow: var(--carina-ring-black);
}
.carina-navigation__user-profile-name {
    margin-top: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-md);
    text-align: center;
    cursor: default;
}
.carina-navigation__user-profile-email {
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
    text-align: center;
    cursor: default;
}
.carina-navigation__user-profile-description {
    margin-top: var(--carina-spacing-1);
    margin-bottom: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-xs);
    text-align: center;
    cursor: default;
}
.carina-pagination__item {
    position: relative;
    min-width: var(--carina-spacing-4);
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-2);
    border-color: transparent;
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-soft);
    font-size: var(--carina-font-size-body-sm);
    font-family: inherit;
    line-height: 0;
    white-space: nowrap;
    text-align: center;
    text-transform: none;
    background: none;
    outline: none;
    cursor: pointer;
    outline-color: var(--carina-colors-transparent);
    outline-offset: calc(var(--carina-border-width-2) * -1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-pagination__item::-moz-focus-inner {
    padding: var(--carina-spacing-0);
    border: 0;
}
.carina-pagination__item > svg {
    margin: -8px -5px;
}
[dir='rtl'] .carina-pagination__item > svg {
    transform: rotate(var(--carina-rotate-negative-180));
    transform-origin: center;
}
.carina-pagination__item:hover {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-hover);
}
.carina-pagination__item:active {
    color: var(--carina-text-color-base);
    background-color: var(--carina-background-color-surface-active);
}
.carina-pagination__item:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
    border-radius: var(--carina-border-radius-md);
}
.carina-pagination__item--disabled {
    color: var(--carina-text-color-disabled);
    pointer-events: none;
}
.carina-pagination__item--selected {
    border-radius: 0;
    color: var(--carina-text-color-base);
    pointer-events: none;
}
.carina-pagination__item--selected::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 4px;
    border-radius: var(--carina-border-radius-full);
    background-color: var(--carina-border-color-secondary-focus);
    content: '';
}
.carina-pagination__item--selected:hover {
    background-color: transparent;
}
.carina-pagination__item--selected:focus {
    outline: none;
}
.carina-pagination {
    display: inline-flex;
    padding: var(--carina-spacing-0) var(--carina-border-width-2);
}
@keyframes carina-progress-bar--outer-container-in {
    0% {
        left: 0;
        width: 30%;
        background-position-x: 0%;
    }
    50% {
        left: 70%;
        width: 30%;
        background-position-x: 100%;
    }
    100% {
        left: 0;
        width: 30%;
        background-position-x: 0%;
    }
}
@keyframes carina-progress-bar--determinate-animation {
    0% {
        background: var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-1,
        var(--carina-background-color-tertiary)
      )
    );
    }
    50% {
        background: var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-2,
        var(--carina-background-color-primary)
      )
    );
    }
    100% {
        background: var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-3,
        var(--carina-background-color-secondary)
      )
    );
    }
}
.carina-progress-bar {
    position: relative;
    justify-content: center;
    width: 100%;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-lg);
    font-family: var(--carina-font-family-primary);
    text-align: center;
}
.carina-progress-bar__bar-container {
    position: relative;
    width: 100%;
    height: 5px;
    margin: var(--carina-spacing-6) auto;
    border-radius: var(--carina-border-radius-full);
    overflow: visible;
    background: var(--carina-background-color-neutral-inactive);
}
.carina-progress-bar__bar-progress-bar {
    position: relative;
    display: block;
    height: 5px;
    border-radius: var(--carina-border-radius-full);
    background-size: 100% 5px;
    opacity: var(--carina-opacity-100);
    transition: clip-path var(--carina-transition-duration-300) linear,
    width var(--carina-transition-duration-300) linear, background 2000ms linear,
    left 2000ms linear, background-image 2000ms linear,
    background-color 2000ms linear, opacity 2000ms linear;
}
.carina-progress-bar__determinate {
    background-image: linear-gradient(
    to right,
    var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-1,
        var(--carina-background-color-tertiary)
      )
    ),
    var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-2,
        var(--carina-background-color-primary)
      )
    ),
    var(
      --carina-progress-bar-background,
      var(
        --carina-progress-bar-background-stop-3,
        var(--carina-background-color-secondary)
      )
    )
  );
    clip-path: inset(
    0% var(--carina-progress-bar-percentage-remaining) 0% 0% round 6px
  );
}
.carina-progress-bar__indeterminate {
    background-image: linear-gradient(
    to right,
    var(--carina-background-color-secondary),
    var(--carina-background-color-tertiary),
    var(--carina-background-color-primary)
  );
    background-size: 333%;
    animation: carina-progress-bar--outer-container-in 3500ms ease-in-out infinite;
}
@keyframes carina-pulse {
    0%,
  50%,
  100% {
        opacity: 1;
    }
    25%,
  75% {
        opacity: var(--carina-pulse-opacity);
    }
}
.carina-pulse {
    --carina-pulse-opacity: 0;
    animation-name: carina-pulse;
}
@keyframes carina-shake {
    0%,
  100% {
        transform: translateX(0);
    }
    20%,
  60% {
        transform: translateX(calc(-1 * var(--carina-shake-distance)));
    }
    40%,
  80% {
        transform: translateX(var(--carina-shake-distance));
    }
}
.carina-shell-next__aside:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside) {
    position: sticky;
    top: calc(
    var(--carina-shell-banner-current-height) +
      var(--carina-shell-title-current-height)
  );
    z-index: var(--carina-shell-aside-z-index);
    max-height: calc(
    100vh - var(--carina-shell-banner-offset) - var(--carina-shell-title-offset)
  );
    overflow-x: hidden;
    overflow-y: auto;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    visibility: hidden;
}
.carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
    translate: 0;
    height: 0;
    left: calc(var(--carina-shell-aside-start-width) * -1);
    grid-area: aside-start;
    width: var(--carina-shell-aside-start-width);
    transition: visibility 0ms ease-in-out 300ms,
    translate 300ms ease-in-out;
}
[dir='rtl'] .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
    translate: var(--carina-shell-aside-start-width);
}
@media (min-width: 768px) {
    .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
        translate: calc(var(--carina-shell-aside-start-width) * -1);
        height: calc(
      100vh - var(--carina-shell-banner-current-height) -
        var(--carina-shell-title-current-height)
    );
        min-width: 0rem;
    }
}
@media (max-width: 1023.98px) {
    .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
        z-index: var(--carina-shell-aside-lgmax-z-index);
        transition: left var(--carina-transition-duration-300) ease-in-out,
      right var(--carina-transition-duration-300) ease-in-out,
      width var(--carina-transition-duration-100) ease-in-out 300ms,
      visibility 0ms ease-in-out 300ms;
    }
    [dir='rtl'] .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
        right: calc(var(--carina-shell-aside-start-width) * -1);
    }
}
@media (min-width: 1024px) {
    .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--start) {
        min-width: 15rem;
    }
}
.carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--start) {
    visibility: inherit;
}
@media (min-width: 768px) {
    .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--start) {
        translate: 0;
        transition: min-width var(--carina-transition-duration-300) ease-in-out,
      translate var(--carina-transition-duration-300) ease-in-out;
    }
    [dir='rtl'] .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--start) {
        translate: 0;
    }
}
.carina-shell-next[data-shell-enabled*='aside-end'] .carina-shell-next__aside--end:is(.carina-shell-next__aside.carina-shell-next__aside--end):not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--end) {
    height: 0;
    right: calc(var(--carina-shell-aside-end-width) * -1);
}
.carina-shell-next__stacked-aside[data-stack-asides='false'] {
    display: contents;
}
.carina-shell-next__banner {
    height: var(--carina-shell-banner-current-height);
    max-height: var(--carina-shell-banner-current-height);
    overflow: hidden;
    visibility: hidden;
}
.carina-shell-next[data-shell-sticky*='banner'] .carina-shell-next__banner {
    position: sticky;
    top: 0;
    z-index: var(--carina-shell-banner-z-index);
}
.carina-shell-next[data-shell-enabled*='banner'] .carina-shell-next__banner {
    visibility: inherit;
}
.carina-shell-next__dock {
    position: sticky;
    z-index: var(--carina-shell-dock-z-index);
    display: none;
    visibility: hidden;
}
.carina-shell-next__dock--start {
    grid-area: unset;
}
.carina-shell-next[data-shell-enabled*='dock-start'] .carina-shell-next__dock--start {
    display: flex;
    visibility: inherit;
}
.carina-shell-next__dock--end {
    grid-area: dock-end;
}
.carina-shell-next[data-shell-enabled*='dock-end'] .carina-shell-next__dock--end {
    display: flex;
    visibility: inherit;
}
.carina-shell-next__dock-items {
    display: flex;
}
.carina-shell-next__dock-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 5.5rem;
    margin: 0.25rem;
    padding: 0.5rem;
    border-width: 0;
    border-radius: 10px;
    color: rgb(26 32 38);
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    transition: background-color 300ms ease 0ms;
}
.carina-shell-next__dock-item:hover {
    background-color: rgb(247 247 247);
}
.carina-shell-next__dock-item__text {
    display: -webkit-box;
    overflow: hidden;
    font-size: var(--carina-font-size-xs);
    white-space: initial;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.carina-shell-next__footer {
    position: relative;
    grid-area: footer;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell-next[data-shell-enabled*='footer'] .carina-shell-next__footer {
    height: -moz-fit-content;
    height: fit-content;
    bottom: var(--carina-shell-dock-end-max-height);
    visibility: inherit;
}
.carina-shell-next__header {
    grid-area: header;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell-next[data-shell-enabled*='header'] .carina-shell-next__header {
    height: -moz-fit-content;
    height: fit-content;
    visibility: inherit;
}
.carina-shell-next__main {
    grid-area: main;
    overflow-x: auto;
}
.carina-shell-next__page {
    display: grid;
    position: relative;
    z-index: var(--carina-shell-page-z-index, 10);
    grid-template-areas: 'title'
    'header'
    'page-actions'
    'main'
    'dock-end';
    grid-template-rows: auto auto auto 1fr auto;
    grid-template-columns: 100%;
    transition: grid-template-columns 300ms ease-in-out,
    grid-template-rows 300ms ease-in-out;
}
.carina-shell-next__page-actions {
    grid-area: page-actions;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell-next[data-shell-enabled*='page-actions'] .carina-shell-next__page-actions {
    height: -moz-fit-content;
    height: fit-content;
    visibility: inherit;
}
.carina-shell-next__panel {
    position: fixed;
    top: 0;
    z-index: var(--carina-shell-panel-z-index);
    width: var(--carina-shell-panel-width);
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    transition: left 300ms ease-in-out, right 300ms ease-in-out,
    visibility 0ms ease-in-out 300ms;
}
.carina-shell-next__panel--start {
    right: unset;
    left: calc(-1 * var(--carina-shell-panel-width));
}
[dir='rtl'] .carina-shell-next__panel--start {
    right: calc(-1 * var(--carina-shell-panel-width));
    left: unset;
}
.carina-shell-next[data-shell-enabled*='panel-start'] .carina-shell-next__panel--start {
    right: unset;
    left: 0;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell-next[data-shell-enabled*='panel-start'] .carina-shell-next__panel--start {
    right: 0;
    left: unset;
}
.carina-shell-next__panel--end {
    right: calc(-1 * var(--carina-shell-panel-width));
    left: unset;
}
[dir='rtl'] .carina-shell-next__panel--end {
    right: unset;
    left: calc(-1 * var(--carina-shell-panel-width));
}
.carina-shell-next[data-shell-enabled*='panel-end'] .carina-shell-next__panel--end {
    right: 0;
    left: unset;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell-next[data-shell-enabled*='panel-end'] .carina-shell-next__panel--end {
    right: unset;
    left: 0;
}
.carina-shell-next__title {
    grid-area: title;
    height: var(--carina-shell-title-current-height);
    max-height: var(--carina-shell-title-current-height);
    overflow: hidden;
    visibility: hidden;
}
.carina-shell-next[data-shell-enabled*='title'] .carina-shell-next__title {
    visibility: inherit;
}
.carina-shell-next__xl-panel {
    display: none;
    position: fixed;
    top: 0;
    z-index: var(--carina-shell-xl-panel-z-index);
    width: auto;
    min-width: var(--carina-shell-xl-panel-width);
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    transition: left 300ms ease-in-out, right 300ms ease-in-out,
    visibility 0ms ease-in-out 300ms;
}
.carina-shell-next__xl-panel--start {
    right: unset;
    left: -100%;
}
[dir='rtl'] .carina-shell-next__xl-panel--start {
    right: -100%;
    left: unset;
}
.carina-shell-next[data-shell-enabled*='xl-panel-start'] .carina-shell-next__xl-panel--start {
    right: unset;
    left: 0;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell-next[data-shell-enabled*='xl-panel-start'] .carina-shell-next__xl-panel--start {
    right: 0;
    left: unset;
}
.carina-shell-next__xl-panel--end {
    right: calc(-1 * var(--carina-shell-xl-panel-width));
    left: unset;
}
[dir='rtl'] .carina-shell-next__xl-panel--end {
    right: unset;
    left: calc(-1 * var(--carina-shell-xl-panel-width));
}
.carina-shell-next[data-shell-enabled*='xl-panel-end'] .carina-shell-next__xl-panel--end {
    right: 0;
    left: unset;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell-next[data-shell-enabled*='xl-panel-end'] .carina-shell-next__xl-panel--end {
    right: unset;
    left: 0;
}
.carina-shell-next {
    --carina-shell-aside-end-current-width: 0px;
    --carina-shell-aside-end-width: 5rem;
    --carina-shell-aside-start-current-width: 0px;
    --carina-shell-aside-start-width: 5rem;
    --carina-shell-banner-current-height: 0px;
    --carina-shell-banner-height: 52px;
    --carina-shell-banner-offset: 0px;
    --carina-shell-dock-end-current-width: 0px;
    --carina-shell-dock-end-max-height: 6rem;
    --carina-shell-dock-end-width: 5rem;
    --carina-shell-dock-start-current-width: 0px;
    --carina-shell-dock-start-max-height: 8.5rem;
    --carina-shell-dock-start-width: 5rem;
    --carina-shell-dock-start-expanded-width: 20rem;
    --carina-shell-panel-width: 20rem;
    --carina-shell-xl-panel-width: 43.75rem;
    --carina-shell-title-current-height: 0px;
    --carina-shell-title-height: 80px;
    --carina-shell-title-offset: 0px;
    --carina-shell-banner-z-index: 60;
    --carina-shell-title-z-index: 20;
    --carina-shell-header-z-index: 10;
    --carina-shell-aside-z-index: 20;
    --carina-shell-aside-lgmax-z-index: 60;
    --carina-shell-aside-end-lgmax-z-index: 80;
    --carina-shell-dock-z-index: 100;
    --carina-shell-dock-end-lgmax-z-index: 80;
    --carina-shell-panel-z-index: 110;
    --carina-shell-xl-panel-z-index: 120;
    --carina-shell-page-z-index: 10;
    position: relative;
    top: 0;
    min-width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
}
.carina-shell-next[data-shell-enabled*='banner'] {
    --carina-shell-banner-current-height: var(--carina-shell-banner-height);
}
.carina-shell-next[data-shell-sticky*='banner'] {
    --carina-shell-banner-offset: var(--carina-shell-banner-current-height);
}
.carina-shell-next[data-shell-enabled*='title'] {
    --carina-shell-title-current-height: var(--carina-shell-title-height);
}
.carina-shell-next[data-shell-sticky*='title'] {
    --carina-shell-title-offset: var(--carina-shell-title-current-height);
}
.carina-shell-next[data-shell-enabled*='dock-start'] {
    --carina-shell-dock-start-current-width: var(
      --carina-shell-dock-start-width
    );
}
.carina-shell-next[data-shell-enabled*='dock-end'] {
    --carina-shell-dock-end-current-width: var(--carina-shell-dock-end-width);
}
.carina-shell-next[data-shell-enabled*='aside-start'] {
    --carina-shell-aside-start-current-width: var(
      --carina-shell-aside-start-width
    );
}
.carina-shell-next[data-shell-enabled*='aside-end'] {
    --carina-shell-aside-end-current-width: var(--carina-shell-aside-end-width);
}
.carina-shell__aside:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside) {
    position: sticky;
    top: calc(
    var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
      var(--carina-shell-title-offset) + var(--carina-shell-breadcrumbs-offset)
  );
    z-index: 30;
    max-height: calc(
    100vh - var(--carina-shell-banner-offset) -
      var(--carina-shell-header-offset) - var(--carina-shell-title-offset) -
      var(--carina-shell-breadcrumbs-offset)
  );
    overflow-x: hidden;
    overflow-y: auto;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background-color: var(--carina-background-color-surface);
    visibility: hidden;
}
@media (min-width: 1024px) {
    .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--start) {
        translate: calc(var(--carina-shell-aside-start-width) * -1);
        grid-area: aside-start;
        width: var(--carina-shell-aside-start-width);
        transition: visibility 0ms ease-in-out 300ms, translate 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--start) {
        translate: var(--carina-shell-aside-start-width);
    }
}
@media (max-width: 1023.98px) {
    .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--start) {
        --carina-shell-aside-start-width: 80px;
        position: absolute;
        right: unset;
        left: calc(var(--carina-shell-aside-start-width) * -1);
        z-index: 80;
        width: 0;
        box-shadow: var(--carina-box-shadow-2xl);
        transition: left 300ms ease-in-out, right 300ms ease-in-out,
      width 0ms ease-in-out 300ms, visibility 0ms ease-in-out 300ms;
    }
    [dir='rtl'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--start) {
        right: calc(var(--carina-shell-aside-start-width) * -1);
        left: unset;
    }
}
.carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--start) {
    visibility: inherit;
}
@media (min-width: 1024px) {
    .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--start) {
        translate: 0;
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      translate 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--start) {
        translate: 0;
    }
}
@media (max-width: 1023.98px) {
    .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--start) {
        right: unset;
        left: var(--carina-shell-dock-start-width);
        width: var(--carina-shell-aside-start-width);
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      left 300ms ease-in-out, right 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--start) {
        right: var(--carina-shell-dock-start-width);
        left: unset;
    }
}
.carina-shell__stacked-aside[data-stack-asides='false'] {
    display: contents;
}
.carina-shell__banner {
    height: 100%;
    max-height: var(--carina-shell-banner-current-height);
    overflow: hidden;
    visibility: hidden;
    transition: max-height 300ms ease-in-out, visibility 0ms ease-in-out 300ms,
    height 0ms ease-in-out 300ms;
}
.carina-shell[data-shell-sticky*='banner'] .carina-shell__banner {
    position: sticky;
    top: 0;
    z-index: 60;
}
.carina-shell[data-shell-enabled*='banner'] .carina-shell__banner {
    visibility: inherit;
    transition: max-height 300ms ease-in-out;
}
.carina-shell__breadcrumbs {
    grid-area: breadcrumbs;
    height: var(--carina-shell-breadcrumbs-current-height);
    max-height: var(--carina-shell-breadcrumbs-current-height);
    overflow: hidden;
    visibility: hidden;
}
.carina-shell[data-shell-enabled*='breadcrumbs'] .carina-shell__breadcrumbs {
    visibility: inherit;
}
.carina-shell__dock {
    position: sticky;
    top: calc(
    var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
      var(--carina-shell-title-offset)
  );
    z-index: 1000;
    display: flex;
    background-color: rgb(255 255 255);
    visibility: hidden;
}
.carina-shell__dock--start {
    grid-area: dock-start;
}
.carina-shell[data-shell-enabled*='dock-start'] .carina-shell__dock--start {
    visibility: inherit;
}
.carina-shell__dock--end {
    grid-area: dock-end;
}
.carina-shell[data-shell-enabled*='dock-end'] .carina-shell__dock--end {
    visibility: inherit;
}
.carina-shell__dock-items {
    display: flex;
}
.carina-shell__dock-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: var(--carina-shell-dock-start-width);
    margin: 0.25rem;
    padding: 0.5rem;
    border-width: 0;
    border-radius: 10px;
    color: var(--carina-text-color-body);
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    transition: background-color var(--carina-transition-duration-300) ease;
}
.carina-shell__dock-item:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-shell__dock-item__text {
    display: -webkit-box;
    overflow: hidden;
    font-size: var(--carina-font-size-xs);
    white-space: initial;
    text-align: center;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.carina-shell__footer {
    position: relative;
    grid-area: footer;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell[data-shell-enabled*='footer'] .carina-shell__footer {
    height: -moz-fit-content;
    height: fit-content;
    visibility: inherit;
}
.carina-shell__header {
    height: 100%;
    max-height: var(--carina-shell-header-current-height);
    overflow: hidden;
    visibility: hidden;
    transition: max-height 300ms ease-in-out, visibility 0ms ease-in-out 300ms;
}
.carina-shell[data-shell-sticky*='header'] .carina-shell__header {
    position: sticky;
    top: var(--carina-shell-banner-offset);
    z-index: 60;
    transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      visibility 0ms ease-in-out 300ms;
}
.carina-shell[data-shell-enabled*='header'] .carina-shell__header {
    visibility: inherit;
    transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
}
.carina-shell__main {
    grid-area: main;
    overflow-x: auto;
}
.carina-shell__page {
    display: grid;
    grid-template-areas: 'dock-start breadcrumbs breadcrumbs breadcrumbs dock-end' 'dock-start aside-start page-title aside-end dock-end' 'dock-start aside-start page-actions aside-end dock-end' 'dock-start aside-start main aside-end dock-end';
    grid-template-rows: auto auto auto 1fr;
    grid-template-columns: var(--carina-shell-dock-start-current-width) var(
      --carina-shell-aside-start-current-width
    )
    1fr var(--carina-shell-aside-end-current-width)
    var(--carina-shell-dock-end-current-width);
    min-height: calc(
    100vh - var(--carina-shell-banner-current-height) -
      var(--carina-shell-header-current-height) -
      var(--carina-shell-title-current-height)
  );
    transition: grid-template-columns 300ms ease-in-out,
    grid-template-rows 300ms ease-in-out;
}
.carina-shell__page-actions {
    grid-area: page-actions;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell[data-shell-enabled*='page-actions'] .carina-shell__page-actions {
    height: -moz-fit-content;
    height: fit-content;
    visibility: inherit;
}
.carina-shell__page-title {
    grid-area: page-title;
    height: 0;
    overflow-x: hidden;
    visibility: hidden;
}
.carina-shell[data-shell-enabled*='page-title'] .carina-shell__page-title {
    height: -moz-fit-content;
    height: fit-content;
    visibility: inherit;
}
.carina-shell__panel {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: var(--carina-shell-panel-width);
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    transition: left 300ms ease-in-out, right 300ms ease-in-out,
    visibility 0ms ease-in-out 300ms;
}
.carina-shell__panel--start {
    right: unset;
    left: calc(-1 * var(--carina-shell-panel-width));
}
[dir='rtl'] .carina-shell__panel--start {
    right: calc(-1 * var(--carina-shell-panel-width));
    left: unset;
}
.carina-shell[data-shell-enabled*='panel-start'] .carina-shell__panel--start {
    right: unset;
    left: 0;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell[data-shell-enabled*='panel-start'] .carina-shell__panel--start {
    right: 0;
    left: unset;
}
.carina-shell__panel--end {
    right: calc(-1 * var(--carina-shell-panel-width));
    left: unset;
}
[dir='rtl'] .carina-shell__panel--end {
    right: unset;
    left: calc(-1 * var(--carina-shell-panel-width));
}
.carina-shell[data-shell-enabled*='panel-end'] .carina-shell__panel--end {
    right: 0;
    left: unset;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell[data-shell-enabled*='panel-end'] .carina-shell__panel--end {
    right: unset;
    left: 0;
}
.carina-shell__title-bar {
    height: 100%;
    max-height: var(--carina-shell-title-current-height);
    overflow: hidden;
    visibility: hidden;
    transition: max-height 300ms ease-in-out, visibility 0ms ease-in-out 300ms;
}
.carina-shell[data-shell-sticky*='title-bar'] .carina-shell__title-bar {
    position: sticky;
    top: calc(
      var(--carina-shell-banner-offset) + var(--carina-shell-header-offset)
    );
    z-index: 60;
    transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      visibility 0ms ease-in-out 300ms;
}
.carina-shell[data-shell-enabled*='title-bar'] .carina-shell__title-bar {
    visibility: inherit;
    transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
}
.carina-shell__xl-panel {
    position: fixed;
    top: 0;
    z-index: var(--carina-shell-panel-z-index);
    width: auto;
    min-width: var(--carina-shell-xl-panel-width);
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    visibility: hidden;
    transition: left 300ms ease-in-out, right 300ms ease-in-out,
    visibility 0ms ease-in-out 300ms;
}
.carina-shell__xl-panel--start {
    right: unset;
    left: -100%;
}
[dir='rtl'] .carina-shell__xl-panel--start {
    right: -100%;
    left: unset;
}
.carina-shell[data-shell-enabled*='xl-panel-start'] .carina-shell__xl-panel--start {
    right: unset;
    left: 0;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell[data-shell-enabled*='xl-panel-start'] .carina-shell__xl-panel--start {
    right: 0;
    left: unset;
}
.carina-shell__xl-panel--end {
    right: calc(-1 * var(--carina-shell-xl-panel-width));
    left: unset;
}
[dir='rtl'] .carina-shell__xl-panel--end {
    right: unset;
    left: calc(-1 * var(--carina-shell-xl-panel-width));
}
.carina-shell[data-shell-enabled*='xl-panel-end'] .carina-shell__xl-panel--end {
    right: 0;
    left: unset;
    visibility: inherit;
    transition: left 300ms ease-in-out, right 300ms ease-in-out;
}
[dir='rtl'] .carina-shell[data-shell-enabled*='xl-panel-end'] .carina-shell__xl-panel--end {
    right: unset;
    left: 0;
}
.carina-shell {
    --carina-shell-aside-end-current-width: 0px;
    --carina-shell-aside-end-width: 5rem;
    --carina-shell-aside-start-current-width: 0px;
    --carina-shell-aside-start-width: 5rem;
    --carina-shell-banner-current-height: 0px;
    --carina-shell-banner-height: 60px;
    --carina-shell-banner-offset: 0px;
    --carina-shell-breadcrumbs-current-height: 0px;
    --carina-shell-breadcrumbs-height: 80px;
    --carina-shell-breadcrumbs-offset: 0px;
    --carina-shell-dock-end-current-width: 0px;
    --carina-shell-dock-end-max-height: 8.5rem;
    --carina-shell-dock-end-width: 5rem;
    --carina-shell-dock-end-expanded-width: 20rem;
    --carina-shell-dock-start-current-width: 0px;
    --carina-shell-dock-start-max-height: 8.5rem;
    --carina-shell-dock-start-width: 5rem;
    --carina-shell-dock-start-expanded-width: 19rem;
    --carina-shell-header-current-height: 0px;
    --carina-shell-header-height: 60px;
    --carina-shell-header-offset: 0px;
    --carina-shell-panel-width: 20rem;
    --carina-shell-xl-panel-width: 43.75rem;
    --carina-shell-title-current-height: 0px;
    --carina-shell-title-height: 60px;
    --carina-shell-title-offset: 0px;
    position: relative;
    top: 0;
    min-width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
}
.carina-shell[data-shell-enabled*='banner'] {
    --carina-shell-banner-current-height: var(--carina-shell-banner-height);
}
.carina-shell[data-shell-sticky*='banner'] {
    --carina-shell-banner-offset: var(--carina-shell-banner-current-height);
}
.carina-shell[data-shell-enabled*='header'] {
    --carina-shell-header-current-height: var(--carina-shell-header-height);
}
.carina-shell[data-shell-sticky*='header'] {
    --carina-shell-header-offset: var(--carina-shell-header-current-height);
}
.carina-shell[data-shell-enabled*='title-bar'] {
    --carina-shell-title-current-height: var(--carina-shell-title-height);
}
.carina-shell[data-shell-sticky*='title-bar'] {
    --carina-shell-title-offset: var(--carina-shell-title-current-height);
}
.carina-shell[data-shell-enabled*='breadcrumbs'] {
    --carina-shell-breadcrumbs-current-height: var(
      --carina-shell-breadcrumbs-height
    );
}
.carina-shell[data-shell-sticky*='breadcrumbs'] {
    --carina-shell-breadcrumbs-offset: var(
      --carina-shell-breadcrumbs-current-height
    );
}
.carina-shell[data-shell-enabled*='dock-start'] {
    --carina-shell-dock-start-current-width: var(
      --carina-shell-dock-start-width
    );
}
.carina-shell[data-shell-enabled*='dock-end'] {
    --carina-shell-dock-end-current-width: var(--carina-shell-dock-end-width);
}
.carina-shell[data-shell-enabled*='aside-start'] {
    --carina-shell-aside-start-current-width: var(
      --carina-shell-aside-start-width
    );
}
.carina-shell[data-shell-enabled*='aside-end'] {
    --carina-shell-aside-end-current-width: var(--carina-shell-aside-end-width);
}
@keyframes carina-skeleton--pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
@keyframes carina-skeleton--shimmer {
    60%,
  100% {
        transform: translateX(100%) skewX(173deg);
    }
}
.carina-skeleton {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 1rem;
    border-radius: 0;
    border-radius: var(--carina-border-radius-sm);
    overflow: hidden;
    background-color: var(--carina-background-color-surface-alt);
}
.carina-skeleton--filled {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-skeleton--pulse,
.carina-skeleton--shimmer {
    animation-name: carina-skeleton--pulse;
    animation-duration: 2000ms;
    animation-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    animation-delay: var(--carina-transition-delay-100);
    animation-iteration-count: infinite;
}
[dir='rtl'] .carina-skeleton--pulse, [dir='rtl'] .carina-skeleton--shimmer {
    animation-direction: 'reverse';
}
.carina-skeleton--has-children {
    height: inherit;
    padding: var(--carina-spacing-4);
}
.carina-slider {
    margin-top: var(--carina-spacing-0);
    margin-right: var(--carina-spacing-0);
    margin-bottom: var(--carina-spacing-4);
    margin-left: var(--carina-spacing-0);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    direction: ltr;
}
.carina-slider--carina-font-reset {
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    text-transform: none;
    text-indent: 0;
    text-shadow: none;
}
.carina-slider__rheostat > div {
    position: relative;
    box-sizing: border-box;
    height: 2.25rem;
    margin: var(--carina-spacing-0) var(--carina-spacing-3);
    overflow: visible;
    cursor: pointer;
}
.carina-slider__rheostat--disabled > div {
    position: relative;
    box-sizing: border-box;
    height: 2.25rem;
    margin: var(--carina-spacing-0) var(--carina-spacing-3);
    overflow: visible;
    cursor: default;
}
.carina-slider__label {
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-normal);
}
.carina-slider__row {
    display: flex;
    align-items: center;
    margin-top: var(--carina-spacing-0);
    margin-right: var(--carina-spacing-0);
    margin-bottom: var(--carina-spacing-2);
    margin-left: var(--carina-spacing-0);
}
.carina-slider__row > div {
    flex: 1 0 auto;
    padding-left: var(--carina-spacing-2);
    line-height: 0;
}
.carina-slider__row > div:first-of-type {
    padding-left: var(--carina-spacing-0);
    text-align: left;
}
.carina-slider__row > div:last-of-type {
    text-align: right;
}
.carina-slider__row > div:not(first-of-type, last-of-type) {
    text-align: center;
}
.carina-slider__row > div:only-child {
    padding: var(--carina-spacing-0);
    text-align: center;
}
.carina-slider__row svg {
    display: inline;
    width: var(--carina-icon-md);
    height: var(--carina-icon-md);
}
.carina-slider__row input {
    width: 65px;
}
.carina-slider__row .carina-slider__row-cell {
    flex: 0 1 auto;
}
.carina-slider__progress-bar {
    position: absolute;
    top: calc(50% - 0.125rem);
    left: 0;
    z-index: calc(var(--carina-z-index-current) + 40);
    box-sizing: border-box;
    height: 0.25rem;
    border-radius: var(--carina-border-radius-full);
    background-color: var(--carina-text-color-primary);
}
.carina-slider__progress-bar--disabled {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-slider__pit {
    top: calc(50% - 0.4375rem);
    z-index: calc(var(--carina-z-index-current) + 10);
    box-sizing: border-box;
    width: 2px;
    height: 0.875rem;
    border-radius: var(--carina-border-radius-sm);
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-slider__background {
    position: absolute;
    top: calc(50% - 0.125rem);
    left: 0;
    z-index: calc(var(--carina-z-index-current) + 20);
    box-sizing: border-box;
    width: 100%;
    height: 0.25rem;
    border-radius: var(--carina-border-radius-full);
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-slider__handle {
    position: absolute;
    top: calc(50% - 1.125rem);
    z-index: calc(var(--carina-z-index-current) + 50);
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    width: 2.25rem;
    height: 2.25rem;
    margin-left: -1.125rem;
    border: none;
    border-radius: var(--carina-border-radius-full);
    overflow: visible;
    background-color: transparent;
    outline: 0;
    cursor: ew-resize;
    pointer-events: auto;
}
.carina-slider__handle::before {
    position: absolute;
    top: calc(50% - var(--carina-spacing-3));
    z-index: calc(var(--carina-z-index-current) + 20);
    display: block;
    box-sizing: border-box;
    width: 1.5rem;
    height: 1.5rem;
    border: none;
    border-radius: var(--carina-border-radius-full);
    background-color: var(--carina-text-color-primary);
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    content: ' ';
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-property: outline-color;
    transition-property: background-color, box-shadow, outline-color;
}
.carina-slider__handle:focus::before {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-slider__handle:hover::before {
    z-index: calc(var(--carina-z-index-current) + 70);
    background-color: var(--carina-text-color-primary-hover);
}
.carina-slider__handle:active::before {
    z-index: calc(var(--carina-z-index-current) + 30);
    background-color: var(--carina-text-color-primary);
    box-shadow: 0 0 0 1rem var(--carina-background-color-primary-pale);
}
.carina-slider__handle--disabled {
    pointer-events: none;
}
.carina-slider__handle--disabled::before {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-slider__handle--floating-label::after {
    bottom: 100%;
    z-index: calc(var(--carina-z-index-current) + 60);
    display: none;
    box-sizing: border-box;
    height: 1.5rem;
    margin-top: -2.75rem;
    padding: var(--carina-spacing-1) var(--carina-spacing-2);
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-primary);
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-normal);
    white-space: nowrap;
    text-align: center;
    background-color: var(--carina-background-color-surface);
    transform: translate3d(0, 0, 0);
    content: attr(aria-valuenow);
}
.carina-slider__handle--floating-label:hover.carina-slider__handle--floating-label::after,
  .carina-slider__handle--floating-label:focus.carina-slider__handle--floating-label::after,
  .carina-slider__handle--floating-label:active.carina-slider__handle--floating-label::after {
    display: block;
}
.carina-slider__handle--persistent-floating-label::after {
    display: block;
}
.carina-split-button {
    display: inline-flex;
}
.carina-split-button__text-button {
    border-start-end-radius: var(--carina-border-radius-none);
    border-end-end-radius: var(--carina-border-radius-none);
}
.carina-split-button__menu-button {
    margin-left: calc(-1 * var(--carina-spacing-px));
    border-start-start-radius: var(--carina-border-radius-none);
    border-end-start-radius: var(--carina-border-radius-none);
}
.carina-status-label {
    display: inline-flex;
    box-sizing: border-box;
    max-width: 100%;
    padding: var(--carina-spacing-0) var(--carina-spacing-2);
    border-width: var(--carina-border-width-0);
    border-radius: var(--carina-border-radius-md);
    color: var(--carina-text-color-base);
}
.carina-status-label--positive {
    background-color: var(--carina-background-color-success-pale);
}
.carina-status-label--positive .carina-status-label__icon-start-container,
    .carina-status-label--positive .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-success-pale-soft);
}
.carina-status-label--negative {
    background-color: var(--carina-background-color-danger-pale);
}
.carina-status-label--negative .carina-status-label__icon-start-container,
    .carina-status-label--negative .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-status-label--transitional {
    background-color: var(--carina-background-color-warning-pale);
}
.carina-status-label--transitional .carina-status-label__icon-start-container,
    .carina-status-label--transitional .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-warning-pale-soft);
}
.carina-status-label--neutral {
    background-color: var(--carina-background-color-info-pale);
}
.carina-status-label--neutral .carina-status-label__icon-start-container,
    .carina-status-label--neutral .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-info-pale-soft);
}
.carina-status-label--priority:not(.carina-status-label--ghost) {
    background-color: var(--carina-background-color-danger);
}
.carina-status-label--priority:not(.carina-status-label--ghost) .carina-status-label__icon-start-container,
    .carina-status-label--priority:not(.carina-status-label--ghost) .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-danger);
}
.carina-status-label--inactive {
    background-color: var(--carina-colors-neutral-10);
}
.carina-status-label--inactive .carina-status-label__icon-start-container,
    .carina-status-label--inactive .carina-status-label__icon-end-container {
    color: var(--carina-colors-neutral-95);
}
.carina-status-label__inner-container {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: var(--carina-border-width-0);
    overflow: hidden;
    font-family: var(--carina-font-family-primary);
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: baseline;
}
.carina-status-label__inner-container--positive {
    color: var(--carina-text-color-on-success-pale-soft);
}
.carina-status-label__inner-container--negative {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-status-label__inner-container--transitional {
    color: var(--carina-text-color-on-warning-pale-soft);
}
.carina-status-label__inner-container--neutral {
    color: var(--carina-text-color-on-info-pale-soft);
}
.carina-status-label__inner-container--priority:not(.carina-status-label--ghost) {
    color: var(--carina-text-color-on-danger);
}
.carina-status-label__inner-container--inactive {
    color: var(--carina-colors-neutral-95);
}
.carina-status-label--pill {
    border-radius: var(--carina-border-radius-full);
    padding: var(--carina-spacing-0) var(--carina-spacing-3);
}
.carina-status-label.carina-status-label--ghost {
    background-color: var(--carina-colors-transparent);
}
.carina-status-label.carina-status-label--ghost.carina-status-label--priority .carina-status-label__inner-container--priority {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-status-label.carina-status-label--ghost.carina-status-label--priority .carina-status-label__icon-start-container,
  .carina-status-label.carina-status-label--ghost.carina-status-label--priority .carina-status-label__icon-end-container {
    color: var(--carina-text-color-on-danger-pale-soft);
}
.carina-status-label__icon-start-container,
.carina-status-label__icon-end-container {
    display: flex;
    align-items: center;
    margin: 0;
    padding-inline-end: 0;
    padding-inline-start: 0;
}
.carina-status-label__icon-start-container {
    margin-inline-end: var(--carina-spacing-2);
    margin-inline-start: 0;
}
.carina-status-label__icon-end-container {
    margin-inline-end: 0;
    margin-inline-start: var(--carina-spacing-2);
}
.carina-status-label--xs {
    line-height: var(--carina-line-height-body-xs);
}
.carina-status-label--xs .carina-status-label__inner-container {
    font-size: var(--carina-font-size-body-2xs);
    padding: var(--carina-spacing-0);
}
.carina-status-label--sm {
    line-height: var(--carina-line-height-body-sm);
}
.carina-status-label--sm .carina-status-label__inner-container {
    font-size: var(--carina-font-size-body-sm);
    padding: var(--carina-spacing-1) var(--carina-spacing-0);
}
.carina-status-label--md {
    line-height: var(--carina-line-height-body-md);
}
.carina-status-label--md .carina-status-label__inner-container {
    font-size: var(--carina-font-size-body-md);
    padding: var(--carina-spacing-1-5) var(--carina-spacing-0);
}
.carina-status-label--lg {
    line-height: var(--carina-line-height-body-xl);
}
.carina-status-label--lg .carina-status-label__inner-container {
    font-size: var(--carina-font-size-body-xl);
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
}
.carina-stepper__horizontal-step {
    width: 100%;
    text-align: center;
    height: 100%;
    padding: var(--carina-spacing-0);
    border: none;
    background: transparent;
    max-height: 104px;
    cursor: pointer;
    color: var(--carina-text-color-soft);
    line-height: var(--carina-line-height-body-lg);
}
.carina-stepper__horizontal-step:disabled,
.carina-stepper__horizontal-step--inert {
    cursor: default;
}
.carina-stepper__horizontal-step__container {
    padding: var(--carina-spacing-7) var(--carina-spacing-0);
    width: 100%;
    max-width: 174px;
    flex-grow: 1;
    flex-shrink: 1;
}
.carina-stepper__horizontal-step__container--first .carina-stepper__horizontal-step__progress-bar-left,
  .carina-stepper__horizontal-step__container--last .carina-stepper__horizontal-step__progress-bar-right {
    opacity: var(--carina-opacity-0);
}
.carina-stepper__horizontal-step__name {
    pointer-events: none;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    font-size: var(--carina-font-size-md);
    line-height: var(--carina-line-height-body-lg);
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-top: var(--carina-spacing-3);
    margin-bottom: var(--carina-spacing-0);
}
.carina-stepper__horizontal-step__name--error {
    color: var(--carina-text-color-danger);
}
.carina-stepper__horizontal-step__name--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-stepper__horizontal-step__name--active,
  .carina-stepper__horizontal-step__name--partial {
    color: var(--carina-text-color-base);
}
.carina-stepper__horizontal-step__progress-bar-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    padding: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
}
.carina-stepper__horizontal-step__progress-bar-left,
.carina-stepper__horizontal-step__progress-bar-right {
    width: 100%;
    height: 2px;
    display: flex;
    flex-grow: 2;
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-stepper__horizontal-step__progress-bar-left {
    border-start-end-radius: var(--carina-border-radius-full);
    border-end-end-radius: var(--carina-border-radius-full);
    margin-inline-end: var(--carina-spacing-1);
}
.carina-stepper__horizontal-step__progress-bar-left--incomplete,
  .carina-stepper__horizontal-step__progress-bar-left--disabled,
  .carina-stepper__horizontal-step__progress-bar-left--optional,
  .carina-stepper__horizontal-step__progress-bar-left--processing {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-stepper__horizontal-step__progress-bar-left--error {
    background-color: var(--carina-background-color-danger);
}
.carina-stepper__horizontal-step__progress-bar-right {
    border-start-start-radius: var(--carina-border-radius-full);
    border-end-start-radius: var(--carina-border-radius-full);
    margin-inline-start: var(--carina-spacing-1);
}
.carina-stepper__horizontal-step__progress-bar-right--incomplete,
  .carina-stepper__horizontal-step__progress-bar-right--disabled,
  .carina-stepper__horizontal-step__progress-bar-right--optional,
  .carina-stepper__horizontal-step__progress-bar-right--processing {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-stepper__horizontal-step__progress-bar-right--error {
    background-color: var(--carina-background-color-danger);
}
.carina-stepper__horizontal-step__icon {
    height: 24px;
    width: 24px;
    font-size: var(--carina-font-size-2xs);
    box-sizing: border-box;
    border-radius: var(--carina-border-radius-full);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    background-color: var(--carina-background-color-surface);
}
.carina-stepper__horizontal-step__icon--processing {
    background-color: var(--carina-background-color-surface);
}
.carina-stepper__horizontal-step__icon--completed {
    border: 4px solid var(--carina-background-color-secondary);
    color: var(--carina-background-color-secondary);
}
.carina-stepper__horizontal-step__icon--completed svg {
    margin-top: 1px;
}
.carina-stepper__horizontal-step__icon--incomplete,
  .carina-stepper__horizontal-step__icon--optional {
    background-color: var(--carina-background-color-surface);
    border: var(--carina-border-width-1) solid var(--carina-border-color-base);
}
.carina-stepper__horizontal-step__icon--incomplete:hover, .carina-stepper__horizontal-step__icon--optional:hover {
    border: 1px solid var(--carina-text-color-soft);
}
.carina-stepper__horizontal-step__icon--disabled {
    border: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-disabled);
}
.carina-stepper__horizontal-step__icon--disabled:hover {
    background-color: var(--carina-text-color-soft);
}
.carina-stepper__horizontal-step__icon--active,
  .carina-stepper__horizontal-step__icon--partial {
    border: var(--carina-border-width-1) solid
      var(--carina-border-color-secondary-focus);
    background-color: var(--carina-background-color-secondary);
    color: var(--carina-text-color-on-secondary);
}
.carina-stepper__horizontal-step__icon--error {
    color: var(--carina-background-color-danger);
    background-color: var(--carina-colors-transparent);
}
.carina-stepper__horizontal-step__icon--error svg {
    margin-bottom: 2px;
}
.carina-stepper__mobile {
    margin-top: 8px;
    padding-inline: 16px;
    width: 100%;
    box-sizing: border-box;
    display: block;
}
.carina-stepper__mobile__circular-progress-bar {
    fill: transparent;
}
.carina-stepper__mobile__circular-progress-bar circle {
    stroke: var(--carina-border-color-secondary-focus);
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
}
.carina-stepper__mobile__progress-bar {
    display: flex;
    position: relative;
    top: calc(-1 * var(--carina-spacing-6));
}
.carina-stepper__mobile__step {
    display: flex;
    flex-direction: column;
}
.carina-stepper__step {
    display: flex;
    width: 100%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-stepper__step > div {
    width: 100%;
}
.carina-stepper__step__button {
    margin: var(--carina-spacing-0);
    border: none;
    width: 100%;
    background: transparent;
    padding: var(--carina-spacing-0);
    color: var(--carina-text-color-soft);
    text-align: left;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    font-family: inherit;
    line-height: inherit;
    font-size: 100%;
    cursor: pointer;
}
.carina-stepper__step__button > div {
    width: unset;
}
.carina-stepper__step__button:disabled,
.carina-stepper__step__button--inert {
    cursor: default;
}
.carina-stepper__step__step-container {
    padding: var(--carina-spacing-4) var(--carina-spacing-0);
    display: flex;
    align-items: center;
    position: relative;
    z-index: 100;
    margin: var(--carina-spacing-1) var(--carina-spacing-0);
    width: 100%;
    box-sizing: border-box;
}
.carina-stepper__step__step-container--collapsed {
    padding: var(--carina-spacing-2) var(--carina-spacing-0);
}
.carina-stepper__step__name-wrapper {
    margin: var(--carina-spacing-0) var(--carina-spacing-2);
    font-size: var(--carina-font-size-md);
    font-weight: var(--carina-font-weight-body);
    pointer-events: none;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.carina-stepper__step__name-wrapper:hover {
    color: var(--carina-font-color-hover);
}
.carina-stepper__step__name-wrapper--error {
    color: var(--carina-text-color-danger);
}
.carina-stepper__step__name-wrapper--current:not(.carina-stepper__step__name-wrapper--error) {
    color: var(--carina-text-color-base);
}
.carina-stepper__step__name-wrapper--disabled,
.carina-stepper__step__name-wrapper--current.carina-stepper__step__name-wrapper--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-stepper__step__top-spacer {
    margin: 0 10px -16px 10px;
    pointer-events: none;
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-stepper__step__top-spacer--incomplete,
  .carina-stepper__step__top-spacer--disabled,
  .carina-stepper__step__top-spacer--optional,
  .carina-stepper__step__top-spacer--processing {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-stepper__step__top-spacer--error {
    background-color: var(--carina-background-color-danger);
}
.carina-stepper__step__bottom-spacer,
.carina-stepper__step__top-spacer {
    width: 4px;
    height: 16px;
}
.carina-stepper__step__bottom-spacer {
    margin: -16px 10px 0 10px;
    pointer-events: none;
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-stepper__step__bottom-spacer--incomplete,
  .carina-stepper__step__bottom-spacer--disabled,
  .carina-stepper__step__bottom-spacer--optional,
  .carina-stepper__step__bottom-spacer--processing {
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-stepper__step__bottom-spacer--error {
    background-color: var(--carina-background-color-danger);
}
.carina-stepper__step__completed-spacer {
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-stepper__step__sub-heading-wrapper {
    font-size: var(--carina-text-base-size-xs);
    color: var(--carina-text-color-soft);
    position: absolute;
    top: 40px;
    left: 48px;
}
.carina-stepper__step__chevron {
    margin: var(--carina-spacing-2) 0 var(--carina-spacing-2) auto;
    padding-top: 4;
    cursor: pointer;
}
.carina-stepper__step__icon {
    height: 24px;
    width: 24px;
    font-size: var(--carina-font-size-2xs);
    box-sizing: border-box;
    border-radius: var(--carina-border-radius-full);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    background-color: var(--carina-background-color-surface);
}
.carina-stepper__step__icon svg {
    margin-top: 2px;
    display: block;
    vertical-align: middle;
}
.carina-stepper__step__icon--processing {
    background-color: var(--carina-background-color-surface);
}
.carina-stepper__step__icon--completed {
    border: 4px solid var(--carina-border-color-secondary-focus);
    color: var(--carina-text-color-secondary);
}
.carina-stepper__step__icon--error {
    border: none;
    color: var(--carina-background-color-danger);
    background-color: var(--carina-colors-transparent);
}
.carina-stepper__step__icon--incomplete,
  .carina-stepper__step__icon--optional {
    border: var(--carina-border-width-1) solid var(--carina-border-color-base);
    background-color: var(--carina-background-color-surface);
}
.carina-stepper__step__icon--incomplete:hover, .carina-stepper__step__icon--optional:hover {
    border: 1px solid var(--carina-text-color-soft);
}
.carina-stepper__step__icon--disabled {
    border: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-disabled);
}
.carina-stepper__step__icon--disabled:hover {
    background-color: var(--carina-text-color-soft);
}
.carina-stepper__step__icon--active:not(.carina-stepper__step__icon--error),
  .carina-stepper__step__icon--partial:not(.carina-stepper__step__icon--error) {
    border: var(--carina-border-width-1) solid
      var(--carina-border-color-secondary-focus);
    background-color: var(--carina-background-color-secondary);
    color: var(--carina-text-color-on-secondary);
}
.carina-stepper__step__icon--collapsed {}
.carina-stepper__progress-bar {
    position: relative;
    top: calc(-1 * var(--carina-spacing-6));
}
.carina-stepper__progress-bar__label {
    text-align: left;
}
.carina-stepper__progress-bar__status-wrapper {
    display: flex;
    justify-content: space-between;
    font-size: var(--carina-font-size-xs);
    color: var(--carina-text-color-soft);
    border-top: 2px solid var(--carina-border-color-soft);
    padding: var(--carina-spacing-1-5) var(--carina-spacing-0);
}
.carina-stepper__progress-bar__percentage {
    text-align: right;
}
.carina-stepper__sub-step {
    border: none;
    background: transparent;
    padding: var(--carina-spacing-0);
    text-align: left;
    display: flex;
    flex-grow: 1;
    position: relative;
    align-items: flex-end;
    font-size: var(--carina-font-size-xs);
    margin-inline-start: 16px;
    line-height: inherit;
    font-family: inherit;
    cursor: pointer;
}
.carina-stepper__sub-step:disabled,
.carina-stepper__sub-step--inert {
    cursor: default;
}
.carina-stepper__sub-step--wrapper {
    display: flex;
}
.carina-stepper__sub-step__name {
    flex-grow: 1;
    pointer-events: none;
    color: var(--carina-text-color-soft);
}
.carina-stepper__sub-step__icon-wrapper {
    pointer-events: none;
    color: var(--carina-text-color-danger);
}
.carina-stepper__sub-step__icon-wrapper--error {
    margin-bottom: 4px;
}
.carina-stepper__sub-step__spacer {
    width: var(--carina-spacing-1);
    height: 36px;
    margin-inline: 10px;
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-stepper__sub-step__spacer--completed,
  .carina-stepper__sub-step__spacer--skipped,
  .carina-stepper__sub-step__spacer--partial {
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-stepper__sub-step__spacer--error {
    background-color: var(--carina-background-color-danger);
}
.carina-stepper__sub-step__spacer--complete::after, .carina-stepper__sub-step__spacer--active::after {
    content: ' ';
    height: var(--carina-spacing-4);
    width: var(--carina-spacing-4);
    margin-top: -1px;
    display: block;
    position: relative;
    top: 100%;
    border-bottom-left-radius: var(--carina-border-radius-full);
    border-bottom-right-radius: var(--carina-border-radius-full);
}
.carina-stepper,
.carina-stepper__wrapper {
    display: flex;
    flex-direction: column;
}
.carina-stepper.carina-stepper--vertical {
    display: none;
    margin: calc(-1 * var(--carina-spacing-2)) var(--carina-spacing-0)
    var(--carina-spacing-0) var(--carina-spacing-0);
    width: 100%;
}
.carina-stepper.carina-stepper--horizontal {
    display: none;
    width: 100%;
    margin: var(--carina-spacing-0);
}
.carina-stepper__progress-bar-wrapper {
    display: none;
}
.carina-tan-table {
    --carina-tan-table-border-color: var(--carina-border-color-soft);
    --carina-tan-table-border-radius: var(--carina-border-radius-xl);
    --carina-tan-table-border-width: var(--carina-border-width-1);
    --carina-tan-table-outside-border-width: var(--carina-tan-table-border-width);
    --carina-tan-table-horizontal-border-width: var(
    --carina-tan-table-border-width
  );
    --carina-tan-table-vertical-border-width: var(
    --carina-tan-table-border-width
  );
    --carina-tan-table-separator-border-width: calc(
    var(--carina-tan-table-border-width) * 2
  );
    --carina-tan-table-line-height: var(--carina-line-height-body-sm);
    --carina-tan-table-padding-horizontal: var(--carina-spacing-4);
    --carina-tan-table-padding-vertical: 18px;
    --carina-tan-table-row-height: 56px;
    --carina-tan-table-on-background-color: var(
    --carina-background-color-surface
  );
    --carina-tan-table-background-color: var(--carina-background-color-surface);
    --carina-tan-table-background-color-alt: var(
    --carina-background-color-surface-alt
  );
    table-layout: fixed;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: var(--carina-spacing-0);
    margin-bottom: var(--carina-spacing-0);
    word-break: break-word;
    text-wrap: stable;
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-tan-table-line-height);
    font-weight: var(--carina-font-weight-body);
    color: var(--carina-text-color-base);
}
.carina-tan-table--auto {
    table-layout: auto;
}
.carina-tan-table--condensed {
    --carina-tan-table-row-height: 48px;
    --carina-tan-table-padding-vertical: var(--carina-spacing-3-5);
}
.carina-tan-table--roomy {
    --carina-tan-table-row-height: 68px;
    --carina-tan-table-padding-vertical: var(--carina-spacing-6);
}
.carina-tan-table--rounded .carina-tan-table-head > tr:first-of-type > :first-child:is(th, td), .carina-tan-table--rounded:not(:has(thead))
    .carina-tan-table-body
    > tr:first-of-type
    > :first-child:is(th, td) {
    border-start-start-radius: var(--carina-tan-table-border-radius);
    transform-style: preserve-3d;
}
.carina-tan-table--rounded .carina-tan-table-head > tr:first-of-type > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded:not(:has(thead))
    .carina-tan-table-body
    > tr:first-of-type
    > :first-child:is(th, td):not([data-dragging='true'])::after {
    width: var(--carina-tan-table-border-radius);
    height: var(--carina-tan-table-border-radius);
    background: var(--carina-tan-table-on-background-color);
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    inset-inline-start: -1px;
    transform: translateZ(-1px);
}
.carina-tan-table--rounded .carina-tan-table-head > tr:first-of-type :last-child:is(th, td), .carina-tan-table--rounded:not(:has(thead))
    .carina-tan-table-body
    > tr:first-of-type
    > :last-child:is(th, td) {
    border-start-end-radius: var(--carina-tan-table-border-radius);
    transform-style: preserve-3d;
}
.carina-tan-table--rounded .carina-tan-table-head > tr:first-of-type :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded:not(:has(thead))
    .carina-tan-table-body
    > tr:first-of-type
    > :last-child:is(th, td):not([data-dragging='true'])::after {
    width: var(--carina-tan-table-border-radius);
    height: var(--carina-tan-table-border-radius);
    background: var(--carina-tan-table-on-background-color);
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    inset-inline-end: -1px;
    transform: translateZ(-1px);
}
.carina-tan-table--rounded .carina-tan-table-footer > tr:only-child > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(
      :first-child:is([rowspan='0'], [rowspan='1'], :not(rowspan))
    )
    + tr:last-of-type
    > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:first-child:is([rowspan='2']))
    + tr:last-of-type
    > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:first-child:is([rowspan='3']))
    + tr:last-of-type
    > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(:first-child:is([rowspan='2']))
    > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:first-child:is([rowspan='3']))
    > :first-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:first-child:is([rowspan='4']))
    > :first-child:is(th, td), .carina-tan-table--rounded:not(:has(tfoot))
    .carina-tan-table-body
    > tr:last-of-type
    > :first-child:is(th, td) {
    border-end-start-radius: var(--carina-tan-table-border-radius);
    transform-style: preserve-3d;
}
.carina-tan-table--rounded .carina-tan-table-footer > tr:only-child > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(
      :first-child:is([rowspan='0'], [rowspan='1'], :not(rowspan))
    )
    + tr:last-of-type
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:first-child:is([rowspan='2']))
    + tr:last-of-type
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:first-child:is([rowspan='3']))
    + tr:last-of-type
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(:first-child:is([rowspan='2']))
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:first-child:is([rowspan='3']))
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:first-child:is([rowspan='4']))
    > :first-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded:not(:has(tfoot))
    .carina-tan-table-body
    > tr:last-of-type
    > :first-child:is(th, td):not([data-dragging='true'])::after {
    width: var(--carina-tan-table-border-radius);
    height: var(--carina-tan-table-border-radius);
    background: var(--carina-tan-table-on-background-color);
    content: '';
    display: block;
    position: absolute;
    bottom: -1px;
    inset-inline-start: -1px;
    transform: translateZ(-1px);
}
.carina-tan-table--rounded .carina-tan-table-footer > tr:only-child > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(
      :last-child:is([rowspan='0'], [rowspan='1'], :not(rowspan))
    )
    + tr:last-of-type
    > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:last-child:is([rowspan='2']))
    + tr:nth-last-of-type(2)
    > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:last-child:is([rowspan='3']))
    + tr:nth-last-of-type(3)
    > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(:last-child:is([rowspan='2']))
    > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:last-child:is([rowspan='3']))
    > :last-child:is(th, td), .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:last-child:is([rowspan='4']))
    > :last-child:is(th, td), .carina-tan-table--rounded:not(:has(tfoot))
    .carina-tan-table-body
    > tr:last-of-type
    > :last-child:is(th, td) {
    border-end-end-radius: var(--carina-tan-table-border-radius);
    transform-style: preserve-3d;
}
.carina-tan-table--rounded .carina-tan-table-footer > tr:only-child > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(
      :last-child:is([rowspan='0'], [rowspan='1'], :not(rowspan))
    )
    + tr:last-of-type
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:last-child:is([rowspan='2']))
    + tr:nth-last-of-type(2)
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:last-child:is([rowspan='3']))
    + tr:nth-last-of-type(3)
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(2):has(:last-child:is([rowspan='2']))
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(3):has(:last-child:is([rowspan='3']))
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded
    .carina-tan-table-footer
    > tr:nth-last-of-type(4):has(:last-child:is([rowspan='4']))
    > :last-child:is(th, td):not([data-dragging='true'])::after, .carina-tan-table--rounded:not(:has(tfoot))
    .carina-tan-table-body
    > tr:last-of-type
    > :last-child:is(th, td):not([data-dragging='true'])::after {
    width: var(--carina-tan-table-border-radius);
    height: var(--carina-tan-table-border-radius);
    background: var(--carina-tan-table-on-background-color);
    content: '';
    display: block;
    position: absolute;
    bottom: -1px;
    inset-inline-end: -1px;
    transform: translateZ(-1px);
}
.carina-tan-table:not(:has(thead)) .carina-tan-table-body > tr:first-of-type :is(th, td) {
    border-top-width: var(--carina-tan-table-outside-border-width);
    border-top-style: solid;
    border-top-color: var(--carina-tan-table-border-color);
}
.carina-tan-table:has(tfoot) .carina-tan-table-body > tr:last-of-type > :is(th, td) {
    border-bottom-width: var(--carina-border-width-0);
}
.carina-tan-table--striped
    .carina-tan-table-body
    > tr:nth-child(
      2n + 1 of [data-carina-tan-table-row-depth='0'],
      :not([data-carina-tan-table-row-depth])
    )
    :is(.carina-tan-table-header, .carina-tan-table-cell),
      .carina-tan-table--striped .carina-tan-table-body .carina-tan-table-row--striped .carina-tan-table-cell {
    background-color: var(--carina-tan-table-background-color-alt);
}
.carina-tan-table--no-dividers
    > :is(thead, tbody, tfoot)
    > .carina-tan-table-row
    > :is(.carina-tan-table-header, .carina-tan-table-cell):not(:last-child):not(.carina-tan-table--pinned-start) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-tan-table--no-outside-borders {
    --carina-tan-table-outside-border-width: var(--carina-border-width-0);
}
.carina-tan-table [data-carina-tan-table-expand-button] span.carina-button__icon-start {
    transition: transform var(--carina-transition-duration-200)
      var(--carina-transition-timing-function-expressive-ease-in)
      var(--carina-transition-duration-100);
}
.carina-tan-table [data-carina-tan-table-expand-button][data-expanded='false']
    span.carina-button__icon-start {
    transform: rotate(0deg);
}
.carina-tan-table [data-carina-tan-table-expand-button][data-expanded='true']
    span.carina-button__icon-start {
    transform: rotate(-180deg);
}
[dir='rtl'] .carina-tan-table [data-carina-tan-table-expand-button][data-expanded='true']
    span.carina-button__icon-start {
    transform: rotate(180deg);
}
.carina-tan-table-body > tr > td {
    border-top-width: var(--carina-border-width-0);
}
.carina-tan-table-body > tr > th {
    border-top-width: var(--carina-border-width-0);
    border-bottom-width: var(--carina-tan-table-horizontal-border-width);
    border-bottom-style: solid;
    border-bottom-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-caption {
    caption-side: bottom;
}
.carina-tan-table-cell {
    border-width: var(--carina-tan-table-horizontal-border-width)
    var(--carina-tan-table-vertical-border-width);
    border-style: solid;
    border-color: var(--carina-tan-table-border-color);
    border-inline-start-width: var(--carina-border-width-0);
    padding: var(--carina-tan-table-padding-vertical)
    var(--carina-tan-table-padding-horizontal);
    vertical-align: middle;
    background-color: var(--carina-tan-table-background-color);
    height: inherit;
}
.carina-tan-table-cell:not(:has(.carina-tan-table-reorder-handle)) {
    cursor: default;
}
.carina-tan-table-cell:last-child {
    border-inline-end-width: var(--carina-tan-table-outside-border-width);
}
.carina-tan-table:not(:has(tfoot)) > tbody > tr:last-child .carina-tan-table-cell {
    border-bottom-width: var(--carina-tan-table-outside-border-width);
}
.carina-tan-table-row[data-dragging='true'] .carina-tan-table-cell,
  .carina-tan-table-row[data-add-border-top='true'] .carina-tan-table-cell {
    border-top-width: var(--carina-tan-table-horizontal-border-width);
    border-top-style: solid;
    border-top-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-cell[data-dragging='true']:not(.carina-tan-table--no-dividers td) {
    border-inline-start-width: var(--carina-tan-table-vertical-border-width);
    border-inline-start-style: solid;
    border-inline-style-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-cell:has(> :is(.carina-tan-table-reorder-handle, .carina-tan-table-row-actions, .carina-tan-table-expandable-container)) {
    padding: var(--carina-spacing-0) var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) {
    padding: var(--carina-spacing-0);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]):focus-within {
    box-shadow: inset 0 0 0 3px var(--carina-border-color-primary-focus);
    outline: none;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]):focus-within .carina-tan-table-fieldset {
    border: none;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]):has([aria-invalid='true']) {
    box-shadow: inset 0 0 0 1px var(--carina-border-color-danger);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]):has([aria-invalid='true']):focus-within {
    box-shadow: inset 0 0 0 3px var(--carina-border-color-danger-focus);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-fieldset {
    border: none;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox__container,
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textarea--grid {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    cursor: text;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-dropdown--grid {
    width: 100%;
    height: 100%;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox__input {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    height: 100%;
    padding: var(--carina-tan-table-padding-vertical)
        var(--carina-tan-table-padding-horizontal);
    min-height: calc(
        (var(--carina-tan-table-padding-vertical) * 2) +
          var(--carina-line-height-body-sm)
      );
    border-bottom-width: var(--carina-tan-table-horizontal-border-width);
    border-bottom-style: solid;
    border-bottom-color: transparent;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox__input--icon-end {
    padding-inline-end: calc(
          (2 * var(--carina-tan-table-padding-horizontal)) +
            var(--carina-icon-xs)
        );
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox__input--icon-start {
    padding-inline-start: calc(
          (2 * var(--carina-tan-table-padding-horizontal)) +
            var(--carina-icon-xs)
        );
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox-icon--grid {
    bottom: calc(50% - (var(--carina-icon-xs) / 2));
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox-icon--end {
    inset-inline-end: var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox-icon--start {
    inset-inline-start: var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textarea__textarea--grid {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    min-height: calc(var(--carina-tan-table-line-height) * 2);
    align-content: center;
    overflow: hidden;
    border-width: var(--carina-border-width-0);
    padding: var(--carina-tan-table-padding-vertical)
        var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-dropdown__button--grid {
    font-size: inherit;
    font-weight: inherit;
    line-height: var(--carina-tan-table-line-height);
    height: 100%;
    padding: var(--carina-tan-table-padding-vertical)
        var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-dropdown__text--grid,
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-dropdown__icon {
    height: 100%;
    align-content: center;
    padding-inline-start: var(--carina-spacing-0);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector--grid {
    justify-content: center;
    height: 100%;
    position: relative;
    align-content: center;
    flex-wrap: wrap;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__buttons--grid {
    justify-content: center;
    align-content: center;
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    top: calc(50% - (var(--carina-spacing-6) / 2));
    z-index: calc(var(--carina-z-index-current) + 1);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__buttons--grid:nth-last-child(2) {
    inset-inline-end: calc(
            var(--carina-spacing-6) +
              (2 * var(--carina-tan-table-padding-horizontal))
          );
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__buttons--grid:last-child {
    inset-inline-end: var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__textbox--grid {
    width: 100%;
    height: 100%;
    padding: var(--carina-spacing-0);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__textbox--grid .carina-tan-table-textbox__input {
    padding-inline-end: calc(
            (2 * var(--carina-spacing-6)) +
              (3 * var(--carina-tan-table-padding-horizontal))
          );
    padding-inline-start: var(--carina-tan-table-padding-horizontal);
    text-align: start;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-picker__container {
    height: 100%;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-picker-toggle-button--neutral:focus-visible {
    box-shadow: inset var(--carina-ring-black);
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker--grid {
    height: 100%;
    align-content: center;
    container-type: inline-size;
    container-name: carina-tan-table-date-range-picker-responsive;
    min-width: 150px;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__separator--grid {
    display: none;
}
.carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__textbox-wrapper--grid {
    height: 100%;
}
.carina-tan-table-checkbox {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-tan-table-checkbox__box {
    height: 16px;
    width: 16px;
    border-width: var(--carina-border-width-1);
    border-style: solid;
    border-color: var(--carina-border-color-base);
    box-sizing: border-box;
    border-radius: var(--carina-border-radius-sm);
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
    transition-duration: calc(
      var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
    );
    transition-property: outline-color;
}
.carina-tan-table-checkbox:hover ~ .carina-tan-table-checkbox__box {
    cursor: pointer;
}
.carina-tan-table-checkbox:focus ~ .carina-tan-table-checkbox__box {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tan-table-checkbox--checked ~ .carina-tan-table-checkbox__box,
  .carina-tan-table-checkbox--indeterminate ~ .carina-tan-table-checkbox__box {
    background-color: var(--carina-background-color-primary);
    border-color: var(--carina-background-color-primary);
    color: var(--carina-text-color-on-primary);
}
.carina-tan-table-checkbox--disabled ~ .carina-tan-table-checkbox__box {
    color: var(--carina-text-color-disabled);
    border-width: var(--carina-border-width-0);
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-tan-table-checkbox__label-text {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-tan-table-column--actions,
  .carina-tan-table-column--actions-1,
  .carina-tan-table-column--reordering,
  .carina-tan-table-column--expandable,
  .carina-tan-table-column--expandable-1 {
    width: calc(
      36px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--actions:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--actions-1:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--reordering:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--expandable:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--expandable-1:not(.carina-tan-table--no-dividers col) {
    width: calc(
        36px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--actions-2 {
    width: calc(
      72px + (2 * var(--carina-tan-table-padding-horizontal)) +
        (2 * var(--carina-spacing-1)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--actions-2:not(.carina-tan-table--no-dividers col) {
    width: calc(
        72px + (2 * var(--carina-tan-table-padding-horizontal)) +
          (2 * var(--carina-spacing-1)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--actions-3 {
    width: calc(
      108px + (2 * var(--carina-tan-table-padding-horizontal)) +
        (4 * var(--carina-spacing-1)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--actions-3:not(.carina-tan-table--no-dividers col) {
    width: calc(
        108px + (2 * var(--carina-tan-table-padding-horizontal)) +
          (4 * var(--carina-spacing-1)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--actions-4 {
    width: calc(
      144px + (2 * var(--carina-tan-table-padding-horizontal)) +
        (6 * var(--carina-spacing-1)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--actions-4:not(.carina-tan-table--no-dividers col) {
    width: calc(
        144px + (2 * var(--carina-tan-table-padding-horizontal)) +
          (6 * var(--carina-spacing-1)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--actions-5 {
    width: calc(
      180px + (2 * var(--carina-tan-table-padding-horizontal)) +
        (8 * var(--carina-spacing-1)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--actions-5:not(.carina-tan-table--no-dividers col) {
    width: calc(
        180px + (2 * var(--carina-tan-table-padding-horizontal)) +
          (8 * var(--carina-spacing-1)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--checkbox,
  .carina-tan-table-column--radio {
    width: calc(
      16px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--radio:not(.carina-tan-table--no-dividers col) {
    width: calc(
        16px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable.carina-tan-table-column--checkbox,
  .carina-tan-table-column--expandable-1.carina-tan-table-column--checkbox {
    width: calc(
      52px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-spacing-4) + var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col), col:first-child.carina-tan-table-column--expandable-1.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col) {
    width: calc(
        52px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-spacing-4) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-2 {
    width: calc(
      72px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-2:not(.carina-tan-table--no-dividers col) {
    width: calc(
        72px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-2.carina-tan-table-column--checkbox {
    width: calc(
      88px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-spacing-4) + var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-2.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col) {
    width: calc(
        88px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-spacing-4) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-3 {
    width: calc(
      108px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-3:not(.carina-tan-table--no-dividers col) {
    width: calc(
        108px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-3.carina-tan-table-column--checkbox {
    width: calc(
      124px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-spacing-4) + var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-3.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col) {
    width: calc(
        124px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-spacing-4) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-4 {
    width: calc(
      144px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-4:not(.carina-tan-table--no-dividers col) {
    width: calc(
        144px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-4.carina-tan-table-column--checkbox {
    width: calc(
      160px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-spacing-4) + var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-4.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col) {
    width: calc(
        160px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-spacing-4) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-5 {
    width: calc(
      180px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-5:not(.carina-tan-table--no-dividers col) {
    width: calc(
        180px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-column--expandable-5.carina-tan-table-column--checkbox {
    width: calc(
      196px + (2 * var(--carina-tan-table-padding-horizontal)) +
        var(--carina-spacing-4) + var(--carina-tan-table-vertical-border-width)
    );
}
col:first-child.carina-tan-table-column--expandable-5.carina-tan-table-column--checkbox:not(.carina-tan-table--no-dividers col) {
    width: calc(
        196px + (2 * var(--carina-tan-table-padding-horizontal)) +
          var(--carina-spacing-4) +
          var(--carina-tan-table-vertical-border-width) +
          var(--carina-tan-table-outside-border-width)
      );
}
.carina-tan-table-responsive {
    container-type: inline-size;
    container-name: carina-table-responsive;
}
.carina-tan-table-container {
    overflow: auto;
}
.carina-tan-table-container[tabindex]:focus {
    outline: var(--carina-border-width-2) solid
      var(--carina-border-color-interactive-focus);
}
.carina-tan-table-container:not(.carina-tan-table-container--horizontal-overflow,.carina-tan-table-container--vertical-overflow):has(
      .carina-tan-table--pinned-top,
      .carina-tan-table--pinned-bottom
    ) {
    overflow: visible;
}
.carina-tan-table-empty__cell, .carina-tan-table-no-results__cell {
    border-width: var(--carina-tan-table-outside-border-width);
    border-style: solid;
    border-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-empty__container, .carina-tan-table-no-results__container {
    align-items: center;
    display: flex;
    flex-direction: column;
    min-height: 580px;
    justify-content: center;
}
.carina-tan-table-empty__illustration, .carina-tan-table-no-results__illustration {
    height: 240px;
    width: 240px;
}
.carina-tan-table-empty__text, .carina-tan-table-no-results__text {
    font-weight: var(--carina-font-weight-display);
    font-size: var(--carina-font-size-display-xs);
    line-height: var(--carina-line-height-display-xs);
    max-width: 450px;
    text-align: center;
    padding-bottom: var(--carina-spacing-6);
}
.carina-tan-table-expandable-container {
    display: flex;
    align-items: center;
    gap: var(--carina-spacing-4);
}
.carina-tan-table-row[data-carina-tan-table-row-depth='1'] .carina-tan-table-expandable-container {
    margin-inline-start: 36px;
}
.carina-tan-table-row[data-carina-tan-table-row-depth='2'] .carina-tan-table-expandable-container {
    margin-inline-start: 72px;
}
.carina-tan-table-row[data-carina-tan-table-row-depth='3'] .carina-tan-table-expandable-container {
    margin-inline-start: 108px;
}
.carina-tan-table-row[data-carina-tan-table-row-depth='4'] .carina-tan-table-expandable-container {
    margin-inline-start: 144px;
}
.carina-tan-table-head {
    background-color: var(--carina-tan-table-background-color);
}
.carina-tan-table-head > tr:first-child > :is(th, td) {
    border-top-width: var(--carina-tan-table-outside-border-width);
}
.carina-tan-table-head > tr:last-child > :is(th, td) {
    border-bottom-width: var(--carina-tan-table-separator-border-width);
    border-bottom-style: solid;
    border-bottom-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-head > tr > :is(th, td):not(:is([rowspan='0'], [rowspan='1'])) {
    border-bottom-width: var(--carina-tan-table-separator-border-width);
    border-bottom-style: solid;
    border-bottom-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-head:has(> :nth-child(2)) tr:first-child > :is(th, td) {
    background-color: var(--carina-tan-table-background-color-alt);
    font-size: var(--carina-font-size-body-md);
}
.carina-tan-table-container--horizontal-overflow
    .carina-tan-table-head
    :is(th, td):not(.carina-tan-table--pinned-end):has(+ :is(th, td).carina-tan-table--pinned-end), .carina-tan-table-container--horizontal-overflow
    .carina-tan-table-head:has(:is(th, td).carina-tan-table--pinned-end)
    :is(th, td):is(:is(th, td):last-child:not(.carina-tan-table--pinned-end)) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-tan-table-header {
    box-sizing: content-box;
    padding: var(--carina-tan-table-padding-vertical)
    var(--carina-tan-table-padding-horizontal);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-display);
    text-align: start;
    vertical-align: middle;
    border-width: var(--carina-tan-table-horizontal-border-width)
    var(--carina-tan-table-vertical-border-width);
    border-style: solid;
    border-color: var(--carina-tan-table-border-color);
    border-inline-start-width: var(--carina-border-width-0);
    border-bottom-width: var(--carina-border-width-0);
    background-color: var(--carina-tan-table-background-color);
    position: relative;
}
.carina-tan-table-header:last-child {
    border-inline-end-width: var(--carina-tan-table-outside-border-width);
}
.carina-tan-table-header:not(
      .carina-tan-table-header--hide-shadow,
      :has(.carina-tan-table-checkbox:focus, [data-carina-tan-table-expand-button]:focus)
    ):focus-within {
    box-shadow: inset 0 0 0 3px var(--carina-border-color-primary-focus);
}
.carina-tan-table-header:focus-within {
    outline: none;
}
.carina-tan-table-header--sortable {
    padding: var(--carina-spacing-0);
}
.carina-tan-table-header__button {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    padding: var(--carina-spacing-0) var(--carina-tan-table-padding-horizontal);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-display);
    text-align: start;
    vertical-align: middle;
    background-color: var(--carina-colors-transparent);
    cursor: pointer;
}
.carina-tan-table-header__button:focus {
    outline: none;
}
.carina-tan-table-header__button-content {
    align-self: center;
    padding: var(--carina-tan-table-padding-vertical) var(--carina-spacing-0);
}
.carina-tan-table-header__button--reorderable {
    cursor: grab;
    position: absolute;
    top: 0;
}
.carina-tan-table-header__button--reorderable:active {
    cursor: grabbing;
}
.carina-tan-table-header__icon {
    align-self: center;
}
.carina-tan-table-header[data-dragging='true']:not(.carina-tan-table--no-dividers th) {
    border-inline-start-width: var(
      --carina-tan-table-vertical-border-width
    ) !important;
    border-inline-start-style: solid !important;
    border-inline-start-color: var(--carina-tan-table-border-color) !important;
}
.carina-tan-table-header:has(> :is(.carina-tan-table-reorder-handle, .carina-tan-table-row-actions, .carina-tan-table-expandable-container)) {
    padding: var(--carina-spacing-0) var(--carina-tan-table-padding-horizontal);
}
.carina-tan-table-pagination {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    min-height: 72px;
}
.carina-tan-table-pagination__page-container {
    display: flex;
    gap: var(--carina-spacing-4);
    padding-inline-start: var(--carina-spacing-4);
    font-size: var(--carina-font-size-body-sm);
    line-height: var(--carina-line-height-body-sm);
    font-weight: var(--carina-font-weight-body);
    color: var(--carina-text-color-base);
}
.carina-tan-table-pagination__page {
    padding: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
    min-width: 36px;
    position: relative;
}
.carina-tan-table-pagination__page-size-dropdown {
    width: -moz-fit-content;
    width: fit-content;
    min-width: 96px;
}
.carina-tan-table-pagination__page-count {
    display: flex;
    gap: var(--carina-spacing-2);
    align-items: center;
    color: var(--carina-text-color-soft);
}
.carina-tan-table-pagination__page-size {
    display: flex;
    gap: var(--carina-spacing-2);
    align-items: center;
}
.carina-tan-table-pagination__navigation {
    align-self: center;
    display: flex;
    justify-content: center;
}
.carina-tan-table-pagination__list {
    list-style: none;
    display: flex;
    padding: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
}
.carina-tan-table-pagination__item {
    padding: var(--carina-spacing-0);
    margin: var(--carina-spacing-0);
    position: relative;
}
.carina-tan-table-pagination__item .carina-tan-table-pagination__button {
    color: var(--carina-text-color-soft);
}
.carina-tan-table-pagination__item .carina-tan-table-pagination__button[aria-current='true'] {
    color: var(--carina-text-color-base);
    opacity: 1;
}
.carina-tan-table-pagination__item:has(> [aria-current='true'])::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: var(--carina-border-width-4);
    width: 30px;
    margin: auto;
    border-radius: var(--carina-border-radius-full);
    background-color: var(--carina-border-color-secondary-focus);
    content: '';
}
.carina-tan-table-radio-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: var(--carina-border-radius-full);
    width: 16px;
    height: 16px;
    border-width: var(--carina-border-width-1);
    border-style: solid;
    border-color: var(--carina-border-color-base);
    display: block;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
}
.carina-tan-table-radio-button:checked {
    background-color: var(--carina-text-color-primary);
    border-color: var(--carina-text-color-primary);
}
.carina-tan-table-radio-button:checked::after {
    position: relative;
    top: 4px;
    margin: auto;
    display: block;
    width: 6px;
    height: 6px;
    border-radius: var(--carina-tan-table-border-radius);
    background: var(--carina-text-color-on-primary);
    content: '';
}
.carina-tan-table-radio-button:hover {
    cursor: pointer;
}
.carina-tan-table-radio-button:focus {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tan-table-radio-button:disabled {
    border-width: var(--carina-border-width-0);
    background-color: var(--carina-background-color-neutral-inactive);
}
.carina-tan-table-radio-button__label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.carina-tan-table-row {
    width: 100%;
    height: var(--carina-tan-table-row-height);
}
.carina-tan-table-row > th:first-child,
  .carina-tan-table-row > td:first-child {
    border-inline-start-width: var(--carina-tan-table-outside-border-width);
    border-inline-start-style: solid;
    border-inline-start-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-container--horizontal-overflow
    .carina-tan-table-row
    .carina-tan-table-cell:not(.carina-tan-table--pinned):has(+ .carina-tan-table-cell.carina-tan-table--pinned) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-tan-table-skeleton {
    height: var(--carina-tan-table-line-height);
}
.carina-tan-table-skeleton__container {
    height: var(--carina-tan-table-line-height);
}
.carina-tan-table-reorder-handle {
    cursor: grab;
}
.carina-tan-table-reorder-handle:active {
    cursor: grabbing;
}
.carina-tan-table-resize-handle {
    position: absolute;
    top: 0;
    height: 100%;
    inset-inline-end: 0;
    width: var(--carina-border-width-4);
    background: var(--carina-border-color-base);
    cursor: col-resize;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    touch-action: none;
    opacity: var(--carina-opacity-0);
}
.carina-tan-table-resize-handle:hover {
    opacity: var(--carina-opacity-100);
}
.carina-tan-table-resize-handle:active {
    background: var(--carina-border-color-primary-focus);
    opacity: var(--carina-opacity-100);
    z-index: calc(var(--carina-z-index-current) + 5);
}
.carina-tan-table-row-actions {
    display: flex;
    gap: var(--carina-spacing-1);
}
.carina-tan-table-footer {
    font-weight: var(--carina-font-weight-display);
}
.carina-tan-table-footer > tr > th,
  .carina-tan-table-footer > tr > td {
    border-top-width: var(--carina-border-width-0);
}
.carina-tan-table-footer > tr:last-child > :is(th, td) {
    border-bottom-width: var(--carina-tan-table-outside-border-width);
}
.carina-tan-table-footer > tr:first-child > :is(th, td) {
    border-top-width: var(--carina-tan-table-separator-border-width);
    border-top-style: solid;
    border-top-color: var(--carina-tan-table-border-color);
}
.carina-tan-table-container--horizontal-overflow
    .carina-tan-table-footer
    :not(.carina-tan-table--pinned-end):has(+ .carina-tan-table--pinned-end),
  .carina-tan-table-container--horizontal-overflow
    .carina-tan-table-footer
    :not(.carina-tan-table--pinned-end):has(+ .carina-tan-table--pinned-end) {
    border-inline-end-width: var(--carina-border-width-0);
}
.carina-tan-table-footer:has(> :nth-child(2)) tr:first-child > :is(th, td) {
    background-color: var(--carina-tan-table-background-color-alt);
    font-size: var(--carina-font-size-body-md);
}
.carina-tan-table--pinned {
    position: sticky;
}
.carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start {
    inset-inline-start: 0px;
    border-inline-end-width: var(--carina-tan-table-separator-border-width);
    border-inline-end-style: solid;
    border-inline-end-color: var(--carina-tan-table-border-color);
    box-shadow: 10px 0 15px -3px rgb(0 0 0 / 0.1),
  4px 0 6px -4px rgb(0 0 0 / 0.1);
    z-index: calc(var(--carina-z-index-current) + 20);
}
.carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start::before {
    content: '';
    clip-path: inset(0px -15px 0px 0px);
}
[dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start {
    box-shadow: -10px 0 15px -3px rgb(0 0 0 / 0.1),
  -4px 0 6px -4px rgb(0 0 0 / 0.1);
}
[dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start::before {
    clip-path: inset(0px 0px 0px -15px);
}
.carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end {
    inset-inline-end: 0px;
    border-inline-start-width: var(--carina-tan-table-separator-border-width);
    border-inline-start-style: solid;
    border-inline-start-color: var(--carina-tan-table-border-color);
    box-shadow: -10px 0 15px -3px rgb(0 0 0 / 0.1),
  -4px 0 6px -4px rgb(0 0 0 / 0.1);
    z-index: calc(var(--carina-z-index-current) + 20);
}
.carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end::before {
    content: '';
    clip-path: inset(0px 0px 0px -15px);
}
[dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end {
    box-shadow: 10px 0 15px -3px rgb(0 0 0 / 0.1),
  4px 0 6px -4px rgb(0 0 0 / 0.1);
}
[dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end::before {
    clip-path: inset(0px -15px 0px 0px);
}
.carina-tan-table--pinned-top {
    top: 0;
    z-index: calc(var(--carina-z-index-current) + 30);
}
.carina-tan-table--pinned-bottom {
    bottom: 0;
    z-index: calc(var(--carina-z-index-current) + 30);
}
.carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start.carina-tan-table--pinned-top,
  .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end.carina-tan-table--pinned-top,
  .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start.carina-tan-table--pinned-bottom,
  .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end.carina-tan-table--pinned-bottom {
    z-index: calc(var(--carina-z-index-current) + 40);
}
.carina-table-basic-cell-renderer--default {
    max-width: 100%;
    overflow: visible;
    overflow-wrap: anywhere;
}
.carina-table-basic-cell-renderer--sticky {
    overflow: hidden;
}
.carina-table-basic-collapsed-cell-renderer {
    width: 100%;
    overflow: hidden;
    overflow-wrap: anywhere;
}
.carina-table-basic-heading-renderer {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    color: var(--carina-text-color-base);
    font-size: var(--carina-font-size-body-sm);
    background-color: transparent;
    outline: none;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.carina-table-basic-heading-renderer:focus > .carina-table-basic-heading-renderer__heading::after {
    position: absolute;
    top: calc(100% + 1px);
    bottom: -2px;
    background-color: var(--carina-background-color-surface);
    content: '';
    pointer-events: none;
    inset-inline-start: 0;
    inset-inline-end: 0;
}
.carina-table-basic-heading-renderer--sortable {
    width: 100%;
    height: 100%;
    margin: calc(-1 * var(--carina-spacing-3)) calc(-1 * var(--carina-spacing-2));
    padding: var(--carina-spacing-3) var(--carina-spacing-2);
    cursor: pointer;
}
.carina-table-basic-heading-renderer--sortable:focus-visible {
    outline: none;
    box-shadow: 0 0 0 var(--carina-border-width-2)
      var(--carina-border-color-primary-focus);
}
.carina-table-basic-heading-renderer__heading {
    position: relative;
    overflow: hidden;
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-display);
}
.carina-table-basic-heading-renderer__heading--sorted {
    font-weight: var(--carina-font-weight-display);
}
.carina-table-checkbox-heading-renderer {
    position: absolute;
    top: 50%;
    padding: 0;
    border: 0;
    background-color: transparent;
    outline: none;
    box-shadow: none;
    transform: translate(-50%, -50%);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    inset-inline-start: 50%;
}
.carina-table-checkbox-heading-renderer:focus-visible {
    outline: var(--carina-border-width-2) solid var(--carina-colors-transparent);
    box-shadow: var(--carina-ring-black);
}
.carina-table-start-column-renderer--drag {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
}
.carina-table-start-column-renderer--multiselect {
    display: flex;
    align-items: center;
    justify-content: center;
}
.carina-column-heading {
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
    box-sizing: border-box;
    width: 100%;
    padding-right: var(--carina-spacing-2);
    padding-left: var(--carina-spacing-2);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
    align-content: center;
    display: flex;
}
.carina-column-heading--edge {
    flex-grow: 0;
    flex-shrink: 0;
    word-wrap: break-word;
}
.carina-column-heading--sticky {
    position: sticky;
    z-index: calc(var(--carina-z-index-current) + 10);
    inset-inline-start: 0;
}
.carina-empty-state-container {
    box-sizing: border-box;
    width: 100%;
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
}
.carina-empty-state-container--top-borders {
    border-width: var(--carina-border-width-1) var(--carina-border-width-0);
}
.carina-table-page-controls {
    display: flex;
    gap: var(--carina-spacing-4);
    align-items: center;
    padding-top: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
}
.carina-table-page-controls__message {
    margin-inline-end: var(--carina-spacing-2);
}
.carina-table-page-controls__nav {
    display: flex;
    gap: var(--carina-spacing-4);
}
.carina-selected-indicator {
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-color: var(--carina-border-color-base);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-sm);
}
.carina-selected-indicator--disabled {
    border-color: var(--carina-border-color-soft);
    color: var(--carina-text-color-disabled);
    background-color: var(--carina-background-color-neutral-inverse);
    pointer-events: none;
}
.carina-selected-indicator--focused {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-selected-indicator--selected,
.carina-selected-indicator--indeterminate {
    border-color: transparent;
    background-color: var(--carina-background-color-primary);
}
.carina-selected-indicator--selected.carina-selected-indicator--focused {
    background-color: transparent;
}
.carina-selected-indicator--selected.carina-selected-indicator--disabled {
    border-color: var(--carina-border-color-soft);
    color: var(--carina-text-color-disabled);
    background-color: var(--carina-background-color-neutral-inactive);
    pointer-events: none;
}
.carina-selected-indicator__check {
    fill: var(--carina-background-color-neutral-inverse);
    vertical-align: middle;
    display: block;
}
.carina-selected-indicator__check--disabled {
    fill: var(--carina-text-color-disabled);
}
.carina-table-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-table-cell {
    flex-grow: 1;
    flex-shrink: 1;
    align-self: center;
    box-sizing: border-box;
    width: 100%;
    padding-right: var(--carina-spacing-2);
    padding-left: var(--carina-spacing-2);
    color: var(--carina-text-color-base);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
    font-family: var(--carina-font-family-primary);
}
.carina-table-cell:not(:has(.carina-table-start-column-renderer--drag)) {
    cursor: default;
}
.carina-table-cell--collapsed {
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-sm);
}
.carina-table-cell--disabled {
    color: var(--carina-text-color-disabled);
}
.carina-table-cell--edge {
    flex-grow: 0;
    flex-shrink: 0;
}
.carina-table-cell--sticky {
    position: sticky;
    inset-inline-start: 0;
}
.carina-table-cell__collapsed {
    width: 100%;
    overflow: hidden;
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-body-xs);
}
.carina-table-element {
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    padding: var(--carina-spacing-px);
}
.carina-table-element--scrollable {
    width: -moz-fit-content;
    width: fit-content;
    min-width: 100%;
}
.carina-table-header {
    box-sizing: border-box;
    width: 100%;
}
.carina-table-header__group {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-height: 56px;
    padding: var(--carina-spacing-3) var(--carina-spacing-2);
    overflow: hidden;
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
    outline-width: var(--carina-border-width-1);
    outline-style: solid;
    outline-color: var(--carina-border-color-soft);
    outline-offset: calc(-1 * var(--carina-spacing-px));
}
.carina-table-header__group--sticky {
    overflow: visible;
    display: flex;
    align-items: stretch;
}
.carina-table-row {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    overflow-x: hidden;
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-base);
}
.carina-table-row::before {
    position: absolute;
    z-index: calc(var(--carina-z-index-current) + 30);
    content: '';
    pointer-events: none;
    inset: 0;
}
.carina-table-row .carina-table-row__actions-end-container:not(
      .carina-table-row__actions-end-container--always-visible
    ):focus-within
    .carina-action-button
    svg {
    color: var(--carina-text-color-base-inverse);
}
.carina-table-row .carina-table-row__actions-end-container:not(
      .carina-table-row__actions-end-container--always-visible
    ):hover
    .carina-action-button
    svg {
    color: var(--carina-text-color-base-inverse);
}
.carina-table-row:hover
    .carina-table-row__actions-start-container
    .carina-action-button:not(.carina-action-button--static-select-indicator)
    .carina-selected-indicator,
  .carina-table-row .carina-table-row__actions-start-container
    .carina-action-button:not(
      .carina-action-button--static-select-indicator
    ):focus-visible
    .carina-selected-indicator {
    border-color: var(--carina-text-color-base-inverse);
    background-color: transparent;
}
.carina-table-row .carina-table-row__actions-start-container:not(:hover)
    .carina-action-button:not(.carina-action-button--static-select-indicator)
    .carina-selected-indicator--selected {
    background-color: transparent;
}
.carina-table-row:hover
    .carina-table-row__actions-start-container:not(:hover)
    .carina-action-button:not(.carina-action-button--static-select-indicator)
    .carina-selected-indicator--selected {
    z-index: calc(var(--carina-z-index-current) + 20);
    border-color: var(--carina-text-color-disabled);
    background-color: var(--carina-text-color-disabled);
}
.carina-table-row:hover
    .carina-table-row__actions-start-container:not(:hover)
    .carina-action-button:not(.carina-action-button--static-select-indicator)
    .carina-selected-indicator {
    z-index: calc(var(--carina-z-index-current) + 20);
    border-color: var(--carina-text-color-disabled);
}
.carina-table-row--sticky {
    overflow-x: visible;
}
.carina-table-row--sticky div[role='cell']:first-of-type:first-of-type {
    background-color: inherit;
}
.carina-table-row--side-borders {
    border-right: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    border-left: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
}
.carina-table-row--striped:nth-of-type(odd) > div {
    background-color: var(--carina-background-color-surface-alt);
}
.carina-table-row--focus-within::after {
    position: absolute;
    z-index: calc(var(--carina-z-index-current) + 30);
    outline: var(--carina-border-width-2) solid
      var(--carina-border-color-primary-focus);
    content: '';
    inset: var(--carina-spacing-0-5);
    pointer-events: none;
}
.carina-table-row__sliding {
    position: relative;
    z-index: calc(var(--carina-z-index-current) + 10);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-height: 56px;
    padding: var(--carina-spacing-2) var(--carina-spacing-2);
    background-color: var(--carina-background-color-surface);
}
.carina-table-row__sliding::after {
    position: absolute;
    content: '';
    inset: 0 var(--carina-spacing-px) var(--carina-spacing-px);
    pointer-events: none;
}
.carina-table-row__sliding:focus {
    outline: none;
}
.carina-table-row__sliding--basic-outline {
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    outline: var(--carina-border-width-1) solid var(--carina-border-color-soft);
}
.carina-table-row--sticky .carina-table-row__sliding--basic-outline {
    outline: none;
}
.carina-table-row__sliding--top-outline {
    border-top: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
}
.carina-table-row__sliding--dragging {
    outline: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    outline-offset: calc(-1 * var(--carina-spacing-px));
}
.carina-table-row:has(.carina-table-row__sliding--dragging) {
    border-left: none;
    border-right: none;
}
.carina-table-row:has(.carina-table-row__sliding) {
    margin-top: 0;
}
.carina-table-row:has(.carina-table-row__sliding):not(:first-child) {
    margin-top: calc(-1 * var(--carina-border-width-1));
}
.carina-table-row__sliding--condensed {
    min-height: 52px;
    padding-top: var(--carina-spacing-2);
    padding-bottom: var(--carina-spacing-2);
}
.carina-table-row__sliding--roomy {
    min-height: 68px;
    padding-top: var(--carina-spacing-4);
    padding-bottom: var(--carina-spacing-4);
}
.carina-table-row__actions-end-container {
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-end: 0;
    display: flex;
    align-items: center;
    min-width: 60px;
    background-color: var(--carina-background-color-neutral);
    padding-inline-start: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-2);
}
.carina-table-row__actions-start-container {
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-start: 0;
    display: flex;
    align-items: center;
    min-width: 60px;
    padding-inline-start: var(--carina-spacing-2);
    padding-inline-end: var(--carina-spacing-2);
    background-color: var(--carina-background-color-neutral);
}
.carina-table-row__actions-start-container--reveal,
.carina-table-row__actions-end-container--reveal {
    opacity: var(--carina-opacity-100);
}
.carina-table-row__actions-start-container--reveal:hover .carina-action-button__x-ray, .carina-table-row__actions-end-container--reveal:hover .carina-action-button__x-ray {
    opacity: var(--carina-opacity-0);
}
.carina-table-row__actions-start-container--hide,
.carina-table-row__actions-end-container--hide {
    opacity: var(--carina-opacity-0);
}
.carina-table-row__actions-start-container.carina-table-row__actions-start-container--always-visible {
    z-index: calc(var(--carina-z-index-current) + 20);
    opacity: var(--carina-opacity-100);
    min-width: 0;
    background-color: unset;
}
.carina-table-row__actions-end-container.carina-table-row__actions-end-container--always-visible {
    z-index: calc(var(--carina-z-index-current) + 20);
    opacity: var(--carina-opacity-100);
    min-width: 0;
    background-color: unset;
}
.carina-table-row__actions-start-trigger {
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-start: 0;
    width: 54px;
}
.carina-table-row__actions-start-trigger--hidden {
    display: none;
}
.carina-table-row__actions-end-trigger {
    position: absolute;
    top: 0;
    bottom: 0;
    inset-inline-end: 0;
    width: 54px;
}
.carina-table-row__actions-end-trigger--hidden {
    display: none;
}
.carina-table-row__contents {
    display: flex;
    width: 100%;
}
.carina-action-button {
    --carina-table-action-button-size: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--carina-table-action-button-size);
    height: var(--carina-table-action-button-size);
    margin-right: var(--carina-spacing-2);
    margin-left: var(--carina-spacing-2);
    border: 0;
    border-radius: calc(var(--carina-table-action-button-size) / 2);
    background-color: transparent;
    outline: none;
    box-shadow: none;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
[dir='rtl'] .carina-action-button {
    transform: scaleX(-1);
}
.carina-action-button:active:not(.carina-action-button--disabled) {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-action-button:focus {
    border: var(--carina-border-width-1) solid
      var(--carina-border-color-inverse);
}
.carina-action-button--disabled {
    opacity: var(--carina-opacity-40);
    cursor: default;
}
.carina-action-button--disabled:hover,
  .carina-action-button--disabled:active {
    opacity: var(--carina-opacity-40);
    cursor: default;
}
.carina-action-button--static-select-indicator:not(.carina-action-button--disabled):focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    outline-offset: var(--carina-border-width-0);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-action-button--static-actions-menu:not(.carina-action-button--disabled):active {
    background-color: var(--carina-background-color-surface-active);
}
.carina-action-button--static-actions-menu:not(.carina-action-button--disabled):focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    outline-offset: var(--carina-border-width-0);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-action-button__x-ray {
    position: absolute;
    z-index: calc(var(--carina-z-index-current) + 50);
    opacity: var(--carina-opacity-0);
    transition: opacity var(--carina-transition-duration-200);
    pointer-events: none;
}
.carina-item-label {
    display: flex;
    align-items: center;
}
.carina-item-label__spacer {
    height: var(--carina-spacing-4);
    width: var(--carina-spacing-4);
}
.carina-item-label__text {
    padding-left: calc(2 * var(--carina-spacing-px));
}
.carina-tabs__wrapper {
    position: relative;
    display: inline-flex;
    flex: 1 0 0%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: flex-start;
    box-sizing: border-box;
    min-width: 100%;
    max-width: 100%;
    overflow: auto;
    white-space: nowrap;
    vertical-align: middle;
    table-layout: fixed;
    background-color: transparent;
    scrollbar-width: none;
}
.carina-tabs__wrapper::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    background: transparent;
}
.carina-tabs {
    position: relative;
    display: table;
    flex: 1 1 0%;
    align-content: start;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    border-bottom: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    overflow: hidden;
    white-space: nowrap;
    vertical-align: top;
    table-layout: fixed;
}
.carina-tabs__arrow-right,
.carina-tabs__arrow-left {
    position: absolute;
    min-width: 40px;
    max-width: 100%;
    max-height: 72px;
    font-size: var(--carina-font-size-body-md);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-soft);
    min-height: 48px;
    border-bottom-style: solid;
    border-bottom-width: var(--carina-border-width-1);
    border-color: var(--carina-border-color-soft);
    cursor: pointer;
}
.carina-tabs__arrow-right:focus, .carina-tabs__arrow-left:focus {
    outline: none;
}
.carina-tabs__arrow-right:hover, .carina-tabs__arrow-left:hover {
    background-color: var(--carina-background-color-surface-hover);
    color: var(--carina-text-color-base);
}
.carina-tabs__arrow-right:active, .carina-tabs__arrow-left:active {
    background-color: var(--carina-background-color-surface-selected);
}
.carina-tabs__arrow-right svg, .carina-tabs__arrow-left svg {
    display: unset;
}
.carina-tabs__arrow-right {
    right: 0;
    border-inline-end: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    min-height: 48px;
    border-bottom-style: solid;
    border-bottom-width: var(--carina-border-width-1);
    border-color: var(--carina-border-color-soft);
}
.carina-tabs__arrow-left {
    left: 0;
    margin-inline-start: 0;
    border-inline-start: var(--carina-border-width-1) solid
    var(--carina-border-color-soft);
    min-height: 48px;
    border-bottom-style: solid;
    border-bottom-width: var(--carina-border-width-1);
    border-color: var(--carina-border-color-soft);
}
[data-scroll-position='0'] .carina-tabs__arrow-left {
    display: none;
    visibility: hidden;
}
[data-scroll-position='0'] .carina-tabs__arrow-right {
    display: none;
    visibility: hidden;
}
[data-scroll-position='1'] .carina-tabs__arrow-left {
    display: none;
    visibility: hidden;
}
[data-scroll-position='1'] .carina-tabs__arrow-right {
    display: unset;
    visibility: unset;
}
[data-scroll-position='2'] .carina-tabs__arrow-left {
    display: unset;
    visibility: unset;
}
[data-scroll-position='2'] .carina-tabs__arrow-right {
    display: none;
    visibility: hidden;
}
[data-scroll-position='3'] .carina-tabs__arrow-left {
    display: unset;
    visibility: unset;
}
[data-scroll-position='3'] .carina-tabs__arrow-right {
    display: unset;
    visibility: unset;
}
[dir='rtl'] [data-scroll-position='2'] .carina-tabs__arrow-left {
    display: none;
    visibility: hidden;
}
[dir='rtl'] [data-scroll-position='2'] .carina-tabs__arrow-right {
    display: unset;
    visibility: unset;
}
[dir='rtl'] [data-scroll-position='1'] .carina-tabs__arrow-left {
    display: unset;
    visibility: unset;
}
[dir='rtl'] [data-scroll-position='1'] .carina-tabs__arrow-right {
    display: none;
    visibility: hidden;
}
.carina-tabs.carina-tabs--bottomless,
.carina-tabs.carina-tabs--secondary {
    border-bottom-width: 0;
}
.carina-tabs__list {
    display: flex;
    gap: var(--carina-spacing-0-5);
    padding: var(--carina-spacing-0) var(--carina-spacing-0-5);
}
.carina-tabs__tab {
    position: relative;
    display: flex;
    flex: 1 0 auto;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 5rem;
    min-height: 47px;
    margin: 0 auto;
    padding-top: 1px;
    padding-right: var(--carina-spacing-4);
    padding-left: var(--carina-spacing-4);
    border: 0;
    border-radius: var(--carina-border-radius-md);
    background: transparent;
    color: var(--carina-text-color-soft);
    font-family: inherit;
    line-height: inherit;
    font-size: var(--carina-font-size-body-md);
    white-space: nowrap;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    outline-color: var(--carina-colors-transparent);
    outline-offset: calc(var(--carina-border-width-2) * -1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color;
    cursor: pointer;
}
.carina-tabs__tab::after {
    content: '';
}
.carina-tabs__tab .carina-tabs__tab::-moz-focus-inner {
    padding: 0;
    border: 0;
    outline: none;
}
.carina-tabs__tab:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tabs__tab:hover {
    color: var(--carina-text-color-base);
    vertical-align: middle;
}
.carina-tabs__tab:hover::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: var(--carina-border-width-4);
    border-top-left-radius: var(--carina-border-radius-md);
    border-top-right-radius: var(--carina-border-radius-md);
    background-color: var(--carina-border-color-soft);
}
.carina-tabs__tab--selected {
    color: var(--carina-text-color-base);
    cursor: auto;
}
.carina-tabs__tab--selected:focus-visible {
    border-radius: var(--carina-border-radius-md) var(--carina-border-radius-md)
      var(--carina-border-radius-none) var(--carina-border-radius-none);
}
.carina-tabs__tab--selected::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: var(--carina-border-width-4);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    content: '';
}
.carina-tabs__tab--pri.carina-tabs__tab--selected::after {
    background-color: var(--carina-border-color-primary-focus);
}
.carina-tabs__tab--sec.carina-tabs__tab--selected::after {
    background-color: var(--carina-border-color-secondary-focus);
}
.carina-tabs__tab--ter.carina-tabs__tab--selected::after {
    background-color: var(--carina-border-color-tertiary-focus);
}
.carina-tabs__tab--secondary {
    border: var(--carina-border-width-1) solid var(--carina-colors-transparent);
}
.carina-tabs__tab--secondary::after {
    content: none;
}
.carina-tabs__tab--secondary:hover {
    background-color: var(--carina-background-color-surface-hover);
}
.carina-tabs__tab--secondary.carina-tabs__tab--selected,
.carina-tabs__tab--secondary:active {
    border-width: var(--carina-border-width-1);
    border-style: solid;
    border-color: var(--carina-border-color-primary-focus);
}
.carina-tabs__tab--pri.carina-tabs__tab--secondary.carina-tabs__tab--selected, .carina-tabs__tab--pri.carina-tabs__tab--secondary:active {
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
    border-color: var(--carina-border-color-primary-focus);
}
.carina-tabs__tab--sec.carina-tabs__tab--secondary.carina-tabs__tab--selected, .carina-tabs__tab--sec.carina-tabs__tab--secondary:active {
    color: var(--carina-text-color-on-secondary);
    background-color: var(--carina-background-color-secondary);
    border-color: var(--carina-border-color-secondary-focus);
}
.carina-tabs__tab--ter.carina-tabs__tab--secondary.carina-tabs__tab--selected, .carina-tabs__tab--ter.carina-tabs__tab--secondary:active {
    color: var(--carina-text-color-on-tertiary-);
    background-color: var(--carina-background-color-tertiary);
    border-color: var(--carina-border-color-tertiary-focus);
}
.carina-tag-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    margin: var(--carina-spacing-0);
    line-height: var(--carina-line-height-normal);
    list-style: none;
    padding-inline-start: 0;
}
.carina-tag-group > li {
    margin-bottom: var(--carina-spacing-2);
    margin-inline-end: var(--carina-spacing-2);
}
.carina-templates-body {
    display: flex;
    flex-shrink: 1;
    height: 100%;
    overflow-y: auto;
}
.carina-templates-default-actions {
    flex-shrink: 0;
}
.carina-templates-content-area {
    display: flex;
    flex-direction: column;
    flex-shrink: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
}
.carina-templates-content-container {
    box-sizing: border-box;
    max-width: 1920px;
    margin: var(--carina-spacing-4);
    padding: var(--carina-spacing-6);
    border: var(--carina-border-width-1) solid var(--carina-border-color-soft);
    border-radius: var(--carina-border-radius-sm);
    overflow: auto;
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
}
.carina-templates-dock {
    flex-shrink: 0;
}
.carina-template-header {
    flex-shrink: 1;
    width: 100%;
}
.carina-template-hero-header {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: var(--carina-spacing-6) var(--carina-spacing-6)
    var(--carina-spacing-0);
    border-bottom: var(--carina-spacing-px) solid var(--carina-border-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    background-color: var(--carina-background-color-surface);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
}
.carina-template-hero-header header {
    position: relative;
    display: flex;
    flex: 1 0 auto;
    width: 100%;
    margin: var(--carina-spacing-4) var(--carina-spacing-0)
      var(--carina-spacing-8) var(--carina-spacing-0);
}
.carina-template-hero-header__title {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    flex: 1 0 auto;
    margin: var(--carina-spacing-0);
    overflow: hidden;
    -webkit-line-clamp: 2;
}
.carina-template-hero-header__logo {
    display: flex;
    margin: var(--carina-spacing-0);
    margin-inline-end: calc(var(--carina-spacing-8) + var(--carina-spacing-1));
}
.carina-template-hero-header__content-block {
    flex: 1 1 0%;
    margin: var(--carina-spacing-0);
    padding: var(--carina-spacing-0);
}
.carina-template-hero-header__content-wrapper {
    display: flex;
    flex: 1;
}
.carina-template-illustration {
    max-height: 100vh;
    padding: var(--carina-spacing-6) var(--carina-spacing-10);
}
.carina-template-illustration__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding-top: var(--carina-spacing-8);
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
}
.carina-template-illustration__illustration-container {
    max-width: 100%;
    margin: var(--carina-spacing-0) auto;
    text-align: center;
}
.carina-template-illustration__illustration-container svg {
    width: auto;
    height: auto;
    margin: auto;
}
.carina-template-illustration__image {
    width: 70%;
    max-width: 375px;
}
.carina-template-illustration__wrapper--compact,
.carina-template-illustration__illustration-container--compact {
    margin-bottom: 26px;
}
.carina-template-illustration__error {
    margin: var(--carina-spacing-4) auto var(--carina-spacing-8);
    color: var(--carina-text-color-danger);
    font-size: var(--carina-font-size-sm);
    font-family: var(--carina-font-family-primary);
    text-align: center;
}
.carina-template-illustration__error-details {
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-xs);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-tight);
    text-align: center;
}
.carina-template-illustration__error-details-heading {
    margin-top: var(--carina-spacing-12);
    margin-bottom: var(--carina-spacing-4);
}
.carina-template-illustration__error-details-date-heading {
    margin-top: var(--carina-spacing-4);
}
.carina-template-illustration__header-wrapper {
    display: block;
    max-width: 375px;
    margin: 0 auto var(--carina-spacing-4);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-2xl);
    line-height: var(--carina-line-height-9);
    font-family: var(--carina-font-family-primary);
    text-align: center;
}
.carina-template-illustration__body-wrapper {
    display: block;
    max-width: 375px;
    margin: var(--carina-spacing-4) auto var(--carina-spacing-8);
    color: var(--carina-text-color-soft);
    font-weight: var(--carina-font-weight-body);
    font-size: var(--carina-font-size-md);
    font-family: var(--carina-font-family-primary);
    text-align: center;
}
.carina-templates-main {
    display: flex;
    flex-direction: column;
    flex-shrink: 1;
    width: 100%;
}
.carina-templates-page {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
}
.carina-templates-scroll-view {
    flex-grow: 1;
    overflow-y: auto;
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    background: var(--carina-background-color-surface-alt);
}
.carina-templates-template-action-bar {
    flex-shrink: 0;
}
.carina-templates-template-actions {
    display: flex;
    flex: 0 0 30%;
    align-items: center;
    max-height: 48px;
}
.carina-templates-template-actions button {
    margin: var(--carina-spacing-2);
}
.carina-templates-template-actions__small {
    position: relative;
    right: 0;
    min-height: 100%;
}
.carina-templates-template-actions--stacked {
    flex-direction: column-reverse;
}
.carina-templates-template-actions--position-flex-end {
    justify-content: flex-end;
}
.carina-templates-template-actions--position-flex-start {
    justify-content: flex-start;
}
.carina-templates-template-actions--position-center {
    justify-content: center;
}
.carina-templates-template-panel {
    flex-shrink: 0;
    height: 100%;
}
.carina-tile {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: var(--carina-tile-padding, var(--carina-spacing-6));
    border-color: var(--carina-border-color-soft);
    border-style: solid;
    border-width: var(--carina-border-width-1);
    border-radius: var(--carina-border-radius-xl);
    color: var(--carina-text-color-body, var(--carina-text-color-base));
    font-weight: var(--carina-font-weight-body);
    font-family: var(--carina-font-family-primary);
    line-height: var(--carina-line-height-normal);
    background-color: var(--carina-background-color-surface);
    cursor: default;
    transition-timing-function: var(
    --carina-transition-timing-function-expressive-ease-in-out
  );
    transition-duration: calc(
    var(--carina-page-loaded, 0) * var(--carina-transition-duration-100)
  );
    transition-property: outline-color, border-color;
    pointer-events: none;
}
.carina-tile--interactive {
    cursor: pointer;
    border-color: var(--carina-border-color-base);
    pointer-events: auto;
    outline-color: var(--carina-colors-transparent);
    outline-offset: var(--carina-border-width-1);
    outline-style: solid;
    outline-width: var(--carina-border-width-2);
}
.carina-tile--interactive:focus-visible {
    outline-color: var(--carina-border-color-primary-focus);
    transition-duration: var(--carina-transition-duration-100);
}
.carina-tile--selected:not(.carina-tile--error):not(.carina-tile--disabled) {
    border-color: var(--carina-border-color-primary-focus);
}
.carina-tile--error {
    border-color: var(--carina-border-color-danger-focus);
}
.carina-tile--error:focus-visible {
    outline-color: var(--carina-border-color-danger-focus);
}
.carina-tile--disabled {
    border-color: var(--carina-border-color-soft);
    background-color: var(--carina-background-color-surface);
    box-shadow: none;
    cursor: default;
}
.carina-tile__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.carina-tile__arrange-icon {
    position: absolute;
    top: var(--carina-tile-padding, var(--carina-spacing-6));
    left: var(--carina-tile-padding, var(--carina-spacing-6));
    background-color: var(--carina-background-color-surface);
    cursor: pointer;
}
.carina-tile__selected-icon {
    position: absolute;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: var(--carina-border-radius-full);
    color: var(--carina-text-color-on-primary);
    background-color: var(--carina-background-color-primary);
    box-shadow: 0 4px 20px -4px var(--carina-border-color-primary-focus);
}
.carina-tile__selected-icon--top-start {
    top: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
    left: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
}
[dir='rtl'] .carina-tile__selected-icon--top-start {
    right: var(
        --carina-tile-selected-indicator-offset,
        var(--carina-tile-padding, var(--carina-spacing-6))
      );
    left: auto;
}
.carina-tile__selected-icon--top-end {
    top: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
    right: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
}
[dir='rtl'] .carina-tile__selected-icon--top-end {
    right: auto;
    left: var(
        --carina-tile-selected-indicator-offset,
        var(--carina-tile-padding, var(--carina-spacing-6))
      );
}
.carina-tile__selected-icon--bottom-start {
    bottom: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
    left: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
}
[dir='rtl'] .carina-tile__selected-icon--bottom-start {
    right: var(
        --carina-tile-selected-indicator-offset,
        var(--carina-tile-padding, var(--carina-spacing-6))
      );
    left: auto;
}
.carina-tile__selected-icon--bottom-end {
    right: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
    bottom: var(
      --carina-tile-selected-indicator-offset,
      var(--carina-tile-padding, var(--carina-spacing-6))
    );
}
[dir='rtl'] .carina-tile__selected-icon--bottom-end {
    right: auto;
    left: var(
        --carina-tile-selected-indicator-offset,
        var(--carina-tile-padding, var(--carina-spacing-6))
      );
}
.carina-tile__body {
    flex: 1 1 auto;
    min-height: 75%;
    padding: inherit;
}
.carina-tile__footer {
    flex: 1 1 auto;
    padding: inherit;
}
.carina-wizard__footer,
.carina-wizard__footer-end-container,
.carina-wizard__footer-start-container {
    display: flex;
}
.carina-wizard__footer {
    justify-content: center;
}
.carina-wizard__footer-end-container {
    margin-inline-start: 12px;
}
.carina-wizard__footer-start-container {
    margin-inline-end: 12px;
}
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.visible {
    visibility: visible;
}
.collapse {
    visibility: collapse;
}
.static {
    position: static;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.sticky {
    position: sticky;
}
.inset-y-0 {
    top: var(--carina-spacing-0);
    bottom: var(--carina-spacing-0);
}
.-left-2 {
    left: calc(var(--carina-spacing-2) * -1);
}
.-left-5 {
    left: calc(var(--carina-spacing-5) * -1);
}
.-left-px {
    left: calc(var(--carina-spacing-px) * -1);
}
.-top-6 {
    top: calc(var(--carina-spacing-6) * -1);
}
.bottom-0 {
    bottom: var(--carina-spacing-0);
}
.end-0 {
    inset-inline-end: var(--carina-spacing-0);
}
.left-0 {
    left: var(--carina-spacing-0);
}
.start-0 {
    inset-inline-start: var(--carina-spacing-0);
}
.top-0 {
    top: var(--carina-spacing-0);
}
.top-1\\/2 {
    top: 50%;
}
.top-\\[-3px\\] {
    top: -3px;
}
.top-\\[3px\\] {
    top: 3px;
}
.z-\\[101\\] {
    z-index: 101;
}
.z-\\[9999\\] {
    z-index: 9999;
}
.z-\\[calc\\(var\\(--carina-z-index-current\\)\\+1\\)\\] {
    z-index: calc(var(--carina-z-index-current) + 1);
}
.m-0 {
    margin: var(--carina-spacing-0);
}
.-mx-px {
    margin-left: calc(var(--carina-spacing-px) * -1);
    margin-right: calc(var(--carina-spacing-px) * -1);
}
.mx-3 {
    margin-left: var(--carina-spacing-3);
    margin-right: var(--carina-spacing-3);
}
.my-1\\.5 {
    margin-top: var(--carina-spacing-1-5);
    margin-bottom: var(--carina-spacing-1-5);
}
.my-4 {
    margin-top: var(--carina-spacing-4);
    margin-bottom: var(--carina-spacing-4);
}
.-me-px {
    margin-inline-end: calc(var(--carina-spacing-px) * -1);
}
.ms-0 {
    margin-inline-start: var(--carina-spacing-0);
}
.ms-3 {
    margin-inline-start: var(--carina-spacing-3);
}
.mt-4 {
    margin-top: var(--carina-spacing-4);
}
.mt-6 {
    margin-top: var(--carina-spacing-6);
}
.inline {
    display: inline;
}
.inline-flex {
    display: inline-flex;
}
.\\!table {
    display: table !important;
}
.table {
    display: table;
}
.contents {
    display: contents;
}
.list-item {
    display: list-item;
}
.h-0 {
    height: var(--carina-spacing-0);
}
.h-10 {
    height: var(--carina-spacing-10);
}
.h-16 {
    height: var(--carina-spacing-16);
}
.h-3 {
    height: var(--carina-spacing-3);
}
.h-4 {
    height: var(--carina-spacing-4);
}
.h-6 {
    height: var(--carina-spacing-6);
}
.h-\\[16px\\] {
    height: 16px;
}
.h-\\[24px\\] {
    height: 24px;
}
.h-\\[36px\\] {
    height: 36px;
}
.h-\\[40px\\] {
    height: 40px;
}
.h-\\[calc\\(100\\%_\\+_6px\\)\\] {
    height: calc(100% + 6px);
}
.h-full {
    height: 100%;
}
.h-screen {
    height: 100vh;
}
.min-h-\\[36px\\] {
    min-height: 36px;
}
.w-0 {
    width: var(--carina-spacing-0);
}
.w-10 {
    width: var(--carina-spacing-10);
}
.w-3 {
    width: var(--carina-spacing-3);
}
.w-4 {
    width: var(--carina-spacing-4);
}
.w-48 {
    width: var(--carina-spacing-48);
}
.w-56 {
    width: var(--carina-spacing-56);
}
.w-6 {
    width: var(--carina-spacing-6);
}
.w-64 {
    width: var(--carina-spacing-64);
}
.w-80 {
    width: var(--carina-spacing-80);
}
.w-\\[16px\\] {
    width: 16px;
}
.w-\\[36px\\] {
    width: 36px;
}
.w-full {
    width: 100%;
}
.min-w-0 {
    min-width: var(--carina-spacing-0);
}
.min-w-\\[160px\\] {
    min-width: 160px;
}
.max-w-\\[230px\\] {
    max-width: 230px;
}
.max-w-\\[calc\\(100\\%_-_85px\\)\\] {
    max-width: calc(100% - 85px);
}
.max-w-full {
    max-width: 100%;
}
.grow {
    flex-grow: 1;
}
.-translate-x-\\[calc\\(100\\%\\+16px\\)\\] {
    --tw-translate-x: calc(calc(100% + 16px) * -1);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-px {
    --tw-translate-y: calc(var(--carina-spacing-px) * -1);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
    --tw-translate-x: var(--carina-spacing-1);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
    --tw-rotate: var(--carina-rotate-180);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
    transform: none;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite;
}
.cursor-pointer {
    cursor: pointer;
}
.select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
.select-text {
    -webkit-user-select: text;
    -moz-user-select: text;
    user-select: text;
}
.select-all {
    -webkit-user-select: all;
    -moz-user-select: all;
    user-select: all;
}
.resize {
    resize: both;
}
.list-none {
    list-style-type: none;
}
.flex-col {
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.\\!items-center {
    align-items: center !important;
}
.items-center {
    align-items: center;
}
.justify-end {
    justify-content: flex-end;
}
.\\!justify-center {
    justify-content: center !important;
}
.justify-center {
    justify-content: center;
}
.gap-2 {
    gap: var(--carina-spacing-2);
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-visible {
    overflow: visible;
}
.overflow-x-hidden {
    overflow-x: hidden;
}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.text-ellipsis {
    text-overflow: ellipsis;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.rounded {
    border-radius: var(--carina-border-radius-sm);
}
.rounded-md {
    border-radius: var(--carina-border-radius-md);
}
.rounded-none {
    border-radius: var(--carina-border-radius-none);
}
.rounded-sm {
    border-radius: var(--carina-border-radius-sm);
}
.rounded-e-md {
    border-start-end-radius: var(--carina-border-radius-md);
    border-end-end-radius: var(--carina-border-radius-md);
}
.rounded-e-none {
    border-start-end-radius: var(--carina-border-radius-none);
    border-end-end-radius: var(--carina-border-radius-none);
}
.rounded-s-\\[calc\\(var\\(--carina-border-radius-md\\)_\\+_3px\\)\\] {
    border-start-start-radius: calc(var(--carina-border-radius-md) + 3px);
    border-end-start-radius: calc(var(--carina-border-radius-md) + 3px);
}
.rounded-s-md {
    border-start-start-radius: var(--carina-border-radius-md);
    border-end-start-radius: var(--carina-border-radius-md);
}
.rounded-s-none {
    border-start-start-radius: var(--carina-border-radius-none);
    border-end-start-radius: var(--carina-border-radius-none);
}
.rounded-ss-md {
    border-start-start-radius: var(--carina-border-radius-md);
}
.border {
    border-width: var(--carina-border-width-1);
}
.border-0 {
    border-width: var(--carina-border-width-0);
}
.border-2 {
    border-width: var(--carina-border-width-2);
}
.border-b {
    border-bottom-width: var(--carina-border-width-1);
}
.border-b-0 {
    border-bottom-width: var(--carina-border-width-0);
}
.border-b-2 {
    border-bottom-width: var(--carina-border-width-2);
}
.border-solid {
    border-style: solid;
}
.border-dashed {
    border-style: dashed;
}
.border-\\[transparent\\] {
    border-color: transparent;
}
.border-base {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-base) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-danger {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-danger) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-hard {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-hard) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-soft {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-soft) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-s-\\[transparent\\] {
    border-inline-start-color: transparent;
}
.bg-\\[transparent\\] {
    background-color: transparent;
}
.bg-surface {
    --tw-bg-opacity: 1;
    background-color: color-mix(in srgb, var(--carina-background-color-surface) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-surface-alt {
    --tw-bg-opacity: 1;
    background-color: color-mix(in srgb, var(--carina-background-color-surface-alt) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.p-0 {
    padding: var(--carina-spacing-0);
}
.p-1 {
    padding: var(--carina-spacing-1);
}
.p-2 {
    padding: var(--carina-spacing-2);
}
.p-4 {
    padding: var(--carina-spacing-4);
}
.px-0 {
    padding-left: var(--carina-spacing-0);
    padding-right: var(--carina-spacing-0);
}
.px-1 {
    padding-left: var(--carina-spacing-1);
    padding-right: var(--carina-spacing-1);
}
.px-2 {
    padding-left: var(--carina-spacing-2);
    padding-right: var(--carina-spacing-2);
}
.px-4 {
    padding-left: var(--carina-spacing-4);
    padding-right: var(--carina-spacing-4);
}
.py-2\\.5 {
    padding-top: var(--carina-spacing-2-5);
    padding-bottom: var(--carina-spacing-2-5);
}
.py-\\[var\\(--carina-tan-table-padding-vertical\\)\\] {
    padding-top: var(--carina-tan-table-padding-vertical);
    padding-bottom: var(--carina-tan-table-padding-vertical);
}
.pb-0 {
    padding-bottom: var(--carina-spacing-0);
}
.pb-1 {
    padding-bottom: var(--carina-spacing-1);
}
.pb-4 {
    padding-bottom: var(--carina-spacing-4);
}
.pe-0 {
    padding-inline-end: var(--carina-spacing-0);
}
.pe-1 {
    padding-inline-end: var(--carina-spacing-1);
}
.pe-3 {
    padding-inline-end: var(--carina-spacing-3);
}
.pe-4 {
    padding-inline-end: var(--carina-spacing-4);
}
.ps-0 {
    padding-inline-start: var(--carina-spacing-0);
}
.ps-1 {
    padding-inline-start: var(--carina-spacing-1);
}
.ps-2 {
    padding-inline-start: var(--carina-spacing-2);
}
.ps-4 {
    padding-inline-start: var(--carina-spacing-4);
}
.ps-\\[var\\(--carina-tan-table-padding-horizontal\\)\\] {
    padding-inline-start: var(--carina-tan-table-padding-horizontal);
}
.text-center {
    text-align: center;
}
.text-start {
    text-align: start;
}
.indent-0 {
    text-indent: var(--carina-spacing-0);
}
.font-body {
    font-family: var(--carina-font-family-body);
    font-weight: var(--carina-font-weight-body);
}
.font-mono {
    font-family: var(--carina-font-family-mono);
}
.text-md {
    font-size: var(--carina-font-size-md);
    line-height: var(--carina-line-height-3);
}
.text-sm {
    font-size: var(--carina-font-size-sm);
    line-height: var(--carina-line-height-3);
}
.uppercase {
    text-transform: uppercase;
}
.leading-normal {
    line-height: var(--carina-line-height-normal);
}
.text-base {
    --tw-text-opacity: 1;
    color: color-mix(in srgb, var(--carina-text-color-base) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-disabled {
    --tw-text-opacity: 1;
    color: color-mix(in srgb, var(--carina-text-color-disabled) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.underline {
    text-decoration-line: underline;
}
.no-underline {
    text-decoration-line: none;
}
.opacity-100 {
    opacity: var(--carina-opacity-100);
}
.shadow {
    --tw-shadow: var(--carina-box-shadow-md);
    --tw-shadow-colored: var(--carina-box-shadow-md);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_color-mix\\(in_srgb\\2c var\\(--carina-border-color-hard\\)_calc\\(var\\(--carina-opacity-25\\)_\\*_100\\%\\)\\2c transparent\\)\\] {
    --tw-shadow: inset 0 0 0 1px color-mix(in srgb,var(--carina-border-color-hard) calc(var(--carina-opacity-25) * 100%),transparent);
    --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
    --tw-shadow: var(--carina-box-shadow-xl);
    --tw-shadow-colored: var(--carina-box-shadow-xl);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
    outline-style: solid;
}
.outline-2 {
    outline-width: 2px;
}
.-outline-offset-4 {
    outline-offset: -4px;
}
.outline-offset-1 {
    outline-offset: 1px;
}
.outline-\\[var\\(--carina-border-color-inverse\\)\\] {
    outline-color: var(--carina-border-color-inverse);
}
.outline-\\[var\\(--carina-colors-transparent\\)\\] {
    outline-color: var(--carina-colors-transparent);
}
.ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(var(--carina-ring-width-2) + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
}
.transition-all {
    transition-property: all;
}
.transition-none {
    transition-property: none;
}
.transition-transform {
    transition-property: transform;
}
.duration-100 {
    transition-duration: var(--carina-transition-duration-100);
}
.duration-300 {
    transition-duration: var(--carina-transition-duration-300);
}
.\\[--carina-avatar-bg\\:var\\(--carina-avatar-group-overflow-bg\\2c \\#c2c2c2\\)\\] {
    --carina-avatar-bg: var(--carina-avatar-group-overflow-bg,#c2c2c2);
}
.\\[--carina-avatar-fg\\:var\\(--carina-avatar-group-overflow-fg\\2c \\#000\\)\\] {
    --carina-avatar-fg: var(--carina-avatar-group-overflow-fg,#000);
}
.group:focus-visible .group-focus-visible\\:outline-\\[var\\(--carina-border-color-primary-focus\\)\\] {
    outline-color: var(--carina-border-color-primary-focus);
}
.group:focus-visible .group-focus-visible\\:duration-100 {
    transition-duration: var(--carina-transition-duration-100);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-b-0 {
    border-bottom-width: var(--carina-border-width-0);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-solid {
    border-style: solid;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-danger {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-danger) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-danger-focus {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-danger-focus) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-primary-focus {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-primary-focus) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.peer:focus-visible ~ .peer-focus-visible\\:outline {
    outline-style: solid;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-2 {
    outline-width: 2px;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-offset-1 {
    outline-offset: 1px;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-\\[var\\(--carina-border-color-danger-focus\\)\\] {
    outline-color: var(--carina-border-color-danger-focus);
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-\\[var\\(--carina-border-color-primary-focus\\)\\] {
    outline-color: var(--carina-border-color-primary-focus);
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-danger {
    --tw-ring-color: var(--carina-ring-color-danger);
}
@media (min-width: 640px) {
    .\\!container {
        max-width: 640px !important;
    }
    .container {
        max-width: 640px;
    }
    .carina-breadcrumbs__breadcrumb,
  .carina-breadcrumbs__breadcrumb-list-item {
        display: inline-flex;
    }
    .carina-breadcrumbs__breadcrumb--mobile,
  .carina-breadcrumbs__breadcrumb-list-item--mobile {
        display: none;
    }
    .carina-modal--fluid {
        --carina-z-index-current: var(--carina-z-index-modal);
        --carina-z-index-popper: calc(
        var(--carina-z-index-modal) + var(--carina-z-index-popper-diff)
      );
        --carina-z-index-scrim: calc(
        var(--carina-z-index-modal) + var(--carina-z-index-scrim-diff)
      );
    }
    .carina-modal__dialog--fluid {
        min-width: 512px;
        width: 80vw;
    }
    .carina-container--fixed {
        max-width: var(--carina-breakpoint-sm);
    }
    .carina-filter-control-bar__tag-list {
        display: flex;
    }
    .carina-filter-control-bar__button {
        margin-top: var(--carina-spacing-0);
    }
    .carina-filter-control-bar .carina-search-bar {
        flex-shrink: 0;
        width: 300px;
    }
    .carina-filter-select__inner {
        display: flex;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-sm {
        flex-direction: row;
        border-bottom-color: var(--carina-border-color-base);
        border-bottom-width: var(--carina-border-width-1);
        border-bottom-style: solid;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-sm:last-child {
        border-color: transparent;
    }
    .carina-formsection--stack.carina-formsection--stack-breakpoint-sm {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-sm {
        padding-left: var(--carina-spacing-6);
    }
    [dir='rtl'] .carina-formsection__content--stack-breakpoint-sm {
        padding-right: var(--carina-spacing-6);
        padding-left: 0;
    }
    .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-sm {
        padding-left: 0;
    }
    [dir='rtl'] .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-sm {
        padding-right: 0;
    }
    .carina-formsection__header.carina-formsection__header--stack-breakpoint-sm {
        width: 200px;
    }
    .carina-formsection__header--stack.carina-formsection__header--stack-breakpoint-sm {
        width: unset;
    }
    .carina-navigation-next__object-header-container__top-breadcrumbs-root,
.carina-navigation-next__object-header-container__top-chevron {
        display: none;
    }
    .carina-navigation-next__object-header-container__lower-container {
        flex-direction: row;
    }
    .carina-navigation-next__object-header-container__lower-divider-icon {
        display: block;
        height: 12px;
        width: 0px;
        border: 1px solid var(--carina-border-color-base);
        margin: auto var(--carina-spacing-3);
    }
    .carina-shell-next[data-shell-enabled*='dock-start'] .carina-shell-next__dock--start {
        grid-area: dock-start;
        height: 0;
    }
    .carina-template-illustration__wrapper svg,
  .carina-template-illustration__illustration-container svg {
        width: 375px;
        height: 375px;
    }
    .carina-template-illustration__wrapper--compact,
  .carina-template-illustration__illustration-container--compact {
        margin-bottom: 32px;
    }
    .carina-template-illustration__wrapper--compact svg, .carina-template-illustration__illustration-container--compact svg {
        width: 250px;
        height: 250px;
    }
}
@media (min-width: 768px) {
    .\\!container {
        max-width: 768px !important;
    }
    .container {
        max-width: 768px;
    }
    .carina-container--fixed {
        max-width: var(--carina-breakpoint-md);
    }
    .carina-formsection.carina-formsection--stack-breakpoint-md {
        flex-direction: row;
        border-bottom-color: var(--carina-border-color-base);
        border-bottom-width: var(--carina-border-width-1);
        border-bottom-style: solid;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-md:last-child {
        border-color: transparent;
    }
    .carina-formsection--stack.carina-formsection--stack-breakpoint-md {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-md {
        padding-left: var(--carina-spacing-6);
    }
    [dir='rtl'] .carina-formsection__content--stack-breakpoint-md {
        padding-right: var(--carina-spacing-6);
        padding-left: 0;
    }
    .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-md {
        padding-left: 0;
    }
    [dir='rtl'] .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-md {
        padding-right: 0;
    }
    .carina-formsection__header.carina-formsection__header--stack-breakpoint-md {
        width: 200px;
    }
    .carina-formsection__header--stack.carina-formsection__header--stack-breakpoint-md {
        width: unset;
    }
    .carina-navigation-next__mobile-navigation-container {
        display: none;
    }
    .carina-navigation-next__mobile-navigation-header {
        display: none;
    }
    .carina-navigation-next__navigation-user-profile {
        padding: var(--carina-spacing-2);
    }
    .carina-navigation-next__navigation-user-profile__link,
.carina-navigation-next__navigation-user-profile__account-link {
        padding: var(--carina-spacing-1-5) var(--carina-spacing-2);
    }
    .carina-navigation-next__navigation-user-profile--expanded {
        width: unset;
        min-width: 304px;
    }
    .carina-navigation-next__object-header-container {
        grid-template-areas: 'start end';
        grid-template-rows: auto;
        grid-template-columns: 1fr min-content;
        height: calc(var(--carina-navigation-object-header-full-height));
        background-color: var(--carina-background-color-surface);
        border-bottom: var(--carina-navigation-object-header-border-height) solid
      var(--carina-border-color-soft);
    }
    .carina-navigation-next__object-header-container__end {
        margin-top: var(--carina-spacing-0);
    }
    .carina-navigation-next__object-header-container__top-chevron-container {
        display: flex;
        width: 24px;
    }
    .carina-navigation-next__object-header-container__top-icon-container {
        display: flex;
        width: 32px;
        margin-inline-end: var(--carina-spacing-2);
    }
    .carina-navigation-next__object-header-container__top-breadcrumbs-root,
.carina-navigation-next__object-header-container__top-chevron {
        display: flex;
    }
    .carina-navigation-next__object-header-container__lower-start-text {
        margin-bottom: var(--carina-spacing-0);
    }
    .carina-navigation-next__object-sidebar-dropdown {
        width: 100%;
        min-width: 42px;
    }
    @container object (min-width: 15rem) {
        .carina-navigation-next__object-sidebar-dropdown {
            width: 100%;
        }
    }
    .carina-navigation-next__object-sidebar-dropdown__row {
        padding: var(--carina-spacing-0) var(--carina-spacing-0)
      var(--carina-spacing-0) var(--carina-spacing-2-5);
    }
    @container object (max-width: 4.25rem) {
        .carina-navigation-next__object-sidebar-dropdown__row {
            padding-left: var(--carina-spacing-0);
        }
        .carina-navigation-next__object-sidebar-dropdown__indicator {
            width: 4px;
            margin: var(--carina-spacing-0) var(--carina-spacing-0-5)
        var(--carina-spacing-0) var(--carina-spacing-0-5);
        }
    }
    @container object (max-width: 13.99rem) {
        .carina-navigation-next__object-sidebar-dropdown__indicator--current {
            display: block;
        }
    }
    .carina-navigation-next__object-sidebar-dropdown__title {
        padding-inline-start: var(--carina-spacing-2-5);
        opacity: 0;
        clip: rect(0, 0, 0, 0);
        height: 0px;
        width: 1px;
        position: absolute;
    }
    @container object (min-width: 15rem) {
        .carina-navigation-next__object-sidebar-dropdown__title {
            opacity: 1;
            clip: unset;
            height: unset;
            width: unset;
            position: static;
        }
    }
    .carina-navigation-next__object-sidebar-dropdown__chevron {
        display: none;
    }
    @container object (min-width: 15rem) {
        .carina-navigation-next__object-sidebar-dropdown__chevron {
            display: block;
        }
    }
    @container object (max-width: 13.99rem) {
        .carina-navigation-next__object-sidebar-dropdown__dropdown {
            display: none;
        }
    }
    .carina-navigation-next__object-sidebar-header__icon svg {
        height: 32px;
        width: 32px;
    }
    .carina-navigation-next__object-sidebar-header__title {
        font-size: var(--carina-font-size-header-4);
    }
    .carina-navigation-next__solution-sidebar-dropdown__dropdown-list-item .carina-navigation-next__solution-sidebar-dropdown__dropdown-link {
        padding-top: var(--carina-spacing-1-5);
        padding-bottom: var(--carina-spacing-1-5);
    }
    @container (min-width: 15rem) {
        .carina-navigation-next__solution-sidebar-link__link {
            min-height: 24px;
            height: auto;
            width: calc(100% - 2 * var(--carina-spacing-3) - 2px);
            opacity: var(--carina-opacity-100);
            transition: opacity var(--carina-transition-duration-300)
        var(--carina-transition-timing-function-expressive-ease-in-out)
        var(--carina-transition-delay-100);
        }
    }
    .carina-navigation-next__solution-sidebar-link__link-content {
        height: 0px;
        width: 0px;
        opacity: var(--carina-opacity-0);
        transition: opacity 0ms;
    }
    .carina-navigation__search {
        position: relative;
    }
    .carina-navigation__top-navigation-overlay {
        opacity: 1;
    }
    .carina-shell-next[data-shell-enabled*='aside-end'] .carina-shell-next__aside--end:is(.carina-shell-next__aside.carina-shell-next__aside--end):not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--end) {
        height: unset;
    }
    .carina-shell-next[data-shell-enabled*='dock-start'] .carina-shell-next__dock--start {
        height: 100%;
        translate: 0;
        transition: width var(--carina-transition-duration-100) ease-in-out;
    }
    @media (prefers-reduced-motion) {
        .carina-shell-next[data-shell-enabled*='dock-start'] .carina-shell-next__dock--start {
            transition: width var(--carina-transition-duration-reduced-motion)
            ease-in-out var(--carina-transition-delay-reduced-motion);
        }
    }
    .carina-shell-next__dock--start {
        top: var(--carina-shell-banner-current-height);
        translate: calc(var(--carina-shell-dock-start-width) * -1);
        width: var(--carina-shell-dock-start-width);
        transition: visibility 0ms ease-in-out var(--carina-transition-delay-300),
        translate var(--carina-transition-duration-200) ease-in-out;
    }
    @media (prefers-reduced-motion) {
        .carina-shell-next__dock--start {
            transition: visibility 0ms ease-in-out
            var(--carina-transition-delay-reduced-motion),
          translate var(--carina-transition-duration-reduced-motion) ease-in-out;
        }
    }
    .carina-shell-next__dock--start:hover,
      .carina-shell-next__dock--start:focus-within {
        width: var(--carina-shell-dock-start-expanded-width);
    }
    [dir='rtl'] .carina-shell-next__dock--start {
        translate: var(--carina-shell-dock-start-width);
    }
    .carina-shell-next__dock--start-open {
        width: var(--carina-shell-dock-start-expanded-width);
    }
    .carina-shell-next[data-shell-enabled*='dock-end'] .carina-shell-next__dock--end {
        z-index: var(--carina-shell-dock-end-lgmax-z-index);
    }
    .carina-shell-next__dock--end {
        top: calc(
        var(--carina-shell-banner-current-height) +
          var(--carina-shell-title-current-height)
      );
        width: var(--carina-shell-dock-end-current-width);
        height: calc(
        100vh - var(--carina-shell-banner-current-height) -
          var(--carina-shell-title-current-height)
      );
        transition: visibility 0ms ease-in-out var(--carina-transition-delay-100),
        width 0ms var(--carina-transition-timing-function-productive-ease-in)
          var(--carina-transition-delay-100);
    }
    .carina-shell-next__dock-items {
        flex-direction: column;
        min-width: var(--carina-shell-dock-end-width);
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .carina-shell-next__dock {
        max-height: calc(100vh - var(--carina-shell-banner-current-height));
        overflow-x: hidden;
        overflow-y: auto;
    }
    .carina-shell-next[data-shell-enabled*='footer'] .carina-shell-next__footer {
        bottom: unset;
    }
    .carina-shell-next__page {
        grid-template-areas: 'dock-start title title title'
      'dock-start aside-start header dock-end'
      'dock-start aside-start page-actions dock-end'
      'dock-start aside-start main dock-end';
        grid-template-rows: auto auto auto 1fr;
        grid-template-columns: var(--carina-shell-dock-start-current-width) var(
        --carina-shell-aside-start-current-width
      )
      1fr var(--carina-shell-dock-end-current-width);
    }
    .carina-shell-next[data-shell-sticky*='page-actions'] .carina-shell-next__page-actions {
        position: sticky;
        top: calc(
        var(--carina-shell-banner-offset) + var(--carina-shell-title-offset)
      );
        z-index: 20;
        transition: top 300ms ease-in-out;
    }
    .carina-shell-next[data-shell-sticky*='title'] .carina-shell-next__title {
        position: sticky;
        top: var(--carina-shell-banner-offset);
        z-index: var(--carina-shell-title-z-index);
    }
    .carina-shell-next__xl-panel {
        display: grid;
    }
    .carina-shell-next {
        --carina-shell-aside-start-width: auto;
        --carina-shell-aside-end-width: 20rem;
        --carina-shell-dock-end-max-height: 8.5rem;
    }
    .carina-shell[data-shell-sticky*='breadcrumbs'] .carina-shell__breadcrumbs {
        position: sticky;
        top: calc(
        var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
          var(--carina-shell-title-offset)
      );
        z-index: 20;
        transition: top 300ms ease-in-out;
    }
    .carina-shell[data-shell-enabled*='dock-start'] .carina-shell__dock--start {
        translate: 0;
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
          translate 300ms ease-in-out;
    }
    .carina-shell__dock--start {
        translate: calc(var(--carina-shell-dock-start-width) * -1);
        width: var(--carina-shell-dock-start-width);
        transition: visibility 0ms ease-in-out 300ms, translate 300ms ease-in-out;
    }
    .carina-shell__dock--start:hover,
      .carina-shell__dock--start:focus-within {
        width: var(--carina-shell-dock-start-expanded-width);
    }
    [dir='rtl'] .carina-shell__dock--start {
        translate: var(--carina-shell-dock-start-width);
    }
    .carina-shell[data-shell-enabled*='dock-end'] .carina-shell__dock--end {
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
    }
    .carina-shell__dock--end {
        width: var(--carina-shell-dock-end-current-width);
        transition: visibility 0ms ease-in-out 300ms, width 0ms ease-in-out 300ms;
    }
    .carina-shell__dock-items {
        flex-direction: column;
        min-width: var(--carina-shell-dock-end-width);
        overflow-x: hidden;
        overflow-y: auto;
    }
    .carina-shell__dock {
        max-height: calc(
      100vh - var(--carina-shell-banner-offset) -
        var(--carina-shell-header-offset) - var(--carina-shell-title-offset)
    );
        overflow-x: hidden;
        overflow-y: auto;
    }
    .carina-shell[data-shell-sticky*='page-actions'] .carina-shell__page-actions {
        position: sticky;
        top: calc(
        var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
          var(--carina-shell-title-offset) +
          var(--carina-shell-breadcrumbs-offset)
      );
        z-index: 20;
        transition: top 300ms ease-in-out;
    }
    .carina-stepper__mobile {
        display: none;
    }
    .carina-stepper__mobile__progress-bar {
        display: none;
    }
    .carina-stepper.carina-stepper--vertical {
        display: flex;
        flex-direction: column;
    }
    .carina-stepper.carina-stepper--horizontal {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
    }
    .carina-stepper__progress-bar-wrapper {
        display: flex;
        flex-direction: column;
    }
}
@media (min-width: 1024px) {
    .\\!container {
        max-width: 1024px !important;
    }
    .container {
        max-width: 1024px;
    }
    .carina-container--fixed {
        max-width: var(--carina-breakpoint-lg);
    }
    .carina-row {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .carina-formsection.carina-formsection--stack-breakpoint-lg {
        flex-direction: row;
        border-bottom-color: var(--carina-border-color-base);
        border-bottom-width: var(--carina-border-width-1);
        border-bottom-style: solid;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-lg:last-child {
        border-color: transparent;
    }
    .carina-formsection--stack.carina-formsection--stack-breakpoint-lg {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-lg {
        padding-left: var(--carina-spacing-6);
    }
    [dir='rtl'] .carina-formsection__content--stack-breakpoint-lg {
        padding-right: var(--carina-spacing-6);
        padding-left: 0;
    }
    .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-lg {
        padding-right: 0;
        padding-left: 0;
    }
    .carina-formsection__header.carina-formsection__header--stack-breakpoint-lg {
        width: 200px;
    }
    .carina-formsection__header--stack.carina-formsection__header--stack-breakpoint-lg {
        width: unset;
    }
    .carina-panel--inline .carina-panel__outer-container {
        position: static;
        height: 100%;
        box-shadow: none;
    }
    .carina-panel--productive.carina-panel--inline.carina-panel--scrim .carina-panel__outer-container, .carina-panel--expressive.carina-panel--inline.carina-panel--scrim .carina-panel__outer-container {
        transition-delay: 0ms;
    }
    .carina-panel__scrim--inline {
        display: none;
    }
    .carina-panel--productive .carina-panel__content-container,
  .carina-panel--expressive.carina-transition--out .carina-panel__content-container {
        transition-delay: 0ms;
    }
    .carina-panel--productive.carina-transition--in .carina-panel__content-container,
  .carina-panel--productive.carina-panel--scrim.carina-transition--in .carina-panel__content-container {
        transition-delay: var(--carina-transition-delay-200);
    }
    .carina-panel--expressive.carina-transition--in .carina-panel__content-container,
  .carina-panel--expressive.carina-panel--scrim.carina-transition--in .carina-panel__content-container {
        transition-delay: var(--carina-transition-delay-400);
    }
    @media not (prefers-reduced-motion) {
        .carina-panel--inline.carina-transition--out .carina-panel__outer-container,
    [dir='rtl'] .carina-panel--inline.carina-transition--out .carina-panel__outer-container {
            --carina-transition-translate-x: 0;
        }
        .carina-panel--inline.carina-transition--out .carina-panel__outer-container {
            --carina-collapse-size: 0px;
        }
    }
    .carina-navigation-next__object-sidebar-collapse {
        min-width: var(--carina-navigation-object-sidebar-full-width);
    }
    .carina-navigation-object-sidebar-container-scroll .carina-navigation-next__object-sidebar-link,
  .carina-navigation-object-sidebar-container-scroll .carina-navigation-next__object-sidebar-dropdown {
        padding-inline-end: 0;
    }
    .carina-navigation-next__solution-navigation-logo--compact {
        width: 5rem;
    }
    .carina-shell-next[data-shell-enabled*='dock-end'] .carina-shell-next__dock--end {
        z-index: var(--carina-shell-dock-end-lgmax-z-index);
    }
    .carina-shell {
        --carina-shell-aside-start-width: 14.5rem;
        --carina-shell-aside-end-width: 14.5rem;
    }
}
@media (min-width: 1280px) {
    .\\!container {
        max-width: 1280px !important;
    }
    .container {
        max-width: 1280px;
    }
    .carina-container--fixed {
        max-width: var(--carina-breakpoint-xl);
    }
    .carina-formsection.carina-formsection--stack-breakpoint-xl {
        flex-direction: row;
        border-bottom-color: var(--carina-border-color-base);
        border-bottom-width: var(--carina-border-width-1);
        border-bottom-style: solid;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-xl:last-child {
        border-color: transparent;
    }
    .carina-formsection--stack.carina-formsection--stack-breakpoint-xl {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-xl {
        padding-left: var(--carina-spacing-6);
    }
    [dir='rtl'] .carina-formsection__content--stack-breakpoint-xl {
        padding-right: var(--carina-spacing-6);
        padding-left: 0;
    }
    .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-xl {
        padding-left: 0;
    }
    [dir='rtl'] .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-xl {
        padding-right: 0;
    }
    .carina-formsection__header.carina-formsection__header--stack-breakpoint-xl {
        width: 200px;
    }
    .carina-formsection__header--stack.carina-formsection__header--stack-breakpoint-xl {
        width: unset;
    }
}
@media (min-width: 1536px) {
    .\\!container {
        max-width: 1536px !important;
    }
    .container {
        max-width: 1536px;
    }
    .carina-container--fixed {
        max-width: var(--carina-breakpoint-2xl);
    }
    .carina-formsection.carina-formsection--stack-breakpoint-2xl {
        flex-direction: row;
        border-bottom-color: var(--carina-border-color-base);
        border-bottom-width: var(--carina-border-width-1);
        border-bottom-style: solid;
    }
    .carina-formsection.carina-formsection--stack-breakpoint-2xl:last-child {
        border-color: transparent;
    }
    .carina-formsection--stack.carina-formsection--stack-breakpoint-2xl {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-2xl {
        padding-left: var(--carina-spacing-6);
    }
    [dir='rtl'] .carina-formsection__content--stack-breakpoint-2xl {
        padding-right: var(--carina-spacing-6);
        padding-left: 0;
    }
    .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-2xl {
        padding-left: 0;
    }
    [dir='rtl'] .carina-formsection__content--stack.carina-formsection__content--stack-breakpoint-2xl {
        padding-right: 0;
    }
    .carina-formsection__header.carina-formsection__header--stack-breakpoint-2xl {
        width: 200px;
    }
    .carina-formsection__header--stack.carina-formsection__header--stack-breakpoint-2xl {
        width: unset;
    }
    .carina-navigation-next__solution-navigation-logo--compact {
        width: 5rem;
    }
    .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start {
        visibility: inherit;
    }
    @media (min-width: 768px) {
        .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start {
            translate: 0;
            transition: min-width var(--carina-transition-duration-300) ease-in-out,
      translate var(--carina-transition-duration-300) ease-in-out;
        }
        [dir='rtl'] .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__aside--start {
            translate: 0;
        }
    }
    .carina-shell-next__aside--start {
        translate: 0;
        height: 0;
        left: calc(var(--carina-shell-aside-start-width) * -1);
        grid-area: aside-start;
        width: var(--carina-shell-aside-start-width);
        transition: visibility 0ms ease-in-out 300ms,
    translate 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell-next__aside--start {
        translate: var(--carina-shell-aside-start-width);
    }
    @media (min-width: 768px) {
        .carina-shell-next__aside--start {
            translate: calc(var(--carina-shell-aside-start-width) * -1);
            height: calc(
      100vh - var(--carina-shell-banner-current-height) -
        var(--carina-shell-title-current-height)
    );
            min-width: 0rem;
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell-next__aside--start {
            z-index: var(--carina-shell-aside-lgmax-z-index);
            transition: left var(--carina-transition-duration-300) ease-in-out,
      right var(--carina-transition-duration-300) ease-in-out,
      width var(--carina-transition-duration-100) ease-in-out 300ms,
      visibility 0ms ease-in-out 300ms;
        }
        [dir='rtl'] .carina-shell-next__aside--start {
            right: calc(var(--carina-shell-aside-start-width) * -1);
        }
    }
    @media (min-width: 1024px) {
        .carina-shell-next__aside--start {
            min-width: 15rem;
        }
    }
    .carina-shell-next[data-shell-enabled*='aside-end'] .carina-shell-next__aside--end:is(.carina-shell-next__aside.carina-shell-next__aside--end) {
        visibility: inherit;
        transition: max-height 300ms ease-in-out;
    }
    .carina-shell-next__aside--end {
        grid-area: aside-end;
        width: var(--carina-shell-aside-end-current-width);
        transition: width 0ms ease-in-out 300ms,
        visibility 0ms ease-in-out 300ms;
    }
    .carina-shell-next__aside {
        position: sticky;
        top: calc(
    var(--carina-shell-banner-current-height) +
      var(--carina-shell-title-current-height)
  );
        z-index: var(--carina-shell-aside-z-index);
        max-height: calc(
    100vh - var(--carina-shell-banner-offset) - var(--carina-shell-title-offset)
  );
        overflow-x: hidden;
        overflow-y: auto;
        color: var(--carina-text-color-body, var(--carina-text-color-base));
        visibility: hidden;
    }
    .carina-shell-next__stacked-aside {
        display: contents;
    }
    .carina-shell-next__page {
        grid-template-areas: 'dock-start title title title title'
      'dock-start aside-start header aside-end dock-end'
      'dock-start aside-start page-actions aside-end dock-end'
      'dock-start aside-start main aside-end dock-end';
        grid-template-rows: auto auto auto 1fr;
        grid-template-columns: var(--carina-shell-dock-start-current-width) var(
        --carina-shell-aside-start-current-width
      )
      1fr var(--carina-shell-aside-end-current-width)
      var(--carina-shell-dock-end-current-width);
        min-height: calc(100vh - var(--carina-shell-banner-current-height));
    }
    .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start {
        visibility: inherit;
    }
    @media (min-width: 1024px) {
        .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start {
            translate: 0;
            transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      translate 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start {
            translate: 0;
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start {
            right: unset;
            left: var(--carina-shell-dock-start-width);
            width: var(--carina-shell-aside-start-width);
            transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      left 300ms ease-in-out, right 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__aside--start {
            right: var(--carina-shell-dock-start-width);
            left: unset;
        }
    }
    @media (min-width: 1024px) {
        .carina-shell__aside--start {
            translate: calc(var(--carina-shell-aside-start-width) * -1);
            grid-area: aside-start;
            width: var(--carina-shell-aside-start-width);
            transition: visibility 0ms ease-in-out 300ms, translate 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell__aside--start {
            translate: var(--carina-shell-aside-start-width);
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell__aside--start {
            --carina-shell-aside-start-width: 80px;
            position: absolute;
            right: unset;
            left: calc(var(--carina-shell-aside-start-width) * -1);
            z-index: 80;
            width: 0;
            box-shadow: var(--carina-box-shadow-2xl);
            transition: left 300ms ease-in-out, right 300ms ease-in-out,
      width 0ms ease-in-out 300ms, visibility 0ms ease-in-out 300ms;
        }
        [dir='rtl'] .carina-shell__aside--start {
            right: calc(var(--carina-shell-aside-start-width) * -1);
            left: unset;
        }
    }
    .carina-shell[data-shell-enabled*='aside-end'] .carina-shell__aside--end:is(.carina-shell__aside.carina-shell__aside--end) {
        visibility: inherit;
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
    }
    .carina-shell__aside--end {
        grid-area: aside-end;
        width: var(--carina-shell-aside-end-current-width);
        transition: width 0ms ease-in-out 300ms, visibility 0ms ease-in-out 300ms;
    }
    .carina-shell__aside {
        position: sticky;
        top: calc(
    var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
      var(--carina-shell-title-offset) + var(--carina-shell-breadcrumbs-offset)
  );
        z-index: 30;
        max-height: calc(
    100vh - var(--carina-shell-banner-offset) -
      var(--carina-shell-header-offset) - var(--carina-shell-title-offset) -
      var(--carina-shell-breadcrumbs-offset)
  );
        overflow-x: hidden;
        overflow-y: auto;
        color: var(--carina-text-color-body, var(--carina-text-color-base));
        background-color: var(--carina-background-color-surface);
        visibility: hidden;
    }
    .carina-shell__stacked-aside {
        display: contents;
    }
}
@media not (prefers-reduced-motion) {
    .carina-transition--scale-in {
        --carina-transition-scale: 1;
    }
    .carina-transition--scale-out {
        --carina-transition-scale: 0;
    }
    .carina-transition--slide-up-in,
  .carina-transition--slide-left-in,
  .carina-transition--slide-right-in,
  .carina-transition--slide-down-in {
        --carina-transition-translate-x: 0;
        --carina-transition-translate-y: 0;
    }
    .carina-transition--slide-up-out {
        --carina-transition-translate-y: 100%;
    }
    .carina-transition--slide-right-out {
        --carina-transition-translate-x: -100%;
    }
    .carina-transition--slide-down-out {
        --carina-transition-translate-y: -100%;
    }
    .carina-transition--slide-left-out {
        --carina-transition-translate-x: 100%;
    }
    .carina-collapse.carina-transition--enter-active:not(.carina-collapse--disabled),
    .carina-collapse.carina-transition--appear-active:not(.carina-collapse--disabled),
    .carina-collapse.carina-transition--exit-active:not(.carina-collapse--disabled),
    .carina-collapse.carina-transition--exit-done:not(.carina-collapse--disabled) {
        overflow: hidden;
    }
    .carina-collapse.carina-transition--enter-done:not(.carina-collapse--disabled),
    .carina-collapse.carina-transition--appear-done:not(.carina-collapse--disabled) {
        overflow: visible;
    }
    .carina-collapse--horizontal.carina-transition--enter-active:not(.carina-collapse--disabled),
    .carina-collapse--horizontal.carina-transition--appear-active:not(.carina-collapse--disabled),
    .carina-collapse--horizontal.carina-transition--exit-start:not(.carina-collapse--disabled) {
        width: var(--carina-collapse-size, var(--carina-collapse-element-size));
    }
    .carina-collapse--horizontal.carina-transition--out:not(.carina-collapse--disabled) {
        width: var(--carina-collapse-min-size, 0px);
    }
    .carina-collapse--horizontal.carina-transition--enter-done:not(.carina-collapse--disabled) {
        width: var(--carina-collapse-size, auto);
    }
    .carina-collapse--vertical.carina-transition--enter-active:not(.carina-collapse--disabled),
    .carina-collapse--vertical.carina-transition--appear-active:not(.carina-collapse--disabled),
    .carina-collapse--vertical.carina-transition--exit-start:not(.carina-collapse--disabled) {
        height: var(--carina-collapse-size, var(--carina-collapse-element-size));
    }
    .carina-collapse--vertical.carina-transition--out:not(.carina-collapse--disabled) {
        height: var(--carina-collapse-min-size, 0px);
    }
    .carina-collapse--vertical.carina-transition--enter-done:not(.carina-collapse--disabled) {
        height: var(--carina-collapse-size, auto);
    }
    .carina-alerts__collapse.carina-transition--appear-start {
        --carina-transition-translate-y: -100%;
    }
    .carina-alerts__collapse.carina-transition--exit-done {
        position: absolute;
    }
    .carina-bounce {
        --carina-bounce-distance: -33%;
        animation-name: carina-bounce;
    }
    .carina-popper__transition--slide-top.carina-transition--out,
  .carina-popper__transition--slide-top.carina-popper__transition--disabled {
        --carina-transition-translate-y: var(--carina-spacing-1);
    }
    .carina-popper__transition--slide-bottom.carina-transition--out,
  .carina-popper__transition--slide-bottom.carina-popper__transition--disabled {
        --carina-transition-translate-y: calc(-1 * var(--carina-spacing-1));
    }
    .carina-popper__transition--slide-left.carina-transition--out,
  .carina-popper__transition--slide-left.carina-popper__transition--disabled {
        --carina-transition-translate-x: var(--carina-spacing-1);
    }
    .carina-popper__transition--slide-right.carina-transition--out,
  .carina-popper__transition--slide-right.carina-popper__transition--disabled {
        --carina-transition-translate-x: calc(-1 * var(--carina-spacing-1));
    }
    [dir='rtl'] .carina-popper__transition--slide-left.carina-transition--out,
  [dir='rtl'] .carina-popper__transition--slide-left.carina-popper__transition--disabled {
        --carina-transition-translate-x: var(--carina-spacing-1);
    }
    [dir='rtl'] .carina-popper__transition--slide-right.carina-transition--out,
  [dir='rtl'] .carina-popper__transition--slide-right.carina-popper__transition--disabled {
        --carina-transition-translate-x: calc(-1 * var(--carina-spacing-1));
    }
    [dir='rtl'] .carina-modal__dialog--start.carina-transition--out,
  .carina-modal__dialog--end.carina-transition--out {
        --carina-transition-translate-x: 100%;
    }
    [dir='rtl'] .carina-modal__dialog--end.carina-transition--out,
  .carina-modal__dialog--start.carina-transition--out {
        --carina-transition-translate-x: -100%;
    }
    .carina-modal__dialog--bottom.carina-transition--out {
        --carina-transition-translate-y: 100%;
    }
    .carina-modal__dialog--center.carina-transition--out,
  .carina-modal__dialog--fullscreen.carina-transition--out {
        --carina-transition-scale-x: 0.5;
        --carina-transition-scale-y: 0.5;
    }
    .carina-modal__dialog--center.carina-transition--exit-active,
  .carina-modal__dialog--fullscreen.carina-transition--exit-active {
        --carina-transition-scale-x: 1;
        --carina-transition-scale-y: 1;
    }
    .carina-transition--out .carina-panel__outer-container {
        --carina-transition-translate-x: 100%;
        box-shadow: none;
    }
    [dir='rtl'] .carina-transition--out .carina-panel__outer-container,
  .carina-panel--start.carina-transition--out .carina-panel__outer-container {
        --carina-transition-translate-x: -100%;
    }
    [dir='rtl'] .carina-panel--start.carina-transition--out .carina-panel__outer-container {
        --carina-transition-translate-x: 100%;
    }
    .carina-navigation-next__app-switcher-button {
        transition: height var(--carina-transition-duration-100)
        var(--carina-transition-timing-function-productive-ease-out),
      margin var(--carina-transition-duration-100)
        var(--carina-transition-timing-function-productive-ease-out);
    }
    .carina-navigation-next__solution-sidebar-collapse {
        width: 100%;
    }
    .carina-shake {
        --carina-shake-distance: 33%;
        animation-name: carina-shake;
    }
    .carina-skeleton--shimmer::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(
      83deg,
      var(--carina-background-color-surface-alt) 0%,
      var(--carina-background-color-neutral-inactive) 40%,
      var(--carina-background-color-neutral-inactive) 60%,
      var(--carina-background-color-surface-alt) 100%
    );
        transform: translateX(-100%) skewX(173deg);
        animation-name: carina-skeleton--shimmer;
        animation-duration: 2000ms;
        animation-timing-function: var(
      --carina-transition-timing-function-expressive-ease-in-out
    );
        animation-delay: var(--carina-transition-delay-100);
        animation-iteration-count: infinite;
        content: '';
    }
    [dir='rtl'] .carina-skeleton--shimmer::after {
        animation-direction: 'reverse';
    }
    .carina-skeleton--carina-skeleton--shimmer.carina-skeleton--filled::after {
        background: linear-gradient(
      83deg,
      var(--carina-background-color-neutral-inactive) 0%,
      var(--carina-background-color-surface-alt) 40%,
      var(--carina-background-color-surface-alt) 60%,
      var(--carina-background-color-neutral-inactive) 100%
    );
    }
}
@media (prefers-reduced-motion) {
    .carina-transition {
        transition-timing-function: var(--carina-transition-timing-function-linear);
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-alerts--page .carina-alerts__collapse,
  .carina-alerts--user .carina-alerts__collapse {
        transition-timing-function: var(--carina-transition-timing-function-linear);
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-carousel__dot {
        transition-property: none;
    }
    .carina-carousel__slider {
        transition-duration: calc(0 * var(--carina-transition-duration-50));
    }
    .carina-modal__content--productive {
        transition-delay: 0ms;
    }
    .carina-modal__content--expressive {
        transition-delay: 0ms;
    }
    .carina-panel .carina-panel__scrim,
  .carina-panel .carina-panel__content-container,
  .carina-panel .carina-panel__outer-container {
        transition-timing-function: var(--carina-transition-timing-function-linear);
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-panel__outer-container {
        opacity: var(--carina-transition-opacity);
    }
    .carina-panel.carina-panel--expressive.carina-panel--scrim .carina-panel__content-container,
  .carina-panel.carina-panel--productive.carina-panel--scrim .carina-panel__content-container,
  .carina-panel.carina-panel--expressive .carina-panel__content-container,
  .carina-panel.carina-panel--productive .carina-panel__content-container {
        transition-delay: 0ms;
    }
    .carina-navigation-next__app-switcher-button {
        transition: all var(--carina-transition-timing-function-linear)
      var(--carina-transition-duration-reduced-motion);
    }
    .carina-navigation-next__mobile-navigation-container .carina-transition {
        transition-timing-function: inherit;
        transition-duration: inherit;
    }
    .carina-navigation-next__mobile-navigation-container .carina-transition--slide-left-in,
    .carina-navigation-next__mobile-navigation-container .carina-transition--slide-right-in {
        --carina-transition-translate-x: 0;
        --carina-transition-translate-y: 0;
    }
    .carina-navigation-next__mobile-navigation-container .carina-transition--slide-right-out {
        --carina-transition-translate-x: -100%;
    }
    .carina-navigation-next__mobile-navigation-container .carina-transition--slide-left-out {
        --carina-transition-translate-x: 100%;
    }
    .carina-navigation-next__solution-navigation-logo__svg-animation-group {
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-navigation-next__solution-navigation-logo__svg-compact,
  .carina-navigation-next__solution-navigation-logo__svg-full {
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-navigation-next__solution-navigation-logo__compact {
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-navigation-next__solution-navigation-logo__full {
        transition-duration: var(--carina-transition-duration-reduced-motion);
    }
    .carina-navigation__side-navigation--animate {
        animation: carina-navigation__side-navigation--outer-container-in-fade
      var(--carina-transition-duration-reduced-motion)
      var(--carina-transition-timing-function-linear);
    }
    .carina-navigation__side-navigation--animate:not(.carina-navigation__side-navigation--open) {
        animation: carina-navigation__side-navigation--outer-container-out-fade
      var(--carina-transition-duration-reduced-motion)
      var(--carina-transition-timing-function-linear);
    }
    .carina-shell-next__dock--end {
        transition: visibility 0ms ease-in-out
        var(--carina-transition-delay-reduced-motion);
    }
}
@container (min-width: 640px) {
    .carina-bulk-action-bar__actions {
        display: flex;
        justify-content: flex-start;
    }
    .carina-bulk-action-bar__actions--small {
        display: none;
    }
    .\\@carina-container--fixed {
        max-width: var(--carina-breakpoint-sm);
    }
    .carina-filter-control-bar__filters-wrapper {
        flex-wrap: nowrap;
    }
}
@media (hover) {
    .carina-carousel__control {}
    div:hover > .carina-carousel__control,
    .carina-carousel__control:focus {
        opacity: var(--carina-opacity-100);
    }
}
@media (max-width: 560px) {
    .carina-modal__dialog--md {
        height: 100%;
        border-radius: 0;
    }
}
@media (max-width: 800px) {
    .carina-modal__dialog--lg {
        height: 100%;
        border-radius: 0;
    }
}
@media (max-width: 1240px) {
    .carina-modal__dialog--xl {
        height: 100%;
        border-radius: 0;
    }
}
@media (max-width: 639.98px) {
    .carina-day-picker__months {
        flex-direction: column;
    }
    .carina-formsection__content--stack-breakpoint-sm {
        flex: 1 0 auto;
    }
    .carina-stepper__step__icon--error svg {
        margin-top: unset;
        margin-bottom: 2px;
    }
    .carina-template-illustration__header-wrapper {
        font-size: var(--carina-font-size-xl);
    }
    .carina-template-illustration__body-wrapper {
        max-width: 100%;
        font-size: var(--carina-font-size-sm);
    }
}
@container (min-width: 768px) {
    .\\@carina-container--fixed {
        max-width: var(--carina-breakpoint-md);
    }
}
@container (min-width: 1024px) {
    .\\@carina-container--fixed {
        max-width: var(--carina-breakpoint-lg);
    }
}
@container (min-width: 1280px) {
    .\\@carina-container--fixed {
        max-width: var(--carina-breakpoint-xl);
    }
}
@container (min-width: 1536px) {
    .\\@carina-container--fixed {
        max-width: var(--carina-breakpoint-2xl);
    }
}
@media (max-width: 767.98px) {
    .carina-formsection__content--stack-breakpoint-md {
        flex: 1 0 auto;
    }
    .carina-navigation-next__solution-sidebar-container-scroll {
        height: calc(100% - var(--carina-navigation-mobile-header-height));
    }
    .carina-navigation-next__solution-sidebar-dropdown__chevron {
        display: block;
    }
    .carina-navigation__app-switcher-menu {
        width: calc(100vw - var(--carina-spacing-8));
    }
    .carina-navigation__search-sub-container {
        width: calc(100vw - 32px);
    }
    .carina-navigation__side-navigation--open {
        width: 100vw;
    }
    .carina-navigation__side-navigation--animate {
        animation: carina-navigation__side-navigation--outer-container-in-small
      var(--carina-transition-duration-400)
      var(--carina-transition-timing-function-expressive-ease-out);
    }
    .carina-navigation__side-navigation--animate:not(.carina-navigation__side-navigation--open) {
        animation: carina-navigation__side-navigation--outer-container-out-small
      var(--carina-transition-duration-200)
      var(--carina-transition-timing-function-expressive-ease-out);
    }
    .carina-shell-next[data-shell-enabled*='dock-start'] .carina-shell-next__dock--start {
        max-width: 100%;
        max-height: var(--carina-shell-dock-start-max-height);
    }
    .carina-shell-next__dock--start {
        width: 100%;
    }
    .carina-shell-next[data-shell-enabled*='dock-end'] .carina-shell-next__dock--end {
        max-width: 100%;
        height: 100%;
        max-height: var(--carina-shell-dock-end-max-height);
    }
    .carina-shell-next__dock--end {
        bottom: 0;
        position: fixed;
        width: 100%;
        transition: visibility 0ms ease-in-out var(--carina-transition-delay-300);
    }
    .carina-shell-next__dock-items {
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .carina-shell-next__dock-items::before,
      .carina-shell-next__dock-items::after {
        content: '';
    }
    .carina-shell-next__dock {
        height: 0;
        max-height: 0;
        overflow: hidden;
    }
    .carina-shell-next__dock-item {
        min-width: 5.5rem;
        max-width: 6rem;
    }
    .carina-shell[data-shell-enabled*='dock-start'] .carina-shell__dock--start {
        max-width: 100%;
        height: 100%;
        max-height: var(--carina-shell-dock-start-max-height);
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
    }
    .carina-shell__dock--start {
        width: 100%;
        transition: max-height 300ms ease-in-out, height 0ms ease-in-out 300ms,
        visibility 0ms ease-in-out 300ms;
    }
    .carina-shell[data-shell-enabled*='dock-end'] .carina-shell__dock--end {
        max-width: 100%;
        height: 100%;
        max-height: var(--carina-shell-dock-end-max-height);
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out;
    }
    .carina-shell__dock--end {
        bottom: 0;
        width: 100%;
        transition: max-height 300ms ease-in-out, height 0ms ease-in-out 300ms,
        visibility 0ms ease-in-out 300ms;
    }
    .carina-shell__dock-items {
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .carina-shell__dock-items::before,
      .carina-shell__dock-items::after {
        content: '';
    }
    .carina-shell__dock {
        height: 0;
        max-height: 0;
        overflow: hidden;
    }
    .carina-shell__dock-item {
        width: var(--carina-shell-dock-start-width);
    }
    .carina-shell__page {
        grid-template-areas: 'dock-start' 'breadcrumbs' 'page-title' 'page-actions' 'main' 'dock-end';
        grid-template-rows: auto auto auto auto 1fr auto;
        grid-template-columns: 1fr;
    }
    .carina-tan-table-pagination__page-container {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .carina-tan-table-pagination {
        flex-direction: column;
        align-items: center;
        padding-top: var(--carina-spacing-4);
        gap: var(--carina-spacing-2);
    }
    .carina-template-hero-header header {
        margin: var(--carina-spacing-4) var(--carina-spacing-0)
        var(--carina-spacing-0) var(--carina-spacing-0);
    }
    .carina-template-hero-header__logo {
        align-self: center;
        margin-inline-end: var(--carina-spacing-0);
    }
    .carina-template-hero-header__content-block {
        margin: var(--carina-spacing-4) var(--carina-spacing-0)
      var(--carina-spacing-8) var(--carina-spacing-0);
    }
    .carina-template-hero-header__content-wrapper {
        flex-direction: column;
        align-items: flex-start;
    }
}
@media (max-width: 1023.98px) {
    .carina-formsection__content--stack-breakpoint-lg {
        flex: 1 0 auto;
    }
    .carina-shell__page {
        grid-template-areas: 'dock-start breadcrumbs dock-end' 'dock-start page-title dock-end' 'dock-start page-actions dock-end' 'dock-start main dock-end';
        grid-template-rows: auto auto auto 1fr;
        grid-template-columns: var(--carina-shell-dock-start-current-width) 1fr var(
        --carina-shell-dock-end-current-width
      );
    }
    .carina-tan-table-pagination__page-container {
        padding-inline-start: var(--carina-spacing-0);
    }
    .carina-tan-table-pagination {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .carina-template-hero-header__action-wrapper {
        position: absolute;
        top: -33px;
        right: 0;
    }
    [dir='rtl'] .carina-template-hero-header__action-wrapper {
        right: unset;
        left: 0;
    }
}
@media (max-width: 1279.98px) {
    .carina-formsection__content--stack-breakpoint-xl {
        flex: 1 0 auto;
    }
}
@media (max-width: 1535.98px) {
    .carina-formsection__content--stack-breakpoint-2xl {
        flex: 1 0 auto;
    }
    .carina-shell-next__aside.carina-shell-next__aside--end:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--end) {
        position: fixed;
        right: calc(var(--carina-shell-aside-end-width) * -1);
        left: unset;
        z-index: var(--carina-shell-aside-lgmax-z-index);
        width: var(--carina-shell-aside-end-current-width);
        height: 100%;
        box-shadow: var(--carina-box-shadow-2xl);
        transition: left 300ms ease-in-out, right 300ms ease-in-out, width 0ms ease-in-out 300ms,
          visibility 0ms ease-in-out 300ms;
    }
    [dir='rtl'] .carina-shell-next__aside.carina-shell-next__aside--end:not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside--end) {
        right: unset;
        left: calc(var(--carina-shell-aside-end-width) * -1);
    }
    .carina-shell-next[data-shell-enabled*='aside-end'] .carina-shell-next__aside--end:is(.carina-shell-next__aside.carina-shell-next__aside--end):not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--end) {
        max-height: 100vh;
        top: 0;
        right: 0;
        left: unset;
        z-index: var(--carina-shell-aside-end-lgmax-z-index);
        visibility: inherit;
        transition: left 300ms ease-in-out, right 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell-next[data-shell-enabled*='aside-end'] .carina-shell-next__aside--end:is(.carina-shell-next__aside.carina-shell-next__aside--end):not(.carina-shell-next__stacked-aside[data-stack-asides='true'] .carina-shell-next__aside.carina-shell-next__aside--end) {
        right: unset;
        left: 0;
    }
    .carina-shell-next__stacked-aside[data-stack-asides='true'] {
        position: sticky;
        top: calc(
    var(--carina-shell-banner-current-height) +
      var(--carina-shell-title-current-height)
  );
        z-index: var(--carina-shell-aside-z-index);
        max-height: calc(
    100vh - var(--carina-shell-banner-offset) - var(--carina-shell-title-offset)
  );
        overflow-x: hidden;
        overflow-y: auto;
        color: var(--carina-text-color-body, var(--carina-text-color-base));
        visibility: hidden;
        translate: 0;
        height: 0;
        left: calc(var(--carina-shell-aside-start-width) * -1);
        grid-area: aside-start;
        width: var(--carina-shell-aside-start-width);
        transition: visibility 0ms ease-in-out 300ms,
    translate 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell-next__stacked-aside[data-stack-asides='true'] {
        translate: var(--carina-shell-aside-start-width);
    }
    @media (min-width: 768px) {
        .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            translate: calc(var(--carina-shell-aside-start-width) * -1);
            height: calc(
      100vh - var(--carina-shell-banner-current-height) -
        var(--carina-shell-title-current-height)
    );
            min-width: 0rem;
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            z-index: var(--carina-shell-aside-lgmax-z-index);
            transition: left var(--carina-transition-duration-300) ease-in-out,
      right var(--carina-transition-duration-300) ease-in-out,
      width var(--carina-transition-duration-100) ease-in-out 300ms,
      visibility 0ms ease-in-out 300ms;
        }
        [dir='rtl'] .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            right: calc(var(--carina-shell-aside-start-width) * -1);
        }
    }
    @media (min-width: 1024px) {
        .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            min-width: 15rem;
        }
    }
    .carina-shell-next__stacked-aside[data-stack-asides='true'] {
        display: flex;
        flex-direction: column;
    }
    .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__stacked-aside[data-stack-asides='true'] {
        visibility: inherit;
    }
    @media (min-width: 768px) {
        .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            translate: 0;
            transition: min-width var(--carina-transition-duration-300) ease-in-out,
      translate var(--carina-transition-duration-300) ease-in-out;
        }
        [dir='rtl'] .carina-shell-next[data-shell-enabled*='aside-start'] .carina-shell-next__stacked-aside[data-stack-asides='true'] {
            translate: 0;
        }
    }
    .carina-shell__aside.carina-shell__aside--end:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--end) {
        position: fixed;
        right: calc(var(--carina-shell-aside-end-width) * -1);
        left: unset;
        z-index: 80;
        width: var(--carina-shell-aside-end-current-width);
        height: 100%;
        box-shadow: var(--carina-box-shadow-2xl);
        transition: left 300ms ease-in-out, right 300ms ease-in-out, width 0ms ease-in-out 300ms,
          visibility 0ms ease-in-out 300ms;
    }
    [dir='rtl'] .carina-shell__aside.carina-shell__aside--end:not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside--end) {
        right: unset;
        left: calc(var(--carina-shell-aside-end-width) * -1);
    }
    .carina-shell[data-shell-enabled*='aside-end'] .carina-shell__aside--end:is(.carina-shell__aside.carina-shell__aside--end):not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--end) {
        right: 0;
        left: unset;
        visibility: inherit;
        transition: max-height 300ms ease-in-out, top 300ms ease-in-out, left 300ms ease-in-out,
            right 300ms ease-in-out;
    }
    [dir='rtl'] .carina-shell[data-shell-enabled*='aside-end'] .carina-shell__aside--end:is(.carina-shell__aside.carina-shell__aside--end):not(.carina-shell__stacked-aside[data-stack-asides='true'] .carina-shell__aside.carina-shell__aside--end) {
        right: unset;
        left: 0;
    }
    .carina-shell__stacked-aside[data-stack-asides='true'] {
        position: sticky;
        top: calc(
    var(--carina-shell-banner-offset) + var(--carina-shell-header-offset) +
      var(--carina-shell-title-offset) + var(--carina-shell-breadcrumbs-offset)
  );
        z-index: 30;
        max-height: calc(
    100vh - var(--carina-shell-banner-offset) -
      var(--carina-shell-header-offset) - var(--carina-shell-title-offset) -
      var(--carina-shell-breadcrumbs-offset)
  );
        overflow-x: hidden;
        overflow-y: auto;
        color: var(--carina-text-color-body, var(--carina-text-color-base));
        background-color: var(--carina-background-color-surface);
        visibility: hidden;
    }
    @media (min-width: 1024px) {
        .carina-shell__stacked-aside[data-stack-asides='true'] {
            translate: calc(var(--carina-shell-aside-start-width) * -1);
            grid-area: aside-start;
            width: var(--carina-shell-aside-start-width);
            transition: visibility 0ms ease-in-out 300ms, translate 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            translate: var(--carina-shell-aside-start-width);
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell__stacked-aside[data-stack-asides='true'] {
            --carina-shell-aside-start-width: 80px;
            position: absolute;
            right: unset;
            left: calc(var(--carina-shell-aside-start-width) * -1);
            z-index: 80;
            width: 0;
            box-shadow: var(--carina-box-shadow-2xl);
            transition: left 300ms ease-in-out, right 300ms ease-in-out,
      width 0ms ease-in-out 300ms, visibility 0ms ease-in-out 300ms;
        }
        [dir='rtl'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            right: calc(var(--carina-shell-aside-start-width) * -1);
            left: unset;
        }
    }
    .carina-shell__stacked-aside[data-stack-asides='true'] {
        display: flex;
        flex-direction: column;
    }
    .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__stacked-aside[data-stack-asides='true'] {
        visibility: inherit;
    }
    @media (min-width: 1024px) {
        .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            translate: 0;
            transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      translate 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            translate: 0;
        }
    }
    @media (max-width: 1023.98px) {
        .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            right: unset;
            left: var(--carina-shell-dock-start-width);
            width: var(--carina-shell-aside-start-width);
            transition: max-height 300ms ease-in-out, top 300ms ease-in-out,
      left 300ms ease-in-out, right 300ms ease-in-out;
        }
        [dir='rtl'] .carina-shell[data-shell-enabled*='aside-start'] .carina-shell__stacked-aside[data-stack-asides='true'] {
            right: var(--carina-shell-dock-start-width);
            left: unset;
        }
    }
    .carina-shell__page {
        grid-template-areas: 'dock-start breadcrumbs breadcrumbs dock-end' 'dock-start aside-start page-title dock-end' 'dock-start aside-start page-actions dock-end' 'dock-start aside-start main dock-end';
        grid-template-rows: auto auto auto 1fr;
        grid-template-columns: var(--carina-shell-dock-start-current-width) var(--carina-shell-aside-start-current-width) 1fr var(
        --carina-shell-dock-end-current-width
      );
    }
}
@container (min-width: 5.01rem) {
    .carina-navigation-next__app-switcher-button {
        height: 48px;
        width: calc(100% - 2 * var(--carina-spacing-4));
        margin-inline-start: var(--carina-spacing-4);
        margin-inline-end: var(--carina-spacing-4);
    }
    .carina-navigation-next__app-switcher-button .carina-navigation-next__app-switcher-button-icon-container {
        padding: var(--carina-spacing-0);
        padding-inline-start: var(--carina-spacing-2);
    }
    .carina-navigation-next__app-switcher-button::before {
        width: calc(100% - 2 * var(--carina-spacing-3));
        height: 48px;
    }
    .carina-navigation-next__solution-sidebar-dropdown__indicator--current-child {
        visibility: hidden;
    }
}
@container (width: 16.5rem) {
    .carina-navigation-next__app-switcher-button-icon {
        justify-content: center;
    }
}
@container (min-width: 16.5rem) {
    .carina-navigation-next__app-switcher-button-text-container {
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-inline-start: var(--carina-spacing-2);
        color: var(--carina-text-color-base-inverse);
        line-height: normal;
    }
}
@container object (max-width: 4.25rem) {
    .carina-navigation-next__object-sidebar-container-container {
        align-items: flex-start;
    }
    .carina-navigation-next__object-sidebar-header {
        display: none;
    }
}
@container object (min-width: 4.25rem) {
    .carina-navigation-next__object-sidebar-dropdown--force-expanded .carina-navigation-next__object-sidebar-dropdown__row {
        padding-top: var(--carina-spacing-1-5);
        padding-bottom: var(--carina-spacing-1-5);
    }
}
@container (max-width: 4.25rem) {
    .carina-navigation-next__object-sidebar-header__title {
        display: none;
    }
}
@container object (min-width: 15rem) {
    .carina-navigation-next__object-sidebar-link {
        width: 100%;
    }
    .carina-navigation-next__object-sidebar-link__children-wrapper {
        height: unset;
        width: -moz-min-content;
        width: min-content;
        clip: unset;
        opacity: 1;
        position: static;
    }
    .carina-navigation-next__object-sidebar-segment__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .carina-navigation-next__object-sidebar-segment::before {
        max-width: 100%;
        border-top: none;
        margin: 0;
        height: 0;
    }
}
@container (min-width: 15rem) {
    .carina-navigation-next__object-sidebar-link__content {
        display: flex;
        width: 100%;
    }
    .carina-navigation-next__object-sidebar-link__content:focus-within {
        outline: 0;
    }
    .carina-navigation-next__object-sidebar-link__chevron--open {
        opacity: var(--carina-opacity-100);
    }
    .carina-navigation-next__solution-sidebar-dropdown {
        padding: var(--carina-spacing-0) var(--carina-spacing-1)
      var(--carina-spacing-0) var(--carina-spacing-0);
        width: calc(100% - 2 * var(--carina-spacing-3));
    }
    .carina-navigation-next__solution-sidebar-dropdown .carina-collapse--vertical {
        --carina-collapse-size: auto;
        opacity: var(--carina-opacity-100);
        width: 100%;
    }
    .carina-navigation-next__solution-sidebar-dropdown__title {
        padding-inline-start: var(--carina-spacing-2);
        display: flex;
        width: calc(100% - (2 * var(--carina-spacing-8)));
    }
    .carina-navigation-next__solution-sidebar-dropdown__dropdown--expanded {
        opacity: var(--carina-opacity-100);
        transition: opacity var(--carina-transition-duration-300)
      var(--carina-transition-timing-function-expressive-ease-in-out)
      var(--carina-transition-delay-100);
    }
    .carina-navigation-next__solution-sidebar-link {
        padding: var(--carina-spacing-0);
        width: calc(100% - 2 * var(--carina-spacing-3) - 2px);
    }
    .carina-navigation-next__solution-sidebar-link__link-content {
        width: 100%;
        height: auto;
        opacity: var(--carina-opacity-100);
    }
}
@container (min-width: 264px) {
    .carina-navigation-next__solution-navigation-logo {
        width: 100%;
    }
    .carina-navigation-next__solution-navigation-logo .carina-navigation-next__solution-navigation-logo__svg-animation-group {
        transform: translate(
        var(--carina-navigation-logo-full-offset),
        var(--carina-navigation-logo-y-offset)
      );
        transition-duration: var(--carina-transition-duration-100);
    }
    .carina-navigation-next__solution-navigation-logo .carina-navigation-next__solution-navigation-logo__svg-full {
        opacity: 1;
    }
    .carina-navigation-next__solution-navigation-logo__full--compact {
        opacity: 100%;
    }
}
@container (max-width: 5.01rem) {
    .carina-navigation-next__solution-navigation-logo__compact {
        display: block;
        opacity: 100%;
    }
    .carina-navigation-next__solution-navigation-logo__full {
        display: none;
        opacity: 0%;
        transform: translateX(-50%);
    }
}
@container (min-width: 19rem) {
    .carina-navigation-next__solution-sidebar-dropdown__chevron {
        display: block;
    }
    .carina-navigation-next__solution-sidebar-link__chevron--open {
        display: block;
    }
}
@media screen (md) {
    .carina-shell-next__xl-panel {
        display: grid;
    }
}
@container carina-table-responsive (max-width: 639.98px) {
    .carina-tan-table {
        border-collapse: collapse;
    }
    .carina-tan-table--rounded .carina-tan-table-body .carina-tan-table-row:first-of-type .carina-tan-table-cell:first-of-type {
        border-radius: var(--carina-tan-table-border-radius)
          var(--carina-tan-table-border-radius) var(--carina-border-radius-none)
          var(--carina-border-radius-none);
    }
    .carina-tan-table--rounded .carina-tan-table-body .carina-tan-table-row:last-of-type .carina-tan-table-cell:last-of-type {
        border-radius: var(--carina-border-radius-none)
          var(--carina-border-radius-none) var(--carina-tan-table-border-radius)
          var(--carina-tan-table-border-radius);
    }
    .carina-tan-table:has(tfoot) .carina-tan-table-body > tr:last-of-type > :is(th, td) {
        border-bottom-width: var(--carina-tan-table-horizontal-border-width);
        border-bottom-style: solid;
        border-bottom-color: var(--carina-tan-table-border-color);
    }
    .carina-tan-table:has(tfoot) .carina-tan-table-body > tr:last-of-type > :is(th, td):last-child {
        border-bottom-width: var(--carina-tan-table-outside-border-width);
    }
    .carina-tan-table--no-dividers
    > :is(thead, tbody, tfoot)
    > .carina-tan-table-row
    > :is(.carina-tan-table-header, .carina-tan-table-cell):not(:last-child):not(.carina-tan-table--pinned-start) {
        border-inline-end-width: var(--carina-tan-table-outside-border-width);
        border-inline-end-style: solid;
        border-inline-end-color: var(--carina-tan-table-border-color);
    }
    .carina-tan-table-body {
        display: block;
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row .carina-tan-table-cell {
        border-radius: var(--carina-border-radius-none);
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row .carina-tan-table-cell:first-child {
        border-top-width: var(--carina-tan-table-outside-border-width);
        border-top-style: solid;
        border-top-color: var(--carina-tan-table-border-color);
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row:not([data-carina-tan-table-row-depth]) .carina-tan-table-cell:last-child {
        margin-bottom: var(--carina-spacing-4);
    }
    .carina-tan-table
      .carina-tan-table-body
      .carina-tan-table-row:has(+ [data-carina-tan-table-row-depth='0'])
      .carina-tan-table-cell:last-child {
        margin-bottom: var(--carina-spacing-4);
    }
    .carina-tan-table--rounded .carina-tan-table-body .carina-tan-table-row:not([data-carina-tan-table-row-depth]) .carina-tan-table-cell:first-child {
        border-radius: var(--carina-tan-table-border-radius)
          var(--carina-tan-table-border-radius) var(--carina-border-radius-none)
          var(--carina-border-radius-none);
    }
    .carina-tan-table--rounded .carina-tan-table-body .carina-tan-table-row:not([data-carina-tan-table-row-depth]) .carina-tan-table-cell:last-child {
        border-radius: var(--carina-border-radius-none)
          var(--carina-border-radius-none) var(--carina-tan-table-border-radius)
          var(--carina-tan-table-border-radius);
    }
    .carina-tan-table--rounded
      .carina-tan-table-body
      .carina-tan-table-row[data-carina-tan-table-row-depth='0']
      .carina-tan-table-cell:first-child {
        border-radius: var(--carina-tan-table-border-radius)
        var(--carina-tan-table-border-radius) var(--carina-border-radius-none)
        var(--carina-border-radius-none);
    }
    .carina-tan-table--rounded
      .carina-tan-table-body
      .carina-tan-table-row:has(+ [data-carina-tan-table-row-depth='0'])
      .carina-tan-table-cell:last-child {
        border-radius: var(--carina-border-radius-none)
        var(--carina-border-radius-none) var(--carina-tan-table-border-radius)
        var(--carina-tan-table-border-radius);
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector-tw__input--grid {
        padding-inline-start: calc(
          50% + 36px + var(--carina-tan-table-vertical-border-width)
        ) !important;
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox__input:not(.carina-tan-table-date-range-picker__textbox-wrapper--grid *) {
        padding-inline-start: calc(
            50% + var(--carina-tan-table-vertical-border-width)
          );
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textbox-icon--start {
        inset-inline-start: calc(
          50% - var(--carina-icon-xs) -
            var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-textarea__textarea--grid {
        padding-inline-start: calc(
          50% + var(--carina-tan-table-vertical-border-width)
        );
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-dropdown__button--grid {
        padding-inline-start: calc(
          50% + var(--carina-tan-table-vertical-border-width)
        );
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-numeric-selector__textbox--grid .carina-tan-table-textbox__input {
        padding-inline-start: calc(
              50% + var(--carina-tan-table-vertical-border-width)
            );
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker--grid {
        padding-inline-start: calc(
          50% - var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table-cell {
        display: block;
        border-width: var(--carina-tan-table-horizontal-border-width)
      var(--carina-tan-table-outside-border-width);
        border-style: solid;
        border-color: var(--carina-tan-table-border-color);
        position: relative;
        padding-inline-start: 50%;
        width: 100cqw;
        align-content: center;
        min-height: var(--carina-tan-table-row-height);
    }
    .carina-tan-table:not(:has(tfoot)) > tbody > tr:last-child .carina-tan-table-cell:not(:last-child) {
        border-bottom-width: var(--carina-tan-table-horizontal-border-width);
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row .carina-tan-table-cell:before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        inset-inline-start: 0;
        width: 45%;
        white-space: nowrap;
        content: attr(data-label);
        font-weight: var(--carina-font-weight-display);
        background: transparent;
        padding: var(--carina-tan-table-padding-vertical)
        var(--carina-tan-table-padding-horizontal);
        text-align: start;
    }
    .carina-tan-table-cell:has(.carina-tan-table-skeleton) {
        padding-inline-start: var(--carina-tan-table-padding-horizontal);
    }
    .carina-tan-table-cell:has(.carina-tan-table-expandable-container:empty) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='1'] .carina-tan-table-cell {
        padding-inline-start: calc(
        50% + var(--carina-tan-table-padding-horizontal)
      );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='1'] .carina-tan-table-cell:before {
        padding-inline-start: calc(
          2 * var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='2'] .carina-tan-table-cell {
        padding-inline-start: calc(
        50% + (2 * var(--carina-tan-table-padding-horizontal))
      );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='2'] .carina-tan-table-cell:before {
        padding-inline-start: calc(
          3 * var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='3'] .carina-tan-table-cell {
        padding-inline-start: calc(
        50% + (3 * var(--carina-tan-table-padding-horizontal))
      );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='3'] .carina-tan-table-cell:before {
        padding-inline-start: calc(
          4 * var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='4'] .carina-tan-table-cell {
        padding-inline-start: calc(
        50% + (4 * var(--carina-tan-table-padding-horizontal))
      );
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row[data-carina-tan-table-row-depth='4'] .carina-tan-table-cell:before {
        padding-inline-start: calc(
          5 * var(--carina-tan-table-padding-horizontal)
        );
    }
    .carina-tan-table .carina-tan-table-head .carina-tan-table-row .carina-tan-table-cell {
        width: 0;
        padding: var(--carina-spacing-0);
        margin: var(--carina-spacing-0);
        border-width: var(--carina-border-width-0);
    }
    .carina-tan-table-cell:has(> .carina-tan-table-reorder-handle) {
        display: flex;
        justify-content: end;
        align-items: center;
    }
    .carina-tan-table-checkbox__box {
        margin-inline-start: auto;
    }
    .carina-tan-table-container {
        overflow-x: hidden;
    }
    .carina-tan-table-empty .carina-tan-table-empty__cell,
      .carina-tan-table-no-results .carina-tan-table-empty__cell,
      .carina-tan-table-empty .carina-tan-table-no-results__cell,
      .carina-tan-table-no-results .carina-tan-table-no-results__cell {
        width: 100cqw;
        border-top-width: var(--carina-tan-table-horizontal-border-width);
        border-top-style: solid;
        border-top-color: var(--carina-tan-table-border-color);
        padding-inline-start: var(--carina-tan-table-padding-horizontal);
    }
    .carina-tan-table-empty__text, .carina-tan-table-no-results__text {
        max-width: calc(100cqw - var(--carina-spacing-8));
    }
    .carina-tan-table-expandable-container {
        justify-content: end;
    }
    .carina-tan-table-head {
        display: block;
        border-width: var(--carina-border-width-0);
    }
    .carina-tan-table-head .carina-tan-table-row {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
    .carina-tan-table-header {
        display: block;
    }
    .carina-tan-table .carina-tan-table-head .carina-tan-table-row .carina-tan-table-header {
        width: 0;
        padding: var(--carina-spacing-0);
        margin: var(--carina-spacing-0);
        border-width: var(--carina-border-width-0);
    }
    .carina-tan-table .carina-tan-table-body .carina-tan-table-row .carina-tan-table-header {
        border-top-width: var(--carina-tan-table-horizontal-border-width);
        border-top-style: solid;
        border-top-color: var(--carina-tan-table-border-color);
        padding: var(--carina-tan-table-padding-vertical)
        var(--carina-tan-table-padding-horizontal);
    }
    .carina-tan-table-radio-button {
        margin-inline-start: auto;
    }
    .carina-tan-table-container--horizontal-overflow
    .carina-tan-table-row
    .carina-tan-table-cell:not(.carina-tan-table--pinned):has(+ .carina-tan-table-cell.carina-tan-table--pinned) {
        border-inline-end-width: var(--carina-tan-table-vertical-border-width);
        border-inline-end-style: solid;
        border-inline-end-color: var(--carina-tan-table-border-color);
    }
    .carina-tan-table-row {
        height: unset;
        border-width: var(--carina-border-width-0);
    }
    .carina-tan-table-row-actions {
        justify-content: end;
    }
    .carina-tan-table-footer {
        display: block;
        border-width: var(--carina-border-width-0);
    }
    .carina-tan-table-footer .carina-tan-table-row {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
    }
    [dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start {
        box-shadow: none;
    }
    .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start {
        box-shadow: none;
    }
    [dir='rtl'] .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end {
        box-shadow: none;
    }
    .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end {
        box-shadow: none;
    }
}
@container carina-tan-table-date-range-picker-responsive (max-width: 299.9px) {
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__textbox-wrapper--grid {
        flex-direction: column;
        min-height: calc(2 * var(--carina-tan-table-row-height));
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__textbox-wrapper--grid .carina-tan-table-textbox__container {
        height: 50%;
    }
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__textbox-wrapper--grid .carina-tan-table-textbox__container:first-child::after {
        content: '';
        position: absolute;
        border-bottom-width: var(
                --carina-tan-table-horizontal-border-width
              );
        border-bottom-style: solid;
        border-bottom-color: var(--carina-tan-table-border-color);
        width: calc(
                100% - (2 * var(--carina-tan-table-padding-horizontal))
              );
        bottom: 0;
        margin: var(--carina-spacing-0)
                var(--carina-tan-table-padding-horizontal);
    }
}
@container carina-tan-table-date-range-picker-responsive (min-width: 300px) {
    .carina-tan-table-cell--editable:has([data-carina-tan-table-editable-input]) .carina-tan-table-date-range-picker__textbox-wrapper--grid .carina-tan-table-textbox__container:first-child::after {
        content: '';
        position: absolute;
        border-left-width: var(--carina-tan-table-vertical-border-width);
        border-left-style: solid;
        border-left-color: var(--carina-tan-table-border-color);
        height: calc(100% - (2 * var(--carina-tan-table-padding-horizontal)));
        right: 0;
        margin: var(--carina-tan-table-padding-horizontal) 0;
    }
}
@container carina-table-responsive (min-width: 640px) {
    .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-start {
        inset-inline-start: var(--carina-tan-table-pinned-start-offset, 0px);
    }
    .carina-tan-table-container--horizontal-overflow .carina-tan-table--pinned-end {
        inset-inline-end: var(--carina-tan-table-pinned-end-offset, 0px);
    }
}
@media (hover: hover) and (pointer: fine) {
    .carina-table-row--striped:nth-of-type(odd) > div:hover {
        background-color: var(--carina-background-color-surface-hover);
    }
    .carina-table-row__actions-start-container--x-ray,
.carina-table-row__actions-end-container--x-ray {
        opacity: var(--carina-opacity-100);
    }
    .carina-table-row__sliding:hover {
        background-color: var(--carina-background-color-surface-hover);
    }
    .carina-table-row__sliding--disabled:hover {
        background-color: var(--carina-background-color-surface);
    }
    .carina-action-button:hover {
        background-color: var(--carina-text-color-base);
    }
    .carina-action-button--disabled:hover {
        background-color: transparent;
    }
    .carina-action-button--static-select-indicator:not(.carina-action-button--disabled):hover {
        background-color: var(--carina-background-color-surface-hover);
    }
    .carina-action-button--static-actions-menu:not(.carina-action-button--disabled):hover {
        background-color: var(--carina-background-color-surface-hover);
    }
}
.sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border-width: 0 !important;
}
.pointer-events-none {
    pointer-events: none !important;
}
.visible {
    visibility: visible !important;
}
.invisible {
    visibility: hidden !important;
}
.collapse {
    visibility: collapse !important;
}
.static {
    position: static !important;
}
.fixed {
    position: fixed !important;
}
.absolute {
    position: absolute !important;
}
.relative {
    position: relative !important;
}
.sticky {
    position: sticky !important;
}
.inset-0 {
    inset: var(--carina-spacing-0) !important;
}
.inset-y-0 {
    top: var(--carina-spacing-0) !important;
    bottom: var(--carina-spacing-0) !important;
}
.-left-2 {
    left: calc(var(--carina-spacing-2) * -1) !important;
}
.-left-5 {
    left: calc(var(--carina-spacing-5) * -1) !important;
}
.-left-px {
    left: calc(var(--carina-spacing-px) * -1) !important;
}
.-top-1\\.5 {
    top: calc(var(--carina-spacing-1-5) * -1) !important;
}
.-top-6 {
    top: calc(var(--carina-spacing-6) * -1) !important;
}
.-top-\\[31px\\] {
    top: -31px !important;
}
.bottom-0 {
    bottom: var(--carina-spacing-0) !important;
}
.end-0 {
    inset-inline-end: var(--carina-spacing-0) !important;
}
.left-0 {
    left: var(--carina-spacing-0) !important;
}
.start-0 {
    inset-inline-start: var(--carina-spacing-0) !important;
}
.top-0 {
    top: var(--carina-spacing-0) !important;
}
.top-1\\/2 {
    top: 50% !important;
}
.top-\\[-3px\\] {
    top: -3px !important;
}
.top-\\[3px\\] {
    top: 3px !important;
}
.top-\\[var\\(--carina-spacing-12\\)\\] {
    top: var(--carina-spacing-12) !important;
}
.z-10 {
    z-index: var(--carina-z-index-10) !important;
}
.z-\\[101\\] {
    z-index: 101 !important;
}
.z-\\[9999\\] {
    z-index: 9999 !important;
}
.z-\\[calc\\(var\\(--carina-z-index-current\\)\\+1\\)\\] {
    z-index: calc(var(--carina-z-index-current) + 1) !important;
}
.col-\\[1\\/-1\\] {
    grid-column: 1/-1 !important;
}
.row-start-2 {
    grid-row-start: 2 !important;
}
.m-0 {
    margin: var(--carina-spacing-0) !important;
}
.\\!-my-\\[var\\(--carina-spacing-2\\)\\] {
    margin-top: calc(var(--carina-spacing-2) * -1) !important;
    margin-bottom: calc(var(--carina-spacing-2) * -1) !important;
}
.\\!-my-\\[var\\(--carina-spacing-3\\)\\] {
    margin-top: calc(var(--carina-spacing-3) * -1) !important;
    margin-bottom: calc(var(--carina-spacing-3) * -1) !important;
}
.-mx-4 {
    margin-left: calc(var(--carina-spacing-4) * -1) !important;
    margin-right: calc(var(--carina-spacing-4) * -1) !important;
}
.-mx-px {
    margin-left: calc(var(--carina-spacing-px) * -1) !important;
    margin-right: calc(var(--carina-spacing-px) * -1) !important;
}
.-my-4 {
    margin-top: calc(var(--carina-spacing-4) * -1) !important;
    margin-bottom: calc(var(--carina-spacing-4) * -1) !important;
}
.mx-3 {
    margin-left: var(--carina-spacing-3) !important;
    margin-right: var(--carina-spacing-3) !important;
}
.mx-6 {
    margin-left: var(--carina-spacing-6) !important;
    margin-right: var(--carina-spacing-6) !important;
}
.mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}
.my-1 {
    margin-top: var(--carina-spacing-1) !important;
    margin-bottom: var(--carina-spacing-1) !important;
}
.my-1\\.5 {
    margin-top: var(--carina-spacing-1-5) !important;
    margin-bottom: var(--carina-spacing-1-5) !important;
}
.my-4 {
    margin-top: var(--carina-spacing-4) !important;
    margin-bottom: var(--carina-spacing-4) !important;
}
.my-6 {
    margin-top: var(--carina-spacing-6) !important;
    margin-bottom: var(--carina-spacing-6) !important;
}
.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
}
.\\!-mr-\\[var\\(--carina-spacing-2\\)\\] {
    margin-right: calc(var(--carina-spacing-2) * -1) !important;
}
.-me-px {
    margin-inline-end: calc(var(--carina-spacing-px) * -1) !important;
}
.-ml-6 {
    margin-left: calc(var(--carina-spacing-6) * -1) !important;
}
.-mt-4 {
    margin-top: calc(var(--carina-spacing-4) * -1) !important;
}
.-mt-\\[var\\(--carina-spacing-12\\)\\] {
    margin-top: calc(var(--carina-spacing-12) * -1) !important;
}
.mb-0 {
    margin-bottom: var(--carina-spacing-0) !important;
}
.mb-1 {
    margin-bottom: var(--carina-spacing-1) !important;
}
.mb-12 {
    margin-bottom: var(--carina-spacing-12) !important;
}
.mb-2 {
    margin-bottom: var(--carina-spacing-2) !important;
}
.mb-3 {
    margin-bottom: var(--carina-spacing-3) !important;
}
.mb-4 {
    margin-bottom: var(--carina-spacing-4) !important;
}
.mb-6 {
    margin-bottom: var(--carina-spacing-6) !important;
}
.mb-8 {
    margin-bottom: var(--carina-spacing-8) !important;
}
.mb-\\[32px\\] {
    margin-bottom: 32px !important;
}
.mb-\\[8px\\] {
    margin-bottom: 8px !important;
}
.ml-0 {
    margin-left: var(--carina-spacing-0) !important;
}
.ml-1 {
    margin-left: var(--carina-spacing-1) !important;
}
.ml-2 {
    margin-left: var(--carina-spacing-2) !important;
}
.ml-8 {
    margin-left: var(--carina-spacing-8) !important;
}
.mr-4 {
    margin-right: var(--carina-spacing-4) !important;
}
.mr-8 {
    margin-right: var(--carina-spacing-8) !important;
}
.ms-0 {
    margin-inline-start: var(--carina-spacing-0) !important;
}
.ms-3 {
    margin-inline-start: var(--carina-spacing-3) !important;
}
.mt-0 {
    margin-top: var(--carina-spacing-0) !important;
}
.mt-0\\.5 {
    margin-top: var(--carina-spacing-0-5) !important;
}
.mt-1 {
    margin-top: var(--carina-spacing-1) !important;
}
.mt-12 {
    margin-top: var(--carina-spacing-12) !important;
}
.mt-14 {
    margin-top: var(--carina-spacing-14) !important;
}
.mt-16 {
    margin-top: var(--carina-spacing-16) !important;
}
.mt-2 {
    margin-top: var(--carina-spacing-2) !important;
}
.mt-4 {
    margin-top: var(--carina-spacing-4) !important;
}
.mt-6 {
    margin-top: var(--carina-spacing-6) !important;
}
.mt-8 {
    margin-top: var(--carina-spacing-8) !important;
}
.mt-\\[24px\\] {
    margin-top: 24px !important;
}
.mt-\\[48px\\] {
    margin-top: 48px !important;
}
.mt-\\[6px\\] {
    margin-top: 6px !important;
}
.mt-\\[8px\\] {
    margin-top: 8px !important;
}
.mt-auto {
    margin-top: auto !important;
}
.box-border {
    box-sizing: border-box !important;
}
.block {
    display: block !important;
}
.inline-block {
    display: inline-block !important;
}
.inline {
    display: inline !important;
}
.\\!flex {
    display: flex !important;
}
.flex {
    display: flex !important;
}
.inline-flex {
    display: inline-flex !important;
}
.\\!table {
    display: table !important;
}
.table {
    display: table !important;
}
.grid {
    display: grid !important;
}
.contents {
    display: contents !important;
}
.list-item {
    display: list-item !important;
}
.hidden {
    display: none !important;
}
.size-4 {
    width: var(--carina-spacing-4) !important;
    height: var(--carina-spacing-4) !important;
}
.size-\\[375px\\] {
    width: 375px !important;
    height: 375px !important;
}
.h-0 {
    height: var(--carina-spacing-0) !important;
}
.h-10 {
    height: var(--carina-spacing-10) !important;
}
.h-12 {
    height: var(--carina-spacing-12) !important;
}
.h-16 {
    height: var(--carina-spacing-16) !important;
}
.h-3 {
    height: var(--carina-spacing-3) !important;
}
.h-4 {
    height: var(--carina-spacing-4) !important;
}
.h-5 {
    height: var(--carina-spacing-5) !important;
}
.h-6 {
    height: var(--carina-spacing-6) !important;
}
.h-8 {
    height: var(--carina-spacing-8) !important;
}
.h-\\[100px\\] {
    height: 100px !important;
}
.h-\\[120px\\] {
    height: 120px !important;
}
.h-\\[12px\\] {
    height: 12px !important;
}
.h-\\[141px\\] {
    height: 141px !important;
}
.h-\\[148px\\] {
    height: 148px !important;
}
.h-\\[14px\\] {
    height: 14px !important;
}
.h-\\[16px\\] {
    height: 16px !important;
}
.h-\\[18px\\] {
    height: 18px !important;
}
.h-\\[20px\\] {
    height: 20px !important;
}
.h-\\[22px\\] {
    height: 22px !important;
}
.h-\\[24px\\] {
    height: 24px !important;
}
.h-\\[28px\\] {
    height: 28px !important;
}
.h-\\[295px\\] {
    height: 295px !important;
}
.h-\\[300px\\] {
    height: 300px !important;
}
.h-\\[32px\\] {
    height: 32px !important;
}
.h-\\[36px\\] {
    height: 36px !important;
}
.h-\\[384px\\] {
    height: 384px !important;
}
.h-\\[400px\\] {
    height: 400px !important;
}
.h-\\[40px\\] {
    height: 40px !important;
}
.h-\\[60px\\] {
    height: 60px !important;
}
.h-\\[75px\\] {
    height: 75px !important;
}
.h-\\[80px\\] {
    height: 80px !important;
}
.h-\\[calc\\(100\\%_\\+_6px\\)\\] {
    height: calc(100% + 6px) !important;
}
.h-auto {
    height: auto !important;
}
.h-fit {
    height: -moz-fit-content !important;
    height: fit-content !important;
}
.h-full {
    height: 100% !important;
}
.h-px {
    height: var(--carina-spacing-px) !important;
}
.h-screen {
    height: 100vh !important;
}
.max-h-\\[600px\\] {
    max-height: 600px !important;
}
.max-h-\\[90dvh\\] {
    max-height: 90dvh !important;
}
.min-h-\\[35dvh\\] {
    min-height: 35dvh !important;
}
.min-h-\\[36px\\] {
    min-height: 36px !important;
}
.w-0 {
    width: var(--carina-spacing-0) !important;
}
.w-1\\/2 {
    width: 50% !important;
}
.w-1\\/3 {
    width: 33.333333% !important;
}
.w-10 {
    width: var(--carina-spacing-10) !important;
}
.w-12 {
    width: var(--carina-spacing-12) !important;
}
.w-16 {
    width: var(--carina-spacing-16) !important;
}
.w-2\\/5 {
    width: 40% !important;
}
.w-20 {
    width: var(--carina-spacing-20) !important;
}
.w-24 {
    width: var(--carina-spacing-24) !important;
}
.w-28 {
    width: var(--carina-spacing-28) !important;
}
.w-3 {
    width: var(--carina-spacing-3) !important;
}
.w-3\\/4 {
    width: 75% !important;
}
.w-36 {
    width: var(--carina-spacing-36) !important;
}
.w-4 {
    width: var(--carina-spacing-4) !important;
}
.w-48 {
    width: var(--carina-spacing-48) !important;
}
.w-56 {
    width: var(--carina-spacing-56) !important;
}
.w-6 {
    width: var(--carina-spacing-6) !important;
}
.w-64 {
    width: var(--carina-spacing-64) !important;
}
.w-8 {
    width: var(--carina-spacing-8) !important;
}
.w-80 {
    width: var(--carina-spacing-80) !important;
}
.w-\\[100px\\] {
    width: 100px !important;
}
.w-\\[116px\\] {
    width: 116px !important;
}
.w-\\[120px\\] {
    width: 120px !important;
}
.w-\\[126px\\] {
    width: 126px !important;
}
.w-\\[132px\\] {
    width: 132px !important;
}
.w-\\[140px\\] {
    width: 140px !important;
}
.w-\\[150px\\] {
    width: 150px !important;
}
.w-\\[160px\\] {
    width: 160px !important;
}
.w-\\[164px\\] {
    width: 164px !important;
}
.w-\\[16px\\] {
    width: 16px !important;
}
.w-\\[180px\\] {
    width: 180px !important;
}
.w-\\[200px\\] {
    width: 200px !important;
}
.w-\\[20px\\] {
    width: 20px !important;
}
.w-\\[220px\\] {
    width: 220px !important;
}
.w-\\[247px\\] {
    width: 247px !important;
}
.w-\\[24px\\] {
    width: 24px !important;
}
.w-\\[250px\\] {
    width: 250px !important;
}
.w-\\[280px\\] {
    width: 280px !important;
}
.w-\\[295px\\] {
    width: 295px !important;
}
.w-\\[300px\\] {
    width: 300px !important;
}
.w-\\[304px\\] {
    width: 304px !important;
}
.w-\\[335px\\] {
    width: 335px !important;
}
.w-\\[350px\\] {
    width: 350px !important;
}
.w-\\[36px\\] {
    width: 36px !important;
}
.w-\\[372px\\] {
    width: 372px !important;
}
.w-\\[400px\\] {
    width: 400px !important;
}
.w-\\[408px\\] {
    width: 408px !important;
}
.w-\\[420px\\] {
    width: 420px !important;
}
.w-\\[428px\\] {
    width: 428px !important;
}
.w-\\[45px\\] {
    width: 45px !important;
}
.w-\\[492px\\] {
    width: 492px !important;
}
.w-\\[500px\\] {
    width: 500px !important;
}
.w-\\[50px\\] {
    width: 50px !important;
}
.w-\\[560px\\] {
    width: 560px !important;
}
.w-\\[60px\\] {
    width: 60px !important;
}
.w-\\[677px\\] {
    width: 677px !important;
}
.w-\\[700px\\] {
    width: 700px !important;
}
.w-\\[75\\%\\] {
    width: 75% !important;
}
.w-\\[75px\\] {
    width: 75px !important;
}
.w-\\[80\\%\\] {
    width: 80% !important;
}
.w-\\[80px\\] {
    width: 80px !important;
}
.w-\\[89px\\] {
    width: 89px !important;
}
.w-\\[90\\%\\] {
    width: 90% !important;
}
.w-full {
    width: 100% !important;
}
.min-w-0 {
    min-width: var(--carina-spacing-0) !important;
}
.min-w-\\[160px\\] {
    min-width: 160px !important;
}
.max-w-\\[1099px\\] {
    max-width: 1099px !important;
}
.max-w-\\[1381px\\] {
    max-width: 1381px !important;
}
.max-w-\\[1445px\\] {
    max-width: 1445px !important;
}
.max-w-\\[1516px\\] {
    max-width: 1516px !important;
}
.max-w-\\[230px\\] {
    max-width: 230px !important;
}
.max-w-\\[428px\\] {
    max-width: 428px !important;
}
.max-w-\\[677px\\] {
    max-width: 677px !important;
}
.max-w-\\[calc\\(100\\%_-_85px\\)\\] {
    max-width: calc(100% - 85px) !important;
}
.max-w-\\[var\\(--max-narrow\\)\\] {
    max-width: var(--max-narrow) !important;
}
.max-w-full {
    max-width: 100% !important;
}
.max-w-lg {
    max-width: 32rem !important;
}
.flex-1 {
    flex: 1 1 0% !important;
}
.shrink-0 {
    flex-shrink: 0 !important;
}
.flex-grow {
    flex-grow: 1 !important;
}
.grow {
    flex-grow: 1 !important;
}
.-translate-x-\\[calc\\(100\\%\\+16px\\)\\] {
    --tw-translate-x: calc(calc(100% + 16px) * -1) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-px {
    --tw-translate-y: calc(var(--carina-spacing-px) * -1) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-1 {
    --tw-translate-x: var(--carina-spacing-1) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
    --tw-rotate: var(--carina-rotate-180) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform-none {
    transform: none !important;
}
@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.animate-fadeIn {
    animation: fadeIn 0.3s ease-in !important;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite !important;
}
.cursor-pointer {
    cursor: pointer !important;
}
.select-none {
    -webkit-user-select: none !important;
       -moz-user-select: none !important;
            user-select: none !important;
}
.select-text {
    -webkit-user-select: text !important;
       -moz-user-select: text !important;
            user-select: text !important;
}
.select-all {
    -webkit-user-select: all !important;
       -moz-user-select: all !important;
            user-select: all !important;
}
.resize {
    resize: both !important;
}
.list-disc {
    list-style-type: disc !important;
}
.list-none {
    list-style-type: none !important;
}
.appearance-none {
    -webkit-appearance: none !important;
       -moz-appearance: none !important;
            appearance: none !important;
}
.grid-cols-\\[1fr_auto_1fr\\] {
    grid-template-columns: 1fr auto 1fr !important;
}
.grid-rows-\\[auto_auto\\] {
    grid-template-rows: auto auto !important;
}
.\\!flex-row {
    flex-direction: row !important;
}
.flex-col {
    flex-direction: column !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.\\!flex-nowrap {
    flex-wrap: nowrap !important;
}
.content-center {
    align-content: center !important;
}
.content-start {
    align-content: flex-start !important;
}
.items-start {
    align-items: flex-start !important;
}
.items-end {
    align-items: flex-end !important;
}
.\\!items-center {
    align-items: center !important;
}
.items-center {
    align-items: center !important;
}
.items-baseline {
    align-items: baseline !important;
}
.justify-start {
    justify-content: flex-start !important;
}
.justify-end {
    justify-content: flex-end !important;
}
.\\!justify-center {
    justify-content: center !important;
}
.justify-center {
    justify-content: center !important;
}
.justify-between {
    justify-content: space-between !important;
}
.gap-1 {
    gap: var(--carina-spacing-1) !important;
}
.gap-1\\.5 {
    gap: var(--carina-spacing-1-5) !important;
}
.gap-2 {
    gap: var(--carina-spacing-2) !important;
}
.gap-3 {
    gap: var(--carina-spacing-3) !important;
}
.gap-4 {
    gap: var(--carina-spacing-4) !important;
}
.gap-6 {
    gap: var(--carina-spacing-6) !important;
}
.gap-\\[4px\\] {
    gap: 4px !important;
}
.gap-y-6 {
    row-gap: var(--carina-spacing-6) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(var(--carina-spacing-1) * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(var(--carina-spacing-1) * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(var(--carina-spacing-2) * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(var(--carina-spacing-2) * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(var(--carina-spacing-3) * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(var(--carina-spacing-3) * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(var(--carina-spacing-4) * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(var(--carina-spacing-4) * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(var(--carina-spacing-6) * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(var(--carina-spacing-6) * var(--tw-space-y-reverse)) !important;
}
.self-start {
    align-self: flex-start !important;
}
.\\!self-stretch {
    align-self: stretch !important;
}
.self-stretch {
    align-self: stretch !important;
}
.justify-self-start {
    justify-self: start !important;
}
.overflow-auto {
    overflow: auto !important;
}
.overflow-hidden {
    overflow: hidden !important;
}
.overflow-clip {
    overflow: clip !important;
}
.overflow-visible {
    overflow: visible !important;
}
.overflow-y-auto {
    overflow-y: auto !important;
}
.overflow-x-hidden {
    overflow-x: hidden !important;
}
.truncate {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}
.text-ellipsis {
    text-overflow: ellipsis !important;
}
.whitespace-nowrap {
    white-space: nowrap !important;
}
.rounded {
    border-radius: var(--carina-border-radius-sm) !important;
}
.rounded-\\[10px\\] {
    border-radius: 10px !important;
}
.rounded-\\[4px\\] {
    border-radius: 4px !important;
}
.rounded-\\[5px\\] {
    border-radius: 5px !important;
}
.rounded-\\[var\\(--carina-border-radius-sm\\)\\] {
    border-radius: var(--carina-border-radius-sm) !important;
}
.rounded-\\[var\\(--carina-border-radius-xl\\)\\] {
    border-radius: var(--carina-border-radius-xl) !important;
}
.rounded-full {
    border-radius: var(--carina-border-radius-full) !important;
}
.rounded-lg {
    border-radius: var(--carina-border-radius-lg) !important;
}
.rounded-md {
    border-radius: var(--carina-border-radius-md) !important;
}
.rounded-none {
    border-radius: var(--carina-border-radius-none) !important;
}
.rounded-sm {
    border-radius: var(--carina-border-radius-sm) !important;
}
.rounded-e-md {
    border-start-end-radius: var(--carina-border-radius-md) !important;
    border-end-end-radius: var(--carina-border-radius-md) !important;
}
.rounded-e-none {
    border-start-end-radius: var(--carina-border-radius-none) !important;
    border-end-end-radius: var(--carina-border-radius-none) !important;
}
.rounded-s-\\[calc\\(var\\(--carina-border-radius-md\\)_\\+_3px\\)\\] {
    border-start-start-radius: calc(var(--carina-border-radius-md) + 3px) !important;
    border-end-start-radius: calc(var(--carina-border-radius-md) + 3px) !important;
}
.rounded-s-md {
    border-start-start-radius: var(--carina-border-radius-md) !important;
    border-end-start-radius: var(--carina-border-radius-md) !important;
}
.rounded-s-none {
    border-start-start-radius: var(--carina-border-radius-none) !important;
    border-end-start-radius: var(--carina-border-radius-none) !important;
}
.rounded-t-\\[var\\(--carina-border-radius-xl\\)\\] {
    border-top-left-radius: var(--carina-border-radius-xl) !important;
    border-top-right-radius: var(--carina-border-radius-xl) !important;
}
.\\!rounded-tl-none {
    border-top-left-radius: var(--carina-border-radius-none) !important;
}
.\\!rounded-tr-none {
    border-top-right-radius: var(--carina-border-radius-none) !important;
}
.rounded-ss-md {
    border-start-start-radius: var(--carina-border-radius-md) !important;
}
.rounded-tl-\\[5px\\] {
    border-top-left-radius: 5px !important;
}
.rounded-tr-\\[5px\\] {
    border-top-right-radius: 5px !important;
}
.border {
    border-width: var(--carina-border-width-1) !important;
}
.border-0 {
    border-width: var(--carina-border-width-0) !important;
}
.border-2 {
    border-width: var(--carina-border-width-2) !important;
}
.border-x {
    border-left-width: var(--carina-border-width-1) !important;
    border-right-width: var(--carina-border-width-1) !important;
}
.border-b {
    border-bottom-width: var(--carina-border-width-1) !important;
}
.border-b-0 {
    border-bottom-width: var(--carina-border-width-0) !important;
}
.border-b-2 {
    border-bottom-width: var(--carina-border-width-2) !important;
}
.border-t {
    border-top-width: var(--carina-border-width-1) !important;
}
.border-solid {
    border-style: solid !important;
}
.border-dashed {
    border-style: dashed !important;
}
.border-none {
    border-style: none !important;
}
.border-\\[--carina-border-color-primary-focus\\] {
    border-color: var(--carina-border-color-primary-focus) !important;
}
.border-\\[transparent\\] {
    border-color: transparent !important;
}
.border-\\[var\\(--carina-border-color-base\\)\\] {
    border-color: var(--carina-border-color-base) !important;
}
.border-\\[var\\(--carina-border-color-divider\\)\\] {
    border-color: var(--carina-border-color-divider) !important;
}
.border-\\[var\\(--carina-border-color-primary-focus\\)\\] {
    border-color: var(--carina-border-color-primary-focus) !important;
}
.border-\\[var\\(--carina-border-color-soft\\)\\] {
    border-color: var(--carina-border-color-soft) !important;
}
.border-base {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-base) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.border-danger {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-danger) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.border-hard {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-hard) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.border-soft {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-soft) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.border-x-\\[color\\:var\\(--carina-border-color-primary-focus\\)\\] {
    border-left-color: var(--carina-border-color-primary-focus) !important;
    border-right-color: var(--carina-border-color-primary-focus) !important;
}
.border-x-\\[color\\:var\\(--carina-border-color-soft\\)\\] {
    border-left-color: var(--carina-border-color-soft) !important;
    border-right-color: var(--carina-border-color-soft) !important;
}
.border-b-\\[color\\:var\\(--carina-border-color-soft\\)\\] {
    border-bottom-color: var(--carina-border-color-soft) !important;
}
.border-s-\\[transparent\\] {
    border-inline-start-color: transparent !important;
}
.border-t-\\[color\\:var\\(--carina-border-color-primary-focus\\)\\] {
    border-top-color: var(--carina-border-color-primary-focus) !important;
}
.border-t-\\[color\\:var\\(--carina-border-color-soft\\)\\] {
    border-top-color: var(--carina-border-color-soft) !important;
}
.\\!bg-\\[\\#CDE4EC33\\] {
    background-color: #CDE4EC33 !important;
}
.bg-\\[\\#CDE4EC\\] {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(205 228 236 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[transparent\\] {
    background-color: transparent !important;
}
.bg-\\[var\\(--carina-background-color-surface\\)\\] {
    background-color: var(--carina-background-color-surface) !important;
}
.bg-\\[var\\(--carina-background-color-surface-alt\\)\\] {
    background-color: var(--carina-background-color-surface-alt) !important;
}
.bg-\\[var\\(--carina-border-color-soft\\)\\] {
    background-color: var(--carina-border-color-soft) !important;
}
.bg-\\[var\\(--carina-border-color-warning\\)\\] {
    background-color: var(--carina-border-color-warning) !important;
}
.bg-\\[var\\(--carina-colors-danger-10\\)\\] {
    background-color: var(--carina-colors-danger-10) !important;
}
.bg-\\[var\\(--carina-colors-success-10\\)\\] {
    background-color: var(--carina-colors-success-10) !important;
}
.bg-surface {
    --tw-bg-opacity: 1 !important;
    background-color: color-mix(in srgb, var(--carina-background-color-surface) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.bg-surface-alt {
    --tw-bg-opacity: 1 !important;
    background-color: color-mix(in srgb, var(--carina-background-color-surface-alt) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.p-0 {
    padding: var(--carina-spacing-0) !important;
}
.p-1 {
    padding: var(--carina-spacing-1) !important;
}
.p-2 {
    padding: var(--carina-spacing-2) !important;
}
.p-3 {
    padding: var(--carina-spacing-3) !important;
}
.p-4 {
    padding: var(--carina-spacing-4) !important;
}
.p-6 {
    padding: var(--carina-spacing-6) !important;
}
.p-8 {
    padding: var(--carina-spacing-8) !important;
}
.p-\\[32px\\] {
    padding: 32px !important;
}
.px-0 {
    padding-left: var(--carina-spacing-0) !important;
    padding-right: var(--carina-spacing-0) !important;
}
.px-1 {
    padding-left: var(--carina-spacing-1) !important;
    padding-right: var(--carina-spacing-1) !important;
}
.px-2 {
    padding-left: var(--carina-spacing-2) !important;
    padding-right: var(--carina-spacing-2) !important;
}
.px-3 {
    padding-left: var(--carina-spacing-3) !important;
    padding-right: var(--carina-spacing-3) !important;
}
.px-4 {
    padding-left: var(--carina-spacing-4) !important;
    padding-right: var(--carina-spacing-4) !important;
}
.px-6 {
    padding-left: var(--carina-spacing-6) !important;
    padding-right: var(--carina-spacing-6) !important;
}
.px-9 {
    padding-left: var(--carina-spacing-9) !important;
    padding-right: var(--carina-spacing-9) !important;
}
.py-2 {
    padding-top: var(--carina-spacing-2) !important;
    padding-bottom: var(--carina-spacing-2) !important;
}
.py-2\\.5 {
    padding-top: var(--carina-spacing-2-5) !important;
    padding-bottom: var(--carina-spacing-2-5) !important;
}
.py-3 {
    padding-top: var(--carina-spacing-3) !important;
    padding-bottom: var(--carina-spacing-3) !important;
}
.py-4 {
    padding-top: var(--carina-spacing-4) !important;
    padding-bottom: var(--carina-spacing-4) !important;
}
.py-6 {
    padding-top: var(--carina-spacing-6) !important;
    padding-bottom: var(--carina-spacing-6) !important;
}
.py-8 {
    padding-top: var(--carina-spacing-8) !important;
    padding-bottom: var(--carina-spacing-8) !important;
}
.py-\\[6px\\] {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}
.py-\\[var\\(--carina-tan-table-padding-vertical\\)\\] {
    padding-top: var(--carina-tan-table-padding-vertical) !important;
    padding-bottom: var(--carina-tan-table-padding-vertical) !important;
}
.\\!pb-6 {
    padding-bottom: var(--carina-spacing-6) !important;
}
.pb-0 {
    padding-bottom: var(--carina-spacing-0) !important;
}
.pb-1 {
    padding-bottom: var(--carina-spacing-1) !important;
}
.pb-10 {
    padding-bottom: var(--carina-spacing-10) !important;
}
.pb-2 {
    padding-bottom: var(--carina-spacing-2) !important;
}
.pb-20 {
    padding-bottom: var(--carina-spacing-20) !important;
}
.pb-3 {
    padding-bottom: var(--carina-spacing-3) !important;
}
.pb-4 {
    padding-bottom: var(--carina-spacing-4) !important;
}
.pb-6 {
    padding-bottom: var(--carina-spacing-6) !important;
}
.pb-8 {
    padding-bottom: var(--carina-spacing-8) !important;
}
.pb-\\[17\\.5px\\] {
    padding-bottom: 17.5px !important;
}
.pb-px {
    padding-bottom: var(--carina-spacing-px) !important;
}
.pe-0 {
    padding-inline-end: var(--carina-spacing-0) !important;
}
.pe-1 {
    padding-inline-end: var(--carina-spacing-1) !important;
}
.pe-3 {
    padding-inline-end: var(--carina-spacing-3) !important;
}
.pe-4 {
    padding-inline-end: var(--carina-spacing-4) !important;
}
.pl-0 {
    padding-left: var(--carina-spacing-0) !important;
}
.pl-2 {
    padding-left: var(--carina-spacing-2) !important;
}
.pl-4 {
    padding-left: var(--carina-spacing-4) !important;
}
.pl-5 {
    padding-left: var(--carina-spacing-5) !important;
}
.pl-8 {
    padding-left: var(--carina-spacing-8) !important;
}
.pr-1 {
    padding-right: var(--carina-spacing-1) !important;
}
.ps-0 {
    padding-inline-start: var(--carina-spacing-0) !important;
}
.ps-1 {
    padding-inline-start: var(--carina-spacing-1) !important;
}
.ps-2 {
    padding-inline-start: var(--carina-spacing-2) !important;
}
.ps-4 {
    padding-inline-start: var(--carina-spacing-4) !important;
}
.ps-\\[var\\(--carina-tan-table-padding-horizontal\\)\\] {
    padding-inline-start: var(--carina-tan-table-padding-horizontal) !important;
}
.pt-0 {
    padding-top: var(--carina-spacing-0) !important;
}
.pt-1 {
    padding-top: var(--carina-spacing-1) !important;
}
.pt-2 {
    padding-top: var(--carina-spacing-2) !important;
}
.pt-3 {
    padding-top: var(--carina-spacing-3) !important;
}
.pt-4 {
    padding-top: var(--carina-spacing-4) !important;
}
.pt-6 {
    padding-top: var(--carina-spacing-6) !important;
}
.pt-8 {
    padding-top: var(--carina-spacing-8) !important;
}
.pt-\\[21\\.5px\\] {
    padding-top: 21.5px !important;
}
.text-center {
    text-align: center !important;
}
.text-start {
    text-align: start !important;
}
.indent-0 {
    text-indent: var(--carina-spacing-0) !important;
}
.align-middle {
    vertical-align: middle !important;
}
.font-body {
    font-family: var(--carina-font-family-body) !important;
}
.font-mono {
    font-family: var(--carina-font-family-mono) !important;
}
.text-2xs {
    font-size: var(--carina-font-size-2xs) !important;
    line-height: var(--carina-line-height-2) !important;
}
.text-\\[10px\\] {
    font-size: 10px !important;
}
.text-\\[12px\\] {
    font-size: 12px !important;
}
.text-\\[13px\\] {
    font-size: 13px !important;
}
.text-\\[14px\\] {
    font-size: 14px !important;
}
.text-\\[21px\\] {
    font-size: 21px !important;
}
.text-\\[24px\\] {
    font-size: 24px !important;
}
.text-\\[length\\:--carina-font-size-md\\] {
    font-size: var(--carina-font-size-md) !important;
}
.text-\\[length\\:--carina-font-size-sm\\] {
    font-size: var(--carina-font-size-sm) !important;
}
.text-\\[length\\:var\\(--carina-font-size-2xl\\)\\] {
    font-size: var(--carina-font-size-2xl) !important;
}
.text-\\[length\\:var\\(--carina-font-size-2xs\\)\\] {
    font-size: var(--carina-font-size-2xs) !important;
}
.text-\\[length\\:var\\(--carina-font-size-body-2xs\\)\\] {
    font-size: var(--carina-font-size-body-2xs) !important;
}
.text-\\[length\\:var\\(--carina-font-size-body-md\\)\\] {
    font-size: var(--carina-font-size-body-md) !important;
}
.text-\\[length\\:var\\(--carina-font-size-body-sm\\)\\] {
    font-size: var(--carina-font-size-body-sm) !important;
}
.text-\\[length\\:var\\(--carina-font-size-body-xs\\)\\] {
    font-size: var(--carina-font-size-body-xs) !important;
}
.text-\\[length\\:var\\(--carina-font-size-display-2xs\\)\\] {
    font-size: var(--carina-font-size-display-2xs) !important;
}
.text-\\[length\\:var\\(--carina-font-size-display-xs\\)\\] {
    font-size: var(--carina-font-size-display-xs) !important;
}
.text-\\[length\\:var\\(--carina-font-size-lg\\)\\] {
    font-size: var(--carina-font-size-lg) !important;
}
.text-\\[length\\:var\\(--carina-font-size-m-header-4\\)\\] {
    font-size: var(--carina-font-size-m-header-4) !important;
}
.text-\\[length\\:var\\(--carina-font-size-md\\)\\] {
    font-size: var(--carina-font-size-md) !important;
}
.text-\\[length\\:var\\(--carina-font-size-sm\\)\\] {
    font-size: var(--carina-font-size-sm) !important;
}
.text-\\[length\\:var\\(--carina-font-size-xs\\)\\] {
    font-size: var(--carina-font-size-xs) !important;
}
.text-body-2xs {
    font-size: var(--carina-font-size-body-2xs) !important;
    line-height: var(--carina-line-height-body-2xs) !important;
}
.text-body-lg {
    font-size: var(--carina-font-size-body-lg) !important;
    line-height: var(--carina-line-height-body-lg) !important;
}
.text-body-md {
    font-size: var(--carina-font-size-body-md) !important;
    line-height: var(--carina-line-height-body-md) !important;
}
.text-body-sm {
    font-size: var(--carina-font-size-body-sm) !important;
    line-height: var(--carina-line-height-body-sm) !important;
}
.text-header-5 {
    font-size: var(--carina-font-size-header-5) !important;
    line-height: var(--carina-line-height-header-5) !important;
    font-weight: var(--carina-font-weight-display) !important;
}
.text-md {
    font-size: var(--carina-font-size-md) !important;
    line-height: var(--carina-line-height-3) !important;
}
.text-sm {
    font-size: var(--carina-font-size-sm) !important;
    line-height: var(--carina-line-height-3) !important;
}
.text-xs {
    font-size: var(--carina-font-size-xs) !important;
    line-height: var(--carina-line-height-3) !important;
}
.font-\\[var\\(--carina-font-weight-body\\)\\] {
    font-weight: var(--carina-font-weight-body) !important;
}
.font-\\[var\\(--carina-font-weight-bold\\)\\] {
    font-weight: var(--carina-font-weight-bold) !important;
}
.font-\\[var\\(--carina-font-weight-display\\)\\] {
    font-weight: var(--carina-font-weight-display) !important;
}
.font-\\[var\\(--carina-font-weight-normal\\)\\] {
    font-weight: var(--carina-font-weight-normal) !important;
}
.font-\\[var\\(--carina-font-weight-semi-bold\\)\\] {
    font-weight: var(--carina-font-weight-semi-bold) !important;
}
.font-body {
    font-weight: var(--carina-font-weight-body) !important;
}
.font-bold {
    font-weight: var(--carina-font-weight-bold) !important;
}
.font-normal {
    font-weight: var(--carina-font-weight-normal) !important;
}
.uppercase {
    text-transform: uppercase !important;
}
.lowercase {
    text-transform: lowercase !important;
}
.leading-2 {
    line-height: var(--carina-line-height-2) !important;
}
.leading-3 {
    line-height: var(--carina-line-height-3) !important;
}
.leading-4 {
    line-height: var(--carina-line-height-4) !important;
}
.leading-6 {
    line-height: var(--carina-line-height-6) !important;
}
.leading-\\[150\\%\\] {
    line-height: 150% !important;
}
.leading-\\[18px\\] {
    line-height: 18px !important;
}
.leading-\\[1\\] {
    line-height: 1 !important;
}
.leading-\\[24px\\] {
    line-height: 24px !important;
}
.leading-\\[var\\(--carina-line-height-3\\)\\] {
    line-height: var(--carina-line-height-3) !important;
}
.leading-\\[var\\(--carina-line-height-4\\)\\] {
    line-height: var(--carina-line-height-4) !important;
}
.leading-\\[var\\(--carina-line-height-5\\)\\] {
    line-height: var(--carina-line-height-5) !important;
}
.leading-\\[var\\(--carina-line-height-body-2x\\)\\] {
    line-height: var(--carina-line-height-body-2x) !important;
}
.leading-\\[var\\(--carina-line-height-body-sm\\)\\] {
    line-height: var(--carina-line-height-body-sm) !important;
}
.leading-\\[var\\(--carina-line-height-display-2xs\\)\\] {
    line-height: var(--carina-line-height-display-2xs) !important;
}
.leading-\\[var\\(--carina-line-height-display-xs\\)\\] {
    line-height: var(--carina-line-height-display-xs) !important;
}
.leading-\\[var\\(--carina-line-height-header-6\\)\\] {
    line-height: var(--carina-line-height-header-6) !important;
}
.leading-\\[var\\(--carina-line-height-normal\\)\\] {
    line-height: var(--carina-line-height-normal) !important;
}
.leading-\\[var\\(--carina-line-height-tight\\)\\] {
    line-height: var(--carina-line-height-tight) !important;
}
.leading-header-4 {
    line-height: var(--carina-line-height-header-4) !important;
}
.leading-normal {
    line-height: var(--carina-line-height-normal) !important;
}
.leading-relaxed {
    line-height: var(--carina-line-height-relaxed) !important;
}
.text-\\[\\#000\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#006AE1\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(0 106 225 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#198A96\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(25 138 150 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#1c2430\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(28 36 48 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#69727f\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(105 114 127 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[var\\(--carina-colors-info-seed\\)\\] {
    color: var(--carina-colors-info-seed) !important;
}
.text-\\[var\\(--carina-colors-success-60\\)\\] {
    color: var(--carina-colors-success-60) !important;
}
.text-\\[var\\(--carina-default-text-icon-base\\)\\] {
    color: var(--carina-default-text-icon-base) !important;
}
.text-\\[var\\(--carina-font-size-header-6\\)\\] {
    color: var(--carina-font-size-header-6) !important;
}
.text-\\[var\\(--carina-interactive-color-fill-base\\)\\] {
    color: var(--carina-interactive-color-fill-base) !important;
}
.text-\\[var\\(--carina-link-color\\2c \\#006ae1\\)\\] {
    color: var(--carina-link-color,#006ae1) !important;
}
.text-\\[var\\(--carina-text-color-base\\)\\] {
    color: var(--carina-text-color-base) !important;
}
.text-\\[var\\(--carina-text-color-danger\\)\\] {
    color: var(--carina-text-color-danger) !important;
}
.text-\\[var\\(--carina-text-color-muted\\)\\] {
    color: var(--carina-text-color-muted) !important;
}
.text-\\[var\\(--carina-text-color-primary\\)\\] {
    color: var(--carina-text-color-primary) !important;
}
.text-\\[var\\(--carina-text-color-soft\\)\\] {
    color: var(--carina-text-color-soft) !important;
}
.text-\\[var\\(--default-text-icon-soft\\)\\] {
    color: var(--default-text-icon-soft) !important;
}
.text-base {
    --tw-text-opacity: 1 !important;
    color: color-mix(in srgb, var(--carina-text-color-base) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}
.text-disabled {
    --tw-text-opacity: 1 !important;
    color: color-mix(in srgb, var(--carina-text-color-disabled) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}
.text-soft {
    --tw-text-opacity: 1 !important;
    color: color-mix(in srgb, var(--carina-text-color-soft) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}
.underline {
    text-decoration-line: underline !important;
}
.line-through {
    text-decoration-line: line-through !important;
}
.no-underline {
    text-decoration-line: none !important;
}
.opacity-0 {
    opacity: var(--carina-opacity-0) !important;
}
.opacity-100 {
    opacity: var(--carina-opacity-100) !important;
}
.shadow {
    --tw-shadow: var(--carina-box-shadow-md) !important;
    --tw-shadow-colored: var(--carina-box-shadow-md) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[inset_0_0_0_1px_color-mix\\(in_srgb\\2c var\\(--carina-border-color-hard\\)_calc\\(var\\(--carina-opacity-25\\)_\\*_100\\%\\)\\2c transparent\\)\\] {
    --tw-shadow: inset 0 0 0 1px color-mix(in srgb,var(--carina-border-color-hard) calc(var(--carina-opacity-25) * 100%),transparent) !important;
    --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl {
    --tw-shadow: var(--carina-box-shadow-xl) !important;
    --tw-shadow-colored: var(--carina-box-shadow-xl) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[var\\(--carina-box-shadow-lg\\)\\] {
    --tw-shadow-color: var(--carina-box-shadow-lg) !important;
    --tw-shadow: var(--tw-shadow-colored) !important;
}
.outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline {
    outline-style: solid !important;
}
.outline-2 {
    outline-width: 2px !important;
}
.-outline-offset-4 {
    outline-offset: -4px !important;
}
.outline-offset-1 {
    outline-offset: 1px !important;
}
.outline-offset-2 {
    outline-offset: 2px !important;
}
.outline-\\[var\\(--carina-border-color-inverse\\)\\] {
    outline-color: var(--carina-border-color-inverse) !important;
}
.outline-\\[var\\(--carina-colors-transparent\\)\\] {
    outline-color: var(--carina-colors-transparent) !important;
}
.outline-transparent {
    outline-color: color-mix(in srgb, var(--carina-colors-transparent) calc(1 * 100%), transparent) !important;
}
.ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(var(--carina-ring-width-2) + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.blur {
    --tw-blur: blur(8px) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
}
.transition-all {
    transition-property: all !important;
}
.transition-none {
    transition-property: none !important;
}
.transition-transform {
    transition-property: transform !important;
}
.duration-100 {
    transition-duration: var(--carina-transition-duration-100) !important;
}
.duration-300 {
    transition-duration: var(--carina-transition-duration-300) !important;
}
.icon-sm {
    width: var(--carina-icon-sm) !important;
    height: var(--carina-icon-sm) !important;
}
.\\[--carina-avatar-bg\\:var\\(--carina-avatar-group-overflow-bg\\2c \\#c2c2c2\\)\\] {
    --carina-avatar-bg: var(--carina-avatar-group-overflow-bg,#c2c2c2) !important;
}
.\\[--carina-avatar-fg\\:var\\(--carina-avatar-group-overflow-fg\\2c \\#000\\)\\] {
    --carina-avatar-fg: var(--carina-avatar-group-overflow-fg,#000) !important;
}
.\\[--carina-tile-padding\\:0px\\] {
    --carina-tile-padding: 0px !important;
}
.\\[border-radius\\:var\\(--carina-border-radius-xl\\)\\] {
    border-radius: var(--carina-border-radius-xl) !important;
}
.\\[border-top-left-radius\\:var\\(--carina-border-radius-3xl\\)\\] {
    border-top-left-radius: var(--carina-border-radius-3xl) !important;
}
.\\[border-top-right-radius\\:var\\(--carina-border-radius-3xl\\)\\] {
    border-top-right-radius: var(--carina-border-radius-3xl) !important;
}
.\\[color\\:var\\(--carina-colors-grayscale-70\\)\\] {
    color: var(--carina-colors-grayscale-70) !important;
}
.\\[color\\:var\\(--carina-text-color-soft\\)\\] {
    color: var(--carina-text-color-soft) !important;
}
.\\[font-size\\:var\\(--carina-font-size-2xl\\)\\] {
    font-size: var(--carina-font-size-2xl) !important;
}
.\\[font-size\\:var\\(--carina-font-size-2xs\\)\\] {
    font-size: var(--carina-font-size-2xs) !important;
}
.\\[font-size\\:var\\(--carina-font-size-header-6\\)\\] {
    font-size: var(--carina-font-size-header-6) !important;
}
.\\[font-size\\:var\\(--carina-font-size-md\\)\\] {
    font-size: var(--carina-font-size-md) !important;
}
.\\[font-size\\:var\\(--carina-font-size-sm\\)\\] {
    font-size: var(--carina-font-size-sm) !important;
}
.\\[font-size\\:var\\(--carina-font-size-xl\\)\\] {
    font-size: var(--carina-font-size-xl) !important;
}
.\\[font-weight\\:var\\(--carina-font-weight-body\\)\\] {
    font-weight: var(--carina-font-weight-body) !important;
}
.\\[font-weight\\:var\\(--carina-font-weight-display\\)\\] {
    font-weight: var(--carina-font-weight-display) !important;
}
.\\[font-weight\\:var\\(--carina-font-weight-normal\\)\\] {
    font-weight: var(--carina-font-weight-normal) !important;
}
.\\[font-weight\\:var\\(--carina-font-weight-semi-bold\\)\\] {
    font-weight: var(--carina-font-weight-semi-bold) !important;
}
.\\[gap\\:var\\(--carina-spacing-2\\)\\] {
    gap: var(--carina-spacing-2) !important;
}
.\\[inset-inline-start\\:calc\\(-1\\*var\\(--carina-spacing-2-5\\)\\)\\] {
    inset-inline-start: calc(-1 * var(--carina-spacing-2-5)) !important;
}
.\\[line-height\\:var\\(--carina-line-height-2\\)\\] {
    line-height: var(--carina-line-height-2) !important;
}
.\\[line-height\\:var\\(--carina-line-height-4\\)\\] {
    line-height: var(--carina-line-height-4) !important;
}
.\\[line-height\\:var\\(--carina-line-height-5\\)\\] {
    line-height: var(--carina-line-height-5) !important;
}
.\\[line-height\\:var\\(--carina-line-height-6\\)\\] {
    line-height: var(--carina-line-height-6) !important;
}
.\\[margin-bottom\\:var\\(--carina-spacing-2\\)\\] {
    margin-bottom: var(--carina-spacing-2) !important;
}
.\\[margin-bottom\\:var\\(--carina-spacing-6\\)\\] {
    margin-bottom: var(--carina-spacing-6) !important;
}
.\\[margin-bottom\\:var\\(--carina-spacing-8\\)\\] {
    margin-bottom: var(--carina-spacing-8) !important;
}
.\\[margin-top\\:var\\(--carina-spacing-12\\)\\] {
    margin-top: var(--carina-spacing-12) !important;
}
.\\[margin-top\\:var\\(--carina-spacing-4\\)\\] {
    margin-top: var(--carina-spacing-4) !important;
}
.\\[margin-top\\:var\\(--carina-spacing-8\\)\\] {
    margin-top: var(--carina-spacing-8) !important;
}
.\\[padding-bottom\\:var\\(--carina-spacing-6\\)\\] {
    padding-bottom: var(--carina-spacing-6) !important;
}
.\\[padding-left\\:var\\(--carina-spacing-9\\)\\] {
    padding-left: var(--carina-spacing-9) !important;
}
.\\[padding-right\\:var\\(--carina-spacing-9\\)\\] {
    padding-right: var(--carina-spacing-9) !important;
}
.\\[padding-top\\:var\\(--carina-spacing-1\\)\\] {
    padding-top: var(--carina-spacing-1) !important;
}
.\\[padding-top\\:var\\(--carina-spacing-6\\)\\] {
    padding-top: var(--carina-spacing-6) !important;
}
.\\[top\\:calc\\(-1\\*var\\(--carina-spacing-0-5\\)\\)\\] {
    top: calc(-1 * var(--carina-spacing-0-5)) !important;
}
.hover\\:underline:hover {
    text-decoration-line: underline;
}
.hover\\:duration-100:hover {
    transition-duration: var(--carina-transition-duration-100);
}
.focus\\:underline:focus {
    text-decoration-line: underline;
}
.focus-visible\\:z-\\[calc\\(var\\(--carina-z-index-current\\)\\+1\\)\\]:focus-visible {
    z-index: calc(var(--carina-z-index-current) + 1);
}
.focus-visible\\:border-b-0:focus-visible {
    border-bottom-width: var(--carina-border-width-0);
}
.focus-visible\\:outline:focus-visible {
    outline-style: solid;
}
.focus-visible\\:ring:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(var(--carina-ring-width-2) + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:duration-100:focus-visible {
    transition-duration: var(--carina-transition-duration-100);
}
.active\\:duration-100:active {
    transition-duration: var(--carina-transition-duration-100);
}
.group:focus-visible .group-focus-visible\\:duration-100 {
    transition-duration: var(--carina-transition-duration-100);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-b-0 {
    border-bottom-width: var(--carina-border-width-0);
}
.peer:focus-visible ~ .peer-focus-visible\\:border-solid {
    border-style: solid;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-danger {
    --tw-border-opacity: 1;
    border-color: color-mix(in srgb, var(--carina-border-color-danger) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.peer:focus-visible ~ .peer-focus-visible\\:outline {
    outline-style: solid;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-2 {
    outline-width: 2px;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-offset-1 {
    outline-offset: 1px;
}
@container (min-width: 640px) {
    .\\@sm\\:hidden {
        display: none;
    }
    .\\@sm\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@sm\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\@sm\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\@sm\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\@sm\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\@sm\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\@sm\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\@sm\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\@sm\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@sm\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@sm\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@sm\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@sm\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@sm\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@sm\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\@sm\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\@sm\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\@sm\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\@sm\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@sm\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@sm\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@sm\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@sm\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@sm\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@sm\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\@sm\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\@sm\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\@sm\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@sm\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\@sm\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\@sm\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\@sm\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\@sm\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\@sm\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\@sm\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\@sm\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\@sm\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\@sm\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\@sm\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\@sm\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\@sm\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\@sm\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\@sm\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    .\\@sm\\:inline {
        display: inline;
    }
    @media (min-width: 1024px) {
        .\\@sm\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@sm\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@sm\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@sm\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@sm\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@sm\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@sm\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\@sm\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\@sm\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\@sm\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\@sm\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@sm\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@sm\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@sm\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@sm\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@sm\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@sm\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\@sm\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@container (min-width: 768px) {
    .\\@md\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@md\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\@md\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\@md\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\@md\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\@md\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\@md\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\@md\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\@md\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@md\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@md\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@md\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@md\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@md\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@md\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\@md\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\@md\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\@md\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\@md\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@md\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@md\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@md\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@md\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@md\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@md\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\@md\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\@md\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\@md\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@md\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\@md\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\@md\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\@md\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\@md\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\@md\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\@md\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\@md\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\@md\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\@md\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\@md\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\@md\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\@md\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\@md\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\@md\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .\\@md\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@md\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@md\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@md\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@md\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@md\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@md\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\@md\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\@md\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\@md\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\@md\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@md\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@md\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@md\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@md\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@md\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@md\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\@md\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@container (min-width: 1024px) {
    .\\@lg\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@lg\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\@lg\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\@lg\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\@lg\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\@lg\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\@lg\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\@lg\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\@lg\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@lg\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@lg\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@lg\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@lg\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@lg\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@lg\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\@lg\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\@lg\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\@lg\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\@lg\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@lg\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@lg\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@lg\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@lg\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@lg\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@lg\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\@lg\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\@lg\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\@lg\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@lg\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\@lg\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\@lg\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\@lg\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\@lg\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\@lg\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\@lg\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\@lg\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\@lg\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\@lg\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\@lg\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\@lg\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\@lg\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\@lg\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\@lg\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .\\@lg\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@lg\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@lg\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@lg\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@lg\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@lg\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@lg\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\@lg\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\@lg\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\@lg\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\@lg\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@lg\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@lg\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@lg\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@lg\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@lg\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@lg\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\@lg\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@container (min-width: 1280px) {
    .\\@xl\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@xl\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\@xl\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\@xl\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\@xl\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\@xl\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\@xl\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\@xl\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\@xl\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@xl\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@xl\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@xl\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@xl\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@xl\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@xl\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\@xl\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\@xl\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\@xl\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\@xl\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@xl\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@xl\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@xl\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@xl\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@xl\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@xl\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\@xl\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\@xl\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\@xl\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@xl\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\@xl\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\@xl\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\@xl\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\@xl\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\@xl\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\@xl\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\@xl\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\@xl\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\@xl\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\@xl\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\@xl\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\@xl\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\@xl\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\@xl\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .\\@xl\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@xl\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@xl\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@xl\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@xl\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@xl\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@xl\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\@xl\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\@xl\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\@xl\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\@xl\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@xl\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@xl\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@xl\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@xl\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@xl\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@xl\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\@xl\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@container (min-width: 1536px) {
    .\\@2xl\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@2xl\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\@2xl\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\@2xl\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\@2xl\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\@2xl\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\@2xl\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\@2xl\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\@2xl\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@2xl\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@2xl\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@2xl\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@2xl\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@2xl\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@2xl\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\@2xl\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\@2xl\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\@2xl\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\@2xl\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\@2xl\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\@2xl\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\@2xl\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\@2xl\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\@2xl\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\@2xl\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\@2xl\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\@2xl\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\@2xl\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\@2xl\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\@2xl\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\@2xl\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\@2xl\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\@2xl\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\@2xl\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\@2xl\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\@2xl\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\@2xl\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\@2xl\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\@2xl\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\@2xl\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\@2xl\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\@2xl\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\@2xl\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .\\@2xl\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@2xl\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@2xl\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@2xl\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@2xl\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@2xl\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@2xl\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\@2xl\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\@2xl\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\@2xl\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\@2xl\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\@2xl\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\@2xl\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\@2xl\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\@2xl\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\@2xl\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\@2xl\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\@2xl\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@media (min-width: 560px) {
    .sm\\:hidden {
        display: none;
    }
    .sm\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .sm\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .sm\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .sm\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .sm\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .sm\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .sm\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .sm\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .sm\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .sm\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .sm\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .sm\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .sm\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .sm\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .sm\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .sm\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .sm\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .sm\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .sm\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .sm\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .sm\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .sm\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .sm\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .sm\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .sm\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .sm\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .sm\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .sm\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .sm\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .sm\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .sm\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .sm\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .sm\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .sm\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .sm\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .sm\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .sm\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .sm\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .sm\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .sm\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .sm\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .sm\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .sm\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    .sm\\:w-full {
        width: 100%;
    }
    .sm\\:flex-col {
        flex-direction: column;
    }
    .sm\\:justify-end {
        justify-content: flex-end;
    }
    .sm\\:px-0 {
        padding-left: var(--carina-spacing-0);
        padding-right: var(--carina-spacing-0);
    }
    @media (min-width: 1024px) {
        .sm\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .sm\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .sm\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .sm\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .sm\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .sm\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .sm\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .sm\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .sm\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .sm\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .sm\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .sm\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .sm\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .sm\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .sm\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .sm\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .sm\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .sm\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@media (min-width: 1080px) {
    .md\\:block {
        display: block;
    }
    .md\\:hidden {
        display: none;
    }
    .md\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .md\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .md\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .md\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .md\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .md\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .md\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .md\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .md\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .md\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .md\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .md\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .md\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .md\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .md\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .md\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .md\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .md\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .md\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .md\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .md\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .md\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .md\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .md\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .md\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .md\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .md\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .md\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .md\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .md\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .md\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .md\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .md\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .md\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .md\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .md\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .md\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .md\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .md\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .md\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .md\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .md\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .md\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    .md\\:items-center {
        align-items: center;
    }
    .md\\:justify-center {
        justify-content: center;
    }
    .md\\:px-0 {
        padding-left: var(--carina-spacing-0);
        padding-right: var(--carina-spacing-0);
    }
    .md\\:pb-0 {
        padding-bottom: var(--carina-spacing-0);
    }
    .md\\:pb-4 {
        padding-bottom: var(--carina-spacing-4);
    }
    @media (min-width: 1024px) {
        .md\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .md\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .md\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .md\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .md\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .md\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .md\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .md\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .md\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .md\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .md\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .md\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .md\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .md\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .md\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .md\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .md\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .md\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@media (min-width: 1464px) {
    .lg\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .lg\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .lg\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .lg\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .lg\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .lg\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .lg\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .lg\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .lg\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .lg\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .lg\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .lg\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .lg\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .lg\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .lg\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .lg\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .lg\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .lg\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .lg\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .lg\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .lg\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .lg\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .lg\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .lg\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .lg\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .lg\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .lg\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .lg\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .lg\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .lg\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .lg\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .lg\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .lg\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .lg\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .lg\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .lg\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .lg\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .lg\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .lg\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .lg\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .lg\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .lg\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .lg\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .lg\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .lg\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .lg\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .lg\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .lg\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .lg\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .lg\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .lg\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .lg\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .lg\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .lg\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .lg\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .lg\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .lg\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .lg\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .lg\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .lg\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .lg\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@media (min-width: 1280px) {
    .xl\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .xl\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .xl\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .xl\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .xl\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .xl\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .xl\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .xl\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .xl\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .xl\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .xl\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .xl\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .xl\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .xl\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .xl\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .xl\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .xl\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .xl\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .xl\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .xl\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .xl\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .xl\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .xl\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .xl\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .xl\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .xl\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .xl\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .xl\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .xl\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .xl\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .xl\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .xl\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .xl\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .xl\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .xl\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .xl\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .xl\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .xl\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .xl\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .xl\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .xl\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .xl\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .xl\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .xl\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .xl\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .xl\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .xl\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .xl\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .xl\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .xl\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .xl\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .xl\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .xl\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .xl\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .xl\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .xl\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .xl\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .xl\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .xl\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .xl\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .xl\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
@media (min-width: 1536px) {
    .\\32xl\\:carina-row--cols-auto > * {
        flex: 0 0 auto;
        width: auto;
    }
    .\\32xl\\:carina-row--cols-default > * {
        flex: 1 0 0%;
    }
    .\\32xl\\:carina-row--cols-1 > * {
        flex: 0 0 auto;
        width: calc(100% / 1);
    }
    .\\32xl\\:carina-row--cols-2 > * {
        flex: 0 0 auto;
        width: calc(100% / 2);
    }
    .\\32xl\\:carina-row--cols-3 > * {
        flex: 0 0 auto;
        width: calc(100% / 3);
    }
    .\\32xl\\:carina-row--cols-4 > * {
        flex: 0 0 auto;
        width: calc(100% / 4);
    }
    .\\32xl\\:carina-row--cols-5 > * {
        flex: 0 0 auto;
        width: calc(100% / 5);
    }
    .\\32xl\\:carina-row--cols-6 > * {
        flex: 0 0 auto;
        width: calc(100% / 6);
    }
    .\\32xl\\:carina-row--gutter-x-compact {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\32xl\\:carina-row--gutter-y-compact {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\32xl\\:carina-row--gutter-x-default {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\32xl\\:carina-row--gutter-y-default {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\32xl\\:carina-row--gutter-x-roomy {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\32xl\\:carina-row--gutter-y-roomy {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\32xl\\:carina-row--gutter-x-0 {
        --carina-row-gutter-x: var(--carina-spacing-0);
    }
    .\\32xl\\:carina-row--gutter-y-0 {
        --carina-row-gutter-y: var(--carina-spacing-0);
    }
    .\\32xl\\:carina-row--gutter-x-2 {
        --carina-row-gutter-x: var(--carina-spacing-2);
    }
    .\\32xl\\:carina-row--gutter-y-2 {
        --carina-row-gutter-y: var(--carina-spacing-2);
    }
    .\\32xl\\:carina-row--gutter-x-4 {
        --carina-row-gutter-x: var(--carina-spacing-4);
    }
    .\\32xl\\:carina-row--gutter-y-4 {
        --carina-row-gutter-y: var(--carina-spacing-4);
    }
    .\\32xl\\:carina-row--gutter-x-6 {
        --carina-row-gutter-x: var(--carina-spacing-6);
    }
    .\\32xl\\:carina-row--gutter-y-6 {
        --carina-row-gutter-y: var(--carina-spacing-6);
    }
    .\\32xl\\:carina-row--gutter-x-8 {
        --carina-row-gutter-x: var(--carina-spacing-8);
    }
    .\\32xl\\:carina-row--gutter-y-8 {
        --carina-row-gutter-y: var(--carina-spacing-8);
    }
    .\\32xl\\:carina-row--gutter-x-10 {
        --carina-row-gutter-x: var(--carina-spacing-10);
    }
    .\\32xl\\:carina-row--gutter-y-10 {
        --carina-row-gutter-y: var(--carina-spacing-10);
    }
    .\\32xl\\:carina-column--fill {
        flex: 1 0 0%;
        width: 0;
    }
    .\\32xl\\:carina-column--auto {
        flex: 0 0 auto;
        width: auto;
    }
    .\\32xl\\:carina-column--span-1 {
        flex: 0 0 auto;
        width: calc(100% * 1 / 12);
    }
    .\\32xl\\:carina-column--span-2 {
        flex: 0 0 auto;
        width: calc(100% * 2 / 12);
    }
    .\\32xl\\:carina-column--span-3 {
        flex: 0 0 auto;
        width: calc(100% * 3 / 12);
    }
    .\\32xl\\:carina-column--span-4 {
        flex: 0 0 auto;
        width: calc(100% * 4 / 12);
    }
    .\\32xl\\:carina-column--span-5 {
        flex: 0 0 auto;
        width: calc(100% * 5 / 12);
    }
    .\\32xl\\:carina-column--span-6 {
        flex: 0 0 auto;
        width: calc(100% * 6 / 12);
    }
    .\\32xl\\:carina-column--span-7 {
        flex: 0 0 auto;
        width: calc(100% * 7 / 12);
    }
    .\\32xl\\:carina-column--span-8 {
        flex: 0 0 auto;
        width: calc(100% * 8 / 12);
    }
    .\\32xl\\:carina-column--span-9 {
        flex: 0 0 auto;
        width: calc(100% * 9 / 12);
    }
    .\\32xl\\:carina-column--span-10 {
        flex: 0 0 auto;
        width: calc(100% * 10 / 12);
    }
    .\\32xl\\:carina-column--span-11 {
        flex: 0 0 auto;
        width: calc(100% * 11 / 12);
    }
    .\\32xl\\:carina-column--span-12 {
        flex: 0 0 auto;
        width: calc(100% * 12 / 12);
    }
    .\\32xl\\:carina-column--offset-1 {
        margin-right: 0;
        margin-left: calc(100% * 1 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-1 {
        margin-right: calc(100% * 1 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-2 {
        margin-right: 0;
        margin-left: calc(100% * 2 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-2 {
        margin-right: calc(100% * 2 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-3 {
        margin-right: 0;
        margin-left: calc(100% * 3 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-3 {
        margin-right: calc(100% * 3 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-4 {
        margin-right: 0;
        margin-left: calc(100% * 4 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-4 {
        margin-right: calc(100% * 4 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-5 {
        margin-right: 0;
        margin-left: calc(100% * 5 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-5 {
        margin-right: calc(100% * 5 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-6 {
        margin-right: 0;
        margin-left: calc(100% * 6 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-6 {
        margin-right: calc(100% * 6 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-7 {
        margin-right: 0;
        margin-left: calc(100% * 7 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-7 {
        margin-right: calc(100% * 7 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-8 {
        margin-right: 0;
        margin-left: calc(100% * 8 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-8 {
        margin-right: calc(100% * 8 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-9 {
        margin-right: 0;
        margin-left: calc(100% * 9 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-9 {
        margin-right: calc(100% * 9 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-10 {
        margin-right: 0;
        margin-left: calc(100% * 10 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-10 {
        margin-right: calc(100% * 10 / 12);
        margin-left: 0;
    }
    .\\32xl\\:carina-column--offset-11 {
        margin-right: 0;
        margin-left: calc(100% * 11 / 12);
    }
    [dir='rtl'] .\\32xl\\:carina-column--offset-11 {
        margin-right: calc(100% * 11 / 12);
        margin-left: 0;
    }
    @media (min-width: 1024px) {
        .\\32xl\\:carina-row--gutter-x-compact {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\32xl\\:carina-row--gutter-y-compact {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\32xl\\:carina-row--gutter-x-default {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\32xl\\:carina-row--gutter-y-default {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\32xl\\:carina-row--gutter-x-roomy {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\32xl\\:carina-row--gutter-y-roomy {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\32xl\\:carina-row--gutter-x-0 {
            --carina-row-gutter-x: var(--carina-spacing-0);
        }
        .\\32xl\\:carina-row--gutter-y-0 {
            --carina-row-gutter-y: var(--carina-spacing-0);
        }
        .\\32xl\\:carina-row--gutter-x-2 {
            --carina-row-gutter-x: var(--carina-spacing-2);
        }
        .\\32xl\\:carina-row--gutter-y-2 {
            --carina-row-gutter-y: var(--carina-spacing-2);
        }
        .\\32xl\\:carina-row--gutter-x-4 {
            --carina-row-gutter-x: var(--carina-spacing-4);
        }
        .\\32xl\\:carina-row--gutter-y-4 {
            --carina-row-gutter-y: var(--carina-spacing-4);
        }
        .\\32xl\\:carina-row--gutter-x-6 {
            --carina-row-gutter-x: var(--carina-spacing-6);
        }
        .\\32xl\\:carina-row--gutter-y-6 {
            --carina-row-gutter-y: var(--carina-spacing-6);
        }
        .\\32xl\\:carina-row--gutter-x-8 {
            --carina-row-gutter-x: var(--carina-spacing-8);
        }
        .\\32xl\\:carina-row--gutter-y-8 {
            --carina-row-gutter-y: var(--carina-spacing-8);
        }
        .\\32xl\\:carina-row--gutter-x-10 {
            --carina-row-gutter-x: var(--carina-spacing-10);
        }
        .\\32xl\\:carina-row--gutter-y-10 {
            --carina-row-gutter-y: var(--carina-spacing-10);
        }
    }
}
.\\[\\&\\>\\*\\]\\:\\!w-full>* {
    width: 100% !important;
}
.\\[\\&\\>img\\]\\:h-full>img {
    height: 100%;
}
.\\[\\&\\>img\\]\\:w-full>img {
    width: 100%;
}
.\\[\\&\\>p\\]\\:m-0>p {
    margin: var(--carina-spacing-0);
}
.\\[\\&_a\\]\\:no-underline a {
    text-decoration-line: none;
}
.hover\\:\\[\\&_a\\]\\:underline a:hover {
    text-decoration-line: underline;
}
.odd\\:\\[--carina-background-color-surface-hover\\:var\\(--carina-background-color-surface-alt\\)\\]:nth-child(odd) {
    --carina-background-color-surface-hover: var(--carina-background-color-surface-alt) !important;
}
.even\\:\\[--carina-background-color-surface-hover\\:var\\(--carina-background-color-surface\\)\\]:nth-child(even) {
    --carina-background-color-surface-hover: var(--carina-background-color-surface) !important;
}
.visited\\:text-\\[\\#006AE1\\]:visited {
    color: rgb(0 106 225 ) !important;
}
.hover\\:scale-grow:hover {
    --tw-scale-x: var(--carina-scale-grow) !important;
    --tw-scale-y: var(--carina-scale-grow) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.hover\\:text-\\[\\#006AE1\\]:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(0 106 225 / var(--tw-text-opacity, 1)) !important;
}
.hover\\:underline:hover {
    text-decoration-line: underline !important;
}
.hover\\:duration-100:hover {
    transition-duration: var(--carina-transition-duration-100) !important;
}
.focus\\:underline:focus {
    text-decoration-line: underline !important;
}
.focus-visible\\:z-\\[calc\\(var\\(--carina-z-index-current\\)\\+1\\)\\]:focus-visible {
    z-index: calc(var(--carina-z-index-current) + 1) !important;
}
.focus-visible\\:border-b-0:focus-visible {
    border-bottom-width: var(--carina-border-width-0) !important;
}
.focus-visible\\:outline-none:focus-visible {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.focus-visible\\:outline:focus-visible {
    outline-style: solid !important;
}
.focus-visible\\:outline-0:focus-visible {
    outline-width: 0px !important;
}
.focus-visible\\:outline-\\[var\\(--carina-border-color-danger-focus\\)\\]:focus-visible {
    outline-color: var(--carina-border-color-danger-focus) !important;
}
.focus-visible\\:outline-\\[var\\(--carina-border-color-primary-focus\\)\\]:focus-visible {
    outline-color: var(--carina-border-color-primary-focus) !important;
}
.focus-visible\\:outline-primary-50:focus-visible {
    outline-color: color-mix(in srgb, var(--carina-colors-primary-50) calc(1 * 100%), transparent) !important;
}
.focus-visible\\:ring:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(var(--carina-ring-width-2) + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus-visible\\:duration-100:focus-visible {
    transition-duration: var(--carina-transition-duration-100) !important;
}
.active\\:scale-shrink:active {
    --tw-scale-x: var(--carina-scale-shrink) !important;
    --tw-scale-y: var(--carina-scale-shrink) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.active\\:duration-100:active {
    transition-duration: var(--carina-transition-duration-100) !important;
}
.group:focus-visible .group-focus-visible\\:outline-\\[var\\(--carina-border-color-primary-focus\\)\\] {
    outline-color: var(--carina-border-color-primary-focus) !important;
}
.group:focus-visible .group-focus-visible\\:duration-100 {
    transition-duration: var(--carina-transition-duration-100) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-b-0 {
    border-bottom-width: var(--carina-border-width-0) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-solid {
    border-style: solid !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-danger {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-danger) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-danger-focus {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-danger-focus) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:border-primary-focus {
    --tw-border-opacity: 1 !important;
    border-color: color-mix(in srgb, var(--carina-border-color-primary-focus) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline {
    outline-style: solid !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-2 {
    outline-width: 2px !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-offset-1 {
    outline-offset: 1px !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-\\[var\\(--carina-border-color-danger-focus\\)\\] {
    outline-color: var(--carina-border-color-danger-focus) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:outline-\\[var\\(--carina-border-color-primary-focus\\)\\] {
    outline-color: var(--carina-border-color-primary-focus) !important;
}
.peer:focus-visible ~ .peer-focus-visible\\:ring-danger {
    --tw-ring-color: var(--carina-ring-color-danger) !important;
}
@container (min-width: 640px) {
    .\\@sm\\:inline {
        display: inline !important;
    }
    .\\@sm\\:hidden {
        display: none !important;
    }
}
@media (min-width: 560px) {
    .sm\\:mt-8 {
        margin-top: var(--carina-spacing-8) !important;
    }
    .sm\\:hidden {
        display: none !important;
    }
    .sm\\:h-\\[151px\\] {
        height: 151px !important;
    }
    .sm\\:h-\\[238px\\] {
        height: 238px !important;
    }
    .sm\\:w-\\[174px\\] {
        width: 174px !important;
    }
    .sm\\:w-\\[175px\\] {
        width: 175px !important;
    }
    .sm\\:w-\\[561px\\] {
        width: 561px !important;
    }
    .sm\\:w-full {
        width: 100% !important;
    }
    .sm\\:max-w-\\[var\\(--max-wide\\)\\] {
        max-width: var(--max-wide) !important;
    }
    .sm\\:flex-row {
        flex-direction: row !important;
    }
    .sm\\:flex-col {
        flex-direction: column !important;
    }
    .sm\\:items-end {
        align-items: flex-end !important;
    }
    .sm\\:justify-end {
        justify-content: flex-end !important;
    }
    .sm\\:justify-between {
        justify-content: space-between !important;
    }
    .sm\\:p-8 {
        padding: var(--carina-spacing-8) !important;
    }
    .sm\\:px-0 {
        padding-left: var(--carina-spacing-0) !important;
        padding-right: var(--carina-spacing-0) !important;
    }
    .sm\\:px-8 {
        padding-left: var(--carina-spacing-8) !important;
        padding-right: var(--carina-spacing-8) !important;
    }
    .sm\\:px-\\[7px\\] {
        padding-left: 7px !important;
        padding-right: 7px !important;
    }
    .sm\\:pl-6 {
        padding-left: var(--carina-spacing-6) !important;
    }
    .sm\\:\\[font-size\\:var\\(--carina-font-size-display-xs\\)\\] {
        font-size: var(--carina-font-size-display-xs) !important;
    }
    .sm\\:\\[gap\\:var\\(--carina-spacing-4\\)\\] {
        gap: var(--carina-spacing-4) !important;
    }
    .sm\\:\\[line-height\\:var\\(--carina-line-height-display-xs\\)\\] {
        line-height: var(--carina-line-height-display-xs) !important;
    }
}
@media (min-width: 1080px) {
    .md\\:col-\\[2\\/3\\] {
        grid-column: 2/3 !important;
    }
    .md\\:row-start-auto {
        grid-row-start: auto !important;
    }
    .md\\:ml-\\[213px\\] {
        margin-left: 213px !important;
    }
    .md\\:block {
        display: block !important;
    }
    .md\\:hidden {
        display: none !important;
    }
    .md\\:h-\\[104px\\] {
        height: 104px !important;
    }
    .md\\:h-\\[195px\\] {
        height: 195px !important;
    }
    .md\\:max-h-\\[280px\\] {
        max-height: 280px !important;
    }
    .md\\:\\!w-\\[240px\\] {
        width: 240px !important;
    }
    .md\\:\\!w-\\[320px\\] {
        width: 320px !important;
    }
    .md\\:w-\\[416px\\] {
        width: 416px !important;
    }
    .md\\:w-\\[420px\\] {
        width: 420px !important;
    }
    .md\\:w-fit {
        width: -moz-fit-content !important;
        width: fit-content !important;
    }
    .md\\:max-w-\\[600px\\] {
        max-width: 600px !important;
    }
    .md\\:grid-rows-1 {
        grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
    }
    .md\\:flex-row {
        flex-direction: row !important;
    }
    .md\\:items-center {
        align-items: center !important;
    }
    .md\\:justify-center {
        justify-content: center !important;
    }
    .md\\:gap-y-0 {
        row-gap: var(--carina-spacing-0) !important;
    }
    .md\\:justify-self-center {
        justify-self: center !important;
    }
    .md\\:px-0 {
        padding-left: var(--carina-spacing-0) !important;
        padding-right: var(--carina-spacing-0) !important;
    }
    .md\\:px-10 {
        padding-left: var(--carina-spacing-10) !important;
        padding-right: var(--carina-spacing-10) !important;
    }
    .md\\:px-9 {
        padding-left: var(--carina-spacing-9) !important;
        padding-right: var(--carina-spacing-9) !important;
    }
    .md\\:py-6 {
        padding-top: var(--carina-spacing-6) !important;
        padding-bottom: var(--carina-spacing-6) !important;
    }
    .md\\:pb-0 {
        padding-bottom: var(--carina-spacing-0) !important;
    }
    .md\\:pb-4 {
        padding-bottom: var(--carina-spacing-4) !important;
    }
    .md\\:pl-8 {
        padding-left: var(--carina-spacing-8) !important;
    }
    .md\\:pt-0 {
        padding-top: var(--carina-spacing-0) !important;
    }
    .md\\:pt-\\[var\\(--carina-spacing-12\\)\\] {
        padding-top: var(--carina-spacing-12) !important;
    }
    .md\\:\\[gap\\:var\\(--carina-spacing-14\\)\\] {
        gap: var(--carina-spacing-14) !important;
    }
    .md\\:\\[margin-top\\:var\\(--carina-spacing-12\\)\\] {
        margin-top: var(--carina-spacing-12) !important;
    }
}
@media (min-width: 1464px) {
    .lg\\:h-\\[280px\\] {
        height: 280px !important;
    }
    .lg\\:w-\\[600px\\] {
        width: 600px !important;
    }
}
.\\[\\&\\>\\*\\]\\:\\!w-full>* {
    width: 100% !important;
}
.\\[\\&\\>img\\]\\:h-full>img {
    height: 100% !important;
}
.\\[\\&\\>img\\]\\:w-full>img {
    width: 100% !important;
}
.\\[\\&\\>p\\]\\:m-0>p {
    margin: var(--carina-spacing-0) !important;
}
.\\[\\&_a\\]\\:ml-3 a {
    margin-left: var(--carina-spacing-3) !important;
}
.\\[\\&_a\\]\\:mr-3 a {
    margin-right: var(--carina-spacing-3) !important;
}
.\\[\\&_a\\]\\:text-xs a {
    font-size: var(--carina-font-size-xs) !important;
    line-height: var(--carina-line-height-3) !important;
}
.\\[\\&_a\\]\\:font-normal a {
    font-weight: var(--carina-font-weight-normal) !important;
}
.\\[\\&_a\\]\\:leading-6 a {
    line-height: var(--carina-line-height-6) !important;
}
.\\[\\&_a\\]\\:no-underline a {
    text-decoration-line: none !important;
}
.hover\\:\\[\\&_a\\]\\:underline a:hover {
    text-decoration-line: underline !important;
}
.\\[\\&_span\\]\\:\\!text-\\[length\\:--carina-font-size-md\\] span {
    font-size: var(--carina-font-size-md) !important;
}
`, "",{"version":3,"sources":["webpack://./src/style/tailwind.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,8BAAoB;IAApB,4BAAoB;IAApB,2DAAoB;IAApB,2DAAoB;IAApB,kCAAoB;IAApB,kCAAoB;IAApB,6BAAoB;IAApB,6BAAoB;IAApB,6BAAoB;IAApB;;;;;;;;4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8EAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,8EAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,qBAAoB;IAApB,oCAAoB;IAApB,uCAAoB;IAApB,eAAoB;IAApB,kCAAoB;IAApB,2CAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,sEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,aAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;;KAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB,uCAAoB;IAApB,qCAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,sEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,cAAoB;IAApB,cAAoB;IAApB,sCAAoB;IAApB,iBAAoB;IAApB,qCAAoB;IAApB,sDAAoB;IAApB,6CAAoB;IAApB,qBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB,yEAAoB;IAApB;;GAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;;IAAA,gDAAoB;IAApB,0CAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;;;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;;IAAA,uCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;;IAAA,oCAAoB;IAApB,+DAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kDAAoB;IAApB,0CAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB,+DAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,iDAAoB;IAApB,0CAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB,+DAAoB;IAApB;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,gDAAoB;IAApB,0CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,0CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;;IAAA,+DAAoB;IAApB;AAAoB;AAApB;;IAAA,YAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;;IAAA,gCAAoB;IAApB,+CAAoB;IAApB,0CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;;;;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,4BAAoB;IAApB,8BAAoB;IAApB,6BAAoB;IAApB,oCAAoB;IAApB,mBAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,4CAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,uCAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB,mDAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,sCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,0BAAoB;IAApB,6BAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;OAAoB;IAApB;;OAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,4CAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,SAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,iBAAoB;IAApB,eAAoB;IAApB,yBAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,YAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,4CAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB,yBAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,kCAAoB;IAApB,0BAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB,sBAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,YAAoB;IAApB,qCAAoB;IAApB,eAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,UAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,8CAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,SAAoB;IAApB,SAAoB;IAApB,oCAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB,yBAAoB;IAApB,8CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kCAAoB;IAApB,0BAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,yBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB,sBAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,YAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,mBAAoB;IAApB,sEAAoB;IAApB,2CAAoB;IAApB,yEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uBAAoB;IAApB,2BAAoB;IAApB,kCAAoB;IAApB,oCAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,yCAAoB;IAApB,6CAAoB;IAApB,kBAAoB;IAApB,8BAAoB;IAApB,+CAAoB;IAApB,gBAAoB;IAApB,2CAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,SAAoB;IAApB,oBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,YAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;;IAAA,kBAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB,sBAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,oDAAoB;IAApB,mBAAoB;IAApB,+CAAoB;IAApB,0CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;;;;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB,sDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB,sDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,kCAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB,+CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB,gCAAoB;IAApB,iCAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA;;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;AAAA;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,iBAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,kBAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,0BAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,gBAAoB;IAApB,UAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,MAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA,wCAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,+BAAoB;IAApB,+BAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB,+BAAoB;IAApB,0CAAoB;IAApB,sDAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,eAAoB;IAApB,6CAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,uCAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,uCAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,YAAoB;IAApB,uCAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB,4EAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uCAAoB;IAApB,0BAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,iBAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB,UAAoB;IAApB,+CAAoB;IAApB,2CAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,kBAAoB;IAApB,QAAoB;IAApB,OAAoB;IAApB,mBAAoB;IAApB;2BAAoB;IAApB,yEAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;iEAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;;;GAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;IAAA,gBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,iBAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,gCAAoB;IAApB,4CAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,+CAAoB;IAApB,uCAAoB;IAApB,oBAAoB;IAApB,sBAAoB;IAApB,gEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;;GAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB,+BAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,oCAAoB;IAApB,uDAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,qBAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,uDAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB,oBAAoB;IAApB,oCAAoB;IAApB,iBAAoB;IAApB,gCAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;;IAAA,oCAAoB;IAApB,8DAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,qCAAoB;IAApB,wCAAoB;IAApB,oCAAoB;IAApB,uCAAoB;IAApB,8EAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,2CAAoB;IAApB,yBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB;;AAAoB;AAApB;;;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,mCAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,2BAAoB;IAApB,4CAAoB;IAApB,8CAAoB;IAApB,gEAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB;mDAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,eAAoB;IAApB,mBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,iCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,wDAAoB;IAApB,0EAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,wDAAoB;IAApB,eAAoB;IAApB,wDAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,gDAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;;IAAA,0CAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA;4CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA,kDAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,+BAAoB;IAApB,qCAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB,8CAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,yBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,qBAAoB;IAApB,iCAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,kCAAoB;IAApB,SAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,iBAAoB;IAApB,kBAAoB;IAApB,kDAAoB;IAApB;;;;;4DAAoB;IAApB,2BAAoB;IAApB,yBAAoB;IAApB,eAAoB;IAApB,gCAAoB;IAApB;;GAAoB;IAApB,yDAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,uDAAoB;IAApB;;;AAAoB;AAApB;IAAA,uDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;;;4DAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;;;4DAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sCAAoB;IAApB,uCAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,SAAoB;IAApB,+CAAoB;IAApB,qBAAoB;IAApB,kDAAoB;IAApB,yBAAoB;IAApB,eAAoB;IAApB;;;;;;AAAoB;AAApB;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sCAAoB;IAApB,kDAAoB;IAApB,gCAAoB;IAApB,8CAAoB;IAApB;;;GAAoB;IAApB,2EAAoB;IAApB,sBAAoB;IAApB,aAAoB;IAApB,uBAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,4BAAoB;IAApB,2CAAoB;IAApB,mEAAoB;IAApB;;GAAoB;IAApB,4CAAoB;IAApB;;;;;GAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yBAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,oBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,gBAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB;AAAoB;AAApB;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,uBAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,sBAAoB;IAApB,qCAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,kDAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,iEAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,sBAAoB;IAApB,gCAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,sBAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mCAAoB;IAApB,wDAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,4CAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB;2BAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;;IAAA,2CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;IAAA,gBAAoB;IAApB;AAAoB;AAApB;;;IAAA,kBAAoB;IAApB,+CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;;;;;qDAAoB;IAApB;AAAoB;AAApB;IAAA,8BAAoB;IAApB,WAAoB;IAApB;;;;;;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;;;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,wDAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,qBAAoB;IAApB,yCAAoB;IAApB;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;;IAAA,2CAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;mDAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB,eAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,sBAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,uBAAoB;IAApB,oBAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,gDAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,MAAoB;IAApB,qBAAoB;IAApB,oBAAoB;IAApB;6DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yCAAoB;IAApB;6DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,QAAoB;IAApB,cAAoB;IAApB,UAAoB;IAApB,uDAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,kBAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,UAAoB;IAApB,kBAAoB;IAApB,oBAAoB;IAApB,yBAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB,uBAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,uBAAoB;IAApB,yBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,sCAAoB;IAApB,sCAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;;;;;;;;;;;;;;;;IAAA,yDAAoB;IAApB;AAAoB;AAApB;;;;;;;;IAAA,qEAAoB;IAApB;AAAoB;AAApB;;;;;;;;;;;;;;;;IAAA,uDAAoB;IAApB;AAAoB;AAApB;;;;;;;;IAAA,mEAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;;;;;;;;;;;;;;;;;;IAAA;AAAoB;AAApB;;;;;;;;IAAA;AAAoB;AAApB;;;;;;;;;IAAA;AAAoB;AAApB;;;;;;;;;IAAA;AAAoB;AAApB;;;;;;;;;;;;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,4BAAoB;IAApB,6BAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+BAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;;KAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;KAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;KAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,kCAAoB;IAApB,SAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,sBAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA;;;;OAAoB;IAApB;AAAoB;AAApB;IAAA;;;;OAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wBAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,YAAoB;IAApB,8DAAoB;IAApB,6CAAoB;IAApB,8CAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,OAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,2DAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,6CAAoB;IAApB;;;;;GAAoB;IAApB;;;;mEAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB;;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,mCAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB;;;;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,2CAAoB;IAApB,mBAAoB;IAApB,uDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,4CAAoB;IAApB;mEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oEAAoB;IAApB;qDAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;qDAAoB;IAApB,kBAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,OAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,sDAAoB;IAApB;AAAoB;AAApB;IAAA,qDAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,eAAoB;IAApB,MAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,gEAAoB;IAApB;;KAAoB;IAApB;;;AAAoB;AAApB;IAAA,gEAAoB;IAApB;;KAAoB;IAApB;;;AAAoB;AAApB;IAAA,oCAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,SAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB,wDAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,gBAAoB;IAApB,sDAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;;IAAA;;GAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;;GAAoB;IAApB,iCAAoB;IAApB,gDAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;;;;IAAA,uDAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,YAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,YAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,+BAAoB;IAApB,wDAAoB;IAApB,SAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,UAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,2CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB,6BAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB,oCAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA;;;;GAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,WAAoB;IAApB,iBAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,qBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,qBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,qBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,qBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,qBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,qBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,qBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,qBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,iBAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,iBAAoB;IAApB,yBAAoB;IAApB,6DAAoB;IAApB,iBAAoB;IAApB,uDAAoB;IAApB,qBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,iBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,oEAAoB;IAApB;AAAoB;AAApB;IAAA,oEAAoB;IAApB;AAAoB;AAApB;IAAA,oEAAoB;IAApB;AAAoB;AAApB;IAAA,oEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,yCAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,eAAoB;IAApB,4CAAoB;IAApB,oCAAoB;IAApB,4CAAoB;IAApB,wCAAoB;IAApB,mCAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,WAAoB;IAApB,2CAAoB;IAApB,gBAAoB;IAApB,oCAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yCAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sCAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,gCAAoB;IAApB,iBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;;IAAA,cAAoB;IAApB;AAAoB;AAApB;;IAAA,cAAoB;IAApB;AAAoB;AAApB,yBAAoB;AAApB;IAAA,6CAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;;;;;;;;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+BAAoB;IAApB,gCAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,sCAAoB;IAApB,6CAAoB;IAApB,gCAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB;;OAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB,wCAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,sCAAoB;IAApB,yCAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,uCAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yCAAoB;IAApB,QAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;;IAAA;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA,qBAAoB;IAApB,0DAAoB;IAApB,mCAAoB;IAApB,+DAAoB;IAApB,wCAAoB;IAApB,mBAAoB;IAApB,4BAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,cAAoB;IAApB,aAAoB;IAApB,gBAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yCAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,4BAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oDAAoB;IAApB,oBAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB,SAAoB;IAApB,6BAAoB;IAApB,sEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,iDAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,OAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,QAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,kBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,oDAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB,UAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,4BAAoB;IAApB,UAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2BAAoB;IAApB,YAAoB;IAApB,4BAAoB;IAApB,UAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,2BAAoB;IAApB,+BAAoB;IAApB,4BAAoB;IAApB,SAAoB;IAApB,YAAoB;IAApB,6BAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,wBAAoB;IAApB,0BAAoB;IAApB,+DAAoB;IAApB,+CAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;;;IAAA,0DAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,2DAAoB;IAApB;AAAoB;AAApB;IAAA,2DAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,+CAAoB;IAApB,6DAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,sCAAoB;IAApB,sCAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,oCAAoB;IAApB,mBAAoB;IAApB,oBAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sCAAoB;IAApB,6CAAoB;IAApB,oBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,gDAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uCAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,sEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,8BAAoB;IAApB,eAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB,gBAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,uCAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,kDAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB,4EAAoB;IAApB;;GAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB,+CAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;;GAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB,sBAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,uCAAoB;IAApB,0CAAoB;IAApB,iBAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,2BAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mEAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,gCAAoB;IAApB,SAAoB;IAApB,uCAAoB;IAApB,oBAAoB;IAApB,mBAAoB;IAApB,2CAAoB;IAApB,mBAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB,4EAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB,+CAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,2EAAoB;IAApB,uCAAoB;IAApB,oBAAoB;IAApB,mBAAoB;IAApB,2CAAoB;IAApB,mBAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB,4EAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,yCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,yBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,eAAoB;IAApB,yBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,gBAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,uBAAoB;IAApB,8CAAoB;IAApB;2BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,2BAAoB;IAApB,eAAoB;IAApB,sCAAoB;IAApB,kBAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,cAAoB;IAApB,qBAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,uDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,gCAAoB;IAApB,6EAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB;;;GAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,6EAAoB;IAApB,eAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;;IAAA;;;GAAoB;IAApB,uEAAoB;IAApB;AAAoB;AAApB;IAAA,wEAAoB;IAApB;;;;AAAoB;AAApB;IAAA,yEAAoB;IAApB;;;;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,gCAAoB;IAApB,eAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,kDAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,yEAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wEAAoB;IAApB;;;;AAAoB;AAApB;IAAA,yEAAoB;IAApB;;;;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wDAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,2EAAoB;IAApB,uCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,oBAAoB;IAApB,kDAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,+CAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,2DAAoB;IAApB,mDAAoB;IAApB;AAAoB;AAApB;IAAA,0BAAoB;IAApB;AAAoB;AAApB;;IAAA,uDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,eAAoB;IAApB,mBAAoB;IAApB,yBAAoB;IAApB,oCAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,6BAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,0DAAoB;IAApB,SAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,oBAAoB;IAApB,uDAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,2CAAoB;IAApB,yBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,6CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,gBAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB,uBAAoB;IAApB,kDAAoB;IAApB,oBAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,gBAAoB;IAApB,aAAoB;IAApB,8BAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB,8CAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,iDAAoB;IAApB,4DAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB,sCAAoB;IAApB,qDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,kCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,kCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA,kCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,eAAoB;IAApB,4BAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,SAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,wBAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA,aAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB,oBAAoB;IAApB,sCAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,cAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,uCAAoB;IAApB,eAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,eAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gCAAoB;IAApB,6CAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB,SAAoB;IAApB,uBAAoB;IAApB,eAAoB;IAApB,cAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,+BAAoB;IAApB;mDAAoB;IAApB,mBAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sCAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yBAAoB;IAApB,SAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;2BAAoB;IAApB,gCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,oCAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sEAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kEAAoB;IAApB,sEAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,sEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kCAAoB;IAApB,WAAoB;IAApB,sBAAoB;IAApB,SAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2BAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;IAAA,8BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,kBAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,gBAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,qBAAoB;IAApB,4CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,wCAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,8BAAoB;IAApB,+BAAoB;IAApB,6CAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB,kEAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;;;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gDAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,kCAAoB;IAApB,+CAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gDAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,kCAAoB;IAApB,+CAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,wCAAoB;IAApB,iEAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,WAAoB;IAApB,sBAAoB;IAApB,SAAoB;IAApB,UAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,4CAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,+CAAoB;IAApB,6BAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,wDAAoB;IAApB,wBAAoB;IAApB;;AAAoB;AAApB;IAAA,6CAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,iDAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB,wBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,sBAAoB;IAApB,kCAAoB;IAApB,uCAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,kDAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;;KAAoB;IAApB,0DAAoB;IAApB,iCAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;8DAAoB;IAApB;mDAAoB;IAApB,yBAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB;uDAAoB;IAApB,cAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB,iBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,6BAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yBAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,4DAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+BAAoB;IAApB;mDAAoB;IAApB;0DAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;;;gEAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB;;2BAAoB;IAApB;0DAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB,sCAAoB;IAApB,uCAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,oBAAoB;IAApB,YAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,oCAAoB;IAApB,yCAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB,SAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;;IAAA,cAAoB;IAApB,qCAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,uCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uBAAoB;IAApB,kBAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB,gBAAoB;IAApB,yCAAoB;IAApB,+CAAoB;IAApB,uCAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB,UAAoB;IAApB,8CAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,SAAoB;IAApB,gCAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,2CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,sBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,sBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,sBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB;IAAoB;IAApB;QAAA,sBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sCAAoB;IAApB,iBAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,YAAoB;IAApB,iBAAoB;IAApB,yBAAoB;IAApB,gEAAoB;IAApB,iBAAoB;IAApB,uDAAoB;IAApB,qBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,uEAAoB;IAApB,qBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,uEAAoB;IAApB,qBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,YAAoB;IAApB,SAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,kDAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,eAAoB;IAApB,kCAAoB;IAApB,qDAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,iDAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,uDAAoB;IAApB,eAAoB;IAApB,4BAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB,sBAAoB;IAApB,kCAAoB;IAApB,gBAAoB;IAApB,iBAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB,wDAAoB;IAApB,aAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,gCAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,yCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,YAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;;AAAoB;AAApB;IAAA,gDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,iBAAoB;IAApB;;AAAoB;AAApB;IAAA,gDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,4DAAoB;IAApB,SAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,eAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,qCAAoB;IAApB,sCAAoB;IAApB,4CAAoB;IAApB,0CAAoB;IAApB;;;;GAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+CAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB;;;;;KAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB;;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,qBAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wDAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB,WAAoB;IAApB,4CAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,uDAAoB;IAApB,2BAAoB;IAApB;AAAoB;AAApB;IAAA;mDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,YAAoB;IAApB,uDAAoB;IAApB;mDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2EAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,+BAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,QAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,wDAAoB;IAApB,uDAAoB;IAApB,qDAAoB;IAApB;mCAAoB;IAApB;AAAoB;AAApB;IAAA,2BAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,wBAAoB;IAApB,mBAAoB;IAApB,wCAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,yDAAoB;IAApB,gCAAoB;IAApB,2CAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,eAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,UAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,4DAAoB;IAApB,6CAAoB;IAApB,yDAAoB;IAApB,kBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yDAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,uCAAoB;IAApB,gCAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,qEAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,wDAAoB;IAApB,qDAAoB;IAApB,kEAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,wDAAoB;IAApB,+DAAoB;IAApB,yEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,kDAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,uBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;qDAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mCAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,aAAoB;IAApB,wDAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,MAAoB;IAApB,WAAoB;IAApB,qDAAoB;IAApB,8BAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,2EAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+BAAoB;IAApB,wDAAoB;IAApB,YAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,+BAAoB;IAApB,gDAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,oCAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,sDAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB,sBAAoB;IAApB,+CAAoB;IAApB,4DAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,gCAAoB;IAApB,uDAAoB;IAApB,qDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,iCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,YAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,uDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB,uDAAoB;IAApB,qDAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,uCAAoB;IAApB,wDAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB;4CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,uCAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB,uCAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,aAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,+BAAoB;IAApB,kCAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,+CAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,oCAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,mDAAoB;IAApB,yEAAoB;IAApB,aAAoB;IAApB;SAAoB;IAApB,6BAAoB;IAApB,0BAAoB;IAApB,4DAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,mCAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,mBAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,4DAAoB;IAApB,6CAAoB;IAApB,yDAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB,iDAAoB;IAApB,gDAAoB;IAApB,mDAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB,wDAAoB;IAApB,uCAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,wBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;mDAAoB;IAApB;AAAoB;AAApB;IAAA,oDAAoB;IAApB,sDAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB,gDAAoB;IAApB,mDAAoB;IAApB,8CAAoB;IAApB,2BAAoB;IAApB,sBAAoB;IAApB;;;GAAoB;IAApB,oCAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;;IAAA,+BAAoB;IAApB,gBAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,wDAAoB;IAApB,WAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,uBAAoB;IAApB,gBAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wDAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,4DAAoB;IAApB,6DAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,4DAAoB;IAApB;mDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB;iEAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;IAAA,wDAAoB;IAApB;AAAoB;AAApB;;;;;IAAA,iEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,uCAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6BAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,aAAoB;IAApB,4BAAoB;IAApB,mBAAoB;IAApB,2BAAoB;IAApB,+CAAoB;IAApB,2CAAoB;IAApB,oCAAoB;IAApB,uCAAoB;IAApB,kBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,2BAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,+CAAoB;IAApB,kBAAoB;IAApB,cAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB,eAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,aAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,iEAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,4DAAoB;IAApB,6CAAoB;IAApB,kBAAoB;IAApB,cAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kCAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,uDAAoB;IAApB,wDAAoB;IAApB,sBAAoB;IAApB;;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,iBAAoB;IAApB,4CAAoB;IAApB,UAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,8CAAoB;IAApB,2CAAoB;IAApB,aAAoB;IAApB;;AAAoB;AAApB;IAAA,0CAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,cAAoB;IAApB,8EAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,gBAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,4DAAoB;IAApB,6CAAoB;IAApB,yDAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB,0DAAoB;IAApB,0DAAoB;IAApB,8DAAoB;IAApB;;;;GAAoB;IAApB,mBAAoB;IAApB,aAAoB;IAApB,6EAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,uCAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,uBAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;;IAAA;aAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB;AAAoB;AAApB;IAAA,8BAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;;IAAA,4BAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,4BAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,aAAoB;IAApB,yBAAoB;IAApB,8BAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB,8CAAoB;IAApB,gDAAoB;IAApB,mDAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB,wDAAoB;IAApB,uCAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,0BAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;mDAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB,8CAAoB;IAApB,gDAAoB;IAApB,mDAAoB;IAApB,8CAAoB;IAApB,sDAAoB;IAApB,wDAAoB;IAApB,uDAAoB;IAApB,2BAAoB;IAApB,wBAAoB;IAApB,qEAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;;IAAA;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,gBAAoB;IAApB;4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mCAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,6CAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB,eAAoB;IAApB,uBAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB;;;AAAoB;AAApB;IAAA,2BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,6BAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,4DAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,cAAoB;IAApB,4DAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,gBAAoB;IAApB;iEAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;;IAAA,+DAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB,WAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,8CAAoB;IAApB,sCAAoB;IAApB,yCAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,wDAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,UAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,6BAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;mDAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,kBAAoB;IAApB,eAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,6CAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,4DAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,4DAAoB;IAApB,kBAAoB;IAApB,cAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kCAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,cAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mBAAoB;IAApB,iBAAoB;IAApB,sBAAoB;IAApB,kCAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,0DAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB,YAAoB;IAApB,wDAAoB;IAApB,cAAoB;IAApB,8CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;wCAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,cAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB,8CAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,2BAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,0CAAoB;IAApB,qBAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,YAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,2BAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB,qBAAoB;IAApB,eAAoB;IAApB;;KAAoB;IAApB,0DAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uCAAoB;IAApB,4CAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;;;;IAAA,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,+BAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,YAAoB;IAApB,+BAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,iDAAoB;IAApB,uCAAoB;IAApB,2BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qBAAoB;IAApB,WAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB,qBAAoB;IAApB;;KAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;wCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,kDAAoB;IAApB,4CAAoB;IAApB,sBAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,uCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,4CAAoB;IAApB,iBAAoB;IAApB,mBAAoB;IAApB,yBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,mDAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oCAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,sBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,aAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+DAAoB;IAApB;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;;;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,6CAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,2CAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA,QAAoB;QAApB;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,QAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,QAAoB;QAApB;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,QAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,QAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,oCAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;mCAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;;gEAAoB;IAApB;AAAoB;AAApB;IAAA;;gEAAoB;IAApB;AAAoB;AAApB;IAAA;mDAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,wDAAoB;IAApB,gBAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB,yBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,2CAAoB;IAApB,oCAAoB;IAApB,gCAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,2BAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,iBAAoB;IAApB,qBAAoB;IAApB;;KAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;wCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iEAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,8BAAoB;IAApB,YAAoB;IAApB,4DAAoB;IAApB,WAAoB;IAApB,qBAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,2BAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,sBAAoB;IAApB,2CAAoB;IAApB,gBAAoB;IAApB,8DAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,YAAoB;IAApB;mCAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,8BAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,eAAoB;IAApB;;;;;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,OAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,kDAAoB;IAApB,iCAAoB;IAApB;;;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,sCAAoB;IAApB;2BAAoB;IAApB;mCAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,sBAAoB;IAApB,gBAAoB;IAApB,oCAAoB;IAApB,gCAAoB;IAApB,0EAAoB;IAApB,6CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,kCAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,yBAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,+CAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,kBAAoB;IAApB,oBAAoB;IAApB,gBAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,+CAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,WAAoB;IAApB,+CAAoB;IAApB,4DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA,OAAoB;QAApB,UAAoB;QAApB;IAAoB;IAApB;QAAA,SAAoB;QAApB,UAAoB;QAApB;IAAoB;IAApB;QAAA,OAAoB;QAApB,UAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;;;;;;;IAAoB;IAApB;QAAA;;;;;;;IAAoB;IAApB;QAAA;;;;;;;IAAoB;AAAA;AAApB;IAAA,kBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,WAAoB;IAApB,WAAoB;IAApB,oCAAoB;IAApB,+CAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,+CAAoB;IAApB,yBAAoB;IAApB,kCAAoB;IAApB;;;;AAAoB;AAApB;IAAA;;;;;;;;;;;;;;;;;;;;;;;GAAoB;IAApB;;;AAAoB;AAApB;IAAA;;;;;GAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;AAAA;AAApB;IAAA,yBAAoB;IAApB;AAAoB;AAApB;IAAA;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;AAAA;AAApB;IAAA,gBAAoB;IAApB;;;GAAoB;IAApB,0CAAoB;IAApB;;GAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,SAAoB;IAApB,sDAAoB;IAApB,sBAAoB;IAApB,4CAAoB;IAApB;+BAAoB;AAAA;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA,2DAAoB;QAApB;;;KAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,gDAAoB;QAApB;;;;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA,mBAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,iDAAoB;IAApB,qDAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,MAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB,yCAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,kBAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,mBAAoB;IAApB,oBAAoB;IAApB,qBAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,gBAAoB;IAApB,qCAAoB;IAApB,oBAAoB;IAApB,kBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,yBAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB,6CAAoB;IAApB;;;;cAAoB;IAApB,2CAAoB;IAApB,2BAAoB;IAApB;;AAAoB;AAApB;IAAA,uBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,0CAAoB;IAApB,sCAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,OAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB,WAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,gDAAoB;IAApB,oDAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,eAAoB;IAApB,MAAoB;IAApB,6CAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,OAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,oDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB,WAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,sCAAoB;IAApB,yCAAoB;IAApB,kCAAoB;IAApB,iCAAoB;IAApB,0CAAoB;IAApB,wCAAoB;IAApB,mCAAoB;IAApB,4CAAoB;IAApB,4CAAoB;IAApB,qCAAoB;IAApB,+CAAoB;IAApB,iCAAoB;IAApB,uCAAoB;IAApB,wCAAoB;IAApB,iCAAoB;IAApB,gCAAoB;IAApB,iCAAoB;IAApB,gCAAoB;IAApB,iCAAoB;IAApB,gCAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,gCAAoB;IAApB,yCAAoB;IAApB,iCAAoB;IAApB,oCAAoB;IAApB,+BAAoB;IAApB,kBAAoB;IAApB,MAAoB;IAApB,eAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB;;;GAAoB;IAApB,WAAoB;IAApB;;;;GAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA,2DAAoB;QAApB,sBAAoB;QAApB,4CAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,sCAAoB;QAApB,kBAAoB;QAApB,YAAoB;QAApB,sDAAoB;QAApB,WAAoB;QAApB,QAAoB;QAApB,wCAAoB;QAApB;;IAAoB;IAApB;QAAA,uDAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA,mBAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB,0CAAoB;QAApB,4CAAoB;QAApB;;IAAoB;IAApB;QAAA,2CAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,qDAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;;AAAoB;AAApB;IAAA,gBAAoB;IAApB,MAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,sDAAoB;IAApB,0DAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB;;;GAAoB;IAApB,aAAoB;IAApB,aAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,gDAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB,qBAAoB;IAApB,6BAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,gBAAoB;IAApB,qCAAoB;IAApB,oBAAoB;IAApB,kBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,yBAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,qDAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,sCAAoB;IAApB,WAAoB;IAApB;;AAAoB;AAApB;IAAA,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,+OAAoB;IAApB,sCAAoB;IAApB;;;;8CAAoB;IAApB;;;;GAAoB;IAApB;;AAAoB;AAApB;IAAA,uBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,qBAAoB;IAApB,SAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,aAAoB;IAApB,sCAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,OAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB,WAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,oDAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;;KAAoB;IAApB,WAAoB;IAApB;;AAAoB;AAApB;IAAA,mBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,0CAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,OAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB;AAAoB;AAApB;IAAA,oDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,QAAoB;IAApB,WAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,2CAAoB;IAApB,oCAAoB;IAApB,6CAAoB;IAApB,sCAAoB;IAApB,yCAAoB;IAApB,kCAAoB;IAApB,iCAAoB;IAApB,8CAAoB;IAApB,uCAAoB;IAApB,sCAAoB;IAApB,0CAAoB;IAApB,0CAAoB;IAApB,mCAAoB;IAApB,6CAAoB;IAApB,4CAAoB;IAApB,4CAAoB;IAApB,qCAAoB;IAApB,+CAAoB;IAApB,yCAAoB;IAApB,kCAAoB;IAApB,iCAAoB;IAApB,iCAAoB;IAApB,uCAAoB;IAApB,wCAAoB;IAApB,iCAAoB;IAApB,gCAAoB;IAApB,kBAAoB;IAApB,MAAoB;IAApB,eAAoB;IAApB,aAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;;QAAA;IAAoB;AAAA;AAApB;IAAA,kBAAoB;IAApB,qBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,sCAAoB;IAApB,0BAAoB;IAApB;;GAAoB;IAApB,mDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB,qCAAoB;IAApB,sCAAoB;IAApB,oCAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB,kBAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,uDAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,uDAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,mCAAoB;IAApB,qCAAoB;IAApB,sCAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gCAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yBAAoB;IAApB,OAAoB;IAApB,iDAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0BAAoB;IAApB,iDAAoB;IAApB,sBAAoB;IAApB,UAAoB;IAApB,gBAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yBAAoB;IAApB,OAAoB;IAApB,iDAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,yBAAoB;IAApB,iDAAoB;IAApB,aAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,eAAoB;IAApB,sBAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,iBAAoB;IAApB,6BAAoB;IAApB,UAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,wCAAoB;IAApB,iDAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,kDAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB,YAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,iDAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,oBAAoB;IAApB,wDAAoB;IAApB,+CAAoB;IAApB,uCAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,kBAAoB;IAApB,wDAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,gDAAoB;IAApB,2DAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,wDAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,8CAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA,aAAoB;IAApB,mBAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,kBAAoB;IAApB,YAAoB;IAApB,gCAAoB;IAApB,YAAoB;IAApB,uBAAoB;IAApB,iBAAoB;IAApB,eAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,wDAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB,gBAAoB;IAApB,uBAAoB;IAApB,oBAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB,qBAAoB;IAApB,4BAAoB;IAApB,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,uBAAoB;IAApB,mBAAoB;IAApB,YAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;;IAAA,WAAoB;IAApB,WAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2DAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB,sBAAoB;IAApB,+CAAoB;IAApB,aAAoB;IAApB,uBAAoB;IAApB,mBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0EAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;gDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB,oBAAoB;IAApB,WAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kDAAoB;IAApB,yBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,+BAAoB;IAApB,YAAoB;IAApB,WAAoB;IAApB,uBAAoB;IAApB,gCAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,wDAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,kBAAoB;IAApB,YAAoB;IAApB,uDAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB,qCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,gBAAoB;IAApB,uBAAoB;IAApB,oBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,yBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,UAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0CAAoB;IAApB,oCAAoB;IAApB,kBAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB,sBAAoB;IAApB,+CAAoB;IAApB,aAAoB;IAApB,uBAAoB;IAApB,mBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4DAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;;IAAA,0EAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,0EAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;gDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB,wCAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB,qCAAoB;IAApB,oCAAoB;IAApB,qDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,uBAAoB;IAApB,gCAAoB;IAApB,gBAAoB;IAApB,aAAoB;IAApB,YAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB,qCAAoB;IAApB,yBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8BAAoB;IAApB,YAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,+BAAoB;IAApB,8BAAoB;IAApB,gBAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,SAAoB;IAApB,2DAAoB;IAApB;AAAoB;AAApB;;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;mDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gEAAoB;IAApB,gEAAoB;IAApB,6DAAoB;IAApB,6EAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,iEAAoB;IAApB,8DAAoB;IAApB,yCAAoB;IAApB,mCAAoB;IAApB;;GAAoB;IAApB,2EAAoB;IAApB;;GAAoB;IAApB,mBAAoB;IAApB,WAAoB;IAApB,yBAAoB;IAApB,iBAAoB;IAApB,mCAAoB;IAApB,sCAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,0CAAoB;IAApB,gDAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;;;;IAAA,gEAAoB;IAApB;AAAoB;AAApB;;;;IAAA,4CAAoB;IAApB,6CAAoB;IAApB,uDAAoB;IAApB,WAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,SAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;;;;IAAA,8DAAoB;IAApB;AAAoB;AAApB;;;;IAAA,4CAAoB;IAApB,6CAAoB;IAApB,uDAAoB;IAApB,WAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,SAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA,8DAAoB;IAApB;AAAoB;AAApB;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA,4CAAoB;IAApB,6CAAoB;IAApB,uDAAoB;IAApB,WAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,YAAoB;IAApB,wBAAoB;IAApB;AAAoB;AAApB;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA,4DAAoB;IAApB;AAAoB;AAApB;;;;;;;;;;;;;;;;;;;;;;;;;;;IAAA,4CAAoB;IAApB,6CAAoB;IAApB,uDAAoB;IAApB,WAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,YAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;;;;;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB,oEAAoB;IAApB,0BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;iDAAoB;IAApB,mBAAoB;IAApB,kDAAoB;IAApB,uDAAoB;IAApB;8CAAoB;IAApB,sBAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,iEAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,wEAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,YAAoB;IAApB;kDAAoB;IAApB;;;OAAoB;IAApB,oEAAoB;IAApB,0BAAoB;IAApB;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,yDAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,0CAAoB;IAApB;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,gDAAoB;IAApB,YAAoB;IAApB;;AAAoB;AAApB;;IAAA,YAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,YAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,qBAAoB;IAApB,aAAoB;IAApB,eAAoB;IAApB,kBAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;;;WAAoB;IAApB,gEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB,qBAAoB;IAApB,2BAAoB;IAApB,6DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,WAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,6CAAoB;IAApB,sBAAoB;IAApB,6CAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;KAAoB;IAApB;;KAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;;IAAA,wDAAoB;IAApB,oDAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;;IAAA;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;AAAoB;AAApB;IAAA;;;;AAAoB;AAApB;IAAA;;;;;;AAAoB;AAApB;IAAA,2BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA,0DAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,mBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,8CAAoB;IAApB,6CAAoB;IAApB,iDAAoB;IAApB,gBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,mEAAoB;IAApB,0BAAoB;IAApB;AAAoB;AAApB;IAAA,mEAAoB;IAApB,0BAAoB;IAApB;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;IAAA,uBAAoB;IAApB;8CAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,iBAAoB;IAApB,sBAAoB;IAApB;iDAAoB;IAApB,mBAAoB;IAApB,kDAAoB;IAApB,uDAAoB;IAApB,iDAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,aAAoB;IAApB,8BAAoB;IAApB,2EAAoB;IAApB,oCAAoB;IAApB,8CAAoB;IAApB,iBAAoB;IAApB,sBAAoB;IAApB,kDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;gBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,qCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB,6CAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB,+BAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,aAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,gCAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,oCAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,4DAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB,+CAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,6CAAoB;IAApB,cAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB;AAAoB;AAApB;IAAA,kDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,oDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;;IAAA,uEAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,YAAoB;IAApB,mBAAoB;IAApB,mCAAoB;IAApB,2CAAoB;IAApB,kBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,iBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oDAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gEAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;;;;;;IAAA;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uBAAoB;IAApB,uEAAoB;IAApB,8BAAoB;IAApB,6DAAoB;IAApB;iCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qBAAoB;IAApB,yEAAoB;IAApB,gCAAoB;IAApB,+DAAoB;IAApB;kCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,MAAoB;IAApB;AAAoB;AAApB;IAAA,SAAoB;IAApB;AAAoB;AAApB;;;;IAAA;AAAoB;AAApB;IAAA,eAAoB;IAApB,iBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,WAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,oCAAoB;IAApB,0CAAoB;IAApB,6BAAoB;IAApB,aAAoB;IAApB,gBAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,qBAAoB;IAApB,YAAoB;IAApB,wDAAoB;IAApB,WAAoB;IAApB,oBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB,6EAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,gBAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,UAAoB;IAApB,SAAoB;IAApB,6BAAoB;IAApB,aAAoB;IAApB,gBAAoB;IAApB,gCAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,4EAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,YAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,0CAAoB;IAApB,8CAAoB;IAApB,wDAAoB;IAApB,oCAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,WAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,4BAAoB;IAApB,mBAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA,6CAAoB;IAApB,wCAAoB;IAApB,gEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,yBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,wCAAoB;IAApB,iEAAoB;IAApB;AAAoB;AAApB;IAAA,oDAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,8EAAoB;IAApB;mCAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,cAAoB;IAApB,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,0CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,YAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,gBAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,uBAAoB;IAApB,kBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,oBAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB,aAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,kBAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iDAAoB;IAApB,WAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;;;;;IAAA;AAAoB;AAApB;;;;;;;;;IAAA,mDAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB,+CAAoB;IAApB;AAAoB;AAApB;;;;IAAA,iDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;mCAAoB;IAApB;;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iDAAoB;IAApB;8CAAoB;IAApB,WAAoB;IAApB,gCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iDAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,WAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8EAAoB;IAApB;mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8EAAoB;IAApB;;AAAoB;AAApB;IAAA,2EAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,gBAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,mBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,eAAoB;IAApB,wDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,eAAoB;IAApB,6CAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,iDAAoB;IAApB,kCAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,iDAAoB;IAApB,kCAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,MAAoB;IAApB,SAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,uCAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,6CAAoB;IAApB,8CAAoB;IAApB,qCAAoB;IAApB,oCAAoB;IAApB,SAAoB;IAApB,+DAAoB;IAApB,6BAAoB;IAApB,aAAoB;IAApB,gBAAoB;IAApB,eAAoB;IAApB,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,iCAAoB;IAApB;AAAoB;AAApB;;IAAA,iCAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,iDAAoB;IAApB,gCAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,+BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,oBAAoB;IAApB,YAAoB;IAApB,mBAAoB;IAApB,iBAAoB;IAApB,yBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,6BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,cAAoB;IAApB,YAAoB;IAApB,oBAAoB;IAApB,mBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB;mCAAoB;IAApB,gBAAoB;IAApB,mBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;;IAAA,kBAAoB;IAApB,eAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,0CAAoB;IAApB,wDAAoB;IAApB,oCAAoB;IAApB,gBAAoB;IAApB,0BAAoB;IAApB,iDAAoB;IAApB,6CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,QAAoB;IAApB;mCAAoB;IAApB,gBAAoB;IAApB,0BAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA,OAAoB;IAApB,sBAAoB;IAApB;mCAAoB;IAApB,gBAAoB;IAApB,0BAAoB;IAApB,iDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,8BAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB,gBAAoB;IAApB,cAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,SAAoB;IAApB,6CAAoB;IAApB,uBAAoB;IAApB,oCAAoB;IAApB,oBAAoB;IAApB,oBAAoB;IAApB,0CAAoB;IAApB,mBAAoB;IAApB,kBAAoB;IAApB,qBAAoB;IAApB,sBAAoB;IAApB,+CAAoB;IAApB,uDAAoB;IAApB,oBAAoB;IAApB,2CAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,kCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,UAAoB;IAApB,SAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,oCAAoB;IAApB,sDAAoB;IAApB,uDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB,oCAAoB;IAApB,2BAAoB;IAApB,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;;IAAA,0CAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA,0CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB,0DAAoB;IAApB;AAAoB;AAApB;IAAA,4CAAoB;IAApB,yDAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,eAAoB;IAApB,2BAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,eAAoB;IAApB,+BAAoB;IAApB,6CAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,cAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB,iBAAoB;IAApB,+BAAoB;IAApB,gCAAoB;IAApB,0EAAoB;IAApB,6CAAoB;IAApB,cAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,eAAoB;IAApB;2BAAoB;IAApB,6EAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,aAAoB;IAApB,cAAoB;IAApB,WAAoB;IAApB;;AAAoB;AAApB;IAAA,4BAAoB;IAApB,oBAAoB;IAApB,cAAoB;IAApB,+BAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,+BAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB;AAAoB;AAApB;IAAA,iBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB,2BAAoB;IAApB,YAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,oCAAoB;IAApB;AAAoB;AAApB;IAAA,WAAoB;IAApB,YAAoB;IAApB;AAAoB;AAApB;IAAA,UAAoB;IAApB;AAAoB;AAApB;;IAAA;AAAoB;AAApB;IAAA,4DAAoB;IAApB,sCAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB,2CAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB,4CAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB,gBAAoB;IAApB,sCAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,sCAAoB;IAApB,wCAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB,gBAAoB;IAApB,4DAAoB;IAApB,oCAAoB;IAApB,2CAAoB;IAApB,qCAAoB;IAApB,8CAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,cAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,MAAoB;IAApB,QAAoB;IAApB,SAAoB;IAApB,OAAoB;IAApB;AAAoB;AAApB;IAAA,YAAoB;IAApB,gBAAoB;IAApB,mEAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,aAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,QAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,4DAAoB;IAApB,6CAAoB;IAApB,mBAAoB;IAApB,0CAAoB;IAApB,6CAAoB;IAApB,mEAAoB;IAApB,2CAAoB;IAApB,8CAAoB;IAApB,6CAAoB;IAApB,wDAAoB;IAApB,eAAoB;IAApB;;GAAoB;IAApB;;GAAoB;IAApB,gDAAoB;IAApB;AAAoB;AAApB;IAAA,eAAoB;IAApB,6CAAoB;IAApB,oBAAoB;IAApB,+CAAoB;IAApB,4CAAoB;IAApB,oBAAoB;IAApB;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,6CAAoB;IAApB,wDAAoB;IAApB,gBAAoB;IAApB;AAAoB;AAApB;IAAA,aAAoB;IAApB,sBAAoB;IAApB,WAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,wDAAoB;IAApB,yDAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB,SAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,UAAoB;IAApB,aAAoB;IAApB,mBAAoB;IAApB,uBAAoB;IAApB,WAAoB;IAApB,YAAoB;IAApB,+CAAoB;IAApB,0CAAoB;IAApB,wDAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;;;;AAAoB;AAApB;IAAA;;;OAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;;;;AAAoB;AAApB;IAAA,WAAoB;IAApB;;;;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;;;;AAAoB;AAApB;IAAA;;;OAAoB;IAApB;AAAoB;AAApB;IAAA;;;KAAoB;IAApB;;;;AAAoB;AAApB;IAAA,WAAoB;IAApB;;;;AAAoB;AAApB;IAAA,cAAoB;IAApB,eAAoB;IAApB;AAAoB;AAApB;IAAA,cAAoB;IAApB;AAAoB;AAApB;;;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB,UAAoB;IAApB,WAAoB;IAApB,UAAoB;IAApB,YAAoB;IAApB,gBAAoB;IAApB,sBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,4BAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gDAAoB;IAApB;AAAoB;AAApB;IAAA,oCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,mCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,8CAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,qDAAoB;IAApB;AAAoB;AAApB;IAAA,yCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,yBAAoB;IAApB,sBAAoB;IAApB;AAAoB;AAApB;IAAA,wBAAoB;IAApB,qBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,gBAAoB;IAApB,uBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,uDAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,qEAAoB;IAApB;AAAoB;AAApB;IAAA,yDAAoB;IAApB;AAAoB;AAApB;IAAA,2DAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA,kBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,sCAAoB;IAApB;AAAoB;AAApB;IAAA,qDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2CAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA,qCAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,wCAAoB;IAApB,gDAAoB;IAApB;AAAoB;AAApB;IAAA,iIAAoB;IAApB,2DAAoB;IAApB;AAAoB;AAApB;IAAA,wCAAoB;IAApB,gDAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,2GAAoB;IAApB,gIAAoB;IAApB;AAAoB;AAApB;IAAA,oBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA,sBAAoB;IAApB;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA,qDAAoB;QAApB;;OAAoB;QAApB;;;IAAoB;IAApB;QAAA,gBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,cAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;QAApB,oDAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,cAAoB;QAApB,YAAoB;QAApB,UAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA,qBAAoB;QAApB;IAAoB;IAApB;;QAAA,YAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;QAApB,oDAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,gCAAoB;QAApB,wBAAoB;QAApB,sCAAoB;QAApB,gEAAoB;QAApB,wDAAoB;QAApB;;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB,WAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,WAAoB;QAApB;IAAoB;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA;;IAAoB;IAApB;QAAA;YAAA;QAAoB;QAApB;YAAA,UAAoB;YAApB;;QAAoB;IAAA;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA,+CAAoB;QAApB,UAAoB;QAApB,sBAAoB;QAApB,WAAoB;QAApB,UAAoB;QAApB;IAAoB;IAApB;QAAA;YAAA,UAAoB;YAApB,WAAoB;YAApB,aAAoB;YAApB,YAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA;IAAoB;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA;YAAA,gBAAoB;YAApB,YAAoB;YAApB,qDAAoB;YAApB,kCAAoB;YAApB;;;QAAoB;IAAA;IAApB;QAAA,WAAoB;QAApB,UAAoB;QAApB,gCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,YAAoB;QAApB,YAAoB;QAApB;IAAoB;IAApB;QAAA;YAAA;;QAAoB;IAAA;IAApB;QAAA,8CAAoB;QAApB,0DAAoB;QAApB,2CAAoB;QAApB;;IAAoB;IAApB;QAAA;YAAA;;;QAAoB;IAAA;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;OAAoB;QAApB,iDAAoB;QAApB;;;OAAoB;QAApB;;;IAAoB;IAApB;QAAA,sBAAoB;QAApB,6CAAoB;QAApB,WAAoB;QAApB,kBAAoB;QAApB;IAAoB;IAApB;QAAA,mEAAoB;QAApB,kBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;4CAAoB;QAApB,sCAAoB;QAApB;;;;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;OAAoB;QAApB,WAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB,sCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB,qCAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;OAAoB;QAApB,WAAoB;QAApB;IAAoB;IAApB;QAAA,YAAoB;QAApB;;IAAoB;IAApB;QAAA,0DAAoB;QAApB,2CAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,iDAAoB;QAApB;IAAoB;IAApB;QAAA,sBAAoB;QAApB,6CAAoB;QAApB,kBAAoB;QAApB;IAAoB;IAApB;QAAA;;;KAAoB;QAApB,kBAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;;OAAoB;QAApB,WAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB,mBAAoB;QAApB,iBAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;QAApB,oDAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,gBAAoB;QAApB,YAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;;YAAA;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,yCAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;QAApB,oDAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;QAApB,oDAAoB;QAApB,iDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,sCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,mBAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA,YAAoB;QAApB,SAAoB;QAApB,sDAAoB;QAApB,sBAAoB;QAApB,4CAAoB;QAApB;+BAAoB;IAAA;IAApB;QAAA;IAAoB;IAApB;QAAA;YAAA,2DAAoB;YAApB;;;KAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA;YAAA,gDAAoB;YAApB;;;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA,mBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB,kDAAoB;QAApB;;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;GAAoB;QAApB,0CAAoB;QAApB;;GAAoB;QAApB,kBAAoB;QAApB,gBAAoB;QAApB,mEAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;sDAAoB;QAApB,sCAAoB;QAApB;;;;gDAAoB;QAApB;IAAoB;IAApB;QAAA,mBAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB,0CAAoB;YAApB,4CAAoB;YAApB;;QAAoB;QAApB;YAAA,2CAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA;YAAA,2DAAoB;YAApB,sBAAoB;YAApB,4CAAoB;YAApB;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA,sCAAoB;YAApB,kBAAoB;YAApB,YAAoB;YAApB,sDAAoB;YAApB,WAAoB;YAApB,QAAoB;YAApB,wCAAoB;YAApB;;QAAoB;QAApB;YAAA,uDAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA,mBAAoB;QAApB;IAAoB;IAApB;QAAA,oBAAoB;QAApB,kDAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;GAAoB;QAApB,WAAoB;QAApB;;;;GAAoB;QAApB,kBAAoB;QAApB,gBAAoB;QAApB,mEAAoB;QAApB,wDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA,kCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,8BAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA,gCAAoB;QAApB;IAAoB;IAApB;;QAAA,8BAAoB;QAApB;IAAoB;IAApB;QAAA,qCAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,4BAAoB;QAApB;IAAoB;IAApB;QAAA,kBAAoB;QAApB,MAAoB;QAApB,QAAoB;QAApB,SAAoB;QAApB,OAAoB;QAApB;;;;;;KAAoB;QAApB,0CAAoB;QAApB,wCAAoB;QAApB,0BAAoB;QAApB;;KAAoB;QAApB,mDAAoB;QAApB,mCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;;;;;IAAoB;AAAA;AAApB;IAAA;QAAA,2EAAoB;QAApB;IAAoB;IAApB;;QAAA,2EAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;QAAA,2EAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA;IAAoB;IAApB;QAAA;;IAAoB;IAApB;QAAA,mCAAoB;QAApB;IAAoB;IAApB;;QAAA,kCAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;IAAoB;AAAA;AAApB;IAAA;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA,2BAAoB;IAApB;;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,iBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,eAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA,eAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,eAAoB;QAApB,YAAoB;QAApB;IAAoB;IAApB;QAAA,SAAoB;QAApB,eAAoB;QAApB,WAAoB;QAApB;IAAoB;IAApB;QAAA,mBAAoB;QAApB,8BAAoB;QAApB,WAAoB;QAApB,YAAoB;QAApB,gBAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA,SAAoB;QAApB,aAAoB;QAApB;IAAoB;IAApB;QAAA,iBAAoB;QAApB;IAAoB;IAApB;QAAA,eAAoB;QAApB,YAAoB;QAApB,qDAAoB;QAApB;IAAoB;IAApB;QAAA,WAAoB;QAApB;;IAAoB;IAApB;QAAA,eAAoB;QAApB,YAAoB;QAApB,mDAAoB;QAApB;IAAoB;IAApB;QAAA,SAAoB;QAApB,WAAoB;QAApB;;IAAoB;IAApB;QAAA,mBAAoB;QAApB,8BAAoB;QAApB,WAAoB;QAApB,YAAoB;QAApB,gBAAoB;QAApB;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA,SAAoB;QAApB,aAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,6FAAoB;QAApB,gDAAoB;QAApB;IAAoB;IAApB;QAAA,sBAAoB;QAApB,uBAAoB;QAApB;IAAoB;IAApB;QAAA,sBAAoB;QAApB,mBAAoB;QAApB,oCAAoB;QAApB;IAAoB;IAApB;QAAA;;IAAoB;IAApB;QAAA,kBAAoB;QAApB;IAAoB;IAApB;QAAA;;IAAoB;IAApB;QAAA,sBAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA,qJAAoB;QAApB,sCAAoB;QAApB;;;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,aAAoB;QAApB,eAAoB;QAApB;IAAoB;IAApB;QAAA,kBAAoB;QAApB,UAAoB;QAApB;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA,eAAoB;QAApB,qDAAoB;QAApB,WAAoB;QAApB,gDAAoB;QAApB,kDAAoB;QAApB,YAAoB;QAApB,wCAAoB;QAApB;;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,iBAAoB;QAApB,MAAoB;QAApB,QAAoB;QAApB,WAAoB;QAApB,oDAAoB;QAApB,mBAAoB;QAApB;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;GAAoB;QAApB,0CAAoB;QAApB;;GAAoB;QAApB,kBAAoB;QAApB,gBAAoB;QAApB,mEAAoB;QAApB,kBAAoB;QAApB,YAAoB;QAApB,SAAoB;QAApB,sDAAoB;QAApB,sBAAoB;QAApB,4CAAoB;QAApB;+BAAoB;IAAA;IAApB;QAAA;IAAoB;IAApB;QAAA;YAAA,2DAAoB;YAApB;;;KAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA;YAAA,gDAAoB;YAApB;;;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA;QAAoB;IAAA;IAApB;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA,mBAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA,eAAoB;QAApB,qDAAoB;QAApB,WAAoB;QAApB,WAAoB;QAApB,kDAAoB;QAApB,YAAoB;QAApB,wCAAoB;QAApB;;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,QAAoB;QAApB,WAAoB;QAApB,mBAAoB;QAApB;;IAAoB;IAApB;QAAA,YAAoB;QAApB;IAAoB;IAApB;QAAA,gBAAoB;QAApB;;;GAAoB;QAApB,WAAoB;QAApB;;;;GAAoB;QAApB,kBAAoB;QAApB,gBAAoB;QAApB,mEAAoB;QAApB,wDAAoB;QAApB,kBAAoB;IAAA;IAApB;QAAA;YAAA,2DAAoB;YAApB,sBAAoB;YAApB,4CAAoB;YAApB;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA,sCAAoB;YAApB,kBAAoB;YAApB,YAAoB;YAApB,sDAAoB;YAApB,WAAoB;YAApB,QAAoB;YAApB,wCAAoB;YAApB;;QAAoB;QAApB;YAAA,uDAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA,mBAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB;;QAAoB;QAApB;YAAA;QAAoB;IAAA;IAApB;QAAA;YAAA,YAAoB;YAApB,0CAAoB;YAApB,4CAAoB;YAApB;;QAAoB;QAApB;YAAA,2CAAoB;YAApB;QAAoB;IAAA;IAApB;QAAA,qMAAoB;QAApB,sCAAoB;QAApB;;;IAAoB;AAAA;AAApB;IAAA;QAAA,YAAoB;QAApB,+CAAoB;QAApB,4CAAoB;QAApB;IAAoB;IAApB;QAAA,gCAAoB;QAApB;IAAoB;IAApB;QAAA,+CAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,UAAoB;QAApB,aAAoB;QAApB,sBAAoB;QAApB,uBAAoB;QAApB,6CAAoB;QAApB,4CAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,sCAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA,aAAoB;QAApB,uBAAoB;QAApB,kBAAoB;QAApB,WAAoB;QAApB,UAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB,8BAAoB;QAApB;IAAoB;IAApB;QAAA,eAAoB;QAApB,gBAAoB;QAApB,SAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;qDAAoB;QAApB;IAAoB;IAApB;QAAA,4BAAoB;QAApB,kCAAoB;QAApB;IAAoB;IAApB;QAAA,6CAAoB;QAApB,aAAoB;QAApB;IAAoB;IAApB;QAAA,kCAAoB;QAApB;;;IAAoB;IAApB;QAAA,gCAAoB;QAApB;IAAoB;IAApB;QAAA,WAAoB;QAApB,YAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;;;OAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,cAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB,WAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA,oEAAoB;QAApB,0BAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA,qEAAoB;QAApB,8BAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,8DAAoB;QAApB,uBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;;;;QAAA;;;IAAoB;IAApB;;;;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA,cAAoB;QAApB;kDAAoB;QAApB,mBAAoB;QAApB,kDAAoB;QAApB,kBAAoB;QAApB,yBAAoB;QAApB,aAAoB;QAApB,qBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,kBAAoB;QAApB,QAAoB;QAApB,2BAAoB;QAApB,qBAAoB;QAApB,UAAoB;QAApB,mBAAoB;QAApB,yBAAoB;QAApB,8CAAoB;QAApB,uBAAoB;QAApB;kDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,kBAAoB;QAApB,UAAoB;QAApB,WAAoB;QAApB,UAAoB;QAApB,YAAoB;QAApB,gBAAoB;QAApB,sBAAoB;QAApB,mBAAoB;QAApB;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA;;;IAAoB;IAApB;QAAA,QAAoB;QAApB,gCAAoB;QAApB,+BAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB,oBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;;QAAA,aAAoB;QAApB,iEAAoB;QAApB,uBAAoB;QAApB,sDAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,cAAoB;QAApB;IAAoB;IAApB;QAAA,kBAAoB;QAApB,UAAoB;QAApB,WAAoB;QAApB,UAAoB;QAApB,YAAoB;QAApB,gBAAoB;QAApB,sBAAoB;QAApB,mBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,QAAoB;QAApB,gCAAoB;QAApB,+BAAoB;QAApB;IAAoB;IAApB;QAAA,iEAAoB;QAApB,uBAAoB;QAApB,sDAAoB;QAApB;;IAAoB;IAApB;QAAA;IAAoB;IAApB;;;QAAA,sEAAoB;QAApB,8BAAoB;QAApB;IAAoB;IAApB;QAAA,aAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,cAAoB;QAApB;IAAoB;IAApB;QAAA,kBAAoB;QAApB,UAAoB;QAApB,WAAoB;QAApB,UAAoB;QAApB,YAAoB;QAApB,gBAAoB;QAApB,sBAAoB;QAApB,mBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA,sBAAoB;QAApB;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA,WAAoB;QAApB,kBAAoB;QAApB;;eAAoB;QAApB,0BAAoB;QAApB,yDAAoB;QAApB;;eAAoB;QAApB,SAAoB;QAApB;;IAAoB;AAAA;AAApB;IAAA;QAAA,WAAoB;QAApB,kBAAoB;QAApB,gEAAoB;QAApB,wBAAoB;QAApB,uDAAoB;QAApB,qEAAoB;QAApB,QAAoB;QAApB;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AACpB;IAAA,6BAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,uBAAmB;IAAnB,2BAAmB;IAAnB,iCAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0DAAmB;IAAnB;AAAmB;AAAnB;IAAA,2DAAmB;IAAnB;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA,oDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oCAAmB;OAAnB,iCAAmB;YAAnB;AAAmB;AAAnB;IAAA,oCAAmB;OAAnB,iCAAmB;YAAnB;AAAmB;AAAnB;IAAA,mCAAmB;OAAnB,gCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mCAAmB;OAAnB,gCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0FAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,oEAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB;AAAmB;AAAnB;IAAA,oEAAmB;IAAnB;AAAmB;AAAnB;IAAA,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA,iEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA,6DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,iDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sDAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sDAAmB;IAAnB,0DAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mDAAmB;IAAnB,2DAAmB;IAAnB;AAAmB;AAAnB;IAAA,4IAAmB;IAAnB,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mDAAmB;IAAnB,2DAAmB;IAAnB;AAAmB;AAAnB;IAAA,yDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,2IAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAFnB;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,2GAGA;IAHA,gIAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,sBAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,qCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,qCAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,YAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,cAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,iCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA,eAGA;QAHA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;QAHA;YAAA;QAGA;IAAA;AAAA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,iDAGA;IAHA,iDAGA;IAHA;AAGA;AAHA;IAAA,+BAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,yCAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,sHAGA;IAHA,2IAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,mDAGA;IAHA,mDAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,iCAGA;IAHA;AAGA;AAHA;IAAA,iCAGA;IAHA;AAGA;AAHA;IAAA,iCAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;AAAA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,gDAGA;QAHA;IAGA;IAHA;QAAA,gDAGA;QAHA;IAGA;IAHA;QAAA,4BAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;AAAA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,kCAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA,gDAGA;QAHA;IAGA;IAHA;QAAA,iDAGA;QAHA;IAGA;IAHA;QAAA,gDAGA;QAHA;IAGA;IAHA;QAAA,+CAGA;QAHA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;IAHA;QAAA;IAGA;AAAA;AAHA;IAAA;QAAA;IAGA;IAHA;QAAA;IAGA;AAAA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA,gDAGA;IAHA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA;AAHA;IAAA;AAGA","sourcesContent":["/* Customized tailwind directives omitting base layer */\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
